/***
Metronic AngularJS App Main Script
***/

/* Metronic App */
angular.module("MyApp", [
    "ui.router",
    "ui.bootstrap",
    "oc.lazyLoad",
    "ngSanitize",
    "pascalprecht.translate",
    "restangular",
    "isteven-multi-select"
]);


/* Metronic App */
angular.module("Login", [
  "ui.router",
  "ui.bootstrap",
  "oc.lazyLoad",
  "ngSanitize",
  "pascalprecht.translate",
  "restangular",
  "isteven-multi-select"
]);

///


/* Configure ocLazyLoader(refer: https://github.com/ocombe/ocLazyLoad) */
angular.module("MyApp").config(['$ocLazyLoadProvider', '$translateProvider', function ($ocLazyLoadProvider, $translateProvider) {
    $ocLazyLoadProvider.config({
        // global configs go here
    });
    $translateProvider.translations('jp', translations.jp);
    $translateProvider.translations('en', translations.en);
    $translateProvider.preferredLanguage('jp');//Ngon ngu su dung
}]);

//AngularJS v1.3.x workaround for old style controller declarition in HTML
angular.module("MyApp").config(['$controllerProvider', function ($controllerProvider) {
    // this option might be handy for migrating old apps, but please don't use it
    // in new ones!
    $controllerProvider.allowGlobals();
}]);

/********************************************
 END: BREAKING CHANGE in AngularJS v1.3.x:
*********************************************/

/* Setup global settings */
angular.module("MyApp").factory('settings', ['$rootScope', function ($rootScope, $state) {
    var folder = "/";
    var basePath = window.location.origin + folder;
    var settings = {
        layout: {
            pageSidebarClosed: false, // sidebar menu state
            pageContentWhite: true, // set page content layout
            pageBodySolid: false, // solid body color state
            pageAutoScrollOnLoad: 1000 // auto scroll to top on page load
        },
        assetsPath: folder + 'assets',
        globalPath: folder + 'assets/global',
        layoutPath: folder + 'assets/layouts/layout2',
        basePath: basePath
    };
    $rootScope.settings = settings;
    return settings;
}]);

/* Setup App Main Controller */
angular.module("MyApp").controller('AppController', ['$scope', '$rootScope', '$templateCache', function ($scope, $rootScope, $templateCache) {
    $scope.$on('$viewContentLoaded', function () {

        App.initComponents(); // init core components
        Layout.init(); //  Init entire layout(header, footer, sidebar, etc) on page load if the partials included in server side instead of loading with ng-include directive
        $templateCache.removeAll();
    });
}]);

/***
Layout Partials.
By default the partials are loaded through AngularJS ng-include directive. In case they loaded in server side(e.g: PHP include function) then below partial
initialization can be disabled and Layout.init() should be called on page load complete as explained above.
***/

/* Setup Layout Part - Header */
angular.module("MyApp").controller('HeaderController', ['$scope', function ($scope) {
    $scope.$on('$includeContentLoaded', function () {
        Layout.initHeader();
    });
}]);

/* Setup Layout Part - Sidebar */
angular.module("MyApp").controller('SidebarController', ['$state', '$scope', function ($state, $scope) {

    $scope.$on('$includeContentLoaded', function () {

        Layout.initSidebar($state);
    });
}]);

/* Setup Layout Part - Quick Sidebar */
angular.module("MyApp").controller('QuickSidebarController', ['$scope', function ($scope) {
    $scope.$on('$includeContentLoaded', function () {
        setTimeout(function () {
            QuickSidebar.init();
        }, 2000)
    });
}]);

/* Setup Layout Part - Theme Panel */
angular.module("MyApp").controller('ThemePanelController', ['$scope', function ($scope) {
    $scope.$on('$includeContentLoaded', function () {
        //Demo.init();
    });
}]);

/* Setup Layout Part - Footer */
angular.module("MyApp").controller('FooterController', ['$scope', function ($scope) {
    $scope.$on('$includeContentLoaded', function () {
        Layout.initFooter(); // init footer
    });
}]);

/* Setup Layout Part - Sidebar */
angular.module("MyApp").controller('PageHeadController', ['$scope', function ($scope) {
    $scope.$on('$includeContentLoaded', function () {
        //Demo.init();
        // init theme panel
    });
}]);
angular.module("MyApp").config(["$locationProvider", function ($locationProvider) {
      $locationProvider.hashPrefix('');
    $locationProvider.html5Mode(true);
}]);
/* Setup Rounting For All Pages */
angular.module("MyApp").config(['$stateProvider', '$urlRouterProvider', '$locationProvider', function ($stateProvider, $urlRouterProvider, $locationProvider) {
    $urlRouterProvider.otherwise("/admin/main");
    //  $urlRouterProvider.otherwise("admin/member/list-member");

    // $locationProvider.html5Mode({ //Remove # in URL
    //     enabled: true,
    //     requireBase: true
    // });
}]);

/* Init global settings request run the app */
angular.module("MyApp").config(['RestangularProvider', '$urlRouterProvider', function (RestangularProvider, $urlRouterProvider) {
    
    RestangularProvider.setBaseUrl(FrimaConfig.host);
    var auth = localStorage.getItem("FrimaAuth");
    if (auth == undefined) {
        //window.location = "/login.html";
        //$state.go("login.login");
        myApp.logout();
        return;
    }
    auth = JSON.parse(auth);
  
    var token = auth.access_token;
    RestangularProvider.setDefaultHeaders({
        "access_token": token
    });
}]);
/* Init global settings and run the app */
angular.module("MyApp").run(["$rootScope", "settings", "$state", "Restangular", function ($rootScope, settings, $state, Restangular) {
    
    $rootScope.$state = $state; // state to be accessed from view
    $rootScope.$settings = settings; // state to be accessed from view
    $rootScope.Host = FrimaConfig.host;
   
    $rootScope.logout = function () {
       
        localStorage.removeItem("FrimaAuth");
        //myApp.logout();
        $state.go('login.login');
    }
    $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
   
        var userInfo = localStorage.getItem("FrimaAuth");
    
        if (userInfo) {
            if (toState.name == 'login.login') {
                location.pathname = '/admin/main';
            }
        }
        if( window.currentState == undefined){
            window.currentState = {};
            window.currentState[toState.name] = {};
        } 
        if (window.currentState[toState.name] == undefined) {
            window.currentState[toState.name] = {};
        }
                

        window.stateName = toState.name;
      
      
       
      
    
    });
    $rootScope.$on("$locationChangeStart", function (event, next, current) {
        var n = next.indexOf("admin/login");

        var userInfo = localStorage.getItem("FrimaAuth");
        if (userInfo == undefined) {
            if (n >= 0) {
                
               
            } else {
                swal.show("error", "アクセス権限がありません。", "", function () {
                   
                    $rootScope.logout();
                });
            }

            //myApp.logout();


        }
        else {

            userInfo = JSON.parse(userInfo);
            var role = userInfo.user;
            $rootScope.role = role;
            $rootScope.user = userInfo.user;
            var domainHttp = userInfo.domainHttp;
            $rootScope.domainHttp=userInfo.domainHttp;
        }
        if ($rootScope.role.role === "Admin" || $rootScope.role.role === "User") {
            $rootScope.role = {
                roleName: "Admin"
            };
        }
        else {
            $rootScope.role = {
                roleName: ""
            };
        }
    });
    Restangular.setErrorInterceptor(function (response, deferred, responseHandler) {
        App.unblockUI();
        if (response.status === 401) {
            swal.show("error", "アクセス権限がありません。", "", function () {
                localStorage.removeItem("FrimaAuth");
                location.pathname = "/admin/login";
            });
            return false; // error handled
        }
        else if (response.status === 500) {
            swal.show("error", response.data.result.message);
            return false;
        }
        return true; // error not handled
    });
    Restangular.addFullRequestInterceptor(function (headers, params, element, httpConfig) {
        App.blockUI();
    });

    Restangular.addResponseInterceptor(function (data, operation, what, url, response, deferred) {
        App.unblockUI();
        deferred.resolve(data);
    });
}]);



(function () {
    'use strict';
    angular.module('MyApp').config(function routerConfig($stateProvider) {
          var resource = "upload";
          var controller = "UploadController";
          var baseTemplateUrl = "/app/modules/"+ resource + "/" + resource;

          $stateProvider
          .state(resource, {
              abtract: true,
              url: "/admin",
              template: "<div ui-view id='up-load-page' class='fade-in-up'></div>"
          })
         
        .state(resource + ".list", {
            url: "/exhibit_list",
            templateUrl: baseTemplateUrl + ".list.html",
            controller: controller,
            data: { pageTitle: '出品情報一覧|管理画面' + FrimaConfig.appName }
        })
        .state(resource + ".detail", {
            url: "/exhibit_detail/{id}",
            templateUrl: baseTemplateUrl + ".detail.html",
            controller: controller,
            data: { pageTitle: '出品情報詳細|管理画面' + FrimaConfig.appName }
        })
        .state(resource + ".add", {
            url: "/add-list",
            templateUrl: baseTemplateUrl + ".add.html",
            controller: controller,
            data: { pageTitle: '出品情報詳細|管理画面' + FrimaConfig.appName }
        })
      });
})();

(function () {
    'use strict';
    angular.module('MyApp').controller('UploadController', UploadController);
    function UploadController($rootScope, $state, $http, $scope, $timeout, $q, $stateParams, $compile, Restangular) {
        $scope.resource = "product";
        $scope.route = "upload";
        $scope.getById = getById;
        $scope.exbit = [];
        var reposity = Restangular.all($scope.resource);
        $scope.category = [];
        $scope.categorylist = categorylist();
        $scope.created_at_from;
        $scope.created_at_to;
        $scope.listcategory = {};
        $scope.seachproduct = [];
        $scope.stopuploadproduct = stopuploadproduct;
        $scope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
            if (from.name != 'member.details') {
                $rootScope.memberSearchUserId = null;
            }
        });
        $scope.dataVio = {

        }
        $scope.dimisData = function () {
            $scope.dataVio.violation_title = "";
            $scope.dataVio.violation_detail = "";
        }
        //checkbox 
        setTimeout(function () {
            var menu = $('.page-sidebar .page-sidebar-menu.page-sidebar-menu-compact>li');
            if (menu.length > 0) {
                menu.removeClass('active');

                $(menu[2]).addClass('active');
            }
        }, 500);


        $('.green-meadow').find(".reloadTableFilter").click(function () {
            setTimeout(function () {
                var filterHeightSearch = $('.green-meadow').height();

                var screenHeight = window.innerHeight;

                var height = screenHeight - 70 - filterHeightSearch - 215;

                $(".dataTables_scrollBody").css('height', height);
            }, 500)

        })

        $scope.statusproduct = [
            { text: "出品中", value: "published" },
            { text: "販売済", value: "completed-buying" },
            { text: "販売停止中", value: "cancel" },
            { text: "違反停止中", value: "violation" }
        ]
        function getById() {
            reposity.get($stateParams.id).then(function (res) {

                $scope.exbit = res.data.product;
                $scope.exbitdata = res.data.product_image_list;
                if ($scope.exbitdata.length == 0) {
                    $scope.exbitdata[0] = {
                        image_url: "/../../assets/layouts/layout2/img/no-image.png"
                    }
                } else {
                    for (let i = 0; i < $scope.exbitdata.length; i++) {
                        $scope.exbitdata[i].image_url = $rootScope.domainHttp + $scope.exbitdata[i].image_url
                    }
                }
                $scope.exbitchat = res.data.chat_list;
                $scope.exbitreport = res.data.report_list;

                if ($scope.exbit.str_tags) {
                    $scope.tag = $scope.exbit.str_tags.split(',');
                } else {
                    $scope.tag = [];
                }
                if ($scope.exbit.category) {
                    if ($scope.exbit.category.relationship_name && $scope.exbit.category.relationship_name != '') {
                        $scope.exbit.category_name = $scope.exbit.category.relationship_name + '>' + $scope.exbit.category.name;
                    } else {
                        $scope.exbit.category_name = $scope.exbit.category.name;
                    }

                } else {
                    $scope.exbit.category_name = "";
                }
                $scope.exbit.created_at = myApp.convertDate($scope.exbit.created_at);
                $scope.exbitchat.map(function (value) {
                    value.created_at = myApp.convertDate(value.created_at);
                })
                $scope.exbitreport.map(function (value) {
                    value.created_at = myApp.convertDate(value.created_at);
                })
            })
        };
        // conbobox  selected
        function categorylist() {
            var repositycate = Restangular.all('category');
            repositycate.customGET('', { parent_id: "0" }).then(function (resault) {
                $scope.category = resault.data;
            })
        }
        // stop upload product
        function stopuploadproduct() {

            //if (!$scope.dataVio.violation_detail || !$scope.dataVio.violation_title) {
            //    swal.show('error', '', '入力してください。', function () {

            //    });
            //    return
            //}
            //if ($scope.dataVio.violation_detail.length > 125) {
            //    swal.show('error', '', '125 文字以内で入力してください。', function () {

            //    });
            //    return
            //}
            //if ($scope.dataVio.violation_title.length > 125) {
            //    swal.show('error', '', '125 文字以内で入力してください。', function () {

            //    });
            //    return
            //}
            var data = {
                violation_title: $scope.dataVio.violation_title,
                violation_detail: $scope.dataVio.violation_detail,
            }
            swal.show('confirm', translations.jp['D002-confirm_stop_product'] + '?', '', function () {
                reposity.one("cancel_product").one($stateParams.id).customPUT(data).then((res) => {
                    swal.show('success', '', '更新しました。', function () {
                        $('.modal-backdrop').css('display', 'none');
                        $state.reload();
                    });
                })
            })
        };
        $scope.dtConfig = {
            resource: $scope.resource,
            route: $scope.route,
            isInlineEdit: false,
            isMutilSelect: false,
            order: [[1, "desc"]],
            lengthChange: false,
            autoWidth: true,
            buttonsConfig: {
                add: false,
                refresh: false
            },
            columnDefs: [
                {
                    "className": "", "targets": "_all", 'createdCell': function (td, cellData, rowData, row, col) {

                        //$(td).attr('title', cellData);
                    }
                }
            ],
            columns: [
                {
                    title: translations.jp["User id"], data: "created_by", orderable: true,
                    width: '120px',
                    className: "text-center",
                    render: function (data, type, full, meta) {
                        if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                            return myApp.trimContent(data);
                        }
                        return data;
                    },
                    fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {



                        $(nTd).attr('title', sData);
                    }
                },
                {
                    title: "商品ID", data: "id",
                    width: '120px',
                    className: "text-center",
                    orderable: true,
                    render: function (data, type, full, meta) {
                        if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                            return myApp.trimContent(data);
                        }
                        return data;
                    }
                    ,
                    fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {



                        $(nTd).attr('title', sData);
                    }
                },
                {
                    title: translations.jp["D001_nameproduct"], data: "name", orderable: true,
                    className: "text-left",
                    render: function (data, type, full, meta) {
                        if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                            return myApp.trimContent(data);
                        }
                        return data;
                    },
                    fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {



                        $(nTd).attr('title', sData);
                    }
                },
                {
                    title: "出品状況", data: "status", orderable: true, width: '130px',
                    className: "text-left",
                    render: function (data, type, full, meta) {
                        switch (data) {
                            case "published": data = "出品中";
                                break;
                            case "completed": data = "販売済";
                                break;
                            case "buying": data = "販売済";
                                break;
                            case "cancel": data = "販売停止中";
                                break;
                            case "violation": data = "違反停止中";
                                break;

                        }



                        return data;
                    },
                    fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {
                        switch (sData) {
                            case "published": sData = "出品中";
                                break;
                            case "completed": sData = "販売済";
                                break;
                            case "buying": sData = "販売済";
                                break;
                            case "cancel": sData = "販売停止中";
                                break;
                            case "violation": sData = "違反停止中";
                                break;

                        }



                        $(nTd).attr('title', sData);
                    }
                },
                {
                    title: "カテゴリー", data: "category.id", orderable: true,
                    className: "text-left",
                    width: '200px',
                    render: function (data, type, full, meta) {
                        if (full.category.relationship_name != '') {
                            data = full.category.relationship_name + '>' + full.category.name;
                        } else {
                            data = full.category.name;
                        }
                        if (!data) {
                            data = "";
                        }
                        if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                            return myApp.trimContent(data);
                        }
                        return data;
                    },
                    fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {
                        var relationship_name='';
                        if (oData.category.relationship_name != '') {
                            relationship_name = oData.category.relationship_name + '>' + oData.category.name;
                        } else {
                            relationship_name = oData.category.name;
                        }

                        $(nTd).attr('title', relationship_name);
                    }
                },
                {
                    title: translations.jp["D001-thumnail"], data: "product_image_url", orderable: false,
                    width: '130px',
                    className: "position-re text-center",
                    render: function (data, type, full, meta) {
                        return myApp.renderImage(data, $rootScope.domainHttp);
                    },
                    fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {



                        $(nTd).attr('title', sData);
                    }
                },



                {
                    title: translations.jp["D001-action"], data: "",
                    defaultContent: "",
                    className: "text-center non-padding",
                    width: '100px',
                    orderable: false,
                    render: function (url, type, full) {
                        return myApp.renderDetailActions(full, "admin/exhibit_detail");
                    }
                }
            ]
        }
    }
})();


(function () {
    'use strict';
    angular.module('MyApp').config(function routerConfig($stateProvider) {
        var resource = "ngword";
        var controller = "NgwordController";
        var baseTemplateUrl = "/app/modules/" + resource + "/" + resource;

        $stateProvider
        .state(resource, {
            abtract: true,
            url: "/admin",
            template: "<div ui-view id='current-controller' class='fade-in-up'></div>"
        })
        .state(resource + ".list", {
            url: "/conf_ngword",
            templateUrl: baseTemplateUrl + ".list.html",
            controller: controller,
            data: { pageTitle: '禁止ワード一覧|管理画面' + FrimaConfig.appName }
        })
         .state(resource + ".detail", {
             url: "/conf",
             templateUrl: baseTemplateUrl + ".detail.html",
             controller: controller,
             data: { pageTitle: '基本設定メニュー画面|管理画面' + FrimaConfig.appName }
         })
      });
})();

(function() {
  "use strict";

  angular.module("MyApp").controller("NgwordController", NgwordController);

  function NgwordController(
    $rootScope,
    $state,
    $http,
    $scope,
    $timeout,
    $q,
    $stateParams,
    $compile,
    Restangular
  ) {
    $scope.resource = "ngword";
    $scope.route = "ngword";
    $scope.dataReport;
    $scope.dataProduct;
    $scope.count = 1;
    $scope.countAll;
    $scope.list = [];
    $scope.reloadList = 1;
    setTimeout(function() {
      var menu = $(
        ".page-sidebar .page-sidebar-menu.page-sidebar-menu-compact>li"
      );
      if (menu.length > 0) {
        menu.removeClass("active");

        $(menu[7]).addClass("active");
      }
    }, 500);
    $scope.goDetailProduct = function() {
      $state.go("upload.detail", { id: $scope.dataProduct.id });
    };
    $scope.deleteMutil = function() {
      var arr = [];
      if ($scope.list) {
        if ($scope.list.length > 0) {
          $scope.list.map(function(value, index) {
            console.log(value);
            arr.push(value.id);
          });
        }
      }
      swal.show("confirm", "選択している言葉を解除しますか。", "", function() {
        Restangular.all($scope.resource + "/delete")
          .post(arr)
          .then(res => {
            $(
              $($("thead")[0])
                .find("th")
                .get(0)
            )
              .find("input:checked")
              .attr("checked", false);
            swal.show(
              "success",
              "情報を削除することが完了しました。",
              "",
              function() {
                $scope.count = $scope.count + 1;
                $scope.list = [];
                $scope.$apply();
              }
            );
          });
      });
    };
    $scope.del = function(id) {
      swal.show("confirm", "削除しますが、よろしいですか。", "", function() {
        Restangular.all($scope.resource + "/" + id)
          .customDELETE("")
          .then(res => {
            swal.show(
              "success",
              "情報を削除することが完了しました。",
              "",
              function() {
                $scope.count = $scope.count + 1;
                $scope.$apply();
              }
            );
          });
      });
    };
    $scope.getCount = function() {
      Restangular.all($scope.resource + "/count")
        .customGET("")
        .then(res => {
          $scope.countAll = res.data;
        });
    };
    $scope.add = function() {
      if (!$scope.ngWord) {
        $scope.errMes = "入力してください。";
        swal.show("error", $scope.errMes, "", function() {});
        return;
      } else {
        if (String($scope.ngWord).length > 256) {
          $scope.errMes = "256 文字以内で入力してください。";
          swal.show("error", $scope.errMes, "", function() {});
          return;
        }
      }
      Restangular.all($scope.resource)
        .post({ ngword: $scope.ngWord })
        .then(function(resp) {
          if (resp.status == "4042") {
            $scope.errMes = "入力されたワードは既に登録されています。";
            swal.show("error", $scope.errMes, "", function() {});
            return;
          }
          $scope.errMes = "";
          $scope.ngWord = "";
          $scope.count++;
          swal.show("success", "登録しました。", "");
        });
    };
    //checkbox
    $scope.goList = function() {
      $state.go("ngword.list");
    };
    //category
    $scope.goListCategory = function() {
      $state.go("category.list");
    };

    // bank
    $scope.goListbank = function() {
      $state.go("bank.list");
    };

    // contact
    $scope.gotoContact = function() {
      $state.go("contact.list");
    };
    // transfer Fee
    //get data GET /admin/configBank
    $scope.config={}
    Restangular.all("configBank").get("").then(function (res) {
        $scope.config.bankFeeValue = res.bankFeeValue;
        $scope.config.bankFeeThresholdValue = res.bankFeeThresholdValue;
    })
    //GET /admin/configSystem
    Restangular.all("configSystem").get("").then(function (res) {
      $scope.config.systemFeeFixedValue = res.systemFeeFixedValue;
      $scope.config.systemFeeValue = res.systemFeeValue;
  })
    $scope.goTransferMethod = function() {
      $state.go("transfer-fee.list");
    };
    $scope.goTransferFeeEdit = function() {
      $state.go("transfer-fee1.edit");
    };
    $scope.goTransferFeeComission = function() {
      $state.go("transfer-fee1.comission-edit");
    };
    $scope.$on("$viewContentLoaded", function() {
      //if ($state.current.name == $scope.route + ".list") {
      //    $scope.getList($stateParams.id);
      //}
    });
    $(".ngwordInput").on("change", function() {
      if (!$scope.ngWord) {
        return ($scope.errMes = "入力してください。");
      } else {
        if (String($scope.ngWord).length > 256) {
          $scope.errMes = "256 文字以内で入力してください。";
          $scope.$apply();
          return false;
        }
        $scope.errMes = "";
        $scope.$apply();
      }
    });
    $(".green-meadow")
      .find(".reloadTableFilter")
      .click(function() {
        setTimeout(function() {
          var filterHeightSearch = $(".green-meadow").height();

          var screenHeight = window.innerHeight;

          var height = screenHeight - 70 - filterHeightSearch - 205;

          $(".dataTables_scrollBody").css("height", height);
        }, 500);
      });
    $scope.dtConfig = {
      resource: $scope.resource,
      route: $scope.route,
      isInlineEdit: false,
      //isMutilSelect: false,
      lengthChange: false,
      order: [[1, "desc"]],
      autoWidth: true,
      buttonsConfig: {
        add: false,
        detail: $scope.route + ".detail",
        refresh: false
      },
      columnDefs: [
        {
          className: "",
          targets: "_all",
          createdCell: function(td, cellData, rowData, row, col) {
            $(td).attr("title", cellData);
          }
        }
      ],

      columns: [
        {
          title:
            '<label class="mt-checkbox mt-checkbox-outline"><input class="select_all" name="select_all" type="checkbox" id="" value=""><span></span></label>',
          data: "id",
          orderable: false,
          width: "62px",
          render: function(data, type, full, meta) {
            var index = -1;
            $.each($scope.list, function(i, v) {
              if (v.id == data) {
                return (index = i);
              }
            });
            if (index != -1) {
              return (
                '<label class="mt-checkbox mt-checkbox-outline"><input class="rowcheck" checked name="rowCheck" type="checkbox" id="' +
                full.id +
                '" value=""><span></span></label>'
              );
            } else {
              return (
                '<label class="mt-checkbox mt-checkbox-outline"><input class="rowcheck" name="rowCheck" type="checkbox" id="' +
                full.id +
                '" value=""><span></span></label>'
              );
            }
          }
        },
        {
          title: "ID",
          data: "id",
          orderable: true,
          width: "130px",
          className: "text-center",
          render: function(data, type, full, meta) {
            if (
              (meta.settings.isInlineEdit && meta.row > 0) ||
              !meta.settings.isInlineEdit
            ) {
              return myApp.trimContent(data);
            }
            return data;
          }
        },
        {
          title: "禁止ワード",
          data: "ngword",
          className: "text-left",
          orderable: true,
          render: function(data, type, full, meta) {
            return myApp.enCodeHtml(data);
          }
        },
        {
          title: "登録日",
          data: "created_at",
          width: "190px",
          className: "text-center",
          orderable: true,
          render: function(data, type, full, meta) {
            return myApp.convertDate(data);
          },
          fnCreatedCell: function(nTd, sData, oData, iRow, iCol) {
            var data = myApp.convertDate(sData);

            $(nTd).attr("title", data);
          }
        },
        {
          title: "機能",
          width: "100px",
          orderable: false,
          className: "text-center non-padding",
          render: function(url, type, full) {
            return (
              `<a class='btn btn-default col-md-12' style="background-color:#D9D9D9;  border: none;" ng-click="del(${
                full.id
              })" >` +
              "削除" +
              `</a>`
            );
          },
          fnCreatedCell: function(nTd, sData, oData, iRow, iCol) {
            $compile(nTd)($scope);
          },
          data: "",
          defaultContent: ""
        }
      ]
    };
  }
})();

(function () {
    'use strict';
    angular.module('MyApp').config(function routerConfig($stateProvider) {
        var resource = "transfer-request";
        var controller = "TransferRequestController";
        var baseTemplateUrl = "/app/modules/" + resource + "/" + resource;

        $stateProvider
        .state(resource, {
            abtract: true,
            url: "/admin",
            template: "<div ui-view id='current-controller' class='fade-in-up'></div>"
        })
        .state(resource + ".list", {
            url: "/claim_list",
            templateUrl: baseTemplateUrl + ".list.html",
            controller: controller,
            data: { pageTitle: '振込申請情報一覧|管理画面' + FrimaConfig.appName }
        })
        .state(resource + ".edit", {
            url: "/edit-transfer-request/{id}",
            templateUrl: baseTemplateUrl + ".edit.html",
            controller: controller,
            data: { pageTitle: '振込申請情報詳細|管理画面' + FrimaConfig.appName }
        })       
        .state(resource + ".detail", {
            url: "/claim_detail/{id}",
            templateUrl: baseTemplateUrl + ".detail.html",
            controller: controller,
            data: { pageTitle: '振込申請情報詳細|管理画面' + FrimaConfig.appName }
        })
      });
})();

(function () {
  'use strict';

  angular.module('MyApp').controller('TransferRequestController', TransferRequestController);

  function TransferRequestController($rootScope, $state, $http, $scope, $timeout, $q, $stateParams, $compile, Restangular) {
    $scope.resource = "request_payment";
    $scope.route = "transfer-request";
    setTimeout(function () {
        var menu = $('.page-sidebar .page-sidebar-menu.page-sidebar-menu-compact>li');
        if (menu.length > 0) {
            menu.removeClass('active');

            $(menu[4]).addClass('active');
        }
    }, 500);
    $scope.create = create;
    $scope.update = update;
    $scope.del = del;
    $scope.getById = getById;
    $scope.payment = [];
    $scope.request_date_start;
    $scope.request_date_end;
    var Repository = Restangular.all($scope.resource);
    function getById(){

        Repository.get($stateParams.id).then(function (respone) {
            $scope.payment = respone.data;
            if($scope.payment.updated_at ==  null || $scope.payment.updated_at ==  ""){
                $('#dateTransfer').hide();
            }else{
                $('#dateTransfer').show();
            }
            if($scope.payment.status == 1) {
                $scope.payment.status = "入金済み";
                $('#buttonTransfer').hide();
                //$('#dateTransfer').show();
            }else{
                $scope.payment.status = "申請中";
                //$('#dateTransfer').hide();
            }
           
            $scope.payment.created_at = myApp.convertDate($scope.payment.created_at);
            $scope.payment.updated_at = myApp.convertDate($scope.payment.updated_at);
        
        }) 
    };
    $('.green-meadow').find(".reloadTableFilter").click(function () {
        setTimeout(function () {
            var filterHeightSearch = $('.green-meadow').height();

            var screenHeight = window.innerHeight;

            var height = screenHeight - 70 - filterHeightSearch - 205;

            $(".dataTables_scrollBody").css('height', height);
        }, 500)

    })
    //  Repository.one($stateParams.id).put("",data).then(function (res) {
    function update() {
        var data = $scope.payment;
        data.id = parseInt($scope.payment.id);
        data.id = $stateParams.id;
        
        swal({ title: '転送完了を確認する',
        type: 'warning',
        showCancelButton: true, confirmButtonColor: '#DD6B55',
        cancelButtonText: 'キャンセル',
        confirmButtonText: 'はい', closeOnConfirm: true },
            function () {
            Repository.one($stateParams.id).customPUT(data).then(function (res) {
                $state.reload();
                }, function (res) {
                swal.show("error", res.data.result);
                });
            }
        );
          
        
      }
    function create(){

    };
 
    function del(){
        
    };
   

   $scope.dtConfig = {
    resource: $scope.resource,
    route: $scope.route,
    isInlineEdit: false,
    isMutilSelect: false,
    lengthChange: false,
    order: [[0, "desc"]],
    autoWidth: true,
    buttonsConfig: {
        add: false,
        detail: $scope.route + ".detail",
        refresh:false
    },
    columnDefs: [
        {
            "className": "", "targets": "_all", 'createdCell': function (td, cellData, rowData, row, col) {
            
                $(td).attr('title', cellData);
            }
        } 
    ],
  
    columns: [
        {
            title: translations.jp["Date request"], data: "created_at",
            width: '180px',
            orderable: true,
            render: function (data, type, full, meta) {
                return myApp.convertDate(data)
            },
            fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {
                


                $(nTd).attr('title', myApp.convertDate(sData));
            }
        },
        {
            title: translations.jp["Request ID"], data: "id", orderable: true,
            width: '130px',
            className:"text-center",
            render: function (data, type, full, meta) {
                if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                    return myApp.trimContent(data);
                }
                return data;
            }
        },
        {
            title: translations.jp["Status"], data: "status", orderable: true,
            width: '150px',
            className: "text-left",
            render: function (data, type, full, meta) {
                if(data == 1){
                    status = translations.jp["Processed"];
                }else{
                    status = translations.jp["Requesting"];
                }
                return status;
            },
            fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {

                if (sData == 1) {
                    sData = translations.jp["Processed"];
                } else {
                    sData = translations.jp["Requesting"];
                }

                $(nTd).attr('title', sData);
            }
        },
        {
            title: translations.jp["Request person ID"], data: "created_by", orderable: true,
            width: '130px',
            className: "text-center",
            render: function (data, type, full, meta) {
                if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                    return myApp.trimContent(data);
                }
                return data;
            }
        },
        {
            title: translations.jp["Money Request"], data: "total", orderable: true,
            className: "text-right",
            render: function (data, type, full, meta) {
               
                return "￥" + myApp.formatNumber(data);
            },
            fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {
                sData = myApp.formatNumber(sData);


                $(nTd).attr('title', "￥" + sData);
            }
        },
        
   
        {
            title: translations.jp["Function"], data: "",
            defaultContent: "",
            className: "text-center non-padding",
            width: '100px',
            orderable: false,
            render: function (url, type, full) {

                return myApp.renderDetailActions(full, "admin/claim_detail");
            }
        }
      ]
    }


  }
})();



(function () {
    'use strict';
    angular.module('MyApp').config(function routerConfig($stateProvider) {
        var resource = "staff";
        var controller = "StaffController";
        var baseTemplateUrl = "/app/modules/" + resource + "/" + resource;

        $stateProvider
        .state(resource, {
            abtract: true,
            url: "/admin",
            template: "<div ui-view id='current-controller' class='fade-in-up'></div>"
        })
        .state(resource + ".add", {
        url: "/staff_add",
        templateUrl: baseTemplateUrl + ".add.html",
        controller: controller,
        data: { pageTitle: 'スタッフ情報新規作成画面' + FrimaConfig.appName }
        })
        
        .state(resource + ".list", {
            url: "/staff_list",
            templateUrl: baseTemplateUrl + ".list.html",
            controller: controller,
            data: { pageTitle: 'スタッフ情報一覧|管理画面' + FrimaConfig.appName }
        })
        .state(resource + ".details", {
            url: "/staff_details/{id}",
            templateUrl: baseTemplateUrl + ".details.html",
            controller: controller,
            data: { pageTitle: 'スタッフ情報編集確認画面' + FrimaConfig.appName }
        })       
        .state(resource + ".edit", {
            url: "/staff_detail/{id}",
            templateUrl: baseTemplateUrl + ".edit.html",
            controller: controller,
            data: { pageTitle: 'スタッフ情報編集確認画面' + FrimaConfig.appName }
        })    
        .state(resource + ".confirm-create", {
            url: "/staff_confirm_create",
            templateUrl: baseTemplateUrl + ".confirm-create.html",
            controller: controller,
            data: { pageTitle: 'スタッフ情報新規作成画面' + FrimaConfig.appName }
        })     
        .state(resource + ".confirm-edit", {
            url: "/staff_confirm_edit",
            templateUrl: baseTemplateUrl + ".confirm-edit.html",
            controller: controller,
            data: { pageTitle: 'スタッフ情報編集画面' + FrimaConfig.appName }
        })  
      });
})();

(function () {
    'use strict';

    angular.module('MyApp').controller('StaffController', StaffController);

    function StaffController($rootScope, $state, $http, $scope, $timeout, $q, $stateParams, $compile, Restangular) {
        $scope.resource = "staff";
        $scope.staffCreatedResource = "staff/create";
        $scope.route = "staff";
        var Repository = Restangular.all($scope.resource);
        setTimeout(function () {
            var menu = $('.page-sidebar .page-sidebar-menu.page-sidebar-menu-compact>li');
            if (menu.length > 0) {
                menu.removeClass('active');

                $(menu[5]).addClass('active');
            }
        }, 500);
        $scope.staff = {};
        $scope.create = create;
        $scope.update = update;
        $scope.del = del;
        $scope.getById = getById;
        $scope.updateStaff = updateStaff;
        $scope.createStaff = createStaff;
        $scope.updateConfirm = false;
        $scope.updateCreate = false;
        $scope.oldPass = "";
        $scope.keyUpPass = false;
        $rootScope.confirmCreate = {};
        var roleName = $rootScope.user.role;
        $('.green-meadow').find(".reloadTableFilter").click(function () {
            setTimeout(function () {
                var filterHeightSearch = $('.green-meadow').height();

                var screenHeight = window.innerHeight;

                var height = screenHeight - 70 - filterHeightSearch - 205;

                $(".dataTables_scrollBody").css('height', height);
            }, 500)

        })
        $scope.keypress = function () {
            
            if ($scope.staff.password.length != 8) {
               
                $scope.keyUpPass = true;
            }
          
        }
        $scope.getCheckedFalse = function () {
            return false;
        };

        $scope.getCheckedTrue = function () {
            return true;
        };
        function create(data) {

            // var data=JSON.stringify($scope.staff);
            // var data=JSON.parse(data);
            // $rootScope.confirmCreate = data;
            //$state.go($scope.route + '.confirm-create');
            $scope.updateCreate = true;
            $scope.updateConfirm = true;
            $scope.$apply();
        };

        function update() {
            //var data = $scope.staff;
            //data.id = parseInt($scope.staff.id);
            //data.id = $stateParams.id;
            //$rootScope.confirmUpdate = data;
            //$state.go($scope.route + '.confirm-edit');

            if (roleName == "User") {
                return false;

            }
            
            $scope.updateCreate = true;
            $scope.updateConfirm = true;
           
            $scope.$apply();
            
        }

        function getById() {
            if ($stateParams.id) {
                Repository.get($stateParams.id).then(function (res) {
                    $scope.staff = res.data;
                    if ($scope.staff.status != 'active') {
                        $scope.staff.is_deleted = "true";
                    } else {
                        $scope.staff.is_deleted = "false";
                    }
                    $scope.oldPass = myApp.clone($scope.staff.password);
                    $scope.staff.password = "12345678";                 
                })
            }
        };
        
        function createStaff() {
            if ($scope.staff.is_deleted == "true") {
                $scope.staff.is_deleted = true;
            } else {
                $scope.staff.is_deleted = false;
            }
            Repository.post($scope.staff).then(function (res) {
                
                if (res.status == 4042) {
                    swal.show("error", "ログインIDはすでに存在します。");
                    return false;
                }
                if (res.status == 200) {
                    swal.show("success", "登録しました。");
                    $scope.goToList();
                } else {
                    swal.show("error", res.data);
                }
            }, function (res) {
               
                swal.show("error", res.data.status);
            });
            //$rootScope.confirmCreate = null;
        };

        //  Repository.one($stateParams.id).put("",data).then(function (res) {
        function updateStaff() {
            var data = myApp.clone($scope.staff);
           
            if ($scope.staff.is_deleted == "true") {
                $scope.staff.is_deleted = true;
            } else {
                $scope.staff.is_deleted = false;
            }
            var data = myApp.clone($scope.staff);
            if ($scope.keyUpPass == false) {
                data.password = $scope.oldPass;
            }
            Repository.customPUT(data).then(function (res) {
              
                if (res.status == 200) {
                    swal.show("success", "更新しました。");
                    $scope.goToList();
                } else {
                    if (res.status == "4010") {
                        swal.show("error", "ログインIDはすでに存在します。");
                        $scope.staff.is_deleted = String($scope.staff.is_deleted);
                    }
                   
                }

            }, function (res) {
                swal.show("error", res.data);
            });
        }
        function del() {

        };
        $scope.goToConfirm = function () {
            $state.go($scope.route + '.confirm');
        }

        $scope.goBack = function () {
         
               
                $scope.updateCreate = false;
                $scope.updateConfirm = false;
               
                $scope.$apply();
               
             
          
         
            
        };
        $scope.goBackCreate = function () {
            //window.history.back();
            $scope.updateCreate = false;
            $scope.updateConfirm = false;
            $scope.$apply();
        };
        $scope.goToAdd = function () {



            if (roleName == "User") {
                return false;
            }
            $state.go($scope.route + '.add');
        }
        $scope.goToList = function () {
            $state.go($scope.route + '.list');
        }

        $scope.dtConfig = {
            resource: $scope.resource,
            route: $scope.route,
            isInlineEdit: false,
            isMutilSelect: false,
            order: [[0, "desc"]],
            lengthChange: false,
            autoWidth: true,
            buttonsConfig: {
                add: false,
                refresh: false,
            },

            columnDefs: [
                {
                    "className": "", "targets": "_all", 'createdCell': function (td, cellData, rowData, row, col) {
                    
                        $(td).attr('title', cellData);
                    }
                } 
            ],

            columns: [
                {
                    title: translations.jp["Status staff"], data: "id",
                    className: "text-center",
                    width: '130px',
                    orderable: true,
                    render: function (data, type, full, meta) {
                        if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                            return myApp.trimContent(data);
                        }

                        return data;
                    }
                },
                {
                    title: translations.jp["Name"], data: "user_name", orderable: true,
                    className: "text-left",
                    render: function (data, type, full, meta) {

                        if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                            return myApp.trimContent(data);
                        }

                        return data;
                    }
                },
                {
                    title: translations.jp["Role"], data: "role", orderable: true,
                    width: '120px',
                    className: "text-left",
                    render: function (data, type, full, meta) {
                        if (data == "Admin") {
                            return translations.jp["Admin"];
                        } else {
                            return translations.jp["User"];
                        }
                    }
                },
                {
                     title: translations.jp["Is Deleted"], data: "status", orderable: true,
                     width: '100px',
                     className: "text-left",
                     render: function (data, type, full, meta) {
                         if (data == 'active') {
                             return translations.jp["Enable"];
                         } else {
                             return translations.jp["Disable"];
                         }
                     }
                },


                {
                    title: translations.jp["Function"], data: "",
                    defaultContent: "",
                    width: '100px',
                    className: "text-center non-padding",
                    orderable: false,
                    render: function (url, type, full) {
                        return myApp.renderDetailActions(full, "admin/staff_detail");
                    }
                }

            ]
        }
    }
})();



(function() {
  "use strict";
  angular.module("MyApp").config(function routerConfig($stateProvider) {
    //bank
    var resource = "transfer-fee1";
    var controller = "TransferFeeEditController";
    var baseTemplateUrl = "/app/modules/" + resource + "/" + resource;
    $stateProvider
      .state(resource, {
        abtract: true,
        url: "/admin",
        template:
          "<div ui-view id='current-controller' class='fade-in-up'></div>"
      })
      .state(resource + ".edit", {
        url: "/transfer-fee-edit",
        templateUrl: baseTemplateUrl + ".edit.html",
        controller: controller,
        data: {
          pageTitle: "基本設定メニュー画面|管理画面" + FrimaConfig.appName
        }
      })
      .state(resource + ".comission-edit", {
        url: "/transfer-comission-edit",
        templateUrl: baseTemplateUrl + ".sales-comission-edit.html",
        controller: controller,
        data: {
          pageTitle: "基本設定メニュー画面|管理画面" + FrimaConfig.appName
        }
      });
  });
})();

(function() {
  "use strict";

  angular
    .module("MyApp")
    .controller("TransferFeeEditController", TransferFeeEditController);
  function TransferFeeEditController($state, $scope, $compile, Restangular) {
    $scope.route = "transfer-fee1";
    $scope.BankFee = {};
    $scope.systemFee = {};
      //get data GET /admin/configBank
      $scope.config={}
      Restangular.all("configBank").get("").then(function (res) {
          $scope.BankFee.bankFeeValue = res.bankFeeValue;
          $scope.BankFee.bankFeeThresholdValue = res.bankFeeThresholdValue;
      })
      //GET /admin/configSystem
      Restangular.all("configSystem").get("").then(function (res) {
        $scope.systemFee.systemFeeFixedValue = res.systemFeeFixedValue;
        $scope.systemFee.systemFeeValue = res.systemFeeValue;
    })

    $scope.addBankFee = function() {
      if($scope.bank_fee_form.$valid){
        Restangular.all("configBank")
        .post($scope.BankFee)
        .then(res => {
          if (res.status == "200") {
            swal.show("success", "登録しました。", "");
          }else{
            swal.show("error", $scope.errMes, "error", function() {});
          }
        });
      }
    };
    $scope.addSystemFee = function() {
      if($scope.system_fee_form.$valid){
      Restangular.all("configSystem")
        .post($scope.systemFee)
        .then(res => {
          if (res.status == "200") {
            swal.show("success", "登録しました。", "");
          }else{
            swal.show("error", $scope.errMes, "error", function() {});
          }
        });
    };
  }
  }
})();

(function () {
    'use strict';
    angular.module('MyApp').config(function routerConfig($stateProvider) {
        //bank
        var resource = "transfer-fee";
        var controller = "TransferFeeController";
        var baseTemplateUrl = "/app/modules/" + resource + "/" + resource;
        $stateProvider
        .state(resource, {
            abtract: true,
            url: "/admin",
            template: "<div ui-view id='current-controller' class='fade-in-up'></div>"
        })
         .state(resource + ".list", {
            url: "/transfer-fee",
            templateUrl: baseTemplateUrl + ".list.html",
            controller: controller,
            data: { pageTitle: '基本設定メニュー画面|管理画面' + FrimaConfig.appName }
        })
      });
})();

(function() {
  "use strict";

  angular
    .module("MyApp")
    .controller("TransferFeeController", TransferFeeController);
  function TransferFeeController(
    $rootScope,
    $state,
    $http,
    $scope,
    $timeout,
    $q,
    $stateParams,
    $compile,
    Restangular
  ) {
    $scope.resource = "transfer-fee";
    $scope.route = "transfer-fee";
    $scope.dataReport;
    $scope.dataProduct;
    $scope.count = 1;
    $scope.countAll;
    $scope.list = [];
    $scope.reloadList = 1;
    $scope.listCate = [];
    $scope.APIData = {};
    $scope.CreateData = {};
    $scope.updateData = {};
    $scope.datanode;
    $scope.dataMove;
    $scope.dataType = {};
    var Repository = Restangular.all("transfer-fee");
  }
})();

(function () {
    'use strict';
    angular.module('MyApp').config(function routerConfig($stateProvider) {
        var resource = "report_violation";
        var controller = "ReportViolationController";
        var baseTemplateUrl = "/app/modules/" + resource + "/" + resource;

        $stateProvider
        .state(resource, {
            abtract: true,
            url: "/admin",
            template: "<div ui-view id='current-controller' class='fade-in-up'></div>"
        })
        .state(resource + ".list", {
            url: "/violation_list",
            templateUrl: baseTemplateUrl + ".list.html",
            controller: controller,
            data: { pageTitle: '違反報告一覧|管理画面' + FrimaConfig.appName }
        })
         .state(resource + ".detail", {
             url: "/violation_detail/{id}",
             templateUrl: baseTemplateUrl + ".detail.html",
             controller: controller,
             data: { pageTitle: '違反報告詳細|管理画面' + FrimaConfig.appName }
         })
      });
})();

// /// <reference path="report_violation.controller.js" />
(function () {
    'use strict';

    angular.module('MyApp').controller('ReportViolationController', ReportViolationController);

    function ReportViolationController($rootScope, $state, $http, $scope, $timeout, $q, $stateParams, $compile, Restangular) {
        $scope.resource = "report_violation";
        $scope.route = "report_violation";
        $scope.dataReport;
        $scope.dataProduct;
        $scope.date_end;
        setTimeout(function () {
            var menu = $('.page-sidebar .page-sidebar-menu.page-sidebar-menu-compact>li');
            if (menu.length > 0) {
                menu.removeClass('active');

                $(menu[6]).addClass('active');
            }
        }, 500);
        $scope.date_start;
        $scope.goDetailProduct = function () {
            $state.go("upload.detail", { id: $scope.dataProduct.id });
        }
        $('.green-meadow').find(".reloadTableFilter").click(function () {
            setTimeout(function () {
                var filterHeightSearch = $('.green-meadow').height();

                var screenHeight = window.innerHeight;

                var height = screenHeight - 70 - filterHeightSearch - 205;

                $(".dataTables_scrollBody").css('height', height);
            }, 500)

        })
        //checkbox  
        $scope.goDetail = function (id) {

            $state.go("report_violation.detail", { id: id });
        }
        $scope.changeStatusReport = function (mode) {

            if (mode == 1) {
                Restangular.all($scope.resource).one($stateParams.id).customPUT({ status: 1 }).then(function (resp) {
                    swal.show('success', "更新しました。", '', function () {
                        $state.reload();
                    });
                })
            }
            if (mode == 2) {
                Restangular.all($scope.resource).one($stateParams.id).customPUT({ status: 2 }).then(function (resp) {
                    swal.show('success', "更新しました。", '', function () {
                        $state.reload();
                    });
                })
            }
        }

        $scope.host = FrimaConfig.host;
        $scope.statusproduct = [
            { text: "出品中", value: "published" },
            { text: "販売済", value: "completed-buying" },
            { text: "販売停止中", value: "cancel" },
            { text: "違反停止中", value: "violation" }
        ]
        $scope.statusBCVP = [
            { text: "未対応", value: "0" },
            { text: "対応中", value: "1" },
            { text: "対応済", value: "2" }
        ]
        $scope.$on('$viewContentLoaded', function () {

            if ($state.current.name == $scope.route + ".detail") {
                $scope.getById($stateParams.id);
            }

        });
        $scope.getById = function () {

            Restangular.all($scope.resource).one($stateParams.id).customGET("").then(function (resp) {
                $scope.dataReport = resp.data.report;
                $scope.dataProduct = resp.data.product;
                $scope.dataUser = resp.data.created_user;

                $scope.dataType = resp.data.data_type;
                if (!$scope.dataReport.user_name || $scope.dataReport.user_name == "null null") {
                    $scope.dataReport.user_name = "";

                }
                if (!$scope.dataProduct.product_image_url || $scope.dataProduct.product_image_url == null) {
                    $scope.dataProduct.product_image_url = "/../../assets/layouts/layout2/img/no-image.png";

                } else {
                    $scope.dataProduct.product_image_url = $rootScope.domainHttp + $scope.dataProduct.product_image_url;
                }

                switch ($scope.dataReport.status) {
                    case 0: $scope.dataReport.statusName = "未対応";
                        break;
                    case 1: $scope.dataReport.statusName = "対応中";
                        break;
                    case 2: $scope.dataReport.statusName = "対応済";
                        break;
                }
                switch ($scope.dataProduct.status) {
                    case "draft": $scope.dataProduct.status = "下書き";
                        break;
                    case "published": $scope.dataProduct.status = "出品中";
                        break;
                    case "completed": $scope.dataProduct.status = "販売済";
                        break;
                    case "buying": $scope.dataProduct.status = "販売済";
                        break;
                    case "cancel": $scope.dataProduct.status = "販売停止中";
                        break;
                    case "violation": $scope.dataProduct.status = "違反停止中";
                        break;
                }
                $scope.dataReport.created_at = myApp.convertDate($scope.dataReport.created_at);


            })
        }
        $scope.dtConfig = {
            resource: $scope.resource,
            route: $scope.route,
            isInlineEdit: false,
            order: [[0, "desc"]],
            isMutilSelect: false,
            lengthChange: false,
            autoWidth: true,
            buttonsConfig: {
                add: false,
                detail: $scope.route + ".detail",
                refresh: false
            },
            columnDefs: [
                {
                    "className": "", "targets": "_all", 'createdCell': function (td, cellData, rowData, row, col) {

                        $(td).attr('title', cellData);
                    }
                }
            ],


            columns: [
                {
                    title: "申請日", data: "created_at",
                    name: "a",
                    width: '180px',
                    orderable: true,
                    render: function (data, type, full, meta) {

                        return myApp.convertDate(data)
                    },
                    fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {
                        var data = myApp.convertDate(sData);

                        $(nTd).attr('title', data);
                    }
                },

                {
                    title: "サムネイル", data: "product.product_image_url", orderable: false,
                    width: '120px',
                    className: "position-re text-center",
                    render: function (data, type, full, meta) {
                        data= $rootScope.domainHttp+data;
                        return `<img class="show-img" src="${data}" width="24" height="24" alt="" />`;

                    }
                },
                {
                    title: "商品名", data: "product.name", orderable: true,
                    className: "text-left",
                    render: function (data, type, full, meta) {
                        return data;
                    }
                },
                {
                    title: "報告者ID", data: "created_user.id", orderable: true,
                    className: "text-center",
                    width: '120px',
                    render: function (data, type, full, meta) {
                        if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                            return myApp.trimContent(full.user_name);
                        }
                        return full.user_name;
                    }
                },
                {
                    title: "出品ステータス", data: "product.status", orderable: true,
                    width: '150px',
                    className: "text-left",
                    render: function (data, type, full, meta) {

                        switch (data) {
                            case "published": data = "出品中";
                                break;
                            case "buying": data = "販売済";
                                break;
                            case "draft": data = "";
                                //下書き
                                break;
                            case "completed": data = "販売済";
                                break;
                            case "stop_buying": data = "販売停止中";
                                break;
                            case "stop_report": data = "違反停止中";
                                break;
                            case "violation": data = "違反停止中";
                                break;
                            case "cancel": data = "販売停止中";
                                break;
                        }
                        return data;
                    },
                    fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {
                        var data = sData;
                        switch (data) {
                            case "published": data = "出品中";
                                break;
                            case "buying": data = "販売済";
                                break;
                            case "draft": data = "";
                                break;
                            case "completed": data = "販売済";
                                break;
                            case "stop_buying": data = "販売停止中";
                                break;
                            case "stop_report": data = "違反停止中";
                                break;
                            case "violation": data = "違反停止中";
                                break;
                            case "cancel": data = "販売停止中";
                                break;
                        }
                        $(nTd).attr('title', data);
                    }
                },

                {
                    title: "違反報告", data: "status", orderable: true,
                    width: '110px',
                    className: "text-left",
                    render: function (data, type, full, meta) {

                        switch (data) {
                            case 0: data = "未対応";
                                break;
                            case 1: data = "対応中";
                                break;
                            case 2: data = "対応済";
                                break;
                        }
                        return data;
                    },
                    fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {
                        switch (sData) {
                            case 0: sData = "未対応";
                                break;
                            case 1: sData = "対応中";
                                break;
                            case 2: sData = "対応済";
                                break;
                        }
                        $(nTd).attr('title', sData);
                    }
                },
                {
                    title: "機能",
                    width: '100px',
                    className: "text-center non-padding",
                    orderable: false,
                    render: function (url, type, full) {

                        return `<a class='btn btn-default col-md-12' style="background-color:#D9D9D9;  border: none;" ng-click="goDetail(${full.id})" >` + translations.jp["Details"] + `</a>`;
                    },
                    fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {

                        $compile(nTd)($scope);
                    },
                    data: "",
                    defaultContent: ""

                }
            ]
        }


    }
})();



(function () {
    'use strict';
    angular.module('MyApp').config(function routerConfig($stateProvider) {
          var resource = "purchase";
          var controller = "PurchaseController";
          var baseTemplateUrl = "/app/modules/" + resource + "/" + resource;

          $stateProvider
          .state(resource, {
              abtract: true,
              url: "/admin",
              template: "<div ui-view id='current-controller' class='fade-in-up'></div>"
          })
        .state(resource + ".list", {
            url: "/buy_list",
            templateUrl: baseTemplateUrl + ".list.html",
            controller: controller,
            reload: true,
            data: { pageTitle: '購入情報一覧|管理画面' + FrimaConfig.appName }
        })
        .state(resource + ".deatils", {
            url: "/buy_detail/{id}",
            templateUrl: baseTemplateUrl + ".details.html",
            controller: controller,
            data: { pageTitle: '購入情報詳細|管理画面' + FrimaConfig.appName }
        })             
      });
})();

(function () {
    'use strict';

    angular.module('MyApp').controller('PurchaseController', PurchaseController);

    function PurchaseController($rootScope, $state, $http, $scope, $timeout, $q, $stateParams, $compile, Restangular) {
        $scope.resource = "product_order";
        $scope.route = "product_order";
        var Repository = Restangular.all($scope.resource);
        setTimeout(function () {
            var menu = $('.page-sidebar .page-sidebar-menu.page-sidebar-menu-compact>li');
            if (menu.length > 0) {
                menu.removeClass('active');

                $(menu[3]).addClass('active');
            }
        }, 500);
        $rootScope.$on('$viewContentLoaded', function () {


        });
        $('.green-meadow').find(".reloadTableFilter").click(function () {
            setTimeout(function () {
                var filterHeightSearch = $('.search-input .green-meadow').height();

                var screenHeight = window.innerHeight;

                var height = screenHeight - 70 - filterHeightSearch - 215;

                $(".dataTables_scrollBody").css('height', height);
            }, 500)

        })
        $scope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
            if (from.name != 'dashboard.list') {
                $rootScope.purchaseStatus = null;
                $rootScope.purchaseStatus_list = null;
            }
            if (from.name != 'member.details') {
                $rootScope.memberSearchUserId = null;
            }
        });


        //0: cancel; 1: wait buyer pay; 2: buyer paid, wait seller deliver; 3: seller deliver, wait buyer receive;
        // 4: buyer Received, wait admin pay seller; 5: Admin paid seller
        $scope.orderStatus = [
            { value: -1, text: "sellerCancel_status" },
            { value: 0, text: "cancelPur" },    
            { value: 1, text: "wait buyer pay" },
            { value: 2, text: "wait seller deliver" },
            { value: 3, text: "wait buyer receive" },
            { value: 4, text: "wait admin pay seller" },
            { value: 5, text: "Admin paid seller" },
        ];


        $scope.getById = getById;
        $scope.confirmPayment = confirmPayment;
        $scope.unConfirmPayment = unConfirmPayment;

        function getById() {

            Repository.get($stateParams.id).then(function (respone) {

                $scope.order = respone.data;
                if (respone.data.product.str_tags != null) {

                    $scope.order.product.str_tags = respone.data.product.str_tags.split(',');
                }
                if ($scope.order.product_image_url == null || $scope.order.product_image_url == "" || !$scope.order.product_image_url) {
                    $scope.order.product_image_url = "/../../assets/layouts/layout2/img/no-image.png";
                }else{
                    $scope.order.product_image_url=$rootScope.domainHttp+$scope.order.product_image_url;
                }
                var postcode = $scope.order.postcode;
                postcode = myApp.formatPhone(postcode);
                //postcode = myApp.reverArr(postcode);
                $scope.order.created_at = myApp.convertDate($scope.order.created_at);
                $scope.order.payment_buy_at = myApp.convertDate($scope.order.payment_buy_at);
                $scope.order.deliver_at = myApp.convertDate($scope.order.deliver_at);
                $scope.order.received_at = myApp.convertDate($scope.order.received_at);
                $scope.order.postcode = postcode;
                var sttText = '';
                
                    for (let i = 0; i < $scope.orderStatus.length; i++) {
                        if ($scope.orderStatus[i].value ==  $scope.order.status) {
                            sttText = $scope.orderStatus[i].text;
                        }
                    }
                    $scope.order.statusText = translations.jp[sttText];
               
                        
                        
            });
        };

        function confirmPayment() {
            swal.show('confirm', translations.jp['confirm_payment_buyer'] + '?', '', function () {
                Repository.one("confirm_payment_buyer").one($stateParams.id).customPUT("").then((res) => {
                    swal.show('success', '更新しました。', '', function () {
                        $state.reload();
                    });
                })
            })
        };

        function unConfirmPayment() {
            swal.show('confirm', translations.jp['un_confirm_payment_buyer'] + '?', '', function () {
                Repository.one("un_confirm_payment_buyer").one($stateParams.id).customPUT("").then((res) => {
                    swal.show('success', '更新しました。', '', function () {
                        $state.reload();
                    });
                })
            })
        };

        $scope.dtConfig = {
            resource: $scope.resource,
            route: $scope.route,
            isInlineEdit: false,
            lengthChange: false,
            isMutilSelect: false,
            order: [[0, "desc"]],
            autoWidth: true,
            buttonsConfig: {
                add: false,
                refresh: false
            },
            columnDefs: [
                {
                    "className": "", "targets": "_all", 'createdCell': function (td, cellData, rowData, row, col) {

                        $(td).attr('title', cellData);
                    }
                } //Căn giữa text trong tất cả các cột
            ],
            // searchPlaceholder: "Nhập tên khách hàng",
            columns: [
                 {
                     title: "購入日", data: "created_at", orderable: true,
                     width: '110px',
                     className: "text-center",
                     orderable: true,
                     render: function (data, type, full, meta) {

                         return myApp.convertDate(data,"notime")
                     },
                     fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {
                         var data = myApp.convertDate(sData,"noTime");

                         $(nTd).attr('title', data);
                     }
                 },
                {
                    title: translations.jp["Buyer id"], data: "user_buy.id", orderable: true,
                    width: '100px',
                    className: "text-center",
                    render: function (data, type, full, meta) {
                        if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                            return myApp.trimContent(data);
                        }
                        return data;
                    }
                },
                {
                    title: "商品ID", data: "product.id",
                    width: '100px',
                    orderable: true,
                    className: "text-center",
                    render: function (data, type, full, meta) {
                        if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                            return myApp.trimContent(data);
                        }
                        return data;
                    }
                },
                {
                    title: translations.jp["Product name"], data: "product.name", orderable: true,
                   
                    className: "text-left, min-width-cell",
                    render: function (data, type, full, meta) {
                        if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                            return myApp.trimContent(data);
                        }
                        return data;
                    }
                },
                {
                    title: translations.jp["Salespeople id"], data: "user_sell.id", orderable: true,
                    className: "text-center",
                    width: '100px',
                    render: function (data, type, full, meta) {
                        if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                            return myApp.trimContent(data);
                        }
                        return data;
                    }
                },
                {
                    title: " 出品者名", data: "user_sell.user_name", orderable: true,
                    className: "text-center",
                    width: '120px',
                    render: function (data, type, full, meta) {
                        if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                            return myApp.trimContent(data);
                        }
                        return data;
                    }
                },
                {
                    title: "購入状況", data: "status", orderable: true,
                    className: "text-left",
                    width: '130px',
                    render: function (data, type, full, meta) {
                        var sttText = '';
                        
                        for (let i = 0; i < $scope.orderStatus.length; i++) {
                            if ($scope.orderStatus[i].value == data) {
                                sttText = $scope.orderStatus[i].text;
                            }
                        }
                        data = translations.jp[sttText];
                        if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                            return myApp.trimContent(data);
                        }
                        return data;
                    },
                    fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {
                        var data = sData;
                        var sttText = '';
                        
                        for (let i = 0; i < $scope.orderStatus.length; i++) {
                            if ($scope.orderStatus[i].value == data) {
                                sttText = $scope.orderStatus[i].text;
                            }
                        }
                        data = translations.jp[sttText];
                        
                        

                        $(nTd).attr('title', data);
                    }
                },



                {
                    title: "アラート状況", data: "alert_status", orderable: true,
                    width: '130px',
                    className: "text-left",
                    render: function (data, type, full, meta) {
                        switch (data) {
                            case 1: data = "入金待ち";
                                break;
                            case 2: data = "配送待ち";
                                break;
                            case 3: data = "受取待ち";
                                break;
                            default: data = " なし";
                                break;
                        }
                        return data;
                    },
                    fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {
                        if (sData) {
                            nTd.parentNode.style.background = "rgb(255, 112, 112)";
                            //nTd.style.color = "#337ab7";
                            nTd.parentNode.className = nTd.parentNode.className + " initBg"
                        }
                        switch (sData) {
                            case 1: sData = "入金待ち";
                                break;
                            case 2: sData = "配送待ち";
                                break;
                            case 3: sData = "受取待ち";
                                break;
                        }



                        //}

                        $(nTd).attr('title', sData);
                    }
                },
                {
                    title: translations.jp["Cost"], data: "product.price", orderable: true,
                    width: '140px',
                    className: "text-right",
                    render: function (data, type, full, meta) {
                        if (data == null) {
                            data = 0;
                            return "￥" + data;
                        }
                        data = myApp.formatNumber(data);

                        return "￥" + data;
                    },
                    fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {
                        sData = myApp.formatNumber(sData);


                        $(nTd).attr('title', "￥" + sData);
                    }
                },

                {
                    title: translations.jp["Action"], data: "",
                    defaultContent: "",
                    className: "text-center non-padding",
                    width: '90px',
                    orderable: false,
                    render: function (url, type, full) {
                        return myApp.renderDetailActions(full, "/admin/buy_detail");
                    }
                }
            ]
        }
    }

})();



(function () {
    'use strict';
    angular.module('MyApp').config(function routerConfig($stateProvider) {
        var resource = "member";
        var controller = "MemberController";
        var baseTemplateUrl = "/app/modules/" + resource + "/" + resource;

        $stateProvider
        .state(resource, {
            abtract: true,
            url: "/admin",
            template: "<div ui-view id='current-controller' class='fade-in-up'></div>"
        })
        .state(resource + ".list", {
            url: "/user_list",
            templateUrl: baseTemplateUrl + ".list.html",
            controller: controller,   
            data: { pageTitle: '会員情報一覧|管理画面' + FrimaConfig.appName }
        })
        .state(resource + ".details", {
            url: "/user_detail/{id}",
            templateUrl: baseTemplateUrl + ".details.html",
            controller: controller,
            data: { pageTitle: '会員情報詳細|管理画面' + FrimaConfig.appName }
        })
      });
})();

(function () {
  'use strict';
  angular.module('MyApp').controller('MemberController', MemberController);
  function MemberController($rootScope, $state, $http, $scope, $timeout, $q, $stateParams, $compile, Restangular,$element) {
    $scope.resource = "member";
    $scope.route = "member";
    var Repository = Restangular.all($scope.resource);
    setTimeout(function () {
        var menu = $('.page-sidebar .page-sidebar-menu.page-sidebar-menu-compact>li');
        if (menu.length > 0) {
            menu.removeClass('active');

            $(menu[1]).addClass('active');
        }
    }, 500);
    $scope.getById = getById;
    $rootScope.memberSearchUserId;
    $scope.member={};
    $scope.memberLeave=memberLeave;
    $scope.gotoCommentOfUser = gotoCommentOfUser;

    $scope.gotoListUpload = function(user_id){ //go to Upload list with user-upload-id
        $rootScope.memberSearchUserId=user_id;
        $state.go("upload.list");
    };
    $scope.gotoListBuy = function(user_id){ //go to Purchase list with buy_id = this user_id
        $rootScope.memberSearchUserId=user_id;
        $state.go("purchase.list");
    };

    $scope.gotoList = function(){
        $state.go("member.list");
    };

    function gotoCommentOfUser(){
        alert('仕様がまだありません。');
        // $stateParams.go("");
    }
    $('.green-meadow').find(".reloadTableFilter").click(function () {
        setTimeout(function () {
            var filterHeightSearch = $('.green-meadow').height();

            var screenHeight = window.innerHeight;

            var height = screenHeight - 70 - filterHeightSearch - 205;

            $(".dataTables_scrollBody").css('height', height);
        }, 500)

    })
    function memberLeave() {
        if ($scope.member.is_deleted == 1 || $scope.member.status == 'leave') {
            return false;
        }
        swal.show('confirm', 'このユーザを退会させても宜しいでしょうか？', '', function () {
            Repository.one("leave").one($stateParams.id).customPUT("").then((res) => {
                
                if (res.status === 'C002001') {
                  
                    8
                    swal.show('error', '取引中の商品があるので、退会することが出来ません。', '', function () {
                    });
                }
                else{          
                    if(res.status==='200'){
                        swal.show('success', '更新しました。', '', function () {
                            $scope.gotoList();
                        });
                    }
                    else{
                        swal.show('error', '取引中の商品があるので、退会することが出来ません。', '', function () {
                        });
                    }    
                }       
            }, function (res) {
               
                if (res.status === 'C002001') {
                    swal.show('error', '取引中の商品があるので、退会することが出来ません。', '', function () {
                    });
                }
            })
        });    
    };
    
    function getById(){   
        Repository.get($stateParams.id).then(function (respone) {
            $scope.member = respone.data;
            
            if (!$scope.member.image_url || $scope.member.image_url == null) {
                $scope.member.image_url = "/../../assets/layouts/layout2/img/no-image.png";
            }


            $scope.member.phone_no = myApp.formatPhone($scope.member.phone_no);
            $scope.member.postcode = myApp.formatPhone($scope.member.postcode);
        });    
    };

    $scope.validatorConfig;

    $scope.dtConfig = {
        resource: $scope.resource,
        route: $scope.route,
        isInlineEdit: false,
        isMutilSelect: false,
        autoWidth: true,
        order: [[0, "desc"]],
        lengthChange: false,
        buttonsConfig: {
            add: false,
            refresh:false
        },
        columnDefs: [
        {
            "className": "", "targets": "_all", 'createdCell': function (td, cellData, rowData, row, col) {
               
                $(td).attr('title', cellData);
            }
        } 
        ],
    
        columns: [
            { 
                title: "ユーザID", data: "id",
                width: '110px',
                className: "text-center",
                orderable: true,
                render: function (data, type, full, meta) {
                    if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                       
                        return String(data);
                    }
                    
                    return data;
                }
            },
            {
                title: "ユーザ名", data: "user_name", orderable: true,
                width: '200px',
                className:"text-left",
                render: function (data, type, full, meta) {
                    if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                        return myApp.enCodeHtml(myApp.trimContent(data));
                    }
                    return data;
                }
            },
            {
                title: translations.jp["Email"], data: "email", orderable: true,
                className: "text-left",
                //width: '20%',
                render: function (data, type, full, meta) {
                    if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                        return myApp.trimContent(data);
                    }
                    return data;
                }
            },
              {
                  title: "ステータス", data: "status", orderable: true,
                  className: "text-left",
                  width: '150px',
                  render: function (data, type, full, meta) {
                      switch (data) {
                          case "leave": data = "退会済";
                              break;
                          case "confirm": data = "仮会員（未認証）";
                              break;
                          case "delete": data = "削除済（退会半年以上)";// 有効
                              break; 
                          case "active": data = "有効";
                              break;
                         
                          
                          
                      }
                     
                  

                      return data;
                  },
                  fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {
                      if (sData == 'leave'|| sData== 'delete') {
                        
                          nTd.parentNode.style.background = "#b5b2b2";
                          nTd.style.color = "#337ab7";
                          nTd.parentNode.className = nTd.parentNode.className + " initBg"
                      }
                      switch (sData) {
                          case "leave": sData = "退会済";
                              break;
                          case "confirm": sData = "仮会員（未認証）";
                              break;
                          case "delete": sData = "削除済（退会半年以上)";
                              break;
                          case "active": sData = "有効";
                              break;
                      }

                      $(nTd).attr('title', sData);
                }
              },
            {
                title: translations.jp["Revenue"], data: "total_revenue", orderable: true,
                className: "text-right",
                width: '150px',
                render: function (data, type, full, meta) {
                    
                    if (data == null || data==0) {
                        data = "￥" + "0";
                        return data;
                    } 
                    data=myApp.formatNumber(data);    
                                   
                    return "￥"+ data;
                },
                fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {
                   
                    sData = myApp.formatNumber(sData);

                    $(nTd).attr('title', "￥" + sData);
                }
            },
            {
                title: translations.jp["Number of Exhibit Items"], data: "total_product",   orderable: true,
                className: "text-right",
                width: '150px',
                render: function (data, type, full, meta) {
                    if(data==null){
                        data = "0";
                        return data;
                    } 
                    data=myApp.formatNumber(data);
                   
                    return data;
                }
            },
            {
                title: translations.jp["Action"], data: "",
               
                width: '100px',
                className: "text-center non-padding",
                orderable: false,
                render: function (url, type, full) {                   
                       return myApp.renderDetailActions(full,"/admin/user_detail");
                },
                defaultContent: "",
                fnCreatedCell: function (nTd, sData, oData, iRow, iCol) {
                    $compile(nTd)($scope);
                }
            }
          ]
        }
  }
})();



(function () {
    'use strict';
    angular.module('MyApp').config(function routerConfig($stateProvider) {
          var resource = "login";
          var controller = "LoginController";
          var baseTemplateUrl = "/login.html";
         
          $stateProvider
          .state(resource, {
              abtract: true,
              url: "/admin",
              template: "<div ui-view id='current-controller' class=''></div>"
          })
          .state(resource + ".login", {
              url: "/login",
              templateUrl: baseTemplateUrl,
              controller: controller,
              data: { pageTitle: 'ログイン|管理画面' + FrimaConfig.appName }
          })
         
      });
})();

(function () {
    'use strict';

    angular.module('MyApp').controller('LoginController', LoginController);

    function LoginController($rootScope, $state, $http, $scope, $timeout, $q, $stateParams, $compile, Restangular) {
    //    $scope.resource = "/user/dashboard";
    //    $scope.route = "dashboard";
    //    var Repository = Restangular.all($scope.resource);
    //    $scope.$on('$viewContentLoaded', function () {
            
    //        $(".page-sidebar-wrapper").find("li").removeClass("active");
    //    });

    //    $scope.AllDashboard = [];
    //    $rootScope.purchaseStatus = null;
    //    $rootScope.purchaseStatus_list = null;

    //    Repository.customGET("").then(function (resp) {
    //        $scope.AllDashboard = resp.data;
    //    });
    //    $scope.gotoLpurchase = function (status_id) {
    //        $rootScope.purchaseStatus = status_id;
    //        $state.go("purchase.list");
    //    };
    //    $scope.gotoLpurchase_list = function (status_id) {
    //        $rootScope.purchaseStatus_list = status_id;
    //        $state.go("purchase.list");
    //    };
    }

  
   
})();



(function () {
    'use strict';
    angular.module('MyApp').config(function routerConfig($stateProvider) {
        var resource = "contact";
        var controller = "contactController";
        var baseTemplateUrl = "/app/modules/" + resource + "/" + resource;

        $stateProvider
        .state(resource, {
            abtract: true,
            url: "/admin",
            template: "<div ui-view id='current-controller' class='fade-in-up'></div>"
        })
        .state(resource + ".list", {
            url: "/list?id",
            templateUrl: baseTemplateUrl + ".list1.html",
            controller: controller,
            data: { pageTitle: '禁止ワード一覧|管理画面' + FrimaConfig.appName }
        })
         .state(resource + ".details", {
             url: "/inquiry_list/{id}",
             templateUrl: baseTemplateUrl + ".details.html",
             controller: controller,
             data: { pageTitle: 'スタッフ情報編集確認画面' + FrimaConfig.appName }
         })  
      });
})();

(function () {
    'use strict';
    angular.module('MyApp').controller('contactController', contactController);
    function contactController($rootScope, $state, $http, $scope, $timeout, $q, $stateParams, $compile, Restangular, $element) {
        $scope.resource = "contact";
        $scope.route = "contact";

        // $scope.filter = {
        //     ...$stateParams
        // }

        $scope.getById = getById;
        var Repository = Restangular.all($scope.resource);

        $scope.resourceTodo = "todo";
        $scope.routeTodo = "todo";
        var RepositoryTodo = Restangular.all($scope.resourceTodo);

        var mang = new Array({"name" : "", "id" : ""});

        Restangular.all("question").get("").then(function (respone) {
            $scope.question =  respone.data;
            for(var i=0;i<$scope.question["content"].length;i++) {
                var a = { name: $scope.question["content"][i].name, id: $scope.question["content"][i].id };
                mang.push(a);
            }

        });
        $scope.options = mang;
        $scope.selectedOption = $scope.options[0];

        function getById() {
            if ($stateParams.id) {
                Repository.get($stateParams.id).then(function (res) {

                    $scope.contact = res.data;

                    Restangular.all("member").get($scope.contact.created_by).then(function (respone) {
                        
                        $scope.member =  respone.data;
                    });
                });
            }
        };

        getById();

        //answer Contact 
        $scope.answerContact = function (rep) {
            
            var data_todo = {
                "todo_content" : $scope.contact.reply_content,
                "receive_user_id" : $scope.contact.created_by
            }
    
            // add todo. 
            RepositoryTodo.customPOST(data_todo).then(function (res) {
            }, function (res) {               
                swal.show("error", res.data.status);
            });

            Repository.customPUT($scope.contact).then(function (res) {
                if (res.status == 4042) {
                    swal.show("error", "ログインIDはすでに存在します。");
                    return false;
                }
                if (res.status == 200) {
                    swal.show("success", "登録しました。");
                } else {
                    swal.show("error", res.data);
                }
            }, function (res) {               
                swal.show("error", res.data.status);
            });
            
        }


        // show datatable.
        $scope.dtConfig = {
            resource: $scope.resource,
            route: $scope.route,
            isInlineEdit: false,
            isMutilSelect: false,
            order: [[0, "desc"]],
            lengthChange: false,
            autoWidth: true,
            buttonsConfig: {
                add: false,
                refresh: false,
            },

            columnDefs: [
        {
            "className": "", "targets": "_all", 'createdCell': function (td, cellData, rowData, row, col) {
              
                $(td).attr('title', cellData);
            }
        } 
            ],

            columns: [
                {
                    title: "問い合わせID", data: "id",
                    width: '110px',
                    className: "text-center",
                    orderable: true,
                    render: function (data, type, full, meta) {
                        if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                           
                            return String(data);
                        }

                        return data;
                    }
                },
                {
                    title: "問い合わせ日", data: "data_type.name",
                    width: '110px',
                    className: "text-center",
                    orderable: true,
                    render: function (data, type, full, meta) {
                 
                        if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                           
                            return String(data);
                        }

                        return data;
                    }
                },
                {
                    title: "会員名", data: "content", orderable: true,
                    width: '200px',
                    className: "text-left",
                    render: function (data, type, full, meta) {
                        if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                            return myApp.enCodeHtml(myApp.trimContent(data));
                        }
                        return data;
                    }
                },

                {
                    title: "回答状況", data: "reply_content", orderable: true,
                    width: '200px',
                    className: "text-left",
                    render: function (data, type, full, meta) {
                        if ((meta.settings.isInlineEdit && meta.row > 0) || !meta.settings.isInlineEdit) {
                            return myApp.enCodeHtml(myApp.trimContent(data));
                        }
                        return data;
                    }
                },
                
                {
                    title: translations.jp["Function"], data: "",
                    defaultContent: "",
                    width: '100px',
                    className: "text-center non-padding",
                    orderable: false,
                    render: function (url, type, full) {
                        return myApp.renderDetailActions(full, "admin/inquiry_list");
                    }
                }
            ]
        }
    }
})();



(function () {
    'use strict';
    angular.module('MyApp').config(function routerConfig($stateProvider) {
          var resource = "dashboard";
          var controller = "DashboardController";
          var baseTemplateUrl = "/app/modules/" + resource + "/" + resource;

          $stateProvider
          .state(resource, {
              abtract: true,
              url: "/admin",
              template: "<div ui-view id='current-controller' class='fade-in-up'></div>"
          })
          .state(resource + ".list", {
              url: "/main",
              templateUrl: baseTemplateUrl + ".list.html",
              controller: controller,
              data: { pageTitle: 'ダッシュボード|管理画面' + FrimaConfig.appName }
          })
         
      });
})();

(function () {
    'use strict';

    angular.module('MyApp').controller('DashboardController', DashboardController);

    function DashboardController($rootScope, $state, $http, $scope, $timeout, $q, $stateParams, $compile, Restangular) {
        $scope.resource = "/user/dashboard";
        $scope.route = "dashboard";
        var Repository = Restangular.all($scope.resource);
        $scope.$on('$viewContentLoaded', function () {
            
            $(".page-sidebar-wrapper").find("li").removeClass("active");
        });

        $scope.AllDashboard = [];
        $rootScope.purchaseStatus = null;
        $rootScope.purchaseStatus_list = null;

        Repository.customGET("").then(function (resp) {
            $scope.AllDashboard = resp.data;
        });
        $scope.gotoLpurchase = function (status_id) {
            $rootScope.purchaseStatus = status_id;
            $state.go("purchase.list");
        };
        $scope.gotoLpurchase_list = function (status_id) {
            $rootScope.purchaseStatus_list = status_id;
            $state.go("purchase.list");
        };
    }

  
   
})();



(function () {
    'use strict';
    angular.module('MyApp').config(function routerConfig($stateProvider) {
        var resource = "category";
        var controller = "CategoryController";
        var baseTemplateUrl = "/app/modules/" + resource + "/" + resource;

        $stateProvider
        .state(resource, {
            abtract: true,
            url: "/admin",
            template: "<div ui-view id='current-controller' class='fade-in-up'></div>"
        })
        .state(resource + ".list", {
            url: "/category",
            templateUrl: baseTemplateUrl + ".list.html",
            controller: controller,
            data: { pageTitle: '禁止ワード一覧|管理画面' + FrimaConfig.appName }
        })
      });
})();

(function () {
  'use strict';
  angular.module('MyApp').controller('CategoryController', CategoryController);

  function CategoryController($rootScope, $state, $http, $scope, $timeout, $q, $stateParams, $compile, Restangular) {
    $scope.resource = "category";
    $scope.route = "category";
    var Repository = Restangular.all("treecategory");
    $scope.list = [];
    $scope.listCate = {};
    $scope.CreateData = {};
    $scope.updateData = {};
    $scope.dataNode;
    $scope.disabled = {
      btnAdd: false,
      btnDelete: false,
      btnUp: false,
      btnDown: false,
    };
    $scope.updateData = {};

    
    $scope.getTree = function () {
      Repository.customGET("").then((res) => {
        var rootcate = [{
          "id": 0,
          "text": "",
          "parent": "#",
          "order_no": 0,
          "is_child": false,
          "relationship_id": "",
          "relationship_name": "",
          "parents_name_full": "",
          "state": {
            "opened": true
          },
        }]
        $scope.listCate = rootcate.concat(res.data);

        //Khởi tạo
        var Tree = $('#tree').jstree({
          'core': {
            'data': $scope.listCate,
            "check_callback": true,
            'themes': {
              'name': 'proton',
              'responsive': true,
              'variant': 'large',
              'stripes': false
            }
          },
          'contextmenu': {
            'items': function ($node) {
              var config = {}
              var tree = $("#tree").jstree(true);

              config.Create = {
                "separator_before": false,
                "separator_after": false,
                "label": "Add",
                "action": function (data) {
                  $scope.AddTree(data);
                }
              };
              if ($node.text != '') {
                config.edit = {
                  "separator_before": false,
                  "separator_after": false,
                  "label": "Edit",
                  "action": function (obj) {
                    tree.edit($node);
                  }
                }
                config.delete = {
                  "separator_before": false,
                  "separator_after": false,
                  "label": "Delete",
                  "action": function (obj) {
                    $scope.DeleteTree($node);
                  }
                }
              }
              return config;
            }
          },
          'types': {
            "root": {
              "icon": "glyphicon glyphicon-plus"
            },
            "child": {
              "icon": "glyphicon glyphicon-leaf"
            },
            "default": {
              "icon": "fa fa-folder icon-state-warning icon-lg"
            },
            "file": {
              "icon": "fa fa-file icon-state-warning icon-lg"
            },
          },
          "state": {
            "key": "myTree"
          },
          "plugins": ['types', 'unique', 'state', 'dnd', 'contextmenu']
        });

        Tree.on("select_node.jstree", function (e, data) {
          $scope.dataNode = data.node;
          $scope.dataNode.level = data.node.parents.length;
          if ($scope.dataNode.text == "") {
            $scope.disabled.btnDelete = true;
            $scope.disabled.btnUp = true;
            $scope.disabled.btnDown = true;
            $scope.$apply();
          } else {
            $scope.disabled.btnDelete = false;
            $scope.disabled.btnUp = false;
            $scope.disabled.btnDown = false;

            if ($scope.dataNode.level > 11) {
              $scope.disabled.btnAdd = true;
            } else {
              $scope.disabled.btnAdd = false;;
            }
            if($scope.dataNode.parent == 0){
                if($scope.dataNode.original.order_no == 0){
                    $scope.disabled.btnUp = true;
                }
            }
            else{
                if($scope.dataNode.original.order_no == 1){
                    $scope.disabled.btnUp = true;
                }
            }
            
            $scope.$apply();
          }
        });

        //sửa
        Tree.bind("dblclick.jstree", function (event) {
          var tree = $(this).jstree();
          var node = tree.get_node(event.target);
          tree.edit(node, null, function (node, status) {
            $scope.updateData.id = node.original.id;
            $scope.updateData.name = node.text;
            $scope.updateData.parent_id = node.original.parent_id;
            $scope.updateData.is_child = node.original.is_child;
            $scope.updateData.relationship_id = node.original.relationship_id;
            $scope.updateData.relationship_name = node.original.relationship_name;
            $scope.updateData.order_no = node.original.order_no;
            if (node.text != $scope.dataNode.name) {
              Repository.customPUT($scope.updateData).then(function (res) {
                if (res.status == 200) {
                  swal("", "Eidt name success", "success");
                } else {
                  swal("", "Edit name error", "error");
                }
              })
            }
          })
        });

        //kéo thả
        Tree.bind("move_node.jstree", function (e, data) {
          var CateId = data.node.original.id;
          var newParentCatId = data.parent;
          var neiborId = data.position;
          Repository.one("move" + "?CateId=" + CateId + "&newParentCatId=" + newParentCatId + "&neiborId=" + neiborId).customPUT("").then(function (res) {

          })
        });
      })
    }
    $scope.getTree();

    // xóa
    $scope.DeleteTree = function () {
      if ($scope.dataNode.children && $scope.dataNode.children.length > 0) {
        swal("", "Không thể xóa danh mục khi đã có danh mục con", "info");
      } else {
        swal({
          title: "このカテゴリを削除してもよろしいですか？",
          text: "",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "同意する",
          cancelButtonText: "キャンセルする",
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
        }, function () {
          Restangular.all('treecategory/' + $scope.dataNode.id).customDELETE("").then(function (res) {
            swal("", "削除に成功しました", "success");
            $('#tree').jstree().delete_node($scope.dataNode.id);
          }, function (res) {
            swal(res.data.result.message, "", "error");
          })
        });
      }
    };

    // thêm
    $scope.AddTree = function (data) {
      var node;
      if ($scope.dataNode != undefined && $scope.dataNode.id > 0) {
        node = $('#tree').jstree().create_node($scope.dataNode.id, {
          "text": "New node",
        }, "last", function () {});
      } else {
        node = $('#tree').jstree().create_node('0', {
          "text": "New node",
        }, "last", function () {});
      }
      $('#tree').jstree().edit(node, null, function (node, status) {
        $scope.CreateData.name = node.text;
        if ($scope.dataNode == undefined) {
          $scope.CreateData.relationship_id = "";
          $scope.CreateData.relationship_name = "";
          $scope.CreateData.parent_id = 0;
        } else {
          $scope.CreateData.relationship_id = $scope.dataNode.original.relationship_id;
          $scope.CreateData.parent_id = $scope.dataNode.id;
          if ($scope.dataNode.original.relationship_name == "") {
            $scope.CreateData.relationship_name = $scope.dataNode.original.name;
          } else {
            $scope.CreateData.relationship_name = $scope.dataNode.original.relationship_name + ">" + $scope.dataNode.original.name;
          }
        }
        Repository.post($scope.CreateData).then(function (res) {
          if (res.status == 200) {
            swal("", "Add category success", "success");
            $state.reload();
          }
        })
      })
    };

    //di chuyển lên xuống
    $scope.go = {
      up: function () {
        $scope.updateData.parent_id = $scope.dataNode.original.parent_id;
        $scope.updateData.id = $scope.dataNode.original.id;
        Repository.one('moveUp').customPUT($scope.updateData).then(function (res) {
          if (res.status == 200) {
            $('#tree').jstree("move_node", "#" + $scope.dataNode.original.id, "#" + $scope.dataNode.original.parent, res.data.order_no);
          }
        });
      },
      down: function () {
        $scope.updateData.parent_id = $scope.dataNode.original.parent_id;
        $scope.updateData.id = $scope.dataNode.original.id;
        Repository.one('moveDown').customPUT($scope.updateData).then(function (res) {
          if (res.status == 200) {
            $('#tree').jstree("move_node", "#" + $scope.dataNode.original.id, "#" + $scope.dataNode.original.parent, res.data.order_no);
          }
        })
      }
    }

  }
})();

(function () {
    'use strict';
    angular.module('MyApp').config(function routerConfig($stateProvider) {
        //bank
        var resource = "bank";
        var controller = "BankController";
        var baseTemplateUrl = "/app/modules/" + resource + "/" + resource;
        $stateProvider
        .state(resource, {
            abtract: true,
            url: "/admin",
            template: "<div ui-view id='current-controller' class='fade-in-up'></div>"
        })
         .state(resource + ".list", {
            url: "/bank",
            templateUrl: baseTemplateUrl + ".list.html",
            controller: controller,
            data: { pageTitle: '基本設定メニュー画面|管理画面' + FrimaConfig.appName }
        })
         .state(resource + ".detail", {
            url: "/bank_detail/{id}",
            templateUrl: baseTemplateUrl + ".detail.html",
            controller: controller,
            data: { pageTitle: '会員情報詳細|管理画面' + FrimaConfig.appName }
        })
        
      });
})();

(function() {
  "use strict";

  angular.module("MyApp").controller("BankController", BankController);
  function BankController($state, $scope, $compile, Restangular) {
    $scope.resource = "bank";
    $scope.route = "bank";
    $scope.dataBank = [];
    $scope.count = 1;
    $scope.list = [];
    $scope.reloadList = 1;
    var Repository = Restangular.all($scope.resource);

    // checkbox
    $scope.clickCheck = function(data) {
      var arr = [];
      if (data == true) {
        angular.forEach($scope.dataBank, function(value, key) {
          arr.push($scope.dataBank[key].id);
          $scope.list = arr;
        });
      } else if (data.length > 0) {
        angular.forEach(data, function(value, key) {
          if (data[key].checked) {
            arr.push(data[key].id);
            $scope.list = arr;
          }
        });
      } else {
        $scope.list = arr;
      }
    };
    //Validate Bank Code
    $scope.validateBankCode = function(model) {
      if(model){
        $scope.dataType.code = model.replace(/[^0-9]+/g, "");
        if ($scope.dataType.code && $scope.dataType.code.length > 4) {
          $scope.dataType.code = $scope.dataType.code.substring(0, 4);
        }else{
         
        }
      }
    };
    $scope.validateBankCodeEditRow = function(model) {
      $scope.editInfo.code = model.replace(/[^0-9]+/g, "");
      if ($scope.editInfo.code && $scope.editInfo.code.length > 4) {
        $scope.editInfo.code = $scope.editInfo.code.substring(0, 4);
      }
    };
    //Press Enter
    $scope.pressEnterEdit = function(event){
      if(event.keyCode==13){
        $scope.sutmitEdit();
      }
    }
    // DELETE BANK
    $scope.deleteBank = function() {
      Restangular.all("deletebank")
        .post($scope.list)
        .then(res => {
          if (res.status == "200") {
            $state.reload();
            swal("", "Delete Bank success", "info");
          }else{
            if(res.status == "4043"){
              swal("", "Have a bank used in request payment list", "error");
          }
        }
        });
    };
    //ADD Bank
    $scope.AddBank = function(data) {
      if (data == undefined) {
        swal("", "input name bank and Bank Code", "error");
        return;
      }
      if($scope.bankForm.$valid){
         if ($scope.dataType.code.length == 1) {
          $scope.dataType.code = "000" + $scope.dataType.code;
        }
        if ($scope.dataType.code.length == 2) {
          $scope.dataType.code = "00" + $scope.dataType.code;
        }
        if ($scope.dataType.code.length == 3) {
          $scope.dataType.code = "0" + $scope.dataType.code;
        }
        $scope.dataType.type = 11;
        $scope.dataType.name = data.name;
        $scope.dataType.code = data.code;
        Restangular.all("bank").post($scope.dataType).then(res => {
            if (res.status == "200") {
              $scope.dataType.name = undefined;
              $scope.dataType.code = undefined;
              $state.reload();
              swal("", "Add Bank success", "info");
            }
            if(res.status == "4042"){
              swal("", "Bank code has readly.", "error");
            }
          });
      }
    };

    $scope.editBank = function(rowIndex, data) {
      $scope.editInfo = data;
      $scope.editRow = rowIndex;
    };
    $scope.unEdit = function() {
      $scope.editRow = null;
    };
    //Edit
    $scope.sutmitEdit = function() {
      if(!$scope.editInfo.code || $scope.editInfo.code.trim()=="") {
        swal("", "code empty", "error");
        return;
      }
      if(!$scope.editInfo.name || $scope.editInfo.name.trim()=="") {
        swal("", "name empty", "error");
        return;
      }
      if(!$scope.editInfo.name_kana || $scope.editInfo.name_kana.trim()=="") {
        swal("", "name kana empty", "error");
        return;
      }
      if ($scope.editInfo.code.length == 1) {
        $scope.editInfo.code = "000" + $scope.editInfo.code;
      }
      if ($scope.editInfo.code.length == 2) {
        $scope.editInfo.code = "00" + $scope.editInfo.code;
      }
      if ($scope.editInfo.code.length == 3) {
        $scope.editInfo.code = "0" + $scope.editInfo.code;
      }
      Repository.customPUT($scope.editInfo).then(res => {
        if (res.status == 200) {        
          swal.show('success', '更新しました。', '', function () {
            $state.reload();
        });
        } else {
          swal("", "Error update Code Bank", "error");
        }
      });
        $scope.editRow = null;
    };
    // $scope.click()
    $scope.dtConfig = {
      resource: $scope.resource,
      route: $scope.route,
      isInlineEdit: true,
      order: [[1, "asc"]],
      isMutilSelect: false,
      lengthChange: false,
      autoWidth: true,
      paging: false,
      isInlineEdit: true,
      buttonsConfig: {
        add: false,
        detail: false,
        refresh: false
      },
      columnDefs: [
        {
          className: "",
          targets: "_all",
          createdCell: function(td, cellData, rowData, row, col) {
            $(td).attr("title", cellData);
          }
        }
      ],
      columns: [
        {
          title:
            '<label class="mt-checkbox mt-checkbox-outline">'+
            '<input class="select_all" name="select_all" type="checkbox" id="" value="">'+
            '<span></span></label>',
          data: "id",
          orderable: false,
          width: "102px",
          render: function(data, type, full, meta) {
            var index = -1;
            $.each($scope.list, function(i, v) {
              if (v.id == data) {
                return (index = i);
              }
            });
            if (index != -1) {
              return (
                '<label class="mt-checkbox mt-checkbox-outline"><input class="rowcheck" checked name="rowCheck" type="checkbox" id="' +
                full.id +
                '" value=""><span style="background-color:white"></span></label>'
              );
            } else {
              return (
                '<label class="mt-checkbox mt-checkbox-outline"><input class="rowcheck" name="rowCheck" type="checkbox" id="' +
                full.id +
                '" value=""><span style="background-color:white"></span></label>'
              );
            }
          }
        },
        {
          title: "銀行コード",
          data: "code",
          orderable: true,
          className: "text-left",
          width:"20%",
          render: function(data, type, full, meta) {
          
            return `<span style="display: block" ng-click='editBank(${
              meta.row
            },${JSON.stringify(full)})' ng-if="editRow!=${
              meta.row
            }">${data}</span>
                   <input ng-change="validateBankCodeEditRow(editInfo.code)" style="color: black !important;" ng-if="editRow==${meta.row}" ng-keypress="pressEnterEdit($event)" ng-model="editInfo.code" 
                   value="${full.code}"/>`;
          },
          fnCreatedCell: function(td) {
            return $compile(td)($scope);
          }
        },
        {
          title: "銀行名",
          data: "name",
          width:"20%",
          orderable: true,
          className: "text-left",
          render: function(data, type, full, meta) {
            return `<span style="display: block" ng-click='editBank(${
              meta.row
            },${JSON.stringify(full)})' ng-if="editRow!=${meta.row}">${
              full.name
            }</span>
                 <input style="color: black !important;" ng-if="editRow==${
                   meta.row
                 }" ng-keypress="pressEnterEdit($event)" ng-model="editInfo.name" value="${data}"/>`;
          },
          fnCreatedCell: function(td) {
            return $compile(td)($scope);
          }
        },
        {
          title: "銀行名（カナ）",
          data: "name_kana",
          orderable: true,
          className: "text-left",
          render: function(data, type, full, meta) {
            if(!full.name_kana){
              full.name_kana = "";
            }
            return `<span style="display: block" ng-click='editBank(${
              meta.row
            },${JSON.stringify(full)})' ng-if="editRow!=${meta.row}">${
              full.name_kana
            }</span>
                 <input style="color: black !important;" ng-if="editRow==${
                   meta.row
                 }" ng-keypress="pressEnterEdit($event)" ng-model="editInfo.name_kana" value="${data}"/>
                 <button ng-if="editRow==${
                   meta.row
                 }" class="btn-sm-fr button_inline" ng-click='sutmitEdit()'>セーブ</button>
                 <button ng-if="editRow==${
                   meta.row
                 }" class="btn-sm-fr button_inline" ng-click='unEdit()'>キャンセル</button>`;
          },
          fnCreatedCell: function(td) {
            return $compile(td)($scope);
          }
        },
        {
          title: translations.jp["Action"],
          data: "",
          width: "100px",
          className: "text-center non-padding",
          orderable: false,
          render: function(url, type, full) {
            return myApp.renderDetailActions(full, "/admin/bank_detail");
          },
          defaultContent: "",
          fnCreatedCell: function(nTd, sData, oData, iRow, iCol) {
            $compile(nTd)($scope);
          }
        }
      ]
    };
  }
})();


(function () {
  "use strict";

  angular.module("MyApp").directive('select2', function ($compile, $q) {
    return {
      restrict: "A",
      scope: {
        name: "@",
        ngModel: "=",
        getData: "&",
        placeholder: "@",
        includeAll: "@",
        level: "@",
        multi: "@"
      },
      // template: '<option ng-if="includeAll==undefined"></option><option ng-select="x.id==ngModel" value="{{x.id}}" ng-repeat="x in data">{{x.name}}</option>',
      template: '',

      controller: function ($scope, $element, $state) {

      },
      link: function ($scope, $element, $attrs, controller) {
        $element.select2().on("change", function (e) {
        });
        var event = function () {
          $scope.getData({}).then(function (resp) {
            var config = {};
            var all = [{ id: "", name: "All" }];
            if ($scope.includeAll != undefined) {
              if (resp.result) {
                if (resp.result.data)
                  $scope.data = all.concat(resp.result.data);
                else
                  $scope.data = all.concat(resp.result);
              }
              else
                $scope.data = all.concat(resp);
            }
            else {
              if (resp.result) {
                if (resp.result.data) {
                  $scope.data = resp.result.data;

                } else {
                  $scope.data = resp.result;
                }
              } else {
                $scope.data = resp;
              }


            }


            config.data = $scope.data.map(function (item) {

              var level = "";
              if ($scope.level) {
                switch (item.level) {

                  case 0:
                    level = ""
                    break;
                  case 1:
                    level = "----"
                    break;
                  case 2:
                    level = "--------"
                    break;
                  default:
                    level = "";
                }
                item.text = level + item.name;
              }
              else
                item.text = item.name;
              return item;
            });
            config.allowClear = true;
            if ($scope.placeholder != undefined)
              config.placeholder = $scope.placeholder;
            else
              config.placeholder = "Select";

            $element.select2(config);


            if ($element.find('option:first').val() == "? undefined:undefined ?") {
              $element.find('option:first').remove();
            }

            //if ($scope.includeAll)
            //    $element.trigger('change');

            $scope.$watch('ngModel', function (newValue, oldValue) {


              $element.trigger('change');
            });
          });
        }
        event();

      }
    };
  })
})();

(function () {
    "use strict";

    angular.module("MyApp").directive('buttonSave', function ($compile, $q) {
        scope: {

            buttonText :'@'
        }
        return {
          restrict: 'E',
          template: "Lưu",
          //replace:true,
          link: function ($scope, $element, $attrs) {

              $element.addClass("btn btn-success");

              if ($scope.buttonText) {
                  $element.text($scope.buttonText);
              }
          }
        }
    })
})();


(function () {
  "use strict";

  angular.module("MyApp").directive('buttonAdd', function ($compile, $q) {
    return {
        restrict: 'E',
        scope:{
            buttonText: '@'
        },
        template: "Add",
      //replace: true,
      link: function ($scope, $element, $attrs) {
          $element.addClass("btn btn-success");
          if ($scope.buttonText) {
              $element.text($scope.buttonText);
          }
      }
    }
  })
})();

(function () {
  "use strict";

  angular.module("MyApp").directive('buttonCancel', function ($compile, $q) {
    return {
      restrict: 'E',
      template: 'Back',
      //replace: true,
      link: function ($scope, $element, $attrs) {
          $element.addClass("btn btn-inverse");
          if ($scope.buttonText) {
              $element.text($scope.buttonText);
          }
      }
    }
  })
})();

(function () {
  "use strict";

  angular.module("MyApp").directive('buttonDelete', function ($compile, $q) {
    return {
      restrict: 'E',
      template: 'Delete',
      //replace: true,
      link: function ($scope, $element, $attrs) {
          $element.addClass("btn btn-danger");
          if ($scope.buttonText) {
              $element.text($scope.buttonText);
          }
      }
    }
  })
})();


(function () {
    "use strict";

    angular.module("MyApp").directive('buttonShow', function ($compile, $q) {
        return {
            restrict: 'E',
            template: 'Active',
            //replace: true,
            link: function ($scope, $element, $attrs) {
                $element.addClass("btn btn-info");
                if ($scope.buttonText) {
                    $element.text($scope.buttonText);
                }
            }
        }
    })
})();

(function () {
    "use strict";

    angular.module("MyApp").directive('buttonHide', function ($compile, $q) {
        return {
            restrict: 'E',
            template: 'Hide',
            //replace: true,
            link: function ($scope, $element, $attrs) {
                $element.addClass("btn btn-info");
                if ($scope.buttonText) {
                    $element.text($scope.buttonText);
                }
            }
        }
    })
})();
(function () {
    "use strict";

    angular.module("MyApp").directive('buttonGoEdit', function ($compile, $q) {
        return {
            restrict: 'E',
            template: 'Edit',
            //replace: true,
            link: function ($scope, $element, $attrs) {
                $element.addClass("btn btn-success");
                if ($scope.buttonText) {
                    $element.text($scope.buttonText);
                }
            }
        }
    })
})();
// Button staff
(function () {
    "use strict";
  
    angular.module("MyApp").directive('buttonAddStaff', function ($compile, $q) {
      return {
          restrict: 'E',
          scope:{
              buttonText: '@'
          },
          template: "登録",
        //replace: true,
        link: function ($scope, $element, $attrs) {
            $element.addClass("btn btn-staff");
            if ($scope.buttonText) {
                $element.text($scope.buttonText);
            }
        }
      }
    })
})();
(function () {
    "use strict";
  
    angular.module("MyApp").directive('buttonUpdateStaff', function ($compile, $q) {
      return {
          restrict: 'E',
          scope:{
              buttonText: '@'
          },
          template: "確認",
        //replace: true,
        link: function ($scope, $element, $attrs) {
            $element.addClass("btn btn-staff");
            if ($scope.buttonText) {
                $element.text($scope.buttonText);
            }
        }
      }
    })
})();
(function () {
    "use strict";
  
    angular.module("MyApp").directive('buttonRegistrationStaff', function ($compile, $q) {
      return {
        restrict: 'E',
        template: '登録',
        //replace: true,
        link: function ($scope, $element, $attrs) {
            $element.addClass("btn btn-staff");
            if ($scope.buttonText) {
                $element.text($scope.buttonText);
            }
        }
      }
    })
  })();
  (function () {
    "use strict";
  
    angular.module("MyApp").directive('buttonConfirmUpdate', function ($compile, $q) {
      return {
          restrict: 'E',
          scope:{
              buttonText: '@'
          },
          template: "登録",
        //replace: true,
        link: function ($scope, $element, $attrs) {
            $element.addClass("btn btn-staff");
            if ($scope.buttonText) {
                $element.text($scope.buttonText);
            }
        }
      }
    })
})();
(function () {
    "use strict";
  
    angular.module("MyApp").directive('buttonConfirmAdd', function ($compile, $q) {
      return {
        restrict: 'E',
        template: '登録',
        scope: {
            buttonText: '@'
        },
        //replace: true,
        link: function ($scope, $element, $attrs) {
            $element.addClass("btn btn-staff");
           
            if ($scope.buttonText) {
                $element.text($scope.buttonText);
            }
        }
      }
    })
  })();

'use strict';

angular.module('MyApp').factory('AppService', function ($http, $state) {
    var pad = function (n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    return {
        pad: pad,
        getUrl: function (routeName, params, options) {
            return $state.href(routeName, params, options);
        },
        convertToLocalDate: function (isoDateString, plusTime) {
            if (isoDateString != undefined) {
                if (!isoDateString.endsWith("Z")) isoDateString = isoDateString + "Z";

                var d = new Date(isoDateString);

                var extraTime = 0;

                if (plusTime != undefined) extraTime = plusTime;

                var localTime = d.getTime() + extraTime;

                var localDate = new Date(localTime);
                //var time = pad(localDate.getHours(), 2) + ":" + pad(localDate.getMinutes(), 2) + ":" + pad(localDate.getSeconds(), 2);
                //var result = localDate.toLocaleDateString() + " " + time;

                var result = pad(localDate.getDate(), 2) + "/" + pad(localDate.getMonth() + 1, 2) + "/" + pad(localDate.getFullYear(), 4) + " " + pad(localDate.getHours(), 2) + ":" + pad(localDate.getMinutes(), 2) + ":" + pad(localDate.getSeconds(), 2);

                return result;
            } else {
                return "";
            }

        },
        convertToISODate: function (localDateString) {

            if (localDateString!= null && localDateString != undefined && localDateString != "") {
                var spaceIndex = localDateString.indexOf(" ");
                var time = "";
                var dateArray;
                if (spaceIndex >= 0) {
                    dateArray = localDateString.substring(0, spaceIndex).split("/")
                }
                else {
                    dateArray = localDateString.split("/");
                }

                var date = dateArray[2] + "/" + dateArray[1] + "/" + dateArray[0];

                if (spaceIndex >= 0) {
                    time = " " + localDateString.substring(spaceIndex + 1, localDateString.length);
                }
                var d = new Date(date + time);
                var localTime = d.getTime() + 420 * 60000;
                var localDate = new Date(localTime);
                var result = localDate.toISOString();
                if (result.indexOf("Z") >= 0) {
                    result = result.substring(0, result.length - 1);
                }
                return result;
            } else {
                return "";
            }
        },
        formatNumber: function (toFormat) {
            if (toFormat == undefined) return "";
            return toFormat.toString().replace(
              /\B(?=(\d{3})+(?!\d))/g, "."
            );
        },
        timeSince: function (isoDateString) {
            if (isoDateString!=null && isoDateString!="" && isoDateString != undefined) {
                if (!isoDateString.endsWith("Z")) isoDateString = isoDateString + "Z";

                var timeStamp = new Date(isoDateString);

                var now = new Date(),
                    secondsPast = (now.getTime() - timeStamp.getTime()) / 1000;
                if (secondsPast < 60) {
                    return parseInt(secondsPast) + 's';
                }
                if (secondsPast < 3600) {
                    return parseInt(secondsPast / 60) + 'm';
                }
                if (secondsPast <= 86400) {
                    return parseInt(secondsPast / 3600) + 'h';
                }
                if (secondsPast > 86400) {
                    var day = timeStamp.getDate();
                    var month = timeStamp.toDateString().match(/ [a-zA-Z]*/)[0].replace(" ", "");
                    var year = timeStamp.getFullYear() == now.getFullYear() ? "" : " " + timeStamp.getFullYear();
                    return day + " " + month + year;
                }
            }
            else {
                return "";
            }
        }
    }
});





(function () {
    "use strict";
    angular.module("MyApp").directive('tmdtTable', function ($compile, $q) {
        return {
            scope: {
                dataTableConfig: "=tmdtTable",
                ngModel: "=?",
                columnsAdd: "=",
                key: '@',
                reload: '=?',
                deleteRow: '@',
                saveState: '@'
            },
            controller: function ($scope, $element, $state, Restangular, $rootScope, $location, $compile) {

                var count = 0;
                if ($scope.ngModel === undefined) {
                    $scope.ngModel = [];
                }

                var filterHeightSearch = $('.green-meadow').height();

                var screenHeight = window.innerHeight;

                var height = screenHeight - filterHeightSearch - 240;

                switch ($scope.dataTableConfig.resource) {
                    case "member": height += 5;
                        break;
                    case "product": height -= 40;
                        break;
                    case "product_order": height -= 20;
                        break;
                    case "request_payment": height += 5;
                        break;
                    case "report_violation": height -= 30;
                        break;
                }

                if (window.innerWidth < 1190) {
                    switch ($scope.dataTableConfig.resource) {
                        case "member": height -= 20;
                            break;
                        case "report_violation": height -= 20;
                            break;
                    }
                }
                if (window.innerWidth < 1050) {
                    switch ($scope.dataTableConfig.resource) {
                        case "member": height -= 30;
                            break;

                    }
                }
                $('.dataTables_scrollBody').css('height', height + "px");
                var defaultConfig = {
                    ajax: function (data, callback, settings) {

                        count = count + 1;

                        //var searchItem = $location.search();
                        var searchItem = window.currentState[window.stateName];
                        var arrKey = Object.keys(searchItem);

                        if (count == 1 && arrKey.length > 0) {

                            if (searchItem.limit)
                                settings._iDisplayLength = searchItem.limit;

                            if (searchItem.skip)
                                settings._iDisplayStart = searchItem.skip;
                            if (searchItem.sortType)
                                settings.aaSorting[0][1] = searchItem.sortType;

                            var sortCol = settings.aaSorting[0][0];

                            if (searchItem.sortBy) {
                                var customSortByName = settings.aoColumns[sortCol].data.split(".");
                                // if (customSortByName.length > 1) {
                                //     settings.aoColumns[sortCol].data = customSortByName[customSortByName.length - 1];
                                //     }else{
                                settings.aoColumns[sortCol].data = searchItem.sortBy;
                                // }
                            }
                            if (searchItem.created_at_from) {
                                searchItem.created_at_from = null;
                            }
                            if (searchItem.created_at_to) {
                                searchItem.created_at_to = null;
                            }
                            if (searchItem.purchasstatus) {
                                searchItem.purchasstatus = null;
                            }
                            if (searchItem.alertstatus) {
                                searchItem.alertstatus = null;
                            }
                            if (searchItem.status_list) {
                                searchItem.status_list = null;
                            }

                            //TO DO gán lại giá trị
                            Object.keys(searchItem).forEach(function (key) {

                                var filter = $element.find(".filter-region " + "[filter='" + key + "']");
                                if (key == "status_list" || key == "category_list" || key == "status_buy_list" || key == "status_alert_list" || key == "upload_status" || key == "status") {
                                    if (searchItem[key]) {

                                        searchItem[key] = "";
                                    }

                                }
                                $(filter).val(searchItem[key]);


                            });
                        }


                        var pageSize = settings._iDisplayLength = 100;
                        var skip = settings._iDisplayStart;

                        var sortCol = settings.aaSorting[0][0];
                        var customSortByName2 = settings.aoColumns[sortCol].data.split(".");
                        if (customSortByName2.length > 1) {
                            settings.aoColumns[sortCol].data = settings.aoColumns[sortCol].data;
                        }
                        if (settings.aaSorting.length > 0) {
                            var sortCol = settings.aaSorting[0][0];
                            var sortType = settings.aaSorting[0][1];

                            var sortBy = settings.aoColumns[sortCol].data;
                        }

                        var params = {
                            page: skip / pageSize,
                            size: pageSize,
                            sortBy: sortBy,
                            sortType: sortType

                        };


                        $element.find(".filter-region [filter]").each(function (index, e) {
                            var val = $(e).val();
                            var counts = 1;
                            $(this).find(':input').each(function (elpindex, ex) {
                                if (ex.type == "checkbox") {

                                    if (ex.checked) {
                                        if (counts == 1) {
                                            val += $(ex).val();
                                        }
                                        else {
                                            val = val + '-' + $(ex).val();
                                        }
                                        counts++;
                                    }
                                }
                            })

                            if (e.type == 'date') {
                                val = Date.parse(new Date(val));

                            }



                            if (val == "all") {
                                val = "";
                            }
                            if (val) {
                                if (e.type == 'date' && $(e).attr("filter") != undefined) {
                                    params[$(e).attr("filter")] = val;
                                }
                                else if ($(e).attr("filter") != undefined) {
                                    params[$(e).attr("filter")] = val.trim();

                                }

                            }
                            // checkbox output-list
                            $(this).find("isteven-multi-select").each(function (index, e) {
                                var filter = $(this).closest('.form-check').attr('filter');
                                var dataListout = $scope.$parent.$eval($(e).attr("output-model"));

                                params[filter] = '';

                                $.each(dataListout, function (i, val) {

                                    if (params[filter].length == 0) {
                                        params[filter] = val.id;
                                    } else {
                                        params[filter] += '-' + val.id;
                                    }
                                });
                                if (params[filter].length == 0) {
                                    delete params[filter];
                                }
                            });
                        });
                        var resource = "";
                        if ($scope.dataTableConfig.noPgnresource)
                            // used in case api returns just a list and not paginating
                            resource = $scope.dataTableConfig.noPgnresource;
                        else
                            resource = $scope.dataTableConfig.resource;
                        if (!$scope.saveState) {
                            //window.currentState[window.stateName]=params;
                        }
                        setTimeout(function () {
                            if ($scope.dataTableConfig.param) {
                                params[$scope.dataTableConfig.param[0].key] = $scope.dataTableConfig.param[0].value;
                            }
                            Restangular.all(resource).customGET("", params).then(function (resp) {

                                if (resp.data != null) {
                                    data.data = resp.data.content;
                                    data.recordsFiltered = resp.data.totalElements;
                                    data.recordsTotal = resp.data.totalElements;
                                }
                                else {
                                    data.data = [];
                                    data.recordsFiltered = 0;
                                    data.recordsTotal = 0;
                                }
                                callback(data);
                            });
                        }, 100);

                    },

                    lengthMenu: [2, 25, 50, 100],
                    pageLength: 2,
                    language: {
                        "lengthMenu": "_MENU_",
                        "info": translations.jp["Total"] + " _TOTAL_ " + translations.jp["Records"] + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + "_START_ " + " ~ " + "_END_" + translations.jp["Records From to"],
                        "infoEmpty": translations.jp["Total"] + " 0 " + translations.jp["Records"] + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + 0 + " ~ " + 0 + translations.jp["Records From to"],
                        "infoFiltered": "(filtered from _MAX_ total entries)",
                        "emptyTable": translations.jp["No matches found"],
                        "infoFiltered": "- filtered from _MAX_ records",
                        "zeroRecords": translations.jp["No matches found"],
                        "paginate": {
                            "first": "<<",
                            "last": ">>",
                            "next": ">",
                            "previous": "<"
                        }
                    },
                    pagingType: "full_numbers",
                    nameElementSuff: "-table",
                    stateSave: true,
                    processing: true,
                    serverSide: true,
                    dom: "<'row'<'col-md-1 col-sm-12'l><'col-md-11 col-sm-12'B<'table-group-actions pull-right'>>><'row'<'col-md-3 col-sm-12 text-right pull-right'i><'table-header't><'col-sm-12'p><'col-md-4 col-sm-12'>>",
                    //dom:'<"top pull-right"r>t<"bottom pagding-center"p><"clear">',
                    bSort: true,
                    sScrollY: height,
                    unEditedColumns: [0],
                    fnDrawCallback: function (nRow) {

                        if (nRow._iRecordsTotal <= nRow._iDisplayLength) {
                            $(".dataTables_paginate").hide();
                        } else {

                            if (nRow.aoData.length == 0 && this.fnPagingInfo().iTotalPages > 0) {



                            }
                        }
                    },
                    editHandler: function (id, isNewTab) {
                        var route = $scope.dataTableConfig.route + ".edit";
                        if ($scope.dataTableConfig.prefixRoute) {
                            route = $scope.dataTableConfig.prefixRoute + route;
                        }
                        if (isNewTab) {
                            var url = $state.href(route, { id: id });
                            window.open(url, '_blank');
                        }
                        else {
                            $state.go(route, { id: id });
                        }
                    },
                };
                var buttonsConfig = $scope.dataTableConfig.buttonsConfig;
                var buttons = [];
                var addButton = {
                    text: '<i class="fa fa-plus"></i> ' + "Thêm mới",
                    action: function (e, dt, node, config) {
                        var isValidated = true;
                        var validationMsg = "";

                        var data = {};
                        var columns = $scope.dataTableConfig.columns;
                        $state.go(buttonsConfig.add);
                    },
                    className: 'btn green'
                };
                var btnAction;

                var refreshButton = {
                    text: '<i class="fa fa-refresh"></i> ' + "Làm mới",
                    action: function (e, dt, node, config) {
                        dt.draw();
                    },
                    className: 'btn info'
                };
                if (buttonsConfig) {

                    if (buttonsConfig.add != false) {
                        buttons.push(addButton);
                    }
                    if (buttonsConfig.refresh != false) {
                        buttons.push(refreshButton);
                    }
                }
                else {
                    if (!$scope.dataTableConfig.buttons) {
                        buttons = [addButton, refreshButton];
                    }
                }
                defaultConfig.buttons = buttons;


                if ($scope.dataTableConfig.searchPlaceholder) {
                    $element.find('input.search-input').attr('placeholder', $scope.dataTableConfig.searchPlaceholder);
                }
                if ($scope.dataTableConfig.isMutilSelect) {
                    var firstcolumn = {
                        title: '<label class="mt-checkbox mt-checkbox-outline"><input class="select_all" name="select_all" type="checkbox" id="" value=""><span></span></label>',
                        defaultcontent: "123",

                        orderable: false,
                        className: "text-center",
                        render: function (url, type, full) {
                            if ($scope.ngModel) {
                                var index = -1;
                                var key;
                                if ($scope.key) {
                                    key = $scope.key;
                                }
                                else {
                                    key = "id";
                                }


                                //$.each($scope.ngModel, function (i, v) {
                                //    if (v[key] == full[key]) {
                                //        return index = i;
                                //    }
                                //})
                                if (index != -1) {
                                    return '<label class="mt-checkbox mt-checkbox-outline"><input class="rowcheck" checked name="rowCheck" type="checkbox" id="' + full[key] + '" value=""><span></span></label>';
                                }
                                else {
                                    return '<label class="mt-checkbox mt-checkbox-outline"><input class="rowcheck" name="rowCheck" type="checkbox" id="' + full[key] + '" value=""><span></span></label>';
                                }
                            } else {
                                return '<label class="mt-checkbox mt-checkbox-outline"><input class="rowcheck" name="rowCheck" type="checkbox" id="' + full[key] + '" value=""><span></span></label>';
                            }

                        }
                    }

                    $scope.dataTableConfig.columns.unshift(firstcolumn);
                }
                $scope.dataTableConfig = $.extend({}, defaultConfig, $scope.dataTableConfig);
                //callback create row
                $scope.dataTableConfig.createdRow = function (row, data, index) {

                    if ($scope.ngModel) {

                        var inde = -1;
                        var key;
                        if ($scope.key) {
                            key = $scope.key;
                        } else
                            key = "id";
                        $.each($scope.ngModel, function (i, v) {

                            if (v[key] == data[key]) {
                                return inde = i;
                            }
                        })
                        if (inde != -1) {
                            $(row).addClass('selected');
                        }
                    }
                    $compile(row)($scope);
                }
                $scope.dataTableConfig.fnRowCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                };

                var _that = this;
                var table = $element.find("table").first();
                this.dConfig = $scope.dataTableConfig;
                var nEditing = null;
                var nNew = false;

                $('.btn-edit').unbind('click');

                if ($scope.dataTableConfig.isInlineEdit == false) {

                    table.on('mousedown', '.btn-edit', function (event) {
                        var nRow = $(this).parents('tr')[0];
                        var data = table.dataTable().fnGetData(nRow);

                        if (event.which == 1) {
                            $scope.dataTableConfig.editHandler(data.id);
                        }

                        else if (event.which == 2) {
                            $scope.dataTableConfig.editHandler(data.id, true);
                        }
                    });

                } else
                    table.on('click', '.btn-edit', function (e) {
                        e.preventDefault();
                        nNew = false;
                        /* Get the row as a parent of the link that was clicked on */
                        var nRow = $(this).parents('tr')[0];
                        if (nEditing !== null && nEditing != nRow) {
                            /* Currently editing - but not this row - restore the old before continuing to edit mode */
                            restoreRow(table, nEditing);
                            editRow(table, nRow);
                            nEditing = nRow;
                        } else if (nEditing == nRow && this.innerHTML == tableTitles.save) {
                            /* Editing this row and want to save it */
                            saveRow(table, nEditing).then(
                                function (content) {
                                    toastr.success(tableTitles.successUpdateMessage);
                                    nEditing = null;
                                },
                                function (content) {
                                    if (content.validationMsg) {
                                        swal(validateMessages.ErrNotValidInput, content.validationMsg, 'warning');
                                    } else {
                                        toastr.error(tableTitles.errorMessage);
                                        nEditing = null;
                                    }
                                });
                        } else {
                            /* No edit in progress - let's start one */
                            editRow(table, nRow);
                            nEditing = nRow;
                        }
                    });

                $('.btn-edit').unbind('click');

                if ($scope.dataTableConfig.isInlineEdit == false) {

                    table.on('mousedown', '.btn-edit', function (event) {
                        var nRow = $(this).parents('tr')[0];
                        var data = table.dataTable().fnGetData(nRow);

                        if (event.which == 1) {
                            $scope.dataTableConfig.editHandler(data.id);
                        }

                        else if (event.which == 2) {
                            $scope.dataTableConfig.editHandler(data.id, true);
                        }
                    });

                } else
                    table.on('click', '.btn-info', function (e) {
                        e.preventDefault();
                        nNew = false;
                        /* Get the row as a parent of the link that was clicked on */
                        var nRow = $(this).parents('tr')[0];
                        if (nEditing !== null && nEditing != nRow) {
                            /* Currently editing - but not this row - restore the old before continuing to edit mode */
                            restoreRow(table, nEditing);
                            editRow(table, nRow);
                            nEditing = nRow;
                        } else if (nEditing == nRow && this.innerHTML == tableTitles.save) {
                            /* Editing this row and want to save it */
                            saveRow(table, nEditing).then(
                                function (content) {
                                    toastr.success(tableTitles.successUpdateMessage);
                                    nEditing = null;
                                },
                                function (content) {
                                    if (content.validationMsg) {
                                        swal(validateMessages.ErrNotValidInput, content.validationMsg, 'warning');
                                    } else {
                                        toastr.error(tableTitles.errorMessage);
                                        nEditing = null;
                                    }
                                });
                        } else {
                            /* No edit in progress - let's start one */
                            editRow(table, nRow);
                            nEditing = nRow;
                        }
                    });

                //This function handles the event of clicking 'remove' button

                table.on('click', '.btn-remove', function (e) {

                    e.preventDefault();

                    var nRow = $(this).parents('tr')[0];
                    swal({
                        title: tableTitles.deleteMessage,
                        text: "",
                        type: "warning",
                        allowOutsideClick: false,
                        showConfirmButton: true,
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        cancelButtonClass: "btn-default",
                        closeOnConfirm: false,
                        closeOnCancel: true,
                        confirmButtonText: tableTitles.delete,
                        cancelButtonText: tableTitles.cancel
                    },
                        function (isConfirm) {
                            if (isConfirm) {
                                deleteRow(table, nRow).then(function (response) {
                                    toastr.success(tableTitles.successDeleteMessage);
                                    table.fnDraw();
                                }, function (reject) {
                                    //toastr.error(tableTitles.errorMessage);
                                });
                                swal.close();
                            } else {
                                swal.close();
                            }
                        });
                });
                table.on('click', '.cancel', function (e) {
                    e.preventDefault();
                    if (nNew) {
                        table.fnDeleteRow(nEditing);
                        nEditing = null;
                        nNew = false;
                    } else {
                        table.fnDraw(false);
                        //restoreRow(table, nEditing);
                        nEditing = null;
                    }
                });
                table.on('click', '.btn-submit', function (e) {
                    addRow(table, nEditing).then(
                        function (content) {
                            toastr.success(tableTitles.successAddMessage);
                        },
                        function (content) {
                            table.fnDeleteRow(this);
                        });
                    nEditing = null;
                });



                $element.find(".search-button").click(function (e) {


                    $scope.dataTableInstance.fnDraw();
                });


                $element.find("input[filter='SearchString']").keypress(function (e) {
                    if (e.keyCode == 13) {
                        $scope.dataTableInstance.fnDraw();
                    }
                });

            },
            link: function ($scope, $element, $attrs, controller, $compile) {

                var init = function () {
                    var table;
                    $scope.dataTableInstance = $element.find("table").dataTable(controller.dConfig);
                    //$scope.dataTableInstance.fnDestroy();
                    //table = $element.find("table").DataTable(controller.dConfig);
                    controller.dataTableInstance = $scope.dataTableInstance;
                    $element.find(".select_all").click(function (e) {
                    });
                    $element.find('thead input[name="select_all"]', $scope.dataTableInstance.api().table().container()).on('click', function (e) {

                        if (this.checked) {
                            $element.find('tbody input[type="checkbox"]:not(:checked)').trigger('click');
                        } else {
                            $element.find('tbody input[type="checkbox"]:checked').trigger('click');
                        }
                        // Prevent click event from propagating to parent



                        e.stopPropagation();
                    });

                    function updateDataTableSelectAllCtrl(table) {

                        var $table = $scope.dataTableInstance.api().table().node();
                        var $chkbox_all = $element.find('tbody input[type="checkbox"]', $table);
                        var $chkbox_checked = $('tbody input[type="checkbox"]:checked', $table);
                        var chkbox_select_all = $('thead input[type=checkbox]', $table).get(0);
                        // If none of the checkboxes are checked
                        if ($chkbox_checked.length === 0) {
                            chkbox_select_all.checked = false;
                            if ('indeterminate' in chkbox_select_all) {
                                chkbox_select_all.indeterminate = false;
                            }
                            // If all of the checkboxes are checked
                        } else if ($chkbox_checked.length === $chkbox_all.length) {
                            setTimeout(function () {
                                $($($('thead')[0]).find('th').get(0)).find('input:not(:checked)').trigger('click');
                            }, 100)


                            // If some of the checkboxes are checked
                        } else {
                            $($($('thead')[0]).find('th').get(0)).find('input:checked').attr("checked", false);
                        }
                        //if (this.checked) {
                        //    $row.addClass('selected');
                        //    $input.removeAttr('disabled');
                        //    $input.removeAttr('title');

                        //} else {

                        //    $row.removeClass('selected');
                        //    $input.attr('disabled', '');
                        //    $input.attr('');

                        //}
                    }

                    $element.find('tbody').on('click', 'input[name="rowCheck"]', function (e) {

                        var rows_selected = [];
                        var $row = $(this).closest('tr');
                        var $input = $row.find('input[type="number"]');

                        // Get row data
                        var data = $scope.dataTableInstance.api().row($row).data();

                        data.soluong = $input.val();
                        // Determine whether row ID is in the list of selected row IDs
                        var index = -1;

                        if ($scope.ngModel.length > 0) {
                            var key;
                            $.each($scope.ngModel, function (i, v) {
                                if ($scope.key != null && $scope.key != undefined) {
                                    key = $scope.key;
                                } else
                                    key = "id";
                                if ($scope.ngModel[i][key] == data[key]) {
                                    index = i;
                                    return false;
                                }
                            })
                        }
                        // If checkbox is checked and row ID is not in list of selected row IDs
                        if (this.checked && index === -1) {
                            $scope.ngModel.push(data);

                            // Otherwise, if checkbox is not checked and row ID is in list of selected row IDs
                        } else if (!this.checked && index !== -1) {
                            $scope.ngModel.splice(index, 1);
                        }
                        //if ($(this).child().closest('input[name="rowCheck"]').is(':checked')) {
                        if (this.checked) {
                            $row.addClass('selected');
                            $input.removeAttr('disabled');
                            $input.removeAttr('title');

                        } else {

                            $row.removeClass('selected');
                            $input.attr('disabled', '');
                            $input.attr('');

                        }

                        // Update state of "Select all" control
                        updateDataTableSelectAllCtrl(table);

                        // Prevent click event from propagating to parent
                        e.stopPropagation();

                        $scope.$apply();

                    });


                    $element.find('tbody').on('focusout', 'input[type="number"]', function () {

                        var quantity = $(this).val();
                        var $row = $(this).closest('tr');
                        var data = table.row($row).data();
                        $.each($scope.ngModel, function (i, v) {
                            if ($scope.ngModel[i].id == data.id) {
                                $scope.ngModel[i].soluong = quantity;
                            }
                        });

                    });
                    $('.disabled').click(function () {

                        return false;
                    })
                    //$element.find(".search-button").click(function (e) {
                    //    $scope.dataTableInstance.fnDraw();
                    //});
                    $element.find(".filter-region select").change(function (e) {
                        $scope.dataTableInstance.fnDraw();
                    });
                    $element.find(".filter-region input").on('keypress', function (e) {

                        if (e.keyCode == 13) {
                            $scope.dataTableInstance.fnDraw();
                        }

                    });
                    $element.find(".filter-region input").map(function (index, value) {

                        if (value.hasAttribute("jqdatepicker")) {
                            $(value).on('change', function (e) {
                                $scope.dataTableInstance.fnDraw();
                            });
                        }
                    })
                    $element.find(".filter-date-time-button").click(function (e) {

                        $scope.dataTableInstance.fnDraw();
                    });
                    $element.find(".clear-date-time-button").click(function (e) {
                        $(this).parents().find('.bs-datetime').find('.bs-date').val("");

                        $scope.dataTableInstance.fnDraw();
                    });
                    $element.find(".filter-region input:checkbox").change(function (e) {
                        //$scope.dataTableInstance.fnDraw();
                    });


                }

                window.setTimeout(init, 200);

                $scope.$watch('reload', function (newVal, oldVal) {
                    if ($scope.reload) {
                        if (newVal != undefined && newVal != 1) {

                            $scope.dataTableInstance.fnDraw(false);
                        }
                    }
                })
            }
        };
    })
})();
(function () {
    "use strict";

    angular.module("MyApp").directive('tmdtForm', function ($compile, $q) {
        return {
            restrict: 'A',
            scope: {
                validationForm:"=?",
                createFunc: "&",
                updateFunc: "&",
                deleteFunc: "&",
                cancelFunc: "&",
                showFunc: "&",
                hideFunc: "&",
                editFunc: "&",
                registrationStaffFunc: "&",
            },
            controller: function ($scope, $element, $state, Restangular, $rootScope) {

            },
            link: function ($scope, $element, $attrs, controller, $rootScope) {
              var validation = {
                rules: {},
                messages: {}
              }
                //Cấu hình validation cho form dựa vào attributes của các input, select, textarea
              setTimeout(function () {
                  $element.attr('novalidate', ' ');
                  $element.find(".form-group").find("input,select,textarea").each(function (i, e) {

                      if ($(e).attr("type") == "text") {
                          $(e).val().trim();
                      }

                      var name = e.getAttribute("name");
                      if (name == null) {
                          name = e.getAttribute("ng-model");
                          if (name != null) $(e).attr("name", name);
                      }

                      if (!validation.rules[name]) {
                          validation.rules[name] = {};
                      }

                      if (!validation.messages[name]) {
                          validation.messages[name] = {};
                      }

                      if (e.hasAttribute("siten-maxlength")) {
                          validation.rules[name].maxlength = parseInt(e.getAttribute("siten-maxlength"));
                          validation.messages[name].maxlength = "Giá trị nhập vào không được vượt quá " + e.getAttribute("siten-maxlength") + " kí tự";
                      }
                      // frima-length
                      if (e.hasAttribute("frima-maxlength")) {
                        validation.rules[name].maxlength = parseInt(e.getAttribute("frima-maxlength"));
                        validation.messages[name].maxlength = "256文字以内で入力してください。";
                    }

                    
                      if (e.hasAttribute('frima-email')) {
                          validation.rules[name].sitenEmail = true;
                          validation.messages[name].sitenEmail = "電子メールが正しくフォーマットされていません。"
                      }
                      

                     
                      if (e.hasAttribute("checkScript")) {
                          validation.rules[name].checkScript = true;
                          validation.messages[name].checkScript = "に無効な文字が含まれています。";
                      }
                     
                     

                    
                      if (e.hasAttribute("frima-required")) {
                        validation.rules[name].required = true;
                        validation.messages[name].required = "必須項目を入力して下さい。";
                        if (e.hasAttribute("frima-required-ms")) {
                            validation.messages[name].required = $(e).attr("frima-required-ms");
                        }
                    }
                     
                     

                    

                      // frima-minlength
                      if (e.hasAttribute("frima-minlength")) {
                        validation.rules[name].minlength = e.getAttribute("frima-minlength");
                        validation.messages[name].minlength = "半角英数記号のみ8文字以上で入力してください。";
                    }


                  });

                  $scope.validator = myApp.validateForm($element, validation);
                  $scope.validationForm = $scope.validator;


                  
                  $element.delegate("button-add", "click", function (e) {
                      if ($scope.validator.form()) {

                          $scope.createFunc();
                      }
                  });
               
                  $element.delegate("button-add-staff", "click", function (e) {
                    if ($scope.validator.form()) {

                        $scope.createFunc();
                    }
                    
                });
                $element.delegate("button-update-staff", "click", function (e) {
                    if ($scope.validator.form()) {
                        $scope.updateFunc();
                    }
                    
                });
                $element.delegate("button-registration-staff", "click", function (e) {
                        $scope.registrationStaffFunc();
    
                });
                $element.delegate("button-confirm-add", "click", function (e) {
                    if ($scope.validator.form()) {

                        $scope.createFunc();
                    }
                    
                });
                $element.delegate("button-confirm-update", "click", function (e) {
                    if ($scope.validator.form()) {

                        $scope.updateFunc();
                    }
                    
                });

                  $element.delegate("button-save", "click", function (e) {
                      if ($scope.validator.form()) {
                          $scope.updateFunc();
                      }
                  });

                  $element.delegate("button-delete", "click", function (e) {
                      $scope.deleteFunc();
                  });

                  $element.delegate("button-cancel", "click", function (e) {
                      $scope.cancelFunc();
                  });
                  $element.delegate("button-show", "click", function (e) {
                      $scope.showFunc();
                  });
                  $element.delegate("button-hide", "click", function (e) {
                      $scope.hideFunc();
                  });
                  $element.delegate("button-go-edit", "click", function (e) {
                      $scope.editFunc();
                  });
              }, 500);

              //Khởi tạo validator

            }
        }
    });
})();

(function () {
    "use strict";

    angular.module("MyApp").directive('bootstrapSwitch', function ($compile, $q) {
        return {
            restrict: 'A',
            scope: {
                ngModel: '=',
                changeFunc:'&'
            },
            template: '',
            controller: function ($scope, $element, $state, Restangular, $rootScope) {

            },
            link: function ($scope, $element, $attrs, controller, $rootScope) {

                    let state = false;
                    if ($scope.ngModel) {
                        state = true;
                    }

                    $element.bootstrapSwitch(
                        {
                            size: 'small',
                            wrapperClass: 'heightSmall',
                            state: state
                        }
                    );
                    $element.on('switchChange.bootstrapSwitch', function (event, state) {

                        $scope.ngModel = state;
                        let name = event.currentTarget.name;
                        if ($scope.changeFunc) {
                            $scope.changeFunc({ name:name, state:state });
                        }
                        //$scope.$apply();
                    });


                $scope.$watch('ngModel', function (newval, oldVal) {
                    if (newval != oldVal) {
                        if (newval== true || newval == false)
                        $element.bootstrapSwitch('state', newval);
                    }
                })
            }
        }
    });
})();

(function () {
    "use strict";

    angular.module("MyApp").directive('summernote1', function ($compile, $q) {
        return {
            restrict: 'A',
            scope: {
                ngModel: '='
            },
            link: function ($scope, $element, $attrs) {

                //install editor
                $element.summernote({
                    minHeight: 300,
                    focus: true,
                    callbacks: {
                        onChange: change
                    }
                });

                function change(contents, $editable) {

                    $scope.ngModel = contents;
                    _.defer(function () {
                        $scope.$apply();
                    });


                    if ($element.closest('.form-group').hasClass('has-error')) {

                        let check = checkTrimString(contents);
                        var name = $element.attr('name');

                        if (check) {

                            $element.siblings('#' + name + '-error').hide();
                            $element.closest('.form-group').removeClass('has-error');


                        }
                    }
                }

                setTimeout(function () {
                    $element.summernote('code', $scope.ngModel);
                }, 500);

                function checkTrimString(value) {

                    if ($.trim(value) != '') {
                        if (value != '<p><br></p>') {
                            var arrText = value.split('<');
                            var inputText = '';

                            $.each(arrText, function (index, value) {

                                if (value.search('>') != -1) {
                                    inputText += value.split('>')[1];
                                } else {
                                    inputText += value;
                                }
                            });

                            inputText = $.trim(inputText.replace(/<br>|&nbsp;|<p><br><(\/)p>|<p>|<(\/)p>/g, ''));

                            if (inputText == "") {

                                return false;
                            } else {

                                return true;
                            }
                        }
                    } else {
                        return false;
                    }
                }
            }
        }
    });

})();

(function () {
  "use strict";

  angular.module("MyApp").directive('select2Promise', function ($compile, $q, Restangular) {

    return {
      restrict: 'A',
      scope: {
        search: '@',
        width: '@',
        boostrapClass: '@',
        placeholder: '@',
        clear: '@',
        getData: '&',
        keyToText: '@',
        selectall: '@',
        ngModel: '=?',
        templateResult: '=',
        level: '@',
        multiple: '@',
        select: '&',
        unselect: '&',
        old_values: '=',
        dataSelected: '<',
        key: '@',
        bindData: "=",
        templateSelection: '=',
        update: '=?',
        selectallvalue: '@'
      },
      template: '<option value=""></option>',
      link: function ($scope, $element, $attrs) {

        var init = function () {
          if ($scope.bindData) {
            let data = [];
            $.each($scope.bindData, (i, v) => {
              data.push(v[$scope.key]);
            })

            $scope.old = data;
          } else
            $scope.old = [];

          $scope.getData().then(function (data) {

            // option select2 default
            var optDefault = {};
            optDefault.minimumResultsForSearch = Infinity; // hidding search box
            optDefault.allowClear = false;
            // option select2 custom
            var optCustom = {};
            if ($scope.search != undefined) {
              optCustom.minimumResultsForSearch = true;
            }
            var all = [{ id: "" }];
            if ($scope.selectall != undefined) {
              $element.find('option:first').remove();
              if ($scope.selectallvalue) {
                all[0].name = $scope.selectallvalue;
              } else { all[0].name = "All"; }


              all[0].id = "all";
            } else {
              if ($scope.placeholder != undefined) {

                optCustom.placeholder = $scope.placeholder;
              } else {
                optCustom.placeholder = "Choose";
              }
            }
            //merge option default with custom
            data = all.concat(data);
            // conver key field to text
            if ($scope.keyToText != undefined) {
              optCustom.data = data.map(function (item) {
                item.text = item[$scope.keyToText];
                return item;
              });
            } else {
              optCustom.data = data.map(function (item) {
                var level = "";
                if ($scope.level) {
                  switch (item.level) {
                    case 0:
                      level = ""
                      break;
                    case 1:
                      level = "----"
                      break;
                    case 2:
                      level = "---------";
                      break;
                    default:
                      level = "";
                  }
                  item.text = level + myApp.trimContent(item.name);
                }
                else {
                  item.text = myApp.trimContent(item.name);
                }
                return item;
              });
            }
            if ($scope.clear != undefined) {
              optCustom.allowClear = true;
            }
            // Merge OptCustom into OptDefault, recursively
            var option = $.extend(true, optDefault, optCustom);
            option.escapeMarkup = function (markup) {
              return markup;
            }
            if ($scope.templateResult != undefined) {

              option.templateResult = $scope.templateResult;

            }
            if ($scope.templateSelection != undefined) {

              option.templateSelection = $scope.templateSelection;
            }

            option.language = {
              noResults: function (params) {
                return "Not found!";
              }
            }
            if ($scope.boostrapClass) {
              option.theme = "bootstrap";
              option.containerCssClass = ':all:';
            }
            if ($scope.width) {
              option.width = $scope.width;
            }

            $element.select2(option).on('change', function (data) {

              if ($scope.multiple) {
                let scope = this.scope;
                let newVal = $element.val();
                if (newVal == null) {
                  newVal = [];
                }
                if (newVal.length > 0) newVal.sort();
                let oldVal = scope.old;
                if (oldVal.length > 0) {
                  oldVal = scope.old.toString().split(",");
                  oldVal.sort();
                }
                if (oldVal == null) {
                  oldVal = [];
                }
                let addValue = $(newVal).not(oldVal).get()[0];
                let subValue = $(oldVal).not(newVal).get()[0];


                if (newVal.length >= oldVal.length) {
                  if (addValue)
                    $scope.select({ id: parseInt(addValue) });
                }
                if (oldVal.length > newVal.length) {
                  $scope.unselect({ id: subValue });
                }
              }

            }.bind({
              scope: $scope
            }));

            setTimeout(() => {
              if ($scope.bindData) {
                let data = [];
                $.each($scope.bindData, (i, v) => {
                  data.push(v[$scope.key]);
                })
                $element.val(data).trigger('change');
              }
            }, 1000);



            $element.on('select2:select', (event) => {
              if ($element.val() != "") {
                $scope.old = $element.val();
              }


              event.preventDefault();

            });

            $element.on('select2:unselecting', (data, choice) => {
              if ($element.val() != "")
                $scope.old = $element.val();
              event.preventDefault();

            });

            

            $scope.$watch('ngModel', function (newVal, oldVal) {

              if (newVal != undefined) {
                window.setTimeout(function () {

                  $element.val($scope.ngModel).trigger('change');
                  if (newVal != '') {
                    var name = $element.attr('name');
                    $element.siblings('.help-block.help-block-error').remove();
                    $element.closest('.form-group').removeClass('has-error');

                  }
                }, 300);
              }
            });

            $element.find('option:first').remove();

          });
        }

       
        init();
     
        $scope.$watch('update', (newVal, oldVal) => {

          if (newVal != undefined && oldVal != undefined) {
            $element.empty();
            init();
          }

        }, true);

      }
    }
  });
})();

/* 
 * Angular JS Multi Select
 * Creates a dropdown-like button with checkboxes. 
 *
 * Project started on: Tue, 14 Jan 2014 - 5:18:02 PM
 * Current version: 4.0.0
 * 
 * Released under the MIT License
 * --------------------------------------------------------------------------------
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Ignatius Steven (https://github.com/isteven)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy 
 * of this software and associated documentation files (the "Software"), to deal 
 * in the Software without restriction, including without limitation the rights 
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell 
 * copies of the Software, and to permit persons to whom the Software is 
 * furnished to do so, subject to the following conditions: 
 *
 * The above copyright notice and this permission notice shall be included in all 
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR 
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, 
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE 
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER 
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, 
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE 
 * SOFTWARE.
 * --------------------------------------------------------------------------------
 */

'use strict'

angular.module( 'isteven-multi-select', ['ng'] ).directive( 'istevenMultiSelect' , [ '$sce', '$timeout', '$templateCache', function ( $sce, $timeout, $templateCache ) {
    return {
        restrict: 
            'AE',

        scope: 
        {   
            // models
            inputModel      : '=',
            outputModel     : '=',

            // settings based on attribute
            isDisabled      : '=',

            // callbacks
            onClear         : '&',  
            onClose         : '&',
            onSearchChange  : '&',  
            onItemClick     : '&',            
            onOpen          : '&', 
            onReset         : '&',  
            onSelectAll     : '&',  
            onSelectNone    : '&',  

            // i18n
            translation     : '='   
        },
        
        /* 
         * The rest are attributes. They don't need to be parsed / binded, so we can safely access them by value.
         * - buttonLabel, directiveId, helperElements, itemLabel, maxLabels, orientation, selectionMode, minSearchLength,
         *   tickProperty, disableProperty, groupProperty, searchProperty, maxHeight, outputProperties
         */
                                                         
         templateUrl: 
            'isteven-multi-select.htm',                            

        link: function ( $scope, element, attrs ) {                       

            $scope.backUp           = [];
            $scope.varButtonLabel   = '';               
            $scope.spacingProperty  = '';
            $scope.indexProperty    = '';                        
            $scope.orientationH     = false;
            $scope.orientationV     = true;
            $scope.filteredModel    = [];
            $scope.inputLabel       = { labelFilter: '' };                        
            $scope.tabIndex         = 0;            
            $scope.lang             = {};
            $scope.helperStatus     = {
                all     : true,
                none    : true,
                reset   : true,
                filter  : true
            };

            var 
                prevTabIndex        = 0,
                helperItems         = [],
                helperItemsLength   = 0,
                checkBoxLayer       = '',
                scrolled            = false,
                selectedItems       = [],
                formElements        = [],
                vMinSearchLength    = 0,
                clickedItem         = null                

            // v3.0.0
            // clear button clicked
            $scope.clearClicked = function( e ) {                
                $scope.inputLabel.labelFilter = '';
                $scope.updateFilter();
                $scope.select( 'clear', e );                
            }

            // A little hack so that AngularJS ng-repeat can loop using start and end index like a normal loop
            // http://stackoverflow.com/questions/16824853/way-to-ng-repeat-defined-number-of-times-instead-of-repeating-over-array
            $scope.numberToArray = function( num ) {
                return new Array( num );   
            }

            // Call this function when user type on the filter field
            $scope.searchChanged = function() {                                                
                if ( $scope.inputLabel.labelFilter.length < vMinSearchLength && $scope.inputLabel.labelFilter.length > 0 ) {
                    return false;
                }                
                $scope.updateFilter();
            }

            $scope.updateFilter = function()
            {      
                // we check by looping from end of input-model
                $scope.filteredModel = [];
                var i = 0;

                if ( typeof $scope.inputModel === 'undefined' ) {
                    return false;                   
                }

                for( i = $scope.inputModel.length - 1; i >= 0; i-- ) {

                    // if it's group end, we push it to filteredModel[];
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === false ) {
                        $scope.filteredModel.push( $scope.inputModel[ i ] );
                    }
                    
                    // if it's data 
                    var gotData = false;
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] === 'undefined' ) {                        
                        
                        // If we set the search-key attribute, we use this loop. 
                        if ( typeof attrs.searchProperty !== 'undefined' && attrs.searchProperty !== '' ) {

                            for (var key in $scope.inputModel[ i ]  ) {
                                if ( 
                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0                                     
                                    && attrs.searchProperty.indexOf( key ) > -1
                                ) {
                                    gotData = true;
                                    break;
                                }
                            }                        
                        }
                        // if there's no search-key attribute, we use this one. Much better on performance.
                        else {
                            for ( var key in $scope.inputModel[ i ]  ) {
                                if ( 
                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0                                     
                                ) {
                                    gotData = true;
                                    break;
                                }
                            }                        
                        }

                        if ( gotData === true ) {    
                            // push
                            $scope.filteredModel.push( $scope.inputModel[ i ] );
                        }
                    }

                    // if it's group start
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === true ) {

                        if ( typeof $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] !== 'undefined' 
                                && $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] === false ) {
                            $scope.filteredModel.pop();
                        }
                        else {
                            $scope.filteredModel.push( $scope.inputModel[ i ] );
                        }
                    }
                }                

                $scope.filteredModel.reverse();  
                
                $timeout( function() {                    

                    $scope.getFormElements();               
                    
                    // Callback: on filter change                      
                    if ( $scope.inputLabel.labelFilter.length > vMinSearchLength ) {

                        var filterObj = [];

                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' ) {                   
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                                                    
                                    var tempObj = angular.copy( value );
                                    var index = filterObj.push( tempObj );                                
                                    delete filterObj[ index - 1 ][ $scope.indexProperty ];
                                    delete filterObj[ index - 1 ][ $scope.spacingProperty ];      
                                }
                            }
                        });

                        $scope.onSearchChange({ 
                            data: 
                            {
                                keyword: $scope.inputLabel.labelFilter, 
                                result: filterObj 
                            } 
                        });
                    }
                },0);
            };

            // List all the input elements. We need this for our keyboard navigation.
            // This function will be called everytime the filter is updated. 
            // Depending on the size of filtered mode, might not good for performance, but oh well..
            $scope.getFormElements = function() {                                     
                formElements = [];

                var 
                    selectButtons   = [],
                    inputField      = [],
                    checkboxes      = [],
                    clearButton     = [];
                
                // If available, then get select all, select none, and reset buttons
                if ( $scope.helperStatus.all || $scope.helperStatus.none || $scope.helperStatus.reset ) {                                                       
                    selectButtons = element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );                    
                    // If available, then get the search box and the clear button
                    if ( $scope.helperStatus.filter ) {                                            
                        // Get helper - search and clear button. 
                        inputField =    element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'input' );                    
                        clearButton =   element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'button' );                        
                    }
                }
                else {
                    if ( $scope.helperStatus.filter ) {   
                        // Get helper - search and clear button. 
                        inputField =    element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'input' );                    
                        clearButton =   element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );
                    }
                }
               
                // Get checkboxes
                if ( !$scope.helperStatus.all && !$scope.helperStatus.none && !$scope.helperStatus.reset && !$scope.helperStatus.filter ) {
                    checkboxes = element.children().children().next()[ 0 ].getElementsByTagName( 'input' );
                }
                else {
                    checkboxes = element.children().children().next().children().next()[ 0 ].getElementsByTagName( 'input' );
                }

                // Push them into global array formElements[] 
                for ( var i = 0; i < selectButtons.length ; i++ )   { formElements.push( selectButtons[ i ] );  }
                for ( var i = 0; i < inputField.length ; i++ )      { formElements.push( inputField[ i ] );     }
                for ( var i = 0; i < clearButton.length ; i++ )     { formElements.push( clearButton[ i ] );    }
                for ( var i = 0; i < checkboxes.length ; i++ )      { formElements.push( checkboxes[ i ] );     }                                
            }            

            // check if an item has attrs.groupProperty (be it true or false)
            $scope.isGroupMarker = function( item , type ) {
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === type ) return true; 
                return false;
            }

            $scope.removeGroupEndMarker = function( item ) {
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) return false; 
                return true;
            }                       

            // call this function when an item is clicked
            $scope.syncItems = function( item, e, ng_repeat_index ) {                                      

                e.preventDefault();
                e.stopPropagation();

                // if the directive is globaly disabled, do nothing
                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {                                        
                    return false;
                }

                // if item is disabled, do nothing
                if ( typeof attrs.isDisabled !== 'undefined' && $scope.isDisabled === true ) {                        
                    return false;
                }                                

                // if end group marker is clicked, do nothing
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) {
                    return false;
                }                

                var index = $scope.filteredModel.indexOf( item );       

                // if the start of group marker is clicked ( only for multiple selection! )
                // how it works:
                // - if, in a group, there are items which are not selected, then they all will be selected
                // - if, in a group, all items are selected, then they all will be de-selected                
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === true ) {                                  

                    // this is only for multiple selection, so if selection mode is single, do nothing
                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                        return false;
                    }
                    
                    var i,j,k;
                    var startIndex = 0;
                    var endIndex = $scope.filteredModel.length - 1;
                    var tempArr = [];

                    // nest level is to mark the depth of the group.
                    // when you get into a group (start group marker), nestLevel++
                    // when you exit a group (end group marker), nextLevel--
                    var nestLevel = 0;                    

                    // we loop throughout the filtered model (not whole model)
                    for( i = index ; i < $scope.filteredModel.length ; i++) {  

                        // this break will be executed when we're done processing each group
                        if ( nestLevel === 0 && i > index ) 
                        {
                            break;
                        }
                    
                        if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === true ) {
                            
                            // To cater multi level grouping
                            if ( tempArr.length === 0 ) {
                                startIndex = i + 1; 
                            }                            
                            nestLevel = nestLevel + 1;
                        }                                                

                        // if group end
                        else if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === false ) {

                            nestLevel = nestLevel - 1;                            

                            // cek if all are ticked or not                            
                            if ( tempArr.length > 0 && nestLevel === 0 ) {                                

                                var allTicked = true;       

                                endIndex = i;

                                for ( j = 0; j < tempArr.length ; j++ ) {                                
                                    if ( typeof tempArr[ j ][ $scope.tickProperty ] !== 'undefined' &&  tempArr[ j ][ $scope.tickProperty ] === false ) {
                                        allTicked = false;
                                        break;
                                    }
                                }                                                                                    

                                if ( allTicked === true ) {
                                    for ( j = startIndex; j <= endIndex ; j++ ) {
                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
                                            if ( typeof attrs.disableProperty === 'undefined' ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
                                            }
                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
                                            }
                                        }
                                    }                                
                                }

                                else {
                                    for ( j = startIndex; j <= endIndex ; j++ ) {
                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
                                            if ( typeof attrs.disableProperty === 'undefined' ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;                                                
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;

                                            }                                            
                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;
                                            }
                                        }
                                    }                                
                                }                                                                                    
                            }
                        }
            
                        // if data
                        else {                            
                            tempArr.push( $scope.filteredModel[ i ] );                                                                                    
                        }
                    }                                 
                }

                // if an item (not group marker) is clicked
                else {

                    // If it's single selection mode
                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                        
                        // first, set everything to false
                        for( i=0 ; i < $scope.filteredModel.length ; i++) {                            
                            $scope.filteredModel[ i ][ $scope.tickProperty ] = false;                            
                        }        
                        for( i=0 ; i < $scope.inputModel.length ; i++) {                            
                            $scope.inputModel[ i ][ $scope.tickProperty ] = false;                            
                        }        
                        
                        // then set the clicked item to true
                        $scope.filteredModel[ index ][ $scope.tickProperty ] = true;                                                                 
                    }   

                    // Multiple
                    else {
                        $scope.filteredModel[ index ][ $scope.tickProperty ]   = !$scope.filteredModel[ index ][ $scope.tickProperty ];
                    }

                    // we refresh input model as well
                    var inputModelIndex = $scope.filteredModel[ index ][ $scope.indexProperty ];                                        
                    $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = $scope.filteredModel[ index ][ $scope.tickProperty ];                    
                }                                  

                // we execute the callback function here
                clickedItem = angular.copy( item );                                                    
                if ( clickedItem !== null ) {                        
                    $timeout( function() {
                        delete clickedItem[ $scope.indexProperty ];
                        delete clickedItem[ $scope.spacingProperty ];      
                        $scope.onItemClick( { data: clickedItem } );
                        clickedItem = null;                    
                    }, 0 );                                                 
                }                                    
                
                $scope.refreshOutputModel();
                $scope.refreshButton();                              

                // We update the index here
                prevTabIndex = $scope.tabIndex;
                $scope.tabIndex = ng_repeat_index + helperItemsLength;
                                
                // Set focus on the hidden checkbox 
                e.target.focus();

                // set & remove CSS style
                $scope.removeFocusStyle( prevTabIndex );
                $scope.setFocusStyle( $scope.tabIndex );

                if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                    // on single selection mode, we then hide the checkbox layer
                    $scope.toggleCheckboxes( e );       
                }
            }     

            // update $scope.outputModel
            $scope.refreshOutputModel = function() {            
                
                $scope.outputModel  = [];
                var 
                    outputProps     = [],
                    tempObj         = {};

                // v4.0.0
                if ( typeof attrs.outputProperties !== 'undefined' ) {                    
                    outputProps = attrs.outputProperties.split(' ');                
                    angular.forEach( $scope.inputModel, function( value, key ) {                    
                        if ( 
                            typeof value !== 'undefined' 
                            && typeof value[ attrs.groupProperty ] === 'undefined' 
                            && value[ $scope.tickProperty ] === true 
                        ) {
                            tempObj         = {};
                            angular.forEach( value, function( value1, key1 ) {                                
                                if ( outputProps.indexOf( key1 ) > -1 ) {                                                                         
                                    tempObj[ key1 ] = value1;                                    
                                }
                            });
                            var index = $scope.outputModel.push( tempObj );                                                               
                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];                                      
                        }
                    });         
                }
                else {
                    angular.forEach( $scope.inputModel, function( value, key ) {                    
                        if ( 
                            typeof value !== 'undefined' 
                            && typeof value[ attrs.groupProperty ] === 'undefined' 
                            && value[ $scope.tickProperty ] === true 
                        ) {
                            var temp = angular.copy( value );
                            var index = $scope.outputModel.push( temp );                                                               
                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];                                      
                        }
                    });         
                }
            }

            // refresh button label
            $scope.refreshButton = function() {

                $scope.varButtonLabel   = '';                
                var ctr                 = 0;                  

                // refresh button label...
                if ( $scope.outputModel.length === 0 ) {
                    // https://github.com/isteven/angular-multi-select/pull/19                    
                    $scope.varButtonLabel = $scope.lang.nothingSelected;
                }
                else {                
                    var tempMaxLabels = $scope.outputModel.length;
                    if ( typeof attrs.maxLabels !== 'undefined' && attrs.maxLabels !== '' ) {
                        tempMaxLabels = attrs.maxLabels;
                    }

                    // if max amount of labels displayed..
                    if ( $scope.outputModel.length > tempMaxLabels ) {
                        $scope.more = true;
                    }
                    else {
                        $scope.more = false;
                    }                
                    
                    angular.forEach( $scope.inputModel, function( value, key ) {
                        if ( typeof value !== 'undefined' && value[ attrs.tickProperty ] === true ) {                        
                            if ( ctr < tempMaxLabels ) {                            
                                $scope.varButtonLabel += ( $scope.varButtonLabel.length > 0 ? '</div>, <div class="buttonLabel">' : '<div class="buttonLabel">') + $scope.writeLabel( value, 'buttonLabel' );
                            }
                            ctr++;
                        }
                    });                

                    if ( $scope.more === true ) {
                        // https://github.com/isteven/angular-multi-select/pull/16
                        if (tempMaxLabels > 0) {
                            $scope.varButtonLabel += ', ... ';
                        }
                        $scope.varButtonLabel += '(' + $scope.outputModel.length + ')';                        
                    }
                }
                $scope.varButtonLabel = $sce.trustAsHtml( $scope.varButtonLabel + '<span class="caret"></span>' );                
            }

            // Check if a checkbox is disabled or enabled. It will check the granular control (disableProperty) and global control (isDisabled)
            // Take note that the granular control has higher priority.
            $scope.itemIsDisabled = function( item ) {
                
                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {                                        
                    return true;
                }
                else {             
                    if ( $scope.isDisabled === true ) {                        
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                
            }

            // A simple function to parse the item label settings. Used on the buttons and checkbox labels.
            $scope.writeLabel = function( item, type ) {
                
                // type is either 'itemLabel' or 'buttonLabel'
                var temp    = attrs[ type ].split( ' ' );                    
                var label   = '';                

                angular.forEach( temp, function( value, key ) {                    
                    item[ value ] && ( label += '&nbsp;' + value.split( '.' ).reduce( function( prev, current ) {
                        return prev[ current ]; 
                    }, item ));        
                });
                
                if ( type.toUpperCase() === 'BUTTONLABEL' ) {                    
                    return label;
                }
                return $sce.trustAsHtml( label );
            }                                

            // UI operations to show/hide checkboxes based on click event..
            $scope.toggleCheckboxes = function( e ) {                                    
                
                // We grab the button
                var clickedEl = element.children()[0];

                // Just to make sure.. had a bug where key events were recorded twice
                angular.element( document ).off( 'click', $scope.externalClickListener );
                angular.element( document ).off( 'keydown', $scope.keyboardListener );        

                // The idea below was taken from another multi-select directive - https://github.com/amitava82/angular-multiselect 
                // His version is awesome if you need a more simple multi-select approach.                                

                // close
                if ( angular.element( checkBoxLayer ).hasClass( 'show' )) {                         

                    angular.element( checkBoxLayer ).removeClass( 'show' );                    
                    angular.element( clickedEl ).removeClass( 'buttonClicked' );                    
                    angular.element( document ).off( 'click', $scope.externalClickListener );
                    angular.element( document ).off( 'keydown', $scope.keyboardListener );                                    

                    // clear the focused element;
                    $scope.removeFocusStyle( $scope.tabIndex );
                    if ( typeof formElements[ $scope.tabIndex ] !== 'undefined' ) {
                        formElements[ $scope.tabIndex ].blur();
                    }

                    // close callback
                    $timeout( function() {
                        $scope.onClose();
                    }, 0 );

                    // set focus on button again
                    element.children().children()[ 0 ].focus();
                } 
                // open
                else                 
                {    
                    // clear filter
                    $scope.inputLabel.labelFilter = '';                
                    $scope.updateFilter();                                

                    helperItems = [];
                    helperItemsLength = 0;

                    angular.element( checkBoxLayer ).addClass( 'show' );
                    angular.element( clickedEl ).addClass( 'buttonClicked' );       

                    // Attach change event listener on the input filter. 
                    // We need this because ng-change is apparently not an event listener.                    
                    angular.element( document ).on( 'click', $scope.externalClickListener );
                    angular.element( document ).on( 'keydown', $scope.keyboardListener );  

                    // to get the initial tab index, depending on how many helper elements we have. 
                    // priority is to always focus it on the input filter                                                                
                    $scope.getFormElements();
                    $scope.tabIndex = 0;

                    var helperContainer = angular.element( element[ 0 ].querySelector( '.helperContainer' ) )[0];                
                    
                    if ( typeof helperContainer !== 'undefined' ) {
                        for ( var i = 0; i < helperContainer.getElementsByTagName( 'BUTTON' ).length ; i++ ) {
                            helperItems[ i ] = helperContainer.getElementsByTagName( 'BUTTON' )[ i ];
                        }
                        helperItemsLength = helperItems.length + helperContainer.getElementsByTagName( 'INPUT' ).length;
                    }
                    
                    // focus on the filter element on open. 
                    if ( element[ 0 ].querySelector( '.inputFilter' ) ) {                        
                        element[ 0 ].querySelector( '.inputFilter' ).focus();    
                        $scope.tabIndex = $scope.tabIndex + helperItemsLength - 2;
                        // blur button in vain
                        angular.element( element ).children()[ 0 ].blur();
                    }
                    // if there's no filter then just focus on the first checkbox item
                    else {                  
                        if ( !$scope.isDisabled ) {                        
                            $scope.tabIndex = $scope.tabIndex + helperItemsLength;
                            if ( $scope.inputModel.length > 0 ) {
                                formElements[ $scope.tabIndex ].focus();
                                $scope.setFocusStyle( $scope.tabIndex );
                                // blur button in vain
                                angular.element( element ).children()[ 0 ].blur();
                            }                            
                        }
                    }                          

                    // open callback
                    $scope.onOpen();
                }                            
            }
            
            // handle clicks outside the button / multi select layer
            $scope.externalClickListener = function( e ) {                   

                var targetsArr = element.find( e.target.tagName );
                for (var i = 0; i < targetsArr.length; i++) {                                        
                    if ( e.target == targetsArr[i] ) {
                        return;
                    }
                }

                angular.element( checkBoxLayer.previousSibling ).removeClass( 'buttonClicked' );                    
                angular.element( checkBoxLayer ).removeClass( 'show' );
                angular.element( document ).off( 'click', $scope.externalClickListener ); 
                angular.element( document ).off( 'keydown', $scope.keyboardListener );                
                
                // close callback                
                $timeout( function() {
                    $scope.onClose();
                }, 0 );

                // set focus on button again
                element.children().children()[ 0 ].focus();
            }
   
            // select All / select None / reset buttons
            $scope.select = function( type, e ) {

                var helperIndex = helperItems.indexOf( e.target );
                $scope.tabIndex = helperIndex;

                switch( type.toUpperCase() ) {
                    case 'ALL':
                        angular.forEach( $scope.filteredModel, function( value, key ) {                            
                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                                
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                
                                    value[ $scope.tickProperty ] = true;
                                }
                            }
                        });                            
                        $scope.refreshOutputModel();                                    
                        $scope.refreshButton();                                                  
                        $scope.onSelectAll();                                                
                        break;
                    case 'NONE':
                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                        
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                
                                    value[ $scope.tickProperty ] = false;
                                }
                            }
                        });               
                        $scope.refreshOutputModel();                                    
                        $scope.refreshButton();                                                                          
                        $scope.onSelectNone();                        
                        break;
                    case 'RESET':            
                        angular.forEach( $scope.filteredModel, function( value, key ) {                            
                            if ( typeof value[ attrs.groupProperty ] === 'undefined' && typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                        
                                var temp = value[ $scope.indexProperty ];                                
                                value[ $scope.tickProperty ] = $scope.backUp[ temp ][ $scope.tickProperty ];
                            }
                        });               
                        $scope.refreshOutputModel();                                    
                        $scope.refreshButton();                                                                          
                        $scope.onReset();                        
                        break;
                    case 'CLEAR':
                        $scope.tabIndex = $scope.tabIndex + 1;
                        $scope.onClear();    
                        break;
                    case 'FILTER':                        
                        $scope.tabIndex = helperItems.length - 1;
                        break;
                    default:                        
                }                                                                                 
            }            

            // just to create a random variable name                
            function genRandomString( length ) {                
                var possible    = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
                var temp        = '';
                for( var i=0; i < length; i++ ) {
                     temp += possible.charAt( Math.floor( Math.random() * possible.length ));
                }
                return temp;
            }

            // count leading spaces
            $scope.prepareGrouping = function() {
                var spacing     = 0;                                                
                angular.forEach( $scope.filteredModel, function( value, key ) {
                    value[ $scope.spacingProperty ] = spacing;                    
                    if ( value[ attrs.groupProperty ] === true ) {
                        spacing+=2;
                    }                    
                    else if ( value[ attrs.groupProperty ] === false ) {
                        spacing-=2;
                    }                 
                });
            }

            // prepare original index
            $scope.prepareIndex = function() {
                var ctr = 0;
                angular.forEach( $scope.filteredModel, function( value, key ) {
                    value[ $scope.indexProperty ] = ctr;
                    ctr++;
                });
            }

            // navigate using up and down arrow
            $scope.keyboardListener = function( e ) { 
                
                var key = e.keyCode ? e.keyCode : e.which;      
                var isNavigationKey = false;                                                

                // ESC key (close)
                if ( key === 27 ) {
                    e.preventDefault();                   
                    e.stopPropagation();
                    $scope.toggleCheckboxes( e );
                }                    
                
                
                // next element ( tab, down & right key )                    
                else if ( key === 40 || key === 39 || ( !e.shiftKey && key == 9 ) ) {                    
                    
                    isNavigationKey = true;
                    prevTabIndex = $scope.tabIndex; 
                    $scope.tabIndex++;                         
                    if ( $scope.tabIndex > formElements.length - 1 ) {
                        $scope.tabIndex = 0;
                        prevTabIndex = formElements.length - 1; 
                    }                                                            
                    while ( formElements[ $scope.tabIndex ].disabled === true ) {
                        $scope.tabIndex++;
                        if ( $scope.tabIndex > formElements.length - 1 ) {
                            $scope.tabIndex = 0;                            
                        }                                                                                    
                        if ( $scope.tabIndex === prevTabIndex ) {
                            break;
                        }
                    }              
                }
                  
                // prev element ( shift+tab, up & left key )
                else if ( key === 38 || key === 37 || ( e.shiftKey && key == 9 ) ) { 
                    isNavigationKey = true;
                    prevTabIndex = $scope.tabIndex; 
                    $scope.tabIndex--;                              
                    if ( $scope.tabIndex < 0 ) {
                        $scope.tabIndex = formElements.length - 1;
                        prevTabIndex = 0;
                    }                                         
                    while ( formElements[ $scope.tabIndex ].disabled === true ) {                        
                        $scope.tabIndex--;
                        if ( $scope.tabIndex === prevTabIndex ) {
                            break;
                        }                                            
                        if ( $scope.tabIndex < 0 ) {
                            $scope.tabIndex = formElements.length - 1;
                        }                             
                    }                                                     
                }                    

                if ( isNavigationKey === true ) {                                         
                    
                    e.preventDefault();

                    // set focus on the checkbox                    
                    formElements[ $scope.tabIndex ].focus();    
                    var actEl = document.activeElement;                     
                    
                    if ( actEl.type.toUpperCase() === 'CHECKBOX' ) {                                                   
                        $scope.setFocusStyle( $scope.tabIndex );
                        $scope.removeFocusStyle( prevTabIndex );
                    }                    
                    else {
                        $scope.removeFocusStyle( prevTabIndex );
                        $scope.removeFocusStyle( helperItemsLength );
                        $scope.removeFocusStyle( formElements.length - 1 );
                    } 
                }                

                isNavigationKey = false;
            }

            // set (add) CSS style on selected row
            $scope.setFocusStyle = function( tabIndex ) {                                
                angular.element( formElements[ tabIndex ] ).parent().parent().parent().addClass( 'multiSelectFocus' );                        
            }

            // remove CSS style on selected row
            $scope.removeFocusStyle = function( tabIndex ) {                
                angular.element( formElements[ tabIndex ] ).parent().parent().parent().removeClass( 'multiSelectFocus' );
            }

            /*********************
             *********************             
             *
             * 1) Initializations
             *
             *********************
             *********************/

            // attrs to $scope - attrs-$scope - attrs - $scope
            // Copy some properties that will be used on the template. They need to be in the $scope.
            $scope.groupProperty    = attrs.groupProperty;   
            $scope.tickProperty     = attrs.tickProperty;
            $scope.directiveId      = attrs.directiveId;
            
            // Unfortunately I need to add these grouping properties into the input model
            var tempStr = genRandomString( 5 );
            $scope.indexProperty = 'idx_' + tempStr;
            $scope.spacingProperty = 'spc_' + tempStr;         

            // set orientation css            
            if ( typeof attrs.orientation !== 'undefined' ) {

                if ( attrs.orientation.toUpperCase() === 'HORIZONTAL' ) {                    
                    $scope.orientationH = true;
                    $scope.orientationV = false;
                }
                else 
                {
                    $scope.orientationH = false;
                    $scope.orientationV = true;
                }
            }            

            // get elements required for DOM operation
            checkBoxLayer = element.children().children().next()[0];

            // set max-height property if provided
            if ( typeof attrs.maxHeight !== 'undefined' ) {                
                var layer = element.children().children().children()[0];
                angular.element( layer ).attr( "style", "height:" + attrs.maxHeight + "; overflow-y:scroll;" );                                
            }

            // some flags for easier checking            
            for ( var property in $scope.helperStatus ) {
                if ( $scope.helperStatus.hasOwnProperty( property )) {                    
                    if ( 
                        typeof attrs.helperElements !== 'undefined' 
                        && attrs.helperElements.toUpperCase().indexOf( property.toUpperCase() ) === -1 
                    ) {
                        $scope.helperStatus[ property ] = false;
                    }
                }
            }
            if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' )  {
                $scope.helperStatus[ 'all' ] = false;
                $scope.helperStatus[ 'none' ] = false;
            }

            // helper button icons.. I guess you can use html tag here if you want to. 
            $scope.icon        = {};            
            $scope.icon.selectAll  = '&#10003;';    // a tick icon
            $scope.icon.selectNone = '&times;';     // x icon
            $scope.icon.reset      = '&#8630;';     // undo icon            
            // this one is for the selected items
            $scope.icon.tickMark   = '&#10003;';    // a tick icon 

            // configurable button labels                       
            if ( typeof attrs.translation !== 'undefined' ) {
                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;' + $scope.translation.selectAll );
                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;' + $scope.translation.selectNone );
                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;' + $scope.translation.reset );
                $scope.lang.search          = $scope.translation.search;                
                $scope.lang.nothingSelected = $sce.trustAsHtml( $scope.translation.nothingSelected );                
            }
            else {
                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;すべて選択' );                
                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;選択なし' );
                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;リセット' );
                $scope.lang.search          = 'サーチ...';
                $scope.lang.nothingSelected = '何も選択されていません';                
            }
            $scope.icon.tickMark = $sce.trustAsHtml( $scope.icon.tickMark );
                
            // min length of keyword to trigger the filter function
            if ( typeof attrs.MinSearchLength !== 'undefined' && parseInt( attrs.MinSearchLength ) > 0 ) {
                vMinSearchLength = Math.floor( parseInt( attrs.MinSearchLength ) );
            }

            /*******************************************************
             *******************************************************
             *
             * 2) Logic starts here, initiated by watch 1 & watch 2
             *
             *******************************************************
             *******************************************************/
            
            // watch1, for changes in input model property
            // updates multi-select when user select/deselect a single checkbox programatically
            // https://github.com/isteven/angular-multi-select/issues/8            
            $scope.$watch( 'inputModel' , function( newVal ) {                                 
                if ( newVal ) {                            
                    $scope.refreshOutputModel();                                    
                    $scope.refreshButton();                                                  
                }
            }, true );
            
            // watch2 for changes in input model as a whole
            // this on updates the multi-select when a user load a whole new input-model. We also update the $scope.backUp variable
            $scope.$watch( 'inputModel' , function( newVal ) {  
                if ( newVal ) {
                    $scope.backUp = angular.copy( $scope.inputModel );    
                    $scope.updateFilter();
                    $scope.prepareGrouping();
                    $scope.prepareIndex();                                                              
                    $scope.refreshOutputModel();                
                    $scope.refreshButton();                                                                                                                 
                }
            });                        

            // watch for changes in directive state (disabled or enabled)
            $scope.$watch( 'isDisabled' , function( newVal ) {         
                $scope.isDisabled = newVal;                               
            });            
            
            // this is for touch enabled devices. We don't want to hide checkboxes on scroll. 
            var onTouchStart = function( e ) { 
            	$scope.$apply( function() {
            		$scope.scrolled = false;
            	}); 
            };
            angular.element( document ).bind( 'touchstart', onTouchStart);
            var onTouchMove = function( e ) { 
            	$scope.$apply( function() {
            		$scope.scrolled = true;                
            	});
            };
            angular.element( document ).bind( 'touchmove', onTouchMove);            

            // unbind document events to prevent memory leaks
            $scope.$on( '$destroy', function () {
			    angular.element( document ).unbind( 'touchstart', onTouchStart);
            	angular.element( document ).unbind( 'touchmove', onTouchMove);
            });
        }
    }
}]).run( [ '$templateCache' , function( $templateCache ) {
    var template = 
        '<span class="multiSelect inlineBlock">' +
            // main button
            '<button id="{{directiveId}}" type="button"' +                
                'ng-click="toggleCheckboxes( $event ); refreshSelectedItems(); refreshButton(); prepareGrouping; prepareIndex();"' +
                'ng-bind-html="varButtonLabel"' +
                'ng-disabled="disable-button"' +
            '>' +
            '</button>' +
            // overlay layer
            '<div class="checkboxLayer">' +
                // container of the helper elements
                '<div class="helperContainer" ng-if="helperStatus.filter || helperStatus.all || helperStatus.none || helperStatus.reset ">' +
                    // container of the first 3 buttons, select all, none and reset
                    '<div class="line" ng-if="helperStatus.all || helperStatus.none || helperStatus.reset ">' +
                        // select all
                        '<button type="button" class="helperButton"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.all"' +
                            'ng-click="select( \'all\', $event );"' +
                            'ng-bind-html="lang.selectAll">' +
                        '</button>'+
                        // select none
                        '<button type="button" class="helperButton"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.none"' +
                            'ng-click="select( \'none\', $event );"' +
                            'ng-bind-html="lang.selectNone">' +
                        '</button>'+
                        // reset
                        '<button type="button" class="helperButton reset"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.reset"' +
                            'ng-click="select( \'reset\', $event );"' +
                            'ng-bind-html="lang.reset">'+
                        '</button>' +
                    '</div>' +
                    // the search box
                    '<div class="line" style="position:relative" ng-if="helperStatus.filter">'+
                        // textfield                
                        '<input placeholder="{{lang.search}}" type="text"' +
                            'ng-click="select( \'filter\', $event )" '+
                            'ng-model="inputLabel.labelFilter" '+
                            'ng-change="searchChanged()" class="inputFilter"'+
                            '/>'+
                        // clear button
                        '<button type="button" class="clearButton" ng-click="clearClicked( $event )" >×</button> '+
                    '</div> '+
                '</div> '+
                // selection items
                '<div class="checkBoxContainer">'+
                    '<div '+
                        'ng-repeat="item in filteredModel | filter:removeGroupEndMarker" class="multiSelectItem"'+
                        'ng-class="{selected: item[ tickProperty ], horizontal: orientationH, vertical: orientationV, multiSelectGroup:item[ groupProperty ], disabled:itemIsDisabled( item )}"'+
                        'ng-click="syncItems( item, $event, $index );" '+
                        'ng-mouseleave="removeFocusStyle( tabIndex );"> '+
                        // this is the spacing for grouped items
                        '<div class="acol" ng-if="item[ spacingProperty ] > 0" ng-repeat="i in numberToArray( item[ spacingProperty ] ) track by $index">'+                        
                    '</div>  '+        
                    '<div class="acol">'+
                        '<label>'+                                
                            // input, so that it can accept focus on keyboard click
                            '<input class="checkbox focusable" type="checkbox" '+
                                'ng-disabled="itemIsDisabled( item )" '+
                                'ng-checked="item[ tickProperty ]" '+
                                'ng-click="syncItems( item, $event, $index )" />'+
                            // item label using ng-bind-hteml
                            '<span '+
                                'ng-class="{disabled:itemIsDisabled( item )}" '+
                                'ng-bind-html="writeLabel( item, \'itemLabel\' )">'+
                            '</span>'+
                        '</label>'+
                    '</div>'+
                    // the tick/check mark
                    '<span class="tickMark" ng-if="item[ groupProperty ] !== true && item[ tickProperty ] === true" ng-bind-html="icon.tickMark"></span>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</span>';
	$templateCache.put( 'isteven-multi-select.htm' , template );
}]); 

(function () {
    "use strict";

    angular.module("MyApp").directive('partternKey', function ($compile, $q) {
        return {
            restrict: 'A',
            link: function ($scope, $element, $attrs) {

              $element.keypress(function (e) {
              
                    var patt = /\`|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\+|\=|\[|\{|\]|\}|\||\\|\'|\<|\,|\.|\>|\?|\/|\""|\;|\:/g;
                    var c = String.fromCharCode(e.keyCode).toString();
                    if (patt.test(c)) {

                        e.preventDefault();
                    }
                });

                $element.on('paste', function (e) {

                    var textpaste = $.trim(e.originalEvent.clipboardData.getData('Text'));
                    for (var i = 0; i < textpaste.length; i++) {
                        var patt = /\`|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\+|\=|\[|\{|\]|\}|\||\\|\'|\<|\,|\.|\>|\?|\/|\""|\;|\:/g;
                        var char = textpaste.charAt(i);
                        if (patt.test(char)) {
                            toastr.error('String "' + textpaste + ' "contain word not allow');
                            e.preventDefault();
                            break;
                        } else {
                            setTimeout(function () {
                                $element.val($.trim($element.val()));
                            }, 100);
                        }
                    }
                });

                $element.on('focusout', function () {
                    $element.val($.trim($element.val()));
                });
            }
        }
    });
    angular.module("MyApp").directive('blockSpace', function ($compile, $q) {
        return {
            restrict: 'A',
            link: function ($scope, $element, $attrs) {
                $element.on('keyup', function (e) {
        
                    if($element.val() == "" && e){}
                })

            }
        }
    })
})();




(function () {
  "use strict";

  angular.module("MyApp").directive('inputOnlyNumber',function inputOnlyNumber() {

   return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elem, attrs, ngModelCtrl) {
      if(!ngModelCtrl) {
        return; 
      }
      angular.element(elem).on("keypress change input onpaste", function(e) {
        if (window.getSelection().toString().length > 0 ) return;
        this.value=this.value.replace(/[^0-9]/g, '');       
        ngModelCtrl.$setViewValue(this.value);
        ngModelCtrl.$render();
      });
    }
  };
});
})();
// export default {
//   name: 'inputOnlyNumber',
//   fn: inputOnlyNumber
// };

// import _ from 'lodash';
(function () {
  "use strict";

  angular.module("MyApp").directive('kataValidator', function ($q, $timeout) {
  'ngInject';
  let KANA_FULL_SIZE_REGEXP = /^([ァ-ンヴ。、ー「」．・\s]+)$/,
    KANA_HALF_SIZE_REGEXP = /^([ｧ-ﾝﾞﾟ｡｢｣､･ｰ\s]+)$/,
    KANA_ALL_SIZE_REGEXP = /^([ァ-ン。ｧ-ﾝﾞﾟ｡、ー「」．・｢｣､･ｰ\s]+)$/,
    ALL_FULL_SIZE = /^([一-龠ぁ-ゔァ-ヴーａ-ｚＡ-Ｚ０-９々〆〤]+)$/,
    KANA_HALF_SIZE_AND_ALPHAB = /^([a-z A-Z 0-9  ｧ-ﾝﾞﾟ｡｢｣､･ｰ]+)$/,
    INTEGER = /[^0-9]+$/,
    ALPHAB = /^[a-z A-Z 0-9]/,
    ESCAPE_SPECIAL_CHAR = /[\\'|&:;=*,%]/gi;
  let KanaRegex = {
      KANA_FULL_SIZE_REGEXP : /([^!@#$()a-z A-Z ａ-ｚＡ-Ｚ 0-9 ０-９ ァ-ンヴ。、ー「」．・\s]+)/gi,
      KANA_HALF_SIZE_REGEXP : /([^!@#$()a-z A-Z ａ-ｚＡ-Ｚ 0-9 ０-９ ｧ-ﾝﾞﾟ｡｢｣､･ｰ\s]+)/gi,
      KANA_ALL_SIZE_REGEXP : /([^!@#$()a-z A-Z ａ-ｚＡ-Ｚ 0-9 ０-９ ァ-ン。ｧ-ﾝﾞﾟ｡、ー「」．・｢｣､･ｰ\s]+)/gi,
      ALL_FULL_SIZE : /([一-龠ぁ-ゔァ-ヴーａ-ｚＡ-Ｚ０-９々〆〤]+)/gi,
      KANA_HALF_SIZE_AND_ALPHAB : /([a-z A-Z 0-9  ｧ-ﾝﾞﾟ｡｢｣､･ｰ]+)/gi,
      INTEGER : /[^0-9]/,
      ALPHAB : /([^!@#$()a-z A-Z 0-9\s]+)/gi,
      ESCAPE_SPECIAL_CHAR : /[\\'|&:;=*,%\"]/gi
  };
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      validatorConfig: '=kataConfig'
    },
    link: function(scope, elem, attrs, ngModel) {
      if (!ngModel) return;
      let kataKanaOptions = scope.validatorConfig || {};
      function kataKanaValidator(value) {
        var input = value;

        return {
          get kataKanaFullSize() {
            return KANA_FULL_SIZE_REGEXP.test(input);
          },
          get kataKanaHalfSize() {

            return KANA_HALF_SIZE_REGEXP.test(input);

          },
          get isAlphaB() {
            return ALPHAB.test(input);
          },
          get integerOnly() {
            return INTEGER.test(input);
          },
          get isalphaBAndKanaHalfSize() {

            return KANA_HALF_SIZE_AND_ALPHAB.test(input);
          },
          get escapeSpecialChar() {
            if (input.length > 0) {
              var result = KANA_HALF_SIZE_AND_ALPHAB.test(input);
              return result;
            }
            //  console.log(input , result);

          },
        }
      };

      function kataKanaReplacetor(typeOfReplacement,inputValue){
          let replaceResult;
          _.forEach(typeOfReplacement,(value,key)=>{
            replaceResult = inputValue.replace(KanaRegex[key],'');

         });
        //  if(kataKanaOptions.escapeSpaceBar){
        //    _.trim(replaceResult);
        //  }
        return replaceResult;
      };

      // SET FORM VALIDATOR BASE ON INPUT FIELD => TO DISPLAY WITH ERROR LABEL || BLOCK INPUT WITH REGEX
      // if (!kataKanaOptions.nonBlockInput) {
      //
      //   let validator = function(value) {
      //     let spec = kataKanaValidator(value);
      //     _.forEach(kataKanaOptions, (value, key) => {
      //       if (value) {
      //         let fnName = key.toString(),
      //           fnSpec = spec[key];
      //         ngModel.$setValidity(fnName, fnSpec);
      //       }
      //     });
      //     return value;
      //   };
      //   ngModel.$parsers.push(validator);
      // } else {
        // debugger;
        let limit = parseInt(attrs.limitTo),
            subStr;
        angular.element(elem).on(" input onpaste keypress click", (e)=>{
          let vm = e.currentTarget,
              currentSelection =  e.currentTarget.selectionEnd;
//           if(vm.value.length == limit) return;
          if (window.getSelection().toString().length > 0 ){
             return;
          }
          else if (e.type != ("click" || "onpaste")  ){
            if(vm.value.length == limit)             e.preventDefault();
            vm.value = kataKanaReplacetor(kataKanaOptions,vm.value).substr(0,limit);
//             vm.value = vm.value.substr(0,currentSelection-1) + vm.value.substr(currentSelection,limit);
            ngModel.$setViewValue(vm.value);
            ngModel.$render();
            vm.selectionEnd = currentSelection;
          }else{
            e.preventDefault();
          }


          return vm.value;
        });
      // }


    }
  };
});
})();


(function () {
  "use strict";

  angular.module("MyApp").directive('datetimePicker', function ($compile, $q) {
    return {
      restrict: 'A',
      scope: {
          selectTime: '@',
          typeTime:'@',
          ngModel:'='
      },
      template: '<input type="text" class="form-control" {{outputValue}}>' +
                  '<div class="input-group-addon">' +
                      '<span class="glyphicon glyphicon-th"></span>' +
                  '</div>',
      link: function ($scope, $element, $attrs) {

          if ($scope.ngModel != undefined) {

              $scope.outputValue = d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear() + d.getHours+":"+d.getMinutes;
          } else
              $scope.outputValue = "";
        var datetimepicker=$element.datetimepicker({
          autoclose: true,
          format: 'dd-mm-yyyy hh:ii',
          clearBtn: true,
          todayHighlight: true
        }).on("changeDate", function (e) {

            //var $this = this;
            //var item = $($this.element).find('input');
            //validator.element(item);
            //$scope.$apply();
            var d = new Date(e.date);
            var utcd = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(),
                d.getMinutes(), d.getSeconds(), d.getMilliseconds());

            // obtain local UTC offset and convert to msec
            var localOffset = d.getTimezoneOffset() * 60000;
            var newdate = new Date(utcd + localOffset);

            $scope.$apply();
            return $scope.ngModel = newdate.toISOString().replace(".000", "");
        }.bind({ element: $element, scope: $scope }));

          $scope.$watch('ngModel', function (newValue, oldValue) {
        });
      }
    }
  });
})();



(function () {
  "use strict";
  angular.module("MyApp").directive('datePicker', function ($compile, $q) {
    return {
      restrict: 'A',
      template: '<input type="text" class="form-control">' +
                  '<div class="input-group-addon">' +
                      '<span class="glyphicon glyphicon-th"></span>' +
                  '</div>',
      link: function ($scope, $element, $attrs) {
          $element.datepicker({
              autoclose: true,
              format: 'dd/mm/yyyy',
              clearBtn: true,
              todayHighlight: true
          });
      }
    }
  });
})();

(function () {
  "use strict";

  angular.module("MyApp").directive('jqdatepicker', ['$rootScope', '$state','$filter',
  function ($rootScope, $state,$filter) {
    return {
      restrict: 'A',
      require: 'ngModel',
       link: function (scope, element, attrs, ngModelCtrl) {
       
          element.datepicker({
            format: 'yyyy/mm/dd',
            autoclose: true,
            todayHighlight: true,
            clearBtn:true
          });
          ngModelCtrl.$formatters.unshift(function(v) {
          return $filter(v); //('date')(v,'yyyy/mm/dd'); 
          });

      }
  };
    
  }
  ]);
})();

swal.show = function (type, title, text, callback) {
  return new Promise(function (resolve, reject) {
    if (type == "success") {
      swal({
        title: title,
        text: text,
        type: "success",
        showCancelButton: false,
        confirmButtonText: "はい",
        closeOnConfirm: true
      }, function () {
        if (callback) {
          callback();
        }
        else {
          resolve();
        }
      });
    }
    else if (type == "confirm") {
      swal({
        title: title,
        text: text,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: translations.jp["Ok"],
        cancelButtonText: translations.jp["Cancel"],
        closeOnConfirm: false,
        showLoaderOnConfirm: true
      },
      function () {
        if (callback) {
          callback();
        }
        else {
          resolve();
        }
      });
    }
    else if (type == "error") {

      swal({
        title: title,
        text: text,
        type: "error",
        showCancelButton: false,
        confirmButtonText: translations.jp["Ok"],
        closeOnConfirm: true
      }, function () {
        if (callback) {
          callback();
        }
        else {
          resolve();
        }
      });
    }
  });
}

angular.module("MyApp").directive("limitToMax", function() {
  "use strict";

  return {
    link: function(scope, element, attributes) {
      var oldVal = null;
      element.on("keydown keyup", function(e) {
        if (
          Number(element.val()) > Number(attributes.max) &&
          e.keyCode != 46 && // delete
          e.keyCode != 8 // backspace
        ) {
          console.log(1);
          e.preventDefault();
          element.val(oldVal);
        } else {
          if (e.keyCode == 187 || e.keyCode == 189 || e.keyCode == 69) {
            e.preventDefault();
            element.val(oldVal);
          } else {
            oldVal = Number(element.val());
          }
        }
      });
    }
  };
});

/***
GLobal Directives
***/

// Route State Load Spinner(used on page or content load)
angular.module("MyApp").directive('ngSpinnerBar', ['$rootScope', '$state',
  function ($rootScope, $state) {
      return {
          link: function (scope, element, attrs) {
              // by defult hide the spinner bar
              element.addClass('hide'); // hide spinner bar by default

              // display the spinner bar whenever the route changes(the content part started loading)
              var stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
                  element.removeClass('hide'); // show spinner bar
              });

              // hide the spinner bar on rounte change success(after the content loaded)
              var stateChan = $rootScope.$on('$stateChangeSuccess', function (event) {
                  element.addClass('hide'); // hide spinner bar
                  $('body').removeClass('page-on-load'); // remove page loading indicator
                  Layout.setAngularJsSidebarMenuActiveLink('match', null, event.currentScope.$state); // activate selected link in the sidebar menu

                  // auto scorll to page top
                  setTimeout(function () {
                      App.scrollTop(); // scroll to the top on content load
                  }, $rootScope.settings.layout.pageAutoScrollOnLoad);
              });

              // handle errors
              $rootScope.$on('$stateNotFound', function () {
                  element.addClass('hide'); // hide spinner bar
              });

              // handle errors
              $rootScope.$on('$stateChangeError', function () {
                  element.addClass('hide'); // hide spinner bar
              });
          }
      };
  }
])

// Handle Dropdown Hover Plugin Integration
angular.module("MyApp").directive('dropdownMenuHover', function () {
    return {
        link: function (scope, elem) {
            elem.dropdownHover();
        }
    };
});

angular.module("MyApp").directive('summernote', function ($compile, $q) {

    return {
        restrict: "EA",
        scope: {
            ngModel: "=",
            name: "@",
            mode: "@"
        },
        template: '',
        controller: function ($scope, $element, $state) {

        },
        link: function ($scope, $element, $attrs, controller) {
            var textarea = $element;
            $(textarea).summernote({
                height: 200,
                callbacks: {
                    onChange: function (contents, $editable) {

                        if ($scope.firstInit == undefined) {
                            $scope.firstInit = false;
                        }
                        else {
                            if (contents) contents = contents.trim();
                            if (contents.startsWith("<p>") && contents.endsWith("</p>")) {
                                contents = contents.substr(3, contents.length - 7);
                            }
                            this.value = contents;
                            //validator.element(this);

                            $scope.ngModel = contents;
                            _.defer(function () {
                                $scope.$apply();
                            });
                        }
                    },
                    onPaste: function (e) {
                        //validator.element($(textarea)[0]);
                    },
                    onKeyup: function (e) {
                        //validator.element($(textarea)[0]);
                    }
                }
            });


            if ($scope.mode == "code") {
                $(textarea).summernote('codeview.toggle');
            }

            $element.closest(".form-group").find(".note-codable").on('keypress', function (e) {
                var contents = ($(textarea).summernote('code') + String.fromCharCode(e.keyCode)).trim();
                $scope.ngModel = contents;
                $element.val(contents);
                //validator.element($(textarea));
                $scope.$apply();
            });

            if ($scope.ngModel) {
                $(textarea).summernote('code', $scope.ngModel);
            }
            else {
                $(textarea).summernote('code', "");
            }


            $scope.$watch('ngModel', function (newValue, oldValue) {
                if (oldValue == undefined) {
                    $(textarea).summernote('code', newValue);
                }
            });
        }
    };

})


angular.module("MyApp").directive('datepicker', function ($compile, $q) {
    return {
        restrict: "A",
        scope: {
            //ngModel: "=",
            name: "@",
            ngModel: "=",
            sitenRequire: "@?",
            validation: "=?",
            sitenLarger: "@?",
            noTime:'@'
        },
        template: '<input style="cursor:pointer" name={{name}} value={{ngModel}} type="text" size="16" filter="{{name}}" siten-larger={{sitenLarger}} class="form-control"><span class="input-group-addon"><button class="btn default date-set" type="button"><i class="fa fa-calendar"></i></button></span><div class="form-control-focus"></div>',

        controller: function ($scope, $element, $state, $rootScope) {
        },
        link: function ($scope, $element, $attrs, controller, $rootScope) {
            var count = 0;
            if ($scope.ngModel != undefined) {
                var myDate = new Date($scope.ngModel);
                var offset = myDate.getTimezoneOffset() * 60 * 1000;

                var withOffset = myDate.getTime();
                var withoutOffset = withOffset - offset;
                var d = new Date($scope.ngModel);

                $scope.outputValue = d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
            }
            if ($scope.sitenRequire != undefined) {

                if (!$element.find('input').attr("siten-required")) {
                    $element.find('input').attr("siten-required", "");
                }

            }
            var datepicker = $element.datepicker({
                format: 'dd/mm/yyyy',
                rtl: App.isRTL(),
                orientation: "bottom left",
                autoclose: true,
                pickerPosition: (App.isRTL() ? "bottom-right" : "bottom-left"),
                minView: 2,
                clearBtn: true,
                todayHighlight: true,

                //startDate: '01/01/2000',
                endDate: '31/12/3000',
                //initialDate: "20/10/2016"
            }).on("changeDate", function (e) {
                var $this = this;
                var item = $($this.element).find('input');
                if (e.date) {
                    var offset = e.date.getTimezoneOffset() * 60 * 1000;
                    var withOffset = e.date.getTime();
                    var withoutOffset = withOffset - offset;



                    //if ($scope.noTime) {
                    //    let date =e.date.getFullYear()+'-'+(e.date.getMonth() + 1)  + "-" + e.date.getDate();
                    //    e.date = new Date(date);
                    //} else
                    e.date = new Date(withoutOffset);
                    let string = e.date.getFullYear() + '-' + (e.date.getMonth() + 1) + "-" + e.date.getDate();
                    //$scope.ngModel = e.date.toISOString();
                    $scope.ngModel = String(string);
                }
                let input = $element.find('input');
                if ($scope.validation) {
                    if ($scope.validation.element) {
                        $scope.validation.element(item);
                    }
                }
                _.defer(function () {
                    $scope.$apply();
                });
            }.bind(
            { element: $element, scope: $scope }
            )
            ).on('change', function () {

            });

            datepicker.on('clearDate', function (e) {

                $scope.ngModel = "";
                datepicker.datepicker('setDate', null);
            }).bind(object = { element: $element, scope: $scope });
            $scope.$watch('ngModel', function (newValue, oldValue) {
                if (newValue != undefined && oldValue == undefined) {
                    var myDate = new Date(newValue);
                    if (myDate.toDateString != "Invalid Date") {
                        var offset = myDate.getTimezoneOffset() * 60 * 1000;

                        var withOffset = myDate.getTime();
                        var withoutOffset = withOffset - offset;
                        //if ($scope.noTime) {
                        //    mydate = new Date(withoutOffset);
                        //    let date = myDate.getFullYear() + '-' + (myDate.getMonth() + 1) + "-" + myDate.getDate();
                        //    datepicker.datepicker('setDate', new Date(date));
                        //}else
                        datepicker.datepicker('setDate', new Date(withoutOffset));
                    }

                }
            });
        }
    };
})


angular.module("MyApp").directive('fileinput', function ($compile, $q, $translate, APIGateway) {
    function base64(file, callback) {
        var coolFile = {};
        function readerOnload(e) {
            var base64 = btoa(e.target.result);
            coolFile.base64 = base64;
            callback(coolFile)
        }

        var reader = new FileReader();
        reader.onload = readerOnload;

        file = file[0].files[0];
        coolFile.filetype = file.type;
        coolFile.size = file.size;
        coolFile.filename = file.name;
        reader.readAsBinaryString(file);
    }

    return {
        restrict: "A",
        scope: {
            name: "@",
            ngModel: "=",
            folder: "@",
            mode: "@"
        },
        template: '<div class="fileinput-preview thumbnail"  style="width: 100px; height: 100px; line-height: 150px;"><img ng-show="ngModel" src="{{ngModel}}" /></div>'
        + '<div style="width:200px"><span class="btn red btn-outline btn-file"><span class="fileinput-new"> {{"chon_anh"|translate}} </span><span class="fileinput-exists"> {{"doi_anh"|translate}} </span>'
        + '<input type="file" accept="image/*" class="{{class}}" /></span><a href="javascript:;" class="btn red fileinput-exists" data-dismiss="fileinput"> {{"xoa_anh"|translate}} </a></div><input name="{{name}}" type="text" ng-model="ngModel" placeholder="' + translations["duong_dan_anh"] + '" />',
        controller: function ($scope, $element, $state) {

        },
        link: function ($scope, $element, $attrs, controller) {
            if ($scope.mode == "sua") $scope.class = "ignore";
            else $scope.class = "";


            $element.find("input[type='file']").change(function (e) {

                $scope.class = "";


                var fileName = $element.find("input[type='file']").val();

                var ext = fileName.substr(fileName.lastIndexOf('.') + 1);
                var folderName = $scope.folder;
                base64($element.find("input[type='file']"), function (data) {
                    APIGateway.sendRequest('uploadImage.POST', { content: data.base64, folder: folderName, extension: ext }).then(function (resp) {
                        $scope.ngModel = resp.data;
                        $scope.$apply();
                    },
                      function (err) {
                          toastr.error("Image upload error");
                      })
                })
            });

            //window.setTimeout(function () {
            //  //debugger
            //  this.$element.find("input[type='file']").val(this.$scope.ngModel);
            //}.bind({$element:$element,$scope:$scope}), 500);

            //$element.bind("change", function (changeEvent) {
            //    var reader = new FileReader();
            //    reader.onload = function (loadEvent) {
            //        scope.$apply(function () {
            //            scope.fileread = loadEvent.target.result;
            //        });
            //    }
            //    reader.readAsDataURL(changeEvent.target.files[0]);
            //  });

        }
    };
})

angular.module("MyApp").directive('convertNumber', function () {
    return {
        require: 'ngModel',
        link: function (scope, el, attr, ctrl) {
            ctrl.$parsers.push(function (value) {
                return parseInt(value, 10);
            });

            ctrl.$formatters.push(function (value) {
                if (!value) return;
                return value.toString();
            });
        }
    }
});

angular.module("MyApp").directive('tmdtModal', function () {
    return {
        link: function (scope, el, attr, ctrl) {
            el.on('show.bs.modal', function () {

                $(this).find('.search-button').trigger('click');


            })


        }
    }
});


﻿jQuery.validator.addClassRules("required", {

    required: true,
    normalizer: function (value) {
        return $.trim(value);
    }
});
jQuery.validator.addMethod("phone", function (value, element) {

    // allow any non-whitespace characters as the host part
    return this.optional(element) || /^\+*\d{1,20}$/.test(value);
}, 'Please enter a valid phone number.');
jQuery.validator.addMethod("phone", function (value, element) {

    // allow any non-whitespace characters as the host part
    return this.optional(element) || /^\+*\d{1,20}$/.test(value);
}, 'Please enter a valid phone number.');


jQuery.validator.addMethod("urlLink", function (value, element) {
    // allow any non-whitespace characters as the host part
    return this.optional(element) || /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/.test(value);
}, 'Please enter a valid URL.');

jQuery.validator.addMethod("expireDate_larger_effectDate", function (value, element, param) {
    var elemTime = $(element).val().split('/');
    var effectTime = $('#' + param).find('input').val().split('/');

    return parseInt(elemTime[0]) >= parseInt(effectTime[0]) && parseInt(elemTime[1]) >= parseInt(effectTime[1]) && parseInt(elemTime[2]) >= parseInt(effectTime[2]);
}, 'Expired date should be greater or equal than  Effect date.');

jQuery.validator.addMethod("min", function (value, element, param) {

   
    if (isNaN(Number(value))|| !value) {
        return true;
    }
    return value > param;
}, 'Expired date should be greater or equal than  Effect date.');
jQuery.validator.addMethod("imageLink", function (value, element) {
    // allow any non-whitespace characters as the host part
    return this.optional(element) || /(https?:)?\/?[^'"<>]+?\.(jpg|jpeg|gif|png)/.test(value);
}, 'Please enter a valid image URL.');


// Add validate method required select 2
jQuery.validator.addMethod("requiredSelect2", function (value, element, arg) {
    return arg !== value;
}, "Bạn phải chọn danh mục.");

// chweck ký tự đặc biệt
jQuery.validator.addMethod("checkScript", function (value, element) {
    // allow any non-whitespace characters as the host part
    return this.optional(element) || /^[\u00BF-\u1FFF\u2C00-\uD7FF\w\@\-_\+\s]*$/g.test(value); // check
}, 'に無効な文字が含まれています');

$.validator.addMethod("greaterThan",
    function (value, element, param) {
        var $otherElement = $(param);
        return parseInt(value, 10) > parseInt($otherElement.val(), 10);
    });
$.validator.addMethod("smallerThan",function (value, element, param) {
        param= param.split(",");
        var $otherElement = $(param[0]);
        if (value != "" && $otherElement.val() != "")
            return parseInt(value, 10) <= parseInt($otherElement.val(), 10);
        else
            return true;
    });

jQuery.validator.addMethod("required", function (value, element) {
    return value.trim() == '' ? false : true;
});
﻿jQuery.validator.addClassRules("required", {
    required: true,
    normalizer: function (value) {
        return $.trim(value);
    }
});
jQuery.validator.addMethod("phone", function (value, element) {

    // allow any non-whitespace characters as the host part
    return this.optional(element) || /^\+*\d{1,20}$/.test(value);
}, 'Please enter a valid phone number.');
jQuery.validator.addMethod("phone", function (value, element) {

    // allow any non-whitespace characters as the host part
    return this.optional(element) || /^\+*\d{1,20}$/.test(value);
}, 'Please enter a valid phone number.');
//jQuery.validator.addMethod("intCheck", function (value, element) {
//    return this.optional(element) || !isNaN(value) && (parseFloat(value) === parseInt(value, 10));

//}, 'Please enter a integer value.');
jQuery.validator.addMethod("length", function (value, element) {
    
    return this.optional(element) || $.trim(value).length === parseInt(element.getAttribute("siten-length"));

}, 'invalid');
jQuery.validator.addMethod("floatCheck", function (value, element) {
    return this.optional(element) || /^[- +]?[\d .]+$/.test(value);

}, 'Please enter a float value.');
jQuery.validator.addMethod("urlLink", function (value, element) {
    // allow any non-whitespace characters as the host part
    return this.optional(element) || /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/.test(value);
}, 'Please enter a valid URL.');

jQuery.validator.addMethod("expireDate_larger_effectDate", function (value, element, param) {
    var elemTime = $(element).val().split('/');
    var effectTime = $('#' + param).find('input').val().split('/');
    var flag = false;

    if (parseInt(elemTime[0]) >= parseInt(effectTime[0])) {
        if (parseInt(elemTime[1]) >= parseInt(effectTime[1])) {
            flag = true;
            if (parseInt(elemTime[2]) >= parseInt(effectTime[2])) {
                flag = true;
            } else {
                flag = false;
            }
        } else {
            flag = false;
            if (parseInt(elemTime[2]) > parseInt(effectTime[2])) {
                flag = true;
            } else {
                flag = false;
            }
        }
    } else {
        if (parseInt(elemTime[1]) > parseInt(effectTime[1])) {
            flag = true;
            if (parseInt(elemTime[2]) >= parseInt(effectTime[2])) {
                flag = true;
            } else {
                flag = false;
            }
        } else {
            flag = false;
            if (parseInt(elemTime[2]) > parseInt(effectTime[2])) {
                flag = true;
            } else {
                flag = false;
            }
        }
    }

    return flag;
}, 'Expired date should be greater or equal than  Effect date.');


jQuery.validator.addMethod("imageLink", function (value, element) {
    // allow any non-whitespace characters as the host part
    return this.optional(element) || /(https?:)?\/?[^'"<>]+?\.(jpg|jpeg|gif|png)/.test(value);
}, 'Please enter a valid image URL.');


// chweck ký tự đặc biệt
jQuery.validator.addMethod("checkScript", function (value, element) {
    // allow any non-whitespace characters as the host part
    return this.optional(element) || /^[\u00BF-\u1FFF\u2C00-\uD7FF\w\@\-_\+\s]*$/g.test(value); // check
}, 'not allow');

$.validator.addMethod("greaterThan",
    function (value, element, param) {
        var $otherElement = $(param);
        return parseInt(value, 10) > parseInt($otherElement.val(), 10);
    });
$.validator.addMethod("smallerThan",

    function (value, element, param) {
        param= param.split(",");
        var $otherElement = $(param[0]);
        if (value != "" && $otherElement.val() != "")
            return parseInt(value, 10) <= parseInt($otherElement.val(), 10);
        else
            return true;
    });

jQuery.validator.addMethod("intCheck", function (value, element) {
    //return this.optional(element) || !isNaN(value) && (parseFloat(value) === parseInt(value, 10));
    return this.optional(element) || /^[- +]?[\d]+$/.test(value);
}, 'Please enter a integer value.');
jQuery.validator.addMethod("sitenEmail", function (value, element) {
    var regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i;
    // allow any non-whitespace characters as the host part
    return this.optional(element) || regex.test(value); // check
}, 'Email chưa đúng định dạng');
jQuery.validator.addMethod("required", function (value, element) {
    return $(element).val().trim() == '' ? false : true;
}, 'Please enter a valid phone number.');






toastr.options = {
    "closeButton": true,
    "debug": false,
    "positionClass": "toast-top-full-width",
    "onclick": null,
    "opacity": 1,
    "showDuration": "1000",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
};

//Get value from object by it's path
Object.byString = function (o, s) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (k in o) {
            o = o[k];
        } else {
            return;
        }
    }
    return o;
}

var entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;'
};


var myApp = {
    clone: (obj) => {
        if (null == obj || "object" != typeof obj) return obj;
        var copy = obj.constructor();
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
        }
        return copy;
    },
    enCodeHtml: function (string) {
        return String(string).replace(/[&<>"'`=\/]/g, function (s) {
            return entityMap[s];
        });
    },

    escapeHtml: function escapeHtml(unsafe) {

        return unsafe.toString().replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    },
    formatNumber: function (number) {
        if (number) {
            return number.toString().replace(
                /\B(?=(\d{3})+(?!\d))/g, ","
            );

        } else {
            return "0";
        }

    },


    htmlEncode: function (value) {
        return $('<div/>').text(value).html();
    },
    strimStringToShort: function (des, maxlength) {
        if (des != null) {
            if (des.length < maxlength)
                return des;
            else
                return des.slice(0, maxlength) + "...";
        } else
            return "";
    },
    renderLink: function (link) {

        return '<a href="' + link + '">' + translations["lien_ket"] + '</a>';
    },
    renderActions: function (full) {
        if (full && full.action == "")
            return "";
        else {
            return "<button  class='glyphicon btn btn-success btn-xs glyphicon-pencil btn-edit'>";
        }
    },
    renderDetailActions: function (full, route) {
        if (full && full.action == "")
            return "";
        else {
            return `<a href='${route}/${full.id}' class='btn btn-default' style="background-color:#D9D9D9;  border: none;">` + translations.jp["Details"] + `</a>`;
        }
    },
    convertDateFormat: function (dateString, notUTC) {
        if (dateString == "")
            return "";
        var format = config.timeFormat;
        var date = new Date(dateString);
        var day = "";
        var month = "";
        var year = "";
        if (notUTC) {
            day = date.getDate();
            month = date.getMonth() + 1;
            year = date.getFullYear();
            month = ("0" + month).slice(-2);
            day = ("0" + day).slice(-2);
        } else {
            day = date.getUTCDate();
            month = date.getUTCMonth() + 1;
            year = date.getUTCFullYear();
            month = ("0" + month).slice(-2);
            day = ("0" + day).slice(-2);
        }
        var convertedString = format.replace('dd', day);
        convertedString = convertedString.replace('mm', month);
        convertedString = convertedString.replace('yyyy', year);
        return convertedString;
    },


    convertDate: function (dateString, notime) {
        if (dateString) {
            var myDate = new Date(dateString);

            var year = myDate.getFullYear();
            var month = String(myDate.getMonth() + 1).length > 1 ? myDate.getMonth() + 1 : "0" + (myDate.getMonth() + 1);
            var dateTime = String(myDate.getDate()).length > 1 ? myDate.getDate() : "0" + myDate.getDate();
            var hours = String(myDate.getHours()).length > 1 ? myDate.getHours() : "0" + myDate.getHours();
            var min = String(myDate.getMinutes()).length > 1 ? myDate.getMinutes() : "0" + myDate.getMinutes();
            var sec = String(myDate.getSeconds()).length > 1 ? myDate.getSeconds() : "0" + myDate.getSeconds();
            var date = year + "/" + month + "/" + dateTime + " " + hours + ":" + min + ":" + sec;
            if (notime) {
                date = year + "/" + month + "/" + dateTime;

            }
            return date;
        }

    },
    fullDateTime(data) {
        let d = new Date(data);
        let year = d.getFullYear();
        let month = d.getMonth() + 1;
        let date = d.getDate();
        let h = d.getHours();
        let minutes = d.getMinutes();

        if (month < 10) month = `0${month}`;
        if (date < 10) date = `0${date}`;
        if (h < 10) h = `0${h}`;
        if (minutes < 10) minutes = `0${minutes}`;
        return `${date}/${month}/${year}/ ${h}:${minutes}`;
    },
    dateTime(data) {

        let d = new Date(data);
        let year = d.getFullYear();
        let month = d.getMonth() + 1;
        let date = d.getDate();
        let h = d.getHours();
        let minutes = d.getMinutes();

        if (month < 10) month = `0${month}`;
        if (date < 10) date = `0${date}`;
        if (h < 10) h = `0${h}`;
        if (minutes < 10) minutes = `0${minutes}`;
        return `${date}/${month}/${year}`;
    },

    formatPhone: function (number) {
        if (number == null)
            return "";
        return number.toString().replace(
            /\B(?=(\d{4})+(?!\d))/g, "-"
        );

    },
    reverse: function (s) {
        var o = '';
        for (var i = s.length - 1; i >= 0; i--)
            o += s[i];

        return o;
    },
    reverArr: function (data) {

        var o = "";
        var arr = data.split("-");
        for (let i = arr.length; i >= 0; i--) {
            arr[i] = this.reverse(arr[i]);
            if (i != arr.length - 1) {
                o += arr[i] + "-";
            } else
                o += arr[i]
        }
        return o;
    },



    trimContent: function (content) {
        if (!content || content == "null") return "";
        content = myApp.escapeHtml(content);
        if (content.length > config.maxLengthDisplay) {
            return content.substr(0, config.maxLengthDisplay) + "...";
        }
        else return content;
    },

    decodeHtml: function (content) {
        return $('<textarea />').html(content).text();
    },

    validateForm: function (element, config) {
        var defaultConfig = {
            errorElement: 'div', //default input error message container
            errorClass: 'help-block help-block-error', // default input error message class
            focusInvalid: true, // do not focus the last invalid input
            //ignore: ".ignore", // validate all fields including form hidden input
            errorPlacement: function (error, element) {
                if (element.closest(".form-group").find(".input-group").length > 0) {
                    error.insertAfter(element.closest(".form-group").find(".input-group"));
                } else if (element.is(':checkbox')) {
                    error.insertAfter(element.closest(".md-checkbox-list, .md-checkbox-inline, .checkbox-list, .checkbox-inline"));
                } else if (element.is(':radio')) {
                    error.insertAfter(element.closest(".md-radio-list, .md-radio-inline, .radio-list,.radio-inline"));
                } else if (element.is('select')) {
                    error.insertAfter(element.closest(".form-group").find(".select2-container"));
                }

                else if (element.is('textarea')) {
                    error.insertAfter(element);
                }
                else if (element.is(':file')) {
                    error.insertAfter(element.closest(".fileinput"));
                }
                else {
                    error.insertAfter(element); // for other inputs, just perform default behavior
                }

            },
            highlight: function (element, errorClass, validClass) {
                $(element)
                    .closest('.form-group').addClass('has-error'); // set error class to the control group

            },
            unhighlight: function (element, errorClass, validClass) { // revert the change done by hightlight
                $(element).closest('.form-group').removeClass('has-error'); // set error class to the control group
            },
            submitHandler: function (form) {

            }
        };

        return $(element).validate($.extend({}, defaultConfig, config));
    },


    logout: function () {

        localStorage.removeItem('FrimaAuth');
        //window.location = "admin/login";
        //$state.go('login');
        //$rootScope.logout();
    },
    renderImage: function (imageUrl, domainHttp) {

        if (imageUrl == null || imageUrl == "") {
            return '<img class="show-img" height="25px" width="25px" src="/../../assets/layouts/layout2/img/no-image.png"/>';
        }
        else return '<img class="show-img" height="25px" width="25px" src="' + domainHttp + imageUrl + '"/>';
    },
    notiLoginRequire: function () {
        toastr.error(notiMessages.loginRequire);
    }
}
//dttb plugin
jQuery.fn.dataTable.Api.register('page.jumpToData()', function (data, column) {
    var pos = this.column(column, { order: 'current' }).data().indexOf(data);

    if (pos >= 0) {
        var page = Math.floor(pos / this.page.info().length);
        this.page(page).draw(false);
    }

    return this;
});
//jstree
/*! jsTree - v3.2.1 - 2015-08-24 - (MIT) */
!function (a) { "use strict"; "function" == typeof define && define.amd ? define(["jquery"], a) : "undefined" != typeof module && module.exports ? module.exports = a(require("jquery")) : a(jQuery) }(function (a, b) {
    "use strict"; if (!a.jstree) {
        var c = 0, d = !1, e = !1, f = !1, g = [], h = a("script:last").attr("src"), i = window.document, j = i.createElement("LI"), k, l; j.setAttribute("role", "treeitem"), k = i.createElement("I"), k.className = "jstree-icon jstree-ocl", k.setAttribute("role", "presentation"), j.appendChild(k), k = i.createElement("A"), k.className = "jstree-anchor", k.setAttribute("href", "#"), k.setAttribute("tabindex", "-1"), l = i.createElement("I"), l.className = "jstree-icon jstree-themeicon", l.setAttribute("role", "presentation"), k.appendChild(l), j.appendChild(k), k = l = null, a.jstree = { version: "3.2.1", defaults: { plugins: [] }, plugins: {}, path: h && -1 !== h.indexOf("/") ? h.replace(/\/[^\/]+$/, "") : "", idregex: /[\\:&!^|()\[\]<>@*'+~#";.,=\- \/${}%?`]/g, root: "#" }, a.jstree.create = function (b, d) { var e = new a.jstree.core(++c), f = d; return d = a.extend(!0, {}, a.jstree.defaults, d), f && f.plugins && (d.plugins = f.plugins), a.each(d.plugins, function (a, b) { "core" !== a && (e = e.plugin(b, d[b])) }), a(b).data("jstree", e), e.init(b, d), e }, a.jstree.destroy = function () { a(".jstree:jstree").jstree("destroy"), a(i).off(".jstree") }, a.jstree.core = function (a) { this._id = a, this._cnt = 0, this._wrk = null, this._data = { core: { themes: { name: !1, dots: !1, icons: !1 }, selected: [], last_error: {}, working: !1, worker_queue: [], focused: null } } }, a.jstree.reference = function (b) { var c = null, d = null; if (!b || !b.id || b.tagName && b.nodeType || (b = b.id), !d || !d.length) try { d = a(b) } catch (e) { } if (!d || !d.length) try { d = a("#" + b.replace(a.jstree.idregex, "\\$&")) } catch (e) { } return d && d.length && (d = d.closest(".jstree")).length && (d = d.data("jstree")) ? c = d : a(".jstree").each(function () { var d = a(this).data("jstree"); return d && d._model.data[b] ? (c = d, !1) : void 0 }), c }, a.fn.jstree = function (c) { var d = "string" == typeof c, e = Array.prototype.slice.call(arguments, 1), f = null; return c !== !0 || this.length ? (this.each(function () { var g = a.jstree.reference(this), h = d && g ? g[c] : null; return f = d && h ? h.apply(g, e) : null, g || d || c !== b && !a.isPlainObject(c) || a.jstree.create(this, c), (g && !d || c === !0) && (f = g || !1), null !== f && f !== b ? !1 : void 0 }), null !== f && f !== b ? f : this) : !1 }, a.expr[":"].jstree = a.expr.createPseudo(function (c) { return function (c) { return a(c).hasClass("jstree") && a(c).data("jstree") !== b } }), a.jstree.defaults.core = { data: !1, strings: !1, check_callback: !1, error: a.noop, animation: 200, multiple: !0, themes: { name: !1, url: !1, dir: !1, dots: !0, icons: !0, stripes: !1, variant: !1, responsive: !1 }, expand_selected_onload: !0, worker: !0, force_text: !1, dblclick_toggle: !0 }, a.jstree.core.prototype = {
            plugin: function (b, c) { var d = a.jstree.plugins[b]; return d ? (this._data[b] = {}, d.prototype = this, new d(c, this)) : this }, init: function (b, c) { this._model = { data: {}, changed: [], force_full_redraw: !1, redraw_timeout: !1, default_state: { loaded: !0, opened: !1, selected: !1, disabled: !1 } }, this._model.data[a.jstree.root] = { id: a.jstree.root, parent: null, parents: [], children: [], children_d: [], state: { loaded: !1 } }, this.element = a(b).addClass("jstree jstree-" + this._id), this.settings = c, this._data.core.ready = !1, this._data.core.loaded = !1, this._data.core.rtl = "rtl" === this.element.css("direction"), this.element[this._data.core.rtl ? "addClass" : "removeClass"]("jstree-rtl"), this.element.attr("role", "tree"), this.settings.core.multiple && this.element.attr("aria-multiselectable", !0), this.element.attr("tabindex") || this.element.attr("tabindex", "0"), this.bind(), this.trigger("init"), this._data.core.original_container_html = this.element.find(" > ul > li").clone(!0), this._data.core.original_container_html.find("li").addBack().contents().filter(function () { return 3 === this.nodeType && (!this.nodeValue || /^\s+$/.test(this.nodeValue)) }).remove(), this.element.html("<ul class='jstree-container-ul jstree-children' role='group'><li id='j" + this._id + "_loading' class='jstree-initial-node jstree-loading jstree-leaf jstree-last' role='tree-item'><i class='jstree-icon jstree-ocl'></i><a class='jstree-anchor' href='#'><i class='jstree-icon jstree-themeicon-hidden'></i>" + this.get_string("Loading ...") + "</a></li></ul>"), this.element.attr("aria-activedescendant", "j" + this._id + "_loading"), this._data.core.li_height = this.get_container_ul().children("li").first().height() || 24, this.trigger("loading"), this.load_node(a.jstree.root) }, destroy: function (a) { if (this._wrk) try { window.URL.revokeObjectURL(this._wrk), this._wrk = null } catch (b) { } a || this.element.empty(), this.teardown() }, teardown: function () { this.unbind(), this.element.removeClass("jstree").removeData("jstree").find("[class^='jstree']").addBack().attr("class", function () { return this.className.replace(/jstree[^ ]*|$/gi, "") }), this.element = null }, bind: function () { var b = "", c = null, d = 0; this.element.on("dblclick.jstree", function (a) { if (a.target.tagName && "input" === a.target.tagName.toLowerCase()) return !0; if (i.selection && i.selection.empty) i.selection.empty(); else if (window.getSelection) { var b = window.getSelection(); try { b.removeAllRanges(), b.collapse() } catch (c) { } } }).on("mousedown.jstree", a.proxy(function (a) { a.target === this.element[0] && (a.preventDefault(), d = +new Date) }, this)).on("mousedown.jstree", ".jstree-ocl", function (a) { a.preventDefault() }).on("click.jstree", ".jstree-ocl", a.proxy(function (a) { this.toggle_node(a.target) }, this)).on("dblclick.jstree", ".jstree-anchor", a.proxy(function (a) { return a.target.tagName && "input" === a.target.tagName.toLowerCase() ? !0 : void (this.settings.core.dblclick_toggle && this.toggle_node(a.target)) }, this)).on("click.jstree", ".jstree-anchor", a.proxy(function (b) { b.preventDefault(), b.currentTarget !== i.activeElement && a(b.currentTarget).focus(), this.activate_node(b.currentTarget, b) }, this)).on("keydown.jstree", ".jstree-anchor", a.proxy(function (b) { if (b.target.tagName && "input" === b.target.tagName.toLowerCase()) return !0; if (32 !== b.which && 13 !== b.which && (b.shiftKey || b.ctrlKey || b.altKey || b.metaKey)) return !0; var c = null; switch (this._data.core.rtl && (37 === b.which ? b.which = 39 : 39 === b.which && (b.which = 37)), b.which) { case 32: b.ctrlKey && (b.type = "click", a(b.currentTarget).trigger(b)); break; case 13: b.type = "click", a(b.currentTarget).trigger(b); break; case 37: b.preventDefault(), this.is_open(b.currentTarget) ? this.close_node(b.currentTarget) : (c = this.get_parent(b.currentTarget), c && c.id !== a.jstree.root && this.get_node(c, !0).children(".jstree-anchor").focus()); break; case 38: b.preventDefault(), c = this.get_prev_dom(b.currentTarget), c && c.length && c.children(".jstree-anchor").focus(); break; case 39: b.preventDefault(), this.is_closed(b.currentTarget) ? this.open_node(b.currentTarget, function (a) { this.get_node(a, !0).children(".jstree-anchor").focus() }) : this.is_open(b.currentTarget) && (c = this.get_node(b.currentTarget, !0).children(".jstree-children")[0], c && a(this._firstChild(c)).children(".jstree-anchor").focus()); break; case 40: b.preventDefault(), c = this.get_next_dom(b.currentTarget), c && c.length && c.children(".jstree-anchor").focus(); break; case 106: this.open_all(); break; case 36: b.preventDefault(), c = this._firstChild(this.get_container_ul()[0]), c && a(c).children(".jstree-anchor").filter(":visible").focus(); break; case 35: b.preventDefault(), this.element.find(".jstree-anchor").filter(":visible").last().focus() } }, this)).on("load_node.jstree", a.proxy(function (b, c) { c.status && (c.node.id !== a.jstree.root || this._data.core.loaded || (this._data.core.loaded = !0, this._firstChild(this.get_container_ul()[0]) && this.element.attr("aria-activedescendant", this._firstChild(this.get_container_ul()[0]).id), this.trigger("loaded")), this._data.core.ready || setTimeout(a.proxy(function () { if (this.element && !this.get_container_ul().find(".jstree-loading").length) { if (this._data.core.ready = !0, this._data.core.selected.length) { if (this.settings.core.expand_selected_onload) { var b = [], c, d; for (c = 0, d = this._data.core.selected.length; d > c; c++) b = b.concat(this._model.data[this._data.core.selected[c]].parents); for (b = a.vakata.array_unique(b), c = 0, d = b.length; d > c; c++) this.open_node(b[c], !1, 0) } this.trigger("changed", { action: "ready", selected: this._data.core.selected }) } this.trigger("ready") } }, this), 0)) }, this)).on("keypress.jstree", a.proxy(function (d) { if (d.target.tagName && "input" === d.target.tagName.toLowerCase()) return !0; c && clearTimeout(c), c = setTimeout(function () { b = "" }, 500); var e = String.fromCharCode(d.which).toLowerCase(), f = this.element.find(".jstree-anchor").filter(":visible"), g = f.index(i.activeElement) || 0, h = !1; if (b += e, b.length > 1) { if (f.slice(g).each(a.proxy(function (c, d) { return 0 === a(d).text().toLowerCase().indexOf(b) ? (a(d).focus(), h = !0, !1) : void 0 }, this)), h) return; if (f.slice(0, g).each(a.proxy(function (c, d) { return 0 === a(d).text().toLowerCase().indexOf(b) ? (a(d).focus(), h = !0, !1) : void 0 }, this)), h) return } if (new RegExp("^" + e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&") + "+$").test(b)) { if (f.slice(g + 1).each(a.proxy(function (b, c) { return a(c).text().toLowerCase().charAt(0) === e ? (a(c).focus(), h = !0, !1) : void 0 }, this)), h) return; if (f.slice(0, g + 1).each(a.proxy(function (b, c) { return a(c).text().toLowerCase().charAt(0) === e ? (a(c).focus(), h = !0, !1) : void 0 }, this)), h) return } }, this)).on("init.jstree", a.proxy(function () { var a = this.settings.core.themes; this._data.core.themes.dots = a.dots, this._data.core.themes.stripes = a.stripes, this._data.core.themes.icons = a.icons, this.set_theme(a.name || "default", a.url), this.set_theme_variant(a.variant) }, this)).on("loading.jstree", a.proxy(function () { this[this._data.core.themes.dots ? "show_dots" : "hide_dots"](), this[this._data.core.themes.icons ? "show_icons" : "hide_icons"](), this[this._data.core.themes.stripes ? "show_stripes" : "hide_stripes"]() }, this)).on("blur.jstree", ".jstree-anchor", a.proxy(function (b) { this._data.core.focused = null, a(b.currentTarget).filter(".jstree-hovered").mouseleave(), this.element.attr("tabindex", "0") }, this)).on("focus.jstree", ".jstree-anchor", a.proxy(function (b) { var c = this.get_node(b.currentTarget); c && c.id && (this._data.core.focused = c.id), this.element.find(".jstree-hovered").not(b.currentTarget).mouseleave(), a(b.currentTarget).mouseenter(), this.element.attr("tabindex", "-1") }, this)).on("focus.jstree", a.proxy(function () { if (+new Date - d > 500 && !this._data.core.focused) { d = 0; var a = this.get_node(this.element.attr("aria-activedescendant"), !0); a && a.find("> .jstree-anchor").focus() } }, this)).on("mouseenter.jstree", ".jstree-anchor", a.proxy(function (a) { this.hover_node(a.currentTarget) }, this)).on("mouseleave.jstree", ".jstree-anchor", a.proxy(function (a) { this.dehover_node(a.currentTarget) }, this)) }, unbind: function () { this.element.off(".jstree"), a(i).off(".jstree-" + this._id) }, trigger: function (a, b) { b || (b = {}), b.instance = this, this.element.triggerHandler(a.replace(".jstree", "") + ".jstree", b) }, get_container: function () { return this.element }, get_container_ul: function () { return this.element.children(".jstree-children").first() }, get_string: function (b) { var c = this.settings.core.strings; return a.isFunction(c) ? c.call(this, b) : c && c[b] ? c[b] : b }, _firstChild: function (a) { a = a ? a.firstChild : null; while (null !== a && 1 !== a.nodeType) a = a.nextSibling; return a }, _nextSibling: function (a) { a = a ? a.nextSibling : null; while (null !== a && 1 !== a.nodeType) a = a.nextSibling; return a }, _previousSibling: function (a) { a = a ? a.previousSibling : null; while (null !== a && 1 !== a.nodeType) a = a.previousSibling; return a }, get_node: function (b, c) { b && b.id && (b = b.id); var d; try { if (this._model.data[b]) b = this._model.data[b]; else if ("string" == typeof b && this._model.data[b.replace(/^#/, "")]) b = this._model.data[b.replace(/^#/, "")]; else if ("string" == typeof b && (d = a("#" + b.replace(a.jstree.idregex, "\\$&"), this.element)).length && this._model.data[d.closest(".jstree-node").attr("id")]) b = this._model.data[d.closest(".jstree-node").attr("id")]; else if ((d = a(b, this.element)).length && this._model.data[d.closest(".jstree-node").attr("id")]) b = this._model.data[d.closest(".jstree-node").attr("id")]; else { if (!(d = a(b, this.element)).length || !d.hasClass("jstree")) return !1; b = this._model.data[a.jstree.root] } return c && (b = b.id === a.jstree.root ? this.element : a("#" + b.id.replace(a.jstree.idregex, "\\$&"), this.element)), b } catch (e) { return !1 } }, get_path: function (b, c, d) { if (b = b.parents ? b : this.get_node(b), !b || b.id === a.jstree.root || !b.parents) return !1; var e, f, g = []; for (g.push(d ? b.id : b.text), e = 0, f = b.parents.length; f > e; e++) g.push(d ? b.parents[e] : this.get_text(b.parents[e])); return g = g.reverse().slice(1), c ? g.join(c) : g }, get_next_dom: function (b, c) { var d; if (b = this.get_node(b, !0), b[0] === this.element[0]) { d = this._firstChild(this.get_container_ul()[0]); while (d && 0 === d.offsetHeight) d = this._nextSibling(d); return d ? a(d) : !1 } if (!b || !b.length) return !1; if (c) { d = b[0]; do d = this._nextSibling(d); while (d && 0 === d.offsetHeight); return d ? a(d) : !1 } if (b.hasClass("jstree-open")) { d = this._firstChild(b.children(".jstree-children")[0]); while (d && 0 === d.offsetHeight) d = this._nextSibling(d); if (null !== d) return a(d) } d = b[0]; do d = this._nextSibling(d); while (d && 0 === d.offsetHeight); return null !== d ? a(d) : b.parentsUntil(".jstree", ".jstree-node").nextAll(".jstree-node:visible").first() }, get_prev_dom: function (b, c) { var d; if (b = this.get_node(b, !0), b[0] === this.element[0]) { d = this.get_container_ul()[0].lastChild; while (d && 0 === d.offsetHeight) d = this._previousSibling(d); return d ? a(d) : !1 } if (!b || !b.length) return !1; if (c) { d = b[0]; do d = this._previousSibling(d); while (d && 0 === d.offsetHeight); return d ? a(d) : !1 } d = b[0]; do d = this._previousSibling(d); while (d && 0 === d.offsetHeight); if (null !== d) { b = a(d); while (b.hasClass("jstree-open")) b = b.children(".jstree-children").first().children(".jstree-node:visible:last"); return b } return d = b[0].parentNode.parentNode, d && d.className && -1 !== d.className.indexOf("jstree-node") ? a(d) : !1 }, get_parent: function (b) { return b = this.get_node(b), b && b.id !== a.jstree.root ? b.parent : !1 }, get_children_dom: function (a) { return a = this.get_node(a, !0), a[0] === this.element[0] ? this.get_container_ul().children(".jstree-node") : a && a.length ? a.children(".jstree-children").children(".jstree-node") : !1 }, is_parent: function (a) { return a = this.get_node(a), a && (a.state.loaded === !1 || a.children.length > 0) }, is_loaded: function (a) { return a = this.get_node(a), a && a.state.loaded }, is_loading: function (a) { return a = this.get_node(a), a && a.state && a.state.loading }, is_open: function (a) { return a = this.get_node(a), a && a.state.opened }, is_closed: function (a) { return a = this.get_node(a), a && this.is_parent(a) && !a.state.opened }, is_leaf: function (a) { return !this.is_parent(a) }, load_node: function (b, c) { var d, e, f, g, h; if (a.isArray(b)) return this._load_nodes(b.slice(), c), !0; if (b = this.get_node(b), !b) return c && c.call(this, b, !1), !1; if (b.state.loaded) { for (b.state.loaded = !1, d = 0, e = b.children_d.length; e > d; d++) { for (f = 0, g = b.parents.length; g > f; f++) this._model.data[b.parents[f]].children_d = a.vakata.array_remove_item(this._model.data[b.parents[f]].children_d, b.children_d[d]); this._model.data[b.children_d[d]].state.selected && (h = !0, this._data.core.selected = a.vakata.array_remove_item(this._data.core.selected, b.children_d[d])), delete this._model.data[b.children_d[d]] } b.children = [], b.children_d = [], h && this.trigger("changed", { action: "load_node", node: b, selected: this._data.core.selected }) } return b.state.failed = !1, b.state.loading = !0, this.get_node(b, !0).addClass("jstree-loading").attr("aria-busy", !0), this._load_node(b, a.proxy(function (a) { b = this._model.data[b.id], b.state.loading = !1, b.state.loaded = a, b.state.failed = !b.state.loaded; var d = this.get_node(b, !0), e = 0, f = 0, g = this._model.data, h = !1; for (e = 0, f = b.children.length; f > e; e++) if (g[b.children[e]] && !g[b.children[e]].state.hidden) { h = !0; break } b.state.loaded && !h && d && d.length && !d.hasClass("jstree-leaf") && d.removeClass("jstree-closed jstree-open").addClass("jstree-leaf"), d.removeClass("jstree-loading").attr("aria-busy", !1), this.trigger("load_node", { node: b, status: a }), c && c.call(this, b, a) }, this)), !0 }, _load_nodes: function (a, b, c) { var d = !0, e = function () { this._load_nodes(a, b, !0) }, f = this._model.data, g, h, i = []; for (g = 0, h = a.length; h > g; g++) !f[a[g]] || (f[a[g]].state.loaded || f[a[g]].state.failed) && c || (this.is_loading(a[g]) || this.load_node(a[g], e), d = !1); if (d) { for (g = 0, h = a.length; h > g; g++) f[a[g]] && f[a[g]].state.loaded && i.push(a[g]); b && !b.done && (b.call(this, i), b.done = !0) } }, load_all: function (b, c) { if (b || (b = a.jstree.root), b = this.get_node(b), !b) return !1; var d = [], e = this._model.data, f = e[b.id].children_d, g, h; for (b.state && !b.state.loaded && d.push(b.id), g = 0, h = f.length; h > g; g++) e[f[g]] && e[f[g]].state && !e[f[g]].state.loaded && d.push(f[g]); d.length ? this._load_nodes(d, function () { this.load_all(b, c) }) : (c && c.call(this, b), this.trigger("load_all", { node: b })) }, _load_node: function (b, c) { var d = this.settings.core.data, e; return d ? a.isFunction(d) ? d.call(this, b, a.proxy(function (d) { d === !1 && c.call(this, !1), this["string" == typeof d ? "_append_html_data" : "_append_json_data"](b, "string" == typeof d ? a(a.parseHTML(d)).filter(function () { return 3 !== this.nodeType }) : d, function (a) { c.call(this, a) }) }, this)) : "object" == typeof d ? d.url ? (d = a.extend(!0, {}, d), a.isFunction(d.url) && (d.url = d.url.call(this, b)), a.isFunction(d.data) && (d.data = d.data.call(this, b)), a.ajax(d).done(a.proxy(function (d, e, f) { var g = f.getResponseHeader("Content-Type"); return g && -1 !== g.indexOf("json") || "object" == typeof d ? this._append_json_data(b, d, function (a) { c.call(this, a) }) : g && -1 !== g.indexOf("html") || "string" == typeof d ? this._append_html_data(b, a(a.parseHTML(d)).filter(function () { return 3 !== this.nodeType }), function (a) { c.call(this, a) }) : (this._data.core.last_error = { error: "ajax", plugin: "core", id: "core_04", reason: "Could not load node", data: JSON.stringify({ id: b.id, xhr: f }) }, this.settings.core.error.call(this, this._data.core.last_error), c.call(this, !1)) }, this)).fail(a.proxy(function (a) { c.call(this, !1), this._data.core.last_error = { error: "ajax", plugin: "core", id: "core_04", reason: "Could not load node", data: JSON.stringify({ id: b.id, xhr: a }) }, this.settings.core.error.call(this, this._data.core.last_error) }, this))) : (e = a.isArray(d) || a.isPlainObject(d) ? JSON.parse(JSON.stringify(d)) : d, b.id === a.jstree.root ? this._append_json_data(b, e, function (a) { c.call(this, a) }) : (this._data.core.last_error = { error: "nodata", plugin: "core", id: "core_05", reason: "Could not load node", data: JSON.stringify({ id: b.id }) }, this.settings.core.error.call(this, this._data.core.last_error), c.call(this, !1))) : "string" == typeof d ? b.id === a.jstree.root ? this._append_html_data(b, a(a.parseHTML(d)).filter(function () { return 3 !== this.nodeType }), function (a) { c.call(this, a) }) : (this._data.core.last_error = { error: "nodata", plugin: "core", id: "core_06", reason: "Could not load node", data: JSON.stringify({ id: b.id }) }, this.settings.core.error.call(this, this._data.core.last_error), c.call(this, !1)) : c.call(this, !1) : b.id === a.jstree.root ? this._append_html_data(b, this._data.core.original_container_html.clone(!0), function (a) { c.call(this, a) }) : c.call(this, !1) }, _node_changed: function (a) { a = this.get_node(a), a && this._model.changed.push(a.id) }, _append_html_data: function (b, c, d) { b = this.get_node(b), b.children = [], b.children_d = []; var e = c.is("ul") ? c.children() : c, f = b.id, g = [], h = [], i = this._model.data, j = i[f], k = this._data.core.selected.length, l, m, n; for (e.each(a.proxy(function (b, c) { l = this._parse_model_from_html(a(c), f, j.parents.concat()), l && (g.push(l), h.push(l), i[l].children_d.length && (h = h.concat(i[l].children_d))) }, this)), j.children = g, j.children_d = h, m = 0, n = j.parents.length; n > m; m++) i[j.parents[m]].children_d = i[j.parents[m]].children_d.concat(h); this.trigger("model", { nodes: h, parent: f }), f !== a.jstree.root ? (this._node_changed(f), this.redraw()) : (this.get_container_ul().children(".jstree-initial-node").remove(), this.redraw(!0)), this._data.core.selected.length !== k && this.trigger("changed", { action: "model", selected: this._data.core.selected }), d.call(this, !0) }, _append_json_data: function (b, c, d, e) { if (null !== this.element) { b = this.get_node(b), b.children = [], b.children_d = [], c.d && (c = c.d, "string" == typeof c && (c = JSON.parse(c))), a.isArray(c) || (c = [c]); var f = null, g = { df: this._model.default_state, dat: c, par: b.id, m: this._model.data, t_id: this._id, t_cnt: this._cnt, sel: this._data.core.selected }, h = function (a, b) { a.data && (a = a.data); var c = a.dat, d = a.par, e = [], f = [], g = [], h = a.df, i = a.t_id, j = a.t_cnt, k = a.m, l = k[d], m = a.sel, n, o, p, q, r = function (a, c, d) { d = d ? d.concat() : [], c && d.unshift(c); var e = a.id.toString(), f, i, j, l, m = { id: e, text: a.text || "", icon: a.icon !== b ? a.icon : !0, parent: c, parents: d, children: a.children || [], children_d: a.children_d || [], data: a.data, state: {}, li_attr: { id: !1 }, a_attr: { href: "#" }, original: !1 }; for (f in h) h.hasOwnProperty(f) && (m.state[f] = h[f]); if (a && a.data && a.data.jstree && a.data.jstree.icon && (m.icon = a.data.jstree.icon), (m.icon === b || null === m.icon || "" === m.icon) && (m.icon = !0), a && a.data && (m.data = a.data, a.data.jstree)) for (f in a.data.jstree) a.data.jstree.hasOwnProperty(f) && (m.state[f] = a.data.jstree[f]); if (a && "object" == typeof a.state) for (f in a.state) a.state.hasOwnProperty(f) && (m.state[f] = a.state[f]); if (a && "object" == typeof a.li_attr) for (f in a.li_attr) a.li_attr.hasOwnProperty(f) && (m.li_attr[f] = a.li_attr[f]); if (m.li_attr.id || (m.li_attr.id = e), a && "object" == typeof a.a_attr) for (f in a.a_attr) a.a_attr.hasOwnProperty(f) && (m.a_attr[f] = a.a_attr[f]); for (a && a.children && a.children === !0 && (m.state.loaded = !1, m.children = [], m.children_d = []), k[m.id] = m, f = 0, i = m.children.length; i > f; f++) j = r(k[m.children[f]], m.id, d), l = k[j], m.children_d.push(j), l.children_d.length && (m.children_d = m.children_d.concat(l.children_d)); return delete a.data, delete a.children, k[m.id].original = a, m.state.selected && g.push(m.id), m.id }, s = function (a, c, d) { d = d ? d.concat() : [], c && d.unshift(c); var e = !1, f, l, m, n, o; do e = "j" + i + "_" + ++j; while (k[e]); o = { id: !1, text: "string" == typeof a ? a : "", icon: "object" == typeof a && a.icon !== b ? a.icon : !0, parent: c, parents: d, children: [], children_d: [], data: null, state: {}, li_attr: { id: !1 }, a_attr: { href: "#" }, original: !1 }; for (f in h) h.hasOwnProperty(f) && (o.state[f] = h[f]); if (a && a.id && (o.id = a.id.toString()), a && a.text && (o.text = a.text), a && a.data && a.data.jstree && a.data.jstree.icon && (o.icon = a.data.jstree.icon), (o.icon === b || null === o.icon || "" === o.icon) && (o.icon = !0), a && a.data && (o.data = a.data, a.data.jstree)) for (f in a.data.jstree) a.data.jstree.hasOwnProperty(f) && (o.state[f] = a.data.jstree[f]); if (a && "object" == typeof a.state) for (f in a.state) a.state.hasOwnProperty(f) && (o.state[f] = a.state[f]); if (a && "object" == typeof a.li_attr) for (f in a.li_attr) a.li_attr.hasOwnProperty(f) && (o.li_attr[f] = a.li_attr[f]); if (o.li_attr.id && !o.id && (o.id = o.li_attr.id.toString()), o.id || (o.id = e), o.li_attr.id || (o.li_attr.id = o.id), a && "object" == typeof a.a_attr) for (f in a.a_attr) a.a_attr.hasOwnProperty(f) && (o.a_attr[f] = a.a_attr[f]); if (a && a.children && a.children.length) { for (f = 0, l = a.children.length; l > f; f++) m = s(a.children[f], o.id, d), n = k[m], o.children.push(m), n.children_d.length && (o.children_d = o.children_d.concat(n.children_d)); o.children_d = o.children_d.concat(o.children) } return a && a.children && a.children === !0 && (o.state.loaded = !1, o.children = [], o.children_d = []), delete a.data, delete a.children, o.original = a, k[o.id] = o, o.state.selected && g.push(o.id), o.id }; if (c.length && c[0].id !== b && c[0].parent !== b) { for (o = 0, p = c.length; p > o; o++) c[o].children || (c[o].children = []), k[c[o].id.toString()] = c[o]; for (o = 0, p = c.length; p > o; o++) k[c[o].parent.toString()].children.push(c[o].id.toString()), l.children_d.push(c[o].id.toString()); for (o = 0, p = l.children.length; p > o; o++) n = r(k[l.children[o]], d, l.parents.concat()), f.push(n), k[n].children_d.length && (f = f.concat(k[n].children_d)); for (o = 0, p = l.parents.length; p > o; o++) k[l.parents[o]].children_d = k[l.parents[o]].children_d.concat(f); q = { cnt: j, mod: k, sel: m, par: d, dpc: f, add: g } } else { for (o = 0, p = c.length; p > o; o++) n = s(c[o], d, l.parents.concat()), n && (e.push(n), f.push(n), k[n].children_d.length && (f = f.concat(k[n].children_d))); for (l.children = e, l.children_d = f, o = 0, p = l.parents.length; p > o; o++) k[l.parents[o]].children_d = k[l.parents[o]].children_d.concat(f); q = { cnt: j, mod: k, sel: m, par: d, dpc: f, add: g } } return "undefined" != typeof window && "undefined" != typeof window.document ? q : void postMessage(q) }, i = function (b, c) { if (null !== this.element) { if (this._cnt = b.cnt, this._model.data = b.mod, c) { var e, f, g = b.add, h = b.sel, i = this._data.core.selected.slice(), j = this._model.data; if (h.length !== i.length || a.vakata.array_unique(h.concat(i)).length !== h.length) { for (e = 0, f = h.length; f > e; e++) -1 === a.inArray(h[e], g) && -1 === a.inArray(h[e], i) && (j[h[e]].state.selected = !1); for (e = 0, f = i.length; f > e; e++) -1 === a.inArray(i[e], h) && (j[i[e]].state.selected = !0) } } b.add.length && (this._data.core.selected = this._data.core.selected.concat(b.add)), this.trigger("model", { nodes: b.dpc, parent: b.par }), b.par !== a.jstree.root ? (this._node_changed(b.par), this.redraw()) : this.redraw(!0), b.add.length && this.trigger("changed", { action: "model", selected: this._data.core.selected }), d.call(this, !0) } }; if (this.settings.core.worker && window.Blob && window.URL && window.Worker) try { null === this._wrk && (this._wrk = window.URL.createObjectURL(new window.Blob(["self.onmessage = " + h.toString()], { type: "text/javascript" }))), !this._data.core.working || e ? (this._data.core.working = !0, f = new window.Worker(this._wrk), f.onmessage = a.proxy(function (a) { i.call(this, a.data, !0); try { f.terminate(), f = null } catch (b) { } this._data.core.worker_queue.length ? this._append_json_data.apply(this, this._data.core.worker_queue.shift()) : this._data.core.working = !1 }, this), g.par ? f.postMessage(g) : this._data.core.worker_queue.length ? this._append_json_data.apply(this, this._data.core.worker_queue.shift()) : this._data.core.working = !1) : this._data.core.worker_queue.push([b, c, d, !0]) } catch (j) { i.call(this, h(g), !1), this._data.core.worker_queue.length ? this._append_json_data.apply(this, this._data.core.worker_queue.shift()) : this._data.core.working = !1 } else i.call(this, h(g), !1) } }, _parse_model_from_html: function (c, d, e) { e = e ? [].concat(e) : [], d && e.unshift(d); var f, g, h = this._model.data, i = { id: !1, text: !1, icon: !0, parent: d, parents: e, children: [], children_d: [], data: null, state: {}, li_attr: { id: !1 }, a_attr: { href: "#" }, original: !1 }, j, k, l; for (j in this._model.default_state) this._model.default_state.hasOwnProperty(j) && (i.state[j] = this._model.default_state[j]); if (k = a.vakata.attributes(c, !0), a.each(k, function (b, c) { return c = a.trim(c), c.length ? (i.li_attr[b] = c, void ("id" === b && (i.id = c.toString()))) : !0 }), k = c.children("a").first(), k.length && (k = a.vakata.attributes(k, !0), a.each(k, function (b, c) { c = a.trim(c), c.length && (i.a_attr[b] = c) })), k = c.children("a").first().length ? c.children("a").first().clone() : c.clone(), k.children("ins, i, ul").remove(), k = k.html(), k = a("<div />").html(k), i.text = this.settings.core.force_text ? k.text() : k.html(), k = c.data(), i.data = k ? a.extend(!0, {}, k) : null, i.state.opened = c.hasClass("jstree-open"), i.state.selected = c.children("a").hasClass("jstree-clicked"), i.state.disabled = c.children("a").hasClass("jstree-disabled"), i.data && i.data.jstree) for (j in i.data.jstree) i.data.jstree.hasOwnProperty(j) && (i.state[j] = i.data.jstree[j]); k = c.children("a").children(".jstree-themeicon"), k.length && (i.icon = k.hasClass("jstree-themeicon-hidden") ? !1 : k.attr("rel")), i.state.icon !== b && (i.icon = i.state.icon), (i.icon === b || null === i.icon || "" === i.icon) && (i.icon = !0), k = c.children("ul").children("li"); do l = "j" + this._id + "_" + ++this._cnt; while (h[l]); return i.id = i.li_attr.id ? i.li_attr.id.toString() : l, k.length ? (k.each(a.proxy(function (b, c) { f = this._parse_model_from_html(a(c), i.id, e), g = this._model.data[f], i.children.push(f), g.children_d.length && (i.children_d = i.children_d.concat(g.children_d)) }, this)), i.children_d = i.children_d.concat(i.children)) : c.hasClass("jstree-closed") && (i.state.loaded = !1), i.li_attr["class"] && (i.li_attr["class"] = i.li_attr["class"].replace("jstree-closed", "").replace("jstree-open", "")), i.a_attr["class"] && (i.a_attr["class"] = i.a_attr["class"].replace("jstree-clicked", "").replace("jstree-disabled", "")), h[i.id] = i, i.state.selected && this._data.core.selected.push(i.id), i.id }, _parse_model_from_flat_json: function (a, c, d) { d = d ? d.concat() : [], c && d.unshift(c); var e = a.id.toString(), f = this._model.data, g = this._model.default_state, h, i, j, k, l = { id: e, text: a.text || "", icon: a.icon !== b ? a.icon : !0, parent: c, parents: d, children: a.children || [], children_d: a.children_d || [], data: a.data, state: {}, li_attr: { id: !1 }, a_attr: { href: "#" }, original: !1 }; for (h in g) g.hasOwnProperty(h) && (l.state[h] = g[h]); if (a && a.data && a.data.jstree && a.data.jstree.icon && (l.icon = a.data.jstree.icon), (l.icon === b || null === l.icon || "" === l.icon) && (l.icon = !0), a && a.data && (l.data = a.data, a.data.jstree)) for (h in a.data.jstree) a.data.jstree.hasOwnProperty(h) && (l.state[h] = a.data.jstree[h]); if (a && "object" == typeof a.state) for (h in a.state) a.state.hasOwnProperty(h) && (l.state[h] = a.state[h]); if (a && "object" == typeof a.li_attr) for (h in a.li_attr) a.li_attr.hasOwnProperty(h) && (l.li_attr[h] = a.li_attr[h]); if (l.li_attr.id || (l.li_attr.id = e), a && "object" == typeof a.a_attr) for (h in a.a_attr) a.a_attr.hasOwnProperty(h) && (l.a_attr[h] = a.a_attr[h]); for (a && a.children && a.children === !0 && (l.state.loaded = !1, l.children = [], l.children_d = []), f[l.id] = l, h = 0, i = l.children.length; i > h; h++) j = this._parse_model_from_flat_json(f[l.children[h]], l.id, d), k = f[j], l.children_d.push(j), k.children_d.length && (l.children_d = l.children_d.concat(k.children_d)); return delete a.data, delete a.children, f[l.id].original = a, l.state.selected && this._data.core.selected.push(l.id), l.id }, _parse_model_from_json: function (a, c, d) { d = d ? d.concat() : [], c && d.unshift(c); var e = !1, f, g, h, i, j = this._model.data, k = this._model.default_state, l; do e = "j" + this._id + "_" + ++this._cnt; while (j[e]); l = { id: !1, text: "string" == typeof a ? a : "", icon: "object" == typeof a && a.icon !== b ? a.icon : !0, parent: c, parents: d, children: [], children_d: [], data: null, state: {}, li_attr: { id: !1 }, a_attr: { href: "#" }, original: !1 }; for (f in k) k.hasOwnProperty(f) && (l.state[f] = k[f]); if (a && a.id && (l.id = a.id.toString()), a && a.text && (l.text = a.text), a && a.data && a.data.jstree && a.data.jstree.icon && (l.icon = a.data.jstree.icon), (l.icon === b || null === l.icon || "" === l.icon) && (l.icon = !0), a && a.data && (l.data = a.data, a.data.jstree)) for (f in a.data.jstree) a.data.jstree.hasOwnProperty(f) && (l.state[f] = a.data.jstree[f]); if (a && "object" == typeof a.state) for (f in a.state) a.state.hasOwnProperty(f) && (l.state[f] = a.state[f]); if (a && "object" == typeof a.li_attr) for (f in a.li_attr) a.li_attr.hasOwnProperty(f) && (l.li_attr[f] = a.li_attr[f]); if (l.li_attr.id && !l.id && (l.id = l.li_attr.id.toString()), l.id || (l.id = e), l.li_attr.id || (l.li_attr.id = l.id), a && "object" == typeof a.a_attr) for (f in a.a_attr) a.a_attr.hasOwnProperty(f) && (l.a_attr[f] = a.a_attr[f]); if (a && a.children && a.children.length) { for (f = 0, g = a.children.length; g > f; f++) h = this._parse_model_from_json(a.children[f], l.id, d), i = j[h], l.children.push(h), i.children_d.length && (l.children_d = l.children_d.concat(i.children_d)); l.children_d = l.children_d.concat(l.children) } return a && a.children && a.children === !0 && (l.state.loaded = !1, l.children = [], l.children_d = []), delete a.data, delete a.children, l.original = a, j[l.id] = l, l.state.selected && this._data.core.selected.push(l.id), l.id }, _redraw: function () { var b = this._model.force_full_redraw ? this._model.data[a.jstree.root].children.concat([]) : this._model.changed.concat([]), c = i.createElement("UL"), d, e, f, g = this._data.core.focused; for (e = 0, f = b.length; f > e; e++) d = this.redraw_node(b[e], !0, this._model.force_full_redraw), d && this._model.force_full_redraw && c.appendChild(d); this._model.force_full_redraw && (c.className = this.get_container_ul()[0].className, c.setAttribute("role", "group"), this.element.empty().append(c)), null !== g && (d = this.get_node(g, !0), d && d.length && d.children(".jstree-anchor")[0] !== i.activeElement ? d.children(".jstree-anchor").focus() : this._data.core.focused = null), this._model.force_full_redraw = !1, this._model.changed = [], this.trigger("redraw", { nodes: b }) }, redraw: function (a) { a && (this._model.force_full_redraw = !0), this._redraw() }, draw_children: function (b) { var c = this.get_node(b), d = !1, e = !1, f = !1, g = i; if (!c) return !1; if (c.id === a.jstree.root) return this.redraw(!0); if (b = this.get_node(b, !0), !b || !b.length) return !1; if (b.children(".jstree-children").remove(), b = b[0], c.children.length && c.state.loaded) { for (f = g.createElement("UL"), f.setAttribute("role", "group"), f.className = "jstree-children", d = 0, e = c.children.length; e > d; d++) f.appendChild(this.redraw_node(c.children[d], !0, !0)); b.appendChild(f) } }, redraw_node: function (b, c, d, e) {
                var f = this.get_node(b), g = !1, h = !1, k = !1, l = !1, m = !1, n = !1, o = "", p = i, q = this._model.data, r = !1, s = !1, t = null, u = 0, v = 0, w = !1, x = !1; if (!f) return !1; if (f.id === a.jstree.root) return this.redraw(!0); if (c = c || 0 === f.children.length, b = i.querySelector ? this.element[0].querySelector("#" + (-1 !== "0123456789".indexOf(f.id[0]) ? "\\3" + f.id[0] + " " + f.id.substr(1).replace(a.jstree.idregex, "\\$&") : f.id.replace(a.jstree.idregex, "\\$&"))) : i.getElementById(f.id)) b = a(b), d || (g = b.parent().parent()[0], g === this.element[0] && (g = null), h = b.index()), c || !f.children.length || b.children(".jstree-children").length || (c = !0),
                    c || (k = b.children(".jstree-children")[0]), r = b.children(".jstree-anchor")[0] === i.activeElement, b.remove(); else if (c = !0, !d) { if (g = f.parent !== a.jstree.root ? a("#" + f.parent.replace(a.jstree.idregex, "\\$&"), this.element)[0] : null, !(null === g || g && q[f.parent].state.opened)) return !1; h = a.inArray(f.id, null === g ? q[a.jstree.root].children : q[f.parent].children) } b = j.cloneNode(!0), o = "jstree-node "; for (l in f.li_attr) if (f.li_attr.hasOwnProperty(l)) { if ("id" === l) continue; "class" !== l ? b.setAttribute(l, f.li_attr[l]) : o += f.li_attr[l] } for (f.a_attr.id || (f.a_attr.id = f.id + "_anchor"), b.setAttribute("aria-selected", !!f.state.selected), b.setAttribute("aria-level", f.parents.length), b.setAttribute("aria-labelledby", f.a_attr.id), f.state.disabled && b.setAttribute("aria-disabled", !0), l = 0, m = f.children.length; m > l; l++) if (!q[f.children[l]].state.hidden) { w = !0; break } if (null !== f.parent && q[f.parent] && !f.state.hidden && (l = a.inArray(f.id, q[f.parent].children), x = f.id, -1 !== l)) for (l++ , m = q[f.parent].children.length; m > l; l++) if (q[q[f.parent].children[l]].state.hidden || (x = q[f.parent].children[l]), x !== f.id) break; f.state.hidden && (o += " jstree-hidden"), f.state.loaded && !w ? o += " jstree-leaf" : (o += f.state.opened && f.state.loaded ? " jstree-open" : " jstree-closed", b.setAttribute("aria-expanded", f.state.opened && f.state.loaded)), x === f.id && (o += " jstree-last"), b.id = f.id, b.className = o, o = (f.state.selected ? " jstree-clicked" : "") + (f.state.disabled ? " jstree-disabled" : ""); for (m in f.a_attr) if (f.a_attr.hasOwnProperty(m)) { if ("href" === m && "#" === f.a_attr[m]) continue; "class" !== m ? b.childNodes[1].setAttribute(m, f.a_attr[m]) : o += " " + f.a_attr[m] } if (o.length && (b.childNodes[1].className = "jstree-anchor " + o), (f.icon && f.icon !== !0 || f.icon === !1) && (f.icon === !1 ? b.childNodes[1].childNodes[0].className += " jstree-themeicon-hidden" : -1 === f.icon.indexOf("/") && -1 === f.icon.indexOf(".") ? b.childNodes[1].childNodes[0].className += " " + f.icon + " jstree-themeicon-custom" : (b.childNodes[1].childNodes[0].style.backgroundImage = "url(" + f.icon + ")", b.childNodes[1].childNodes[0].style.backgroundPosition = "center center", b.childNodes[1].childNodes[0].style.backgroundSize = "auto", b.childNodes[1].childNodes[0].className += " jstree-themeicon-custom")), this.settings.core.force_text ? b.childNodes[1].appendChild(p.createTextNode(f.text)) : b.childNodes[1].innerHTML += f.text, c && f.children.length && (f.state.opened || e) && f.state.loaded) { for (n = p.createElement("UL"), n.setAttribute("role", "group"), n.className = "jstree-children", l = 0, m = f.children.length; m > l; l++) n.appendChild(this.redraw_node(f.children[l], c, !0)); b.appendChild(n) } if (k && b.appendChild(k), !d) { for (g || (g = this.element[0]), l = 0, m = g.childNodes.length; m > l; l++) if (g.childNodes[l] && g.childNodes[l].className && -1 !== g.childNodes[l].className.indexOf("jstree-children")) { t = g.childNodes[l]; break } t || (t = p.createElement("UL"), t.setAttribute("role", "group"), t.className = "jstree-children", g.appendChild(t)), g = t, h < g.childNodes.length ? g.insertBefore(b, g.childNodes[h]) : g.appendChild(b), r && (u = this.element[0].scrollTop, v = this.element[0].scrollLeft, b.childNodes[1].focus(), this.element[0].scrollTop = u, this.element[0].scrollLeft = v) } return f.state.opened && !f.state.loaded && (f.state.opened = !1, setTimeout(a.proxy(function () { this.open_node(f.id, !1, 0) }, this), 0)), b
            }, open_node: function (c, d, e) { var f, g, h, i; if (a.isArray(c)) { for (c = c.slice(), f = 0, g = c.length; g > f; f++) this.open_node(c[f], d, e); return !0 } return c = this.get_node(c), c && c.id !== a.jstree.root ? (e = e === b ? this.settings.core.animation : e, this.is_closed(c) ? this.is_loaded(c) ? (h = this.get_node(c, !0), i = this, h.length && (e && h.children(".jstree-children").length && h.children(".jstree-children").stop(!0, !0), c.children.length && !this._firstChild(h.children(".jstree-children")[0]) && this.draw_children(c), e ? (this.trigger("before_open", { node: c }), h.children(".jstree-children").css("display", "none").end().removeClass("jstree-closed").addClass("jstree-open").attr("aria-expanded", !0).children(".jstree-children").stop(!0, !0).slideDown(e, function () { this.style.display = "", i.trigger("after_open", { node: c }) })) : (this.trigger("before_open", { node: c }), h[0].className = h[0].className.replace("jstree-closed", "jstree-open"), h[0].setAttribute("aria-expanded", !0))), c.state.opened = !0, d && d.call(this, c, !0), h.length || this.trigger("before_open", { node: c }), this.trigger("open_node", { node: c }), e && h.length || this.trigger("after_open", { node: c }), !0) : this.is_loading(c) ? setTimeout(a.proxy(function () { this.open_node(c, d, e) }, this), 500) : void this.load_node(c, function (a, b) { return b ? this.open_node(a, d, e) : d ? d.call(this, a, !1) : !1 }) : (d && d.call(this, c, !1), !1)) : !1 }, _open_to: function (b) { if (b = this.get_node(b), !b || b.id === a.jstree.root) return !1; var c, d, e = b.parents; for (c = 0, d = e.length; d > c; c += 1) c !== a.jstree.root && this.open_node(e[c], !1, 0); return a("#" + b.id.replace(a.jstree.idregex, "\\$&"), this.element) }, close_node: function (c, d) { var e, f, g, h; if (a.isArray(c)) { for (c = c.slice(), e = 0, f = c.length; f > e; e++) this.close_node(c[e], d); return !0 } return c = this.get_node(c), c && c.id !== a.jstree.root ? this.is_closed(c) ? !1 : (d = d === b ? this.settings.core.animation : d, g = this, h = this.get_node(c, !0), h.length && (d ? h.children(".jstree-children").attr("style", "display:block !important").end().removeClass("jstree-open").addClass("jstree-closed").attr("aria-expanded", !1).children(".jstree-children").stop(!0, !0).slideUp(d, function () { this.style.display = "", h.children(".jstree-children").remove(), g.trigger("after_close", { node: c }) }) : (h[0].className = h[0].className.replace("jstree-open", "jstree-closed"), h.attr("aria-expanded", !1).children(".jstree-children").remove())), c.state.opened = !1, this.trigger("close_node", { node: c }), void (d && h.length || this.trigger("after_close", { node: c }))) : !1 }, toggle_node: function (b) { var c, d; if (a.isArray(b)) { for (b = b.slice(), c = 0, d = b.length; d > c; c++) this.toggle_node(b[c]); return !0 } return this.is_closed(b) ? this.open_node(b) : this.is_open(b) ? this.close_node(b) : void 0 }, open_all: function (b, c, d) { if (b || (b = a.jstree.root), b = this.get_node(b), !b) return !1; var e = b.id === a.jstree.root ? this.get_container_ul() : this.get_node(b, !0), f, g, h; if (!e.length) { for (f = 0, g = b.children_d.length; g > f; f++) this.is_closed(this._model.data[b.children_d[f]]) && (this._model.data[b.children_d[f]].state.opened = !0); return this.trigger("open_all", { node: b }) } d = d || e, h = this, e = this.is_closed(b) ? e.find(".jstree-closed").addBack() : e.find(".jstree-closed"), e.each(function () { h.open_node(this, function (a, b) { b && this.is_parent(a) && this.open_all(a, c, d) }, c || 0) }), 0 === d.find(".jstree-closed").length && this.trigger("open_all", { node: this.get_node(d) }) }, close_all: function (b, c) { if (b || (b = a.jstree.root), b = this.get_node(b), !b) return !1; var d = b.id === a.jstree.root ? this.get_container_ul() : this.get_node(b, !0), e = this, f, g; for (d.length && (d = this.is_open(b) ? d.find(".jstree-open").addBack() : d.find(".jstree-open"), a(d.get().reverse()).each(function () { e.close_node(this, c || 0) })), f = 0, g = b.children_d.length; g > f; f++) this._model.data[b.children_d[f]].state.opened = !1; this.trigger("close_all", { node: b }) }, is_disabled: function (a) { return a = this.get_node(a), a && a.state && a.state.disabled }, enable_node: function (b) { var c, d; if (a.isArray(b)) { for (b = b.slice(), c = 0, d = b.length; d > c; c++) this.enable_node(b[c]); return !0 } return b = this.get_node(b), b && b.id !== a.jstree.root ? (b.state.disabled = !1, this.get_node(b, !0).children(".jstree-anchor").removeClass("jstree-disabled").attr("aria-disabled", !1), void this.trigger("enable_node", { node: b })) : !1 }, disable_node: function (b) { var c, d; if (a.isArray(b)) { for (b = b.slice(), c = 0, d = b.length; d > c; c++) this.disable_node(b[c]); return !0 } return b = this.get_node(b), b && b.id !== a.jstree.root ? (b.state.disabled = !0, this.get_node(b, !0).children(".jstree-anchor").addClass("jstree-disabled").attr("aria-disabled", !0), void this.trigger("disable_node", { node: b })) : !1 }, hide_node: function (b, c) { var d, e; if (a.isArray(b)) { for (b = b.slice(), d = 0, e = b.length; e > d; d++) this.hide_node(b[d], !0); return this.redraw(), !0 } return b = this.get_node(b), b && b.id !== a.jstree.root ? void (b.state.hidden || (b.state.hidden = !0, this._node_changed(b.parent), c || this.redraw(), this.trigger("hide_node", { node: b }))) : !1 }, show_node: function (b, c) { var d, e; if (a.isArray(b)) { for (b = b.slice(), d = 0, e = b.length; e > d; d++) this.show_node(b[d], !0); return this.redraw(), !0 } return b = this.get_node(b), b && b.id !== a.jstree.root ? void (b.state.hidden && (b.state.hidden = !1, this._node_changed(b.parent), c || this.redraw(), this.trigger("show_node", { node: b }))) : !1 }, hide_all: function (b) { var c, d = this._model.data, e = []; for (c in d) d.hasOwnProperty(c) && c !== a.jstree.root && !d[c].state.hidden && (d[c].state.hidden = !0, e.push(c)); return this._model.force_full_redraw = !0, b || this.redraw(), this.trigger("hide_all", { nodes: e }), e }, show_all: function (b) { var c, d = this._model.data, e = []; for (c in d) d.hasOwnProperty(c) && c !== a.jstree.root && d[c].state.hidden && (d[c].state.hidden = !1, e.push(c)); return this._model.force_full_redraw = !0, b || this.redraw(), this.trigger("show_all", { nodes: e }), e }, activate_node: function (a, c) { if (this.is_disabled(a)) return !1; if (c && "object" == typeof c || (c = {}), this._data.core.last_clicked = this._data.core.last_clicked && this._data.core.last_clicked.id !== b ? this.get_node(this._data.core.last_clicked.id) : null, this._data.core.last_clicked && !this._data.core.last_clicked.state.selected && (this._data.core.last_clicked = null), !this._data.core.last_clicked && this._data.core.selected.length && (this._data.core.last_clicked = this.get_node(this._data.core.selected[this._data.core.selected.length - 1])), this.settings.core.multiple && (c.metaKey || c.ctrlKey || c.shiftKey) && (!c.shiftKey || this._data.core.last_clicked && this.get_parent(a) && this.get_parent(a) === this._data.core.last_clicked.parent)) if (c.shiftKey) { var d = this.get_node(a).id, e = this._data.core.last_clicked.id, f = this.get_node(this._data.core.last_clicked.parent).children, g = !1, h, i; for (h = 0, i = f.length; i > h; h += 1) f[h] === d && (g = !g), f[h] === e && (g = !g), this.is_disabled(f[h]) || !g && f[h] !== d && f[h] !== e ? this.deselect_node(f[h], !0, c) : this.select_node(f[h], !0, !1, c); this.trigger("changed", { action: "select_node", node: this.get_node(a), selected: this._data.core.selected, event: c }) } else this.is_selected(a) ? this.deselect_node(a, !1, c) : this.select_node(a, !1, !1, c); else !this.settings.core.multiple && (c.metaKey || c.ctrlKey || c.shiftKey) && this.is_selected(a) ? this.deselect_node(a, !1, c) : (this.deselect_all(!0), this.select_node(a, !1, !1, c), this._data.core.last_clicked = this.get_node(a)); this.trigger("activate_node", { node: this.get_node(a), event: c }) }, hover_node: function (a) { if (a = this.get_node(a, !0), !a || !a.length || a.children(".jstree-hovered").length) return !1; var b = this.element.find(".jstree-hovered"), c = this.element; b && b.length && this.dehover_node(b), a.children(".jstree-anchor").addClass("jstree-hovered"), this.trigger("hover_node", { node: this.get_node(a) }), setTimeout(function () { c.attr("aria-activedescendant", a[0].id) }, 0) }, dehover_node: function (a) { return a = this.get_node(a, !0), a && a.length && a.children(".jstree-hovered").length ? (a.children(".jstree-anchor").removeClass("jstree-hovered"), void this.trigger("dehover_node", { node: this.get_node(a) })) : !1 }, select_node: function (b, c, d, e) { var f, g, h, i; if (a.isArray(b)) { for (b = b.slice(), g = 0, h = b.length; h > g; g++) this.select_node(b[g], c, d, e); return !0 } return b = this.get_node(b), b && b.id !== a.jstree.root ? (f = this.get_node(b, !0), void (b.state.selected || (b.state.selected = !0, this._data.core.selected.push(b.id), d || (f = this._open_to(b)), f && f.length && f.attr("aria-selected", !0).children(".jstree-anchor").addClass("jstree-clicked"), this.trigger("select_node", { node: b, selected: this._data.core.selected, event: e }), c || this.trigger("changed", { action: "select_node", node: b, selected: this._data.core.selected, event: e })))) : !1 }, deselect_node: function (b, c, d) { var e, f, g; if (a.isArray(b)) { for (b = b.slice(), e = 0, f = b.length; f > e; e++) this.deselect_node(b[e], c, d); return !0 } return b = this.get_node(b), b && b.id !== a.jstree.root ? (g = this.get_node(b, !0), void (b.state.selected && (b.state.selected = !1, this._data.core.selected = a.vakata.array_remove_item(this._data.core.selected, b.id), g.length && g.attr("aria-selected", !1).children(".jstree-anchor").removeClass("jstree-clicked"), this.trigger("deselect_node", { node: b, selected: this._data.core.selected, event: d }), c || this.trigger("changed", { action: "deselect_node", node: b, selected: this._data.core.selected, event: d })))) : !1 }, select_all: function (b) { var c = this._data.core.selected.concat([]), d, e; for (this._data.core.selected = this._model.data[a.jstree.root].children_d.concat(), d = 0, e = this._data.core.selected.length; e > d; d++) this._model.data[this._data.core.selected[d]] && (this._model.data[this._data.core.selected[d]].state.selected = !0); this.redraw(!0), this.trigger("select_all", { selected: this._data.core.selected }), b || this.trigger("changed", { action: "select_all", selected: this._data.core.selected, old_selection: c }) }, deselect_all: function (a) { var b = this._data.core.selected.concat([]), c, d; for (c = 0, d = this._data.core.selected.length; d > c; c++) this._model.data[this._data.core.selected[c]] && (this._model.data[this._data.core.selected[c]].state.selected = !1); this._data.core.selected = [], this.element.find(".jstree-clicked").removeClass("jstree-clicked").parent().attr("aria-selected", !1), this.trigger("deselect_all", { selected: this._data.core.selected, node: b }), a || this.trigger("changed", { action: "deselect_all", selected: this._data.core.selected, old_selection: b }) }, is_selected: function (b) { return b = this.get_node(b), b && b.id !== a.jstree.root ? b.state.selected : !1 }, get_selected: function (b) { return b ? a.map(this._data.core.selected, a.proxy(function (a) { return this.get_node(a) }, this)) : this._data.core.selected.slice() }, get_top_selected: function (b) { var c = this.get_selected(!0), d = {}, e, f, g, h; for (e = 0, f = c.length; f > e; e++) d[c[e].id] = c[e]; for (e = 0, f = c.length; f > e; e++) for (g = 0, h = c[e].children_d.length; h > g; g++) d[c[e].children_d[g]] && delete d[c[e].children_d[g]]; c = []; for (e in d) d.hasOwnProperty(e) && c.push(e); return b ? a.map(c, a.proxy(function (a) { return this.get_node(a) }, this)) : c }, get_bottom_selected: function (b) { var c = this.get_selected(!0), d = [], e, f; for (e = 0, f = c.length; f > e; e++) c[e].children.length || d.push(c[e].id); return b ? a.map(d, a.proxy(function (a) { return this.get_node(a) }, this)) : d }, get_state: function () { var b = { core: { open: [], scroll: { left: this.element.scrollLeft(), top: this.element.scrollTop() }, selected: [] } }, c; for (c in this._model.data) this._model.data.hasOwnProperty(c) && c !== a.jstree.root && (this._model.data[c].state.opened && b.core.open.push(c), this._model.data[c].state.selected && b.core.selected.push(c)); return b }, set_state: function (c, d) { if (c) { if (c.core) { var e, f, g, h, i; if (c.core.open) return a.isArray(c.core.open) && c.core.open.length ? this._load_nodes(c.core.open, function (a) { this.open_node(a, !1, 0), delete c.core.open, this.set_state(c, d) }, !0) : (delete c.core.open, this.set_state(c, d)), !1; if (c.core.scroll) return c.core.scroll && c.core.scroll.left !== b && this.element.scrollLeft(c.core.scroll.left), c.core.scroll && c.core.scroll.top !== b && this.element.scrollTop(c.core.scroll.top), delete c.core.scroll, this.set_state(c, d), !1; if (c.core.selected) return h = this, this.deselect_all(), a.each(c.core.selected, function (a, b) { h.select_node(b, !1, !0) }), delete c.core.selected, this.set_state(c, d), !1; for (i in c) c.hasOwnProperty(i) && "core" !== i && -1 === a.inArray(i, this.settings.plugins) && delete c[i]; if (a.isEmptyObject(c.core)) return delete c.core, this.set_state(c, d), !1 } return a.isEmptyObject(c) ? (c = null, d && d.call(this), this.trigger("set_state"), !1) : !0 } return !1 }, refresh: function (b, c) { this._data.core.state = c === !0 ? {} : this.get_state(), c && a.isFunction(c) && (this._data.core.state = c.call(this, this._data.core.state)), this._cnt = 0, this._model.data = {}, this._model.data[a.jstree.root] = { id: a.jstree.root, parent: null, parents: [], children: [], children_d: [], state: { loaded: !1 } }, this._data.core.selected = [], this._data.core.last_clicked = null, this._data.core.focused = null; var d = this.get_container_ul()[0].className; b || (this.element.html("<ul class='" + d + "' role='group'><li class='jstree-initial-node jstree-loading jstree-leaf jstree-last' role='treeitem' id='j" + this._id + "_loading'><i class='jstree-icon jstree-ocl'></i><a class='jstree-anchor' href='#'><i class='jstree-icon jstree-themeicon-hidden'></i>" + this.get_string("Loading ...") + "</a></li></ul>"), this.element.attr("aria-activedescendant", "j" + this._id + "_loading")), this.load_node(a.jstree.root, function (b, c) { c && (this.get_container_ul()[0].className = d, this._firstChild(this.get_container_ul()[0]) && this.element.attr("aria-activedescendant", this._firstChild(this.get_container_ul()[0]).id), this.set_state(a.extend(!0, {}, this._data.core.state), function () { this.trigger("refresh") })), this._data.core.state = null }) }, refresh_node: function (b) { if (b = this.get_node(b), !b || b.id === a.jstree.root) return !1; var c = [], d = [], e = this._data.core.selected.concat([]); d.push(b.id), b.state.opened === !0 && c.push(b.id), this.get_node(b, !0).find(".jstree-open").each(function () { c.push(this.id) }), this._load_nodes(d, a.proxy(function (a) { this.open_node(c, !1, 0), this.select_node(this._data.core.selected), this.trigger("refresh_node", { node: b, nodes: a }) }, this)) }, set_id: function (b, c) { if (b = this.get_node(b), !b || b.id === a.jstree.root) return !1; var d, e, f = this._model.data; for (c = c.toString(), f[b.parent].children[a.inArray(b.id, f[b.parent].children)] = c, d = 0, e = b.parents.length; e > d; d++) f[b.parents[d]].children_d[a.inArray(b.id, f[b.parents[d]].children_d)] = c; for (d = 0, e = b.children.length; e > d; d++) f[b.children[d]].parent = c; for (d = 0, e = b.children_d.length; e > d; d++) f[b.children_d[d]].parents[a.inArray(b.id, f[b.children_d[d]].parents)] = c; return d = a.inArray(b.id, this._data.core.selected), -1 !== d && (this._data.core.selected[d] = c), d = this.get_node(b.id, !0), d && (d.attr("id", c).children(".jstree-anchor").attr("id", c + "_anchor").end().attr("aria-labelledby", c + "_anchor"), this.element.attr("aria-activedescendant") === b.id && this.element.attr("aria-activedescendant", c)), delete f[b.id], b.id = c, b.li_attr.id = c, f[c] = b, !0 }, get_text: function (b) { return b = this.get_node(b), b && b.id !== a.jstree.root ? b.text : !1 }, set_text: function (b, c) { var d, e; if (a.isArray(b)) { for (b = b.slice(), d = 0, e = b.length; e > d; d++) this.set_text(b[d], c); return !0 } return b = this.get_node(b), b && b.id !== a.jstree.root ? (b.text = c, this.get_node(b, !0).length && this.redraw_node(b.id), this.trigger("set_text", { obj: b, text: c }), !0) : !1 }, get_json: function (b, c, d) { if (b = this.get_node(b || a.jstree.root), !b) return !1; c && c.flat && !d && (d = []); var e = { id: b.id, text: b.text, icon: this.get_icon(b), li_attr: a.extend(!0, {}, b.li_attr), a_attr: a.extend(!0, {}, b.a_attr), state: {}, data: c && c.no_data ? !1 : a.extend(!0, {}, b.data) }, f, g; if (c && c.flat ? e.parent = b.parent : e.children = [], !c || !c.no_state) for (f in b.state) b.state.hasOwnProperty(f) && (e.state[f] = b.state[f]); if (c && c.no_id && (delete e.id, e.li_attr && e.li_attr.id && delete e.li_attr.id, e.a_attr && e.a_attr.id && delete e.a_attr.id), c && c.flat && b.id !== a.jstree.root && d.push(e), !c || !c.no_children) for (f = 0, g = b.children.length; g > f; f++) c && c.flat ? this.get_json(b.children[f], c, d) : e.children.push(this.get_json(b.children[f], c)); return c && c.flat ? d : b.id === a.jstree.root ? e.children : e }, create_node: function (c, d, e, f, g) { if (null === c && (c = a.jstree.root), c = this.get_node(c), !c) return !1; if (e = e === b ? "last" : e, !e.toString().match(/^(before|after)$/) && !g && !this.is_loaded(c)) return this.load_node(c, function () { this.create_node(c, d, e, f, !0) }); d || (d = { text: this.get_string("New node") }), "string" == typeof d && (d = { text: d }), d.text === b && (d.text = this.get_string("New node")); var h, i, j, k; switch (c.id === a.jstree.root && ("before" === e && (e = "first"), "after" === e && (e = "last")), e) { case "before": h = this.get_node(c.parent), e = a.inArray(c.id, h.children), c = h; break; case "after": h = this.get_node(c.parent), e = a.inArray(c.id, h.children) + 1, c = h; break; case "inside": case "first": e = 0; break; case "last": e = c.children.length; break; default: e || (e = 0) } if (e > c.children.length && (e = c.children.length), d.id || (d.id = !0), !this.check("create_node", d, c, e)) return this.settings.core.error.call(this, this._data.core.last_error), !1; if (d.id === !0 && delete d.id, d = this._parse_model_from_json(d, c.id, c.parents.concat()), !d) return !1; for (h = this.get_node(d), i = [], i.push(d), i = i.concat(h.children_d), this.trigger("model", { nodes: i, parent: c.id }), c.children_d = c.children_d.concat(i), j = 0, k = c.parents.length; k > j; j++) this._model.data[c.parents[j]].children_d = this._model.data[c.parents[j]].children_d.concat(i); for (d = h, h = [], j = 0, k = c.children.length; k > j; j++) h[j >= e ? j + 1 : j] = c.children[j]; return h[e] = d.id, c.children = h, this.redraw_node(c, !0), f && f.call(this, this.get_node(d)), this.trigger("create_node", { node: this.get_node(d), parent: c.id, position: e }), d.id }, rename_node: function (b, c) { var d, e, f; if (a.isArray(b)) { for (b = b.slice(), d = 0, e = b.length; e > d; d++) this.rename_node(b[d], c); return !0 } return b = this.get_node(b), b && b.id !== a.jstree.root ? (f = b.text, this.check("rename_node", b, this.get_parent(b), c) ? (this.set_text(b, c), this.trigger("rename_node", { node: b, text: c, old: f }), !0) : (this.settings.core.error.call(this, this._data.core.last_error), !1)) : !1 }, delete_node: function (b) { var c, d, e, f, g, h, i, j, k, l, m, n; if (a.isArray(b)) { for (b = b.slice(), c = 0, d = b.length; d > c; c++) this.delete_node(b[c]); return !0 } if (b = this.get_node(b), !b || b.id === a.jstree.root) return !1; if (e = this.get_node(b.parent), f = a.inArray(b.id, e.children), l = !1, !this.check("delete_node", b, e, f)) return this.settings.core.error.call(this, this._data.core.last_error), !1; for (-1 !== f && (e.children = a.vakata.array_remove(e.children, f)), g = b.children_d.concat([]), g.push(b.id), j = 0, k = g.length; k > j; j++) { for (h = 0, i = b.parents.length; i > h; h++) f = a.inArray(g[j], this._model.data[b.parents[h]].children_d), -1 !== f && (this._model.data[b.parents[h]].children_d = a.vakata.array_remove(this._model.data[b.parents[h]].children_d, f)); this._model.data[g[j]].state.selected && (l = !0, f = a.inArray(g[j], this._data.core.selected), -1 !== f && (this._data.core.selected = a.vakata.array_remove(this._data.core.selected, f))) } for (this.trigger("delete_node", { node: b, parent: e.id }), l && this.trigger("changed", { action: "delete_node", node: b, selected: this._data.core.selected, parent: e.id }), j = 0, k = g.length; k > j; j++) delete this._model.data[g[j]]; return -1 !== a.inArray(this._data.core.focused, g) && (this._data.core.focused = null, m = this.element[0].scrollTop, n = this.element[0].scrollLeft, e.id === a.jstree.root ? this.get_node(this._model.data[a.jstree.root].children[0], !0).children(".jstree-anchor").focus() : this.get_node(e, !0).children(".jstree-anchor").focus(), this.element[0].scrollTop = m, this.element[0].scrollLeft = n), this.redraw_node(e, !0), !0 }, check: function (b, c, d, e, f) { c = c && c.id ? c : this.get_node(c), d = d && d.id ? d : this.get_node(d); var g = b.match(/^move_node|copy_node|create_node$/i) ? d : c, h = this.settings.core.check_callback; return "move_node" !== b && "copy_node" !== b || f && f.is_multi || c.id !== d.id && a.inArray(c.id, d.children) !== e && -1 === a.inArray(d.id, c.children_d) ? (g && g.data && (g = g.data), g && g.functions && (g.functions[b] === !1 || g.functions[b] === !0) ? (g.functions[b] === !1 && (this._data.core.last_error = { error: "check", plugin: "core", id: "core_02", reason: "Node data prevents function: " + b, data: JSON.stringify({ chk: b, pos: e, obj: c && c.id ? c.id : !1, par: d && d.id ? d.id : !1 }) }), g.functions[b]) : h === !1 || a.isFunction(h) && h.call(this, b, c, d, e, f) === !1 || h && h[b] === !1 ? (this._data.core.last_error = { error: "check", plugin: "core", id: "core_03", reason: "User config for core.check_callback prevents function: " + b, data: JSON.stringify({ chk: b, pos: e, obj: c && c.id ? c.id : !1, par: d && d.id ? d.id : !1 }) }, !1) : !0) : (this._data.core.last_error = { error: "check", plugin: "core", id: "core_01", reason: "Moving parent inside child", data: JSON.stringify({ chk: b, pos: e, obj: c && c.id ? c.id : !1, par: d && d.id ? d.id : !1 }) }, !1) }, last_error: function () { return this._data.core.last_error }, move_node: function (c, d, e, f, g, h, i) { var j, k, l, m, n, o, p, q, r, s, t, u, v, w; if (d = this.get_node(d), e = e === b ? 0 : e, !d) return !1; if (!e.toString().match(/^(before|after)$/) && !g && !this.is_loaded(d)) return this.load_node(d, function () { this.move_node(c, d, e, f, !0, !1, i) }); if (a.isArray(c)) { if (1 !== c.length) { for (j = 0, k = c.length; k > j; j++) (r = this.move_node(c[j], d, e, f, g, !1, i)) && (d = r, e = "after"); return this.redraw(), !0 } c = c[0] } if (c = c && c.id ? c : this.get_node(c), !c || c.id === a.jstree.root) return !1; if (l = (c.parent || a.jstree.root).toString(), n = e.toString().match(/^(before|after)$/) && d.id !== a.jstree.root ? this.get_node(d.parent) : d, o = i ? i : this._model.data[c.id] ? this : a.jstree.reference(c.id), p = !o || !o._id || this._id !== o._id, m = o && o._id && l && o._model.data[l] && o._model.data[l].children ? a.inArray(c.id, o._model.data[l].children) : -1, o && o._id && (c = o._model.data[c.id]), p) return (r = this.copy_node(c, d, e, f, g, !1, i)) ? (o && o.delete_node(c), r) : !1; switch (d.id === a.jstree.root && ("before" === e && (e = "first"), "after" === e && (e = "last")), e) { case "before": e = a.inArray(d.id, n.children); break; case "after": e = a.inArray(d.id, n.children) + 1; break; case "inside": case "first": e = 0; break; case "last": e = n.children.length; break; default: e || (e = 0) } if (e > n.children.length && (e = n.children.length), !this.check("move_node", c, n, e, { core: !0, origin: i, is_multi: o && o._id && o._id !== this._id, is_foreign: !o || !o._id })) return this.settings.core.error.call(this, this._data.core.last_error), !1; if (c.parent === n.id) { for (q = n.children.concat(), r = a.inArray(c.id, q), -1 !== r && (q = a.vakata.array_remove(q, r), e > r && e--), r = [], s = 0, t = q.length; t > s; s++) r[s >= e ? s + 1 : s] = q[s]; r[e] = c.id, n.children = r, this._node_changed(n.id), this.redraw(n.id === a.jstree.root) } else { for (r = c.children_d.concat(), r.push(c.id), s = 0, t = c.parents.length; t > s; s++) { for (q = [], w = o._model.data[c.parents[s]].children_d, u = 0, v = w.length; v > u; u++) -1 === a.inArray(w[u], r) && q.push(w[u]); o._model.data[c.parents[s]].children_d = q } for (o._model.data[l].children = a.vakata.array_remove_item(o._model.data[l].children, c.id), s = 0, t = n.parents.length; t > s; s++) this._model.data[n.parents[s]].children_d = this._model.data[n.parents[s]].children_d.concat(r); for (q = [], s = 0, t = n.children.length; t > s; s++) q[s >= e ? s + 1 : s] = n.children[s]; for (q[e] = c.id, n.children = q, n.children_d.push(c.id), n.children_d = n.children_d.concat(c.children_d), c.parent = n.id, r = n.parents.concat(), r.unshift(n.id), w = c.parents.length, c.parents = r, r = r.concat(), s = 0, t = c.children_d.length; t > s; s++) this._model.data[c.children_d[s]].parents = this._model.data[c.children_d[s]].parents.slice(0, -1 * w), Array.prototype.push.apply(this._model.data[c.children_d[s]].parents, r); (l === a.jstree.root || n.id === a.jstree.root) && (this._model.force_full_redraw = !0), this._model.force_full_redraw || (this._node_changed(l), this._node_changed(n.id)), h || this.redraw() } return f && f.call(this, c, n, e), this.trigger("move_node", { node: c, parent: n.id, position: e, old_parent: l, old_position: m, is_multi: o && o._id && o._id !== this._id, is_foreign: !o || !o._id, old_instance: o, new_instance: this }), c.id }, copy_node: function (c, d, e, f, g, h, i) { var j, k, l, m, n, o, p, q, r, s, t; if (d = this.get_node(d), e = e === b ? 0 : e, !d) return !1; if (!e.toString().match(/^(before|after)$/) && !g && !this.is_loaded(d)) return this.load_node(d, function () { this.copy_node(c, d, e, f, !0, !1, i) }); if (a.isArray(c)) { if (1 !== c.length) { for (j = 0, k = c.length; k > j; j++) (m = this.copy_node(c[j], d, e, f, g, !0, i)) && (d = m, e = "after"); return this.redraw(), !0 } c = c[0] } if (c = c && c.id ? c : this.get_node(c), !c || c.id === a.jstree.root) return !1; switch (q = (c.parent || a.jstree.root).toString(), r = e.toString().match(/^(before|after)$/) && d.id !== a.jstree.root ? this.get_node(d.parent) : d, s = i ? i : this._model.data[c.id] ? this : a.jstree.reference(c.id), t = !s || !s._id || this._id !== s._id, s && s._id && (c = s._model.data[c.id]), d.id === a.jstree.root && ("before" === e && (e = "first"), "after" === e && (e = "last")), e) { case "before": e = a.inArray(d.id, r.children); break; case "after": e = a.inArray(d.id, r.children) + 1; break; case "inside": case "first": e = 0; break; case "last": e = r.children.length; break; default: e || (e = 0) } if (e > r.children.length && (e = r.children.length), !this.check("copy_node", c, r, e, { core: !0, origin: i, is_multi: s && s._id && s._id !== this._id, is_foreign: !s || !s._id })) return this.settings.core.error.call(this, this._data.core.last_error), !1; if (p = s ? s.get_json(c, { no_id: !0, no_data: !0, no_state: !0 }) : c, !p) return !1; if (p.id === !0 && delete p.id, p = this._parse_model_from_json(p, r.id, r.parents.concat()), !p) return !1; for (m = this.get_node(p), c && c.state && c.state.loaded === !1 && (m.state.loaded = !1), l = [], l.push(p), l = l.concat(m.children_d), this.trigger("model", { nodes: l, parent: r.id }), n = 0, o = r.parents.length; o > n; n++) this._model.data[r.parents[n]].children_d = this._model.data[r.parents[n]].children_d.concat(l); for (l = [], n = 0, o = r.children.length; o > n; n++) l[n >= e ? n + 1 : n] = r.children[n]; return l[e] = m.id, r.children = l, r.children_d.push(m.id), r.children_d = r.children_d.concat(m.children_d), r.id === a.jstree.root && (this._model.force_full_redraw = !0), this._model.force_full_redraw || this._node_changed(r.id), h || this.redraw(r.id === a.jstree.root), f && f.call(this, m, r, e), this.trigger("copy_node", { node: m, original: c, parent: r.id, position: e, old_parent: q, old_position: s && s._id && q && s._model.data[q] && s._model.data[q].children ? a.inArray(c.id, s._model.data[q].children) : -1, is_multi: s && s._id && s._id !== this._id, is_foreign: !s || !s._id, old_instance: s, new_instance: this }), m.id }, cut: function (b) { if (b || (b = this._data.core.selected.concat()), a.isArray(b) || (b = [b]), !b.length) return !1; var c = [], g, h, i; for (h = 0, i = b.length; i > h; h++) g = this.get_node(b[h]), g && g.id && g.id !== a.jstree.root && c.push(g); return c.length ? (d = c, f = this, e = "move_node", void this.trigger("cut", { node: b })) : !1 }, copy: function (b) { if (b || (b = this._data.core.selected.concat()), a.isArray(b) || (b = [b]), !b.length) return !1; var c = [], g, h, i; for (h = 0, i = b.length; i > h; h++) g = this.get_node(b[h]), g && g.id && g.id !== a.jstree.root && c.push(g); return c.length ? (d = c, f = this, e = "copy_node", void this.trigger("copy", { node: b })) : !1 }, get_buffer: function () { return { mode: e, node: d, inst: f } }, can_paste: function () { return e !== !1 && d !== !1 }, paste: function (a, b) { return a = this.get_node(a), a && e && e.match(/^(copy_node|move_node)$/) && d ? (this[e](d, a, b, !1, !1, !1, f) && this.trigger("paste", { parent: a.id, node: d, mode: e }), d = !1, e = !1, void (f = !1)) : !1 }, clear_buffer: function () { d = !1, e = !1, f = !1, this.trigger("clear_buffer") }, edit: function (b, c, d) { var e, f, g, h, i, j, k, l, m, n = !1; return (b = this.get_node(b)) ? this.settings.core.check_callback === !1 ? (this._data.core.last_error = { error: "check", plugin: "core", id: "core_07", reason: "Could not edit node because of check_callback" }, this.settings.core.error.call(this, this._data.core.last_error), !1) : (m = b, c = "string" == typeof c ? c : b.text, this.set_text(b, ""), b = this._open_to(b), m.text = c, e = this._data.core.rtl, f = this.element.width(), this._data.core.focused = m.id, g = b.children(".jstree-anchor").focus(), h = a("<span>"), i = c, j = a("<div />", { css: { position: "absolute", top: "-200px", left: e ? "0px" : "-1000px", visibility: "hidden" } }).appendTo("body"), k = a("<input />", { value: i, "class": "jstree-rename-input", css: { padding: "0", border: "1px solid silver", "box-sizing": "border-box", display: "inline-block", height: this._data.core.li_height + "px", lineHeight: this._data.core.li_height + "px", width: "150px" }, blur: a.proxy(function (c) { c.stopImmediatePropagation(), c.preventDefault(); var e = h.children(".jstree-rename-input"), f = e.val(), k = this.settings.core.force_text, l; "" === f && (f = i), j.remove(), h.replaceWith(g), h.remove(), i = k ? i : a("<div></div>").append(a.parseHTML(i)).html(), this.set_text(b, i), l = !!this.rename_node(b, k ? a("<div></div>").text(f).text() : a("<div></div>").append(a.parseHTML(f)).html()), l || this.set_text(b, i), this._data.core.focused = m.id, setTimeout(a.proxy(function () { var a = this.get_node(m.id, !0); a.length && (this._data.core.focused = m.id, a.children(".jstree-anchor").focus()) }, this), 0), d && d.call(this, m, l, n) }, this), keydown: function (a) { var b = a.which; 27 === b && (n = !0, this.value = i), (27 === b || 13 === b || 37 === b || 38 === b || 39 === b || 40 === b || 32 === b) && a.stopImmediatePropagation(), (27 === b || 13 === b) && (a.preventDefault(), this.blur()) }, click: function (a) { a.stopImmediatePropagation() }, mousedown: function (a) { a.stopImmediatePropagation() }, keyup: function (a) { k.width(Math.min(j.text("pW" + this.value).width(), f)) }, keypress: function (a) { return 13 === a.which ? !1 : void 0 } }), l = { fontFamily: g.css("fontFamily") || "", fontSize: g.css("fontSize") || "", fontWeight: g.css("fontWeight") || "", fontStyle: g.css("fontStyle") || "", fontStretch: g.css("fontStretch") || "", fontVariant: g.css("fontVariant") || "", letterSpacing: g.css("letterSpacing") || "", wordSpacing: g.css("wordSpacing") || "" }, h.attr("class", g.attr("class")).append(g.contents().clone()).append(k), g.replaceWith(h), j.css(l), void k.css(l).width(Math.min(j.text("pW" + k[0].value).width(), f))[0].select()) : !1 }, set_theme: function (b, c) {
                if (!b) return !1; if (c === !0) { var d = this.settings.core.themes.dir; d || (d = a.jstree.path + "/themes"), c = d + "/" + b + "/style.css" } c && -1 === a.inArray(c, g) && (a("head").append('<link rel="stylesheet" href="' + c + '" type="text/css" />'), g.push(c)), this._data.core.themes.name && this.element.removeClass("jstree-" + this._data.core.themes.name),
                    this._data.core.themes.name = b, this.element.addClass("jstree-" + b), this.element[this.settings.core.themes.responsive ? "addClass" : "removeClass"]("jstree-" + b + "-responsive"), this.trigger("set_theme", { theme: b })
            }, get_theme: function () { return this._data.core.themes.name }, set_theme_variant: function (a) { this._data.core.themes.variant && this.element.removeClass("jstree-" + this._data.core.themes.name + "-" + this._data.core.themes.variant), this._data.core.themes.variant = a, a && this.element.addClass("jstree-" + this._data.core.themes.name + "-" + this._data.core.themes.variant) }, get_theme_variant: function () { return this._data.core.themes.variant }, show_stripes: function () { this._data.core.themes.stripes = !0, this.get_container_ul().addClass("jstree-striped") }, hide_stripes: function () { this._data.core.themes.stripes = !1, this.get_container_ul().removeClass("jstree-striped") }, toggle_stripes: function () { this._data.core.themes.stripes ? this.hide_stripes() : this.show_stripes() }, show_dots: function () { this._data.core.themes.dots = !0, this.get_container_ul().removeClass("jstree-no-dots") }, hide_dots: function () { this._data.core.themes.dots = !1, this.get_container_ul().addClass("jstree-no-dots") }, toggle_dots: function () { this._data.core.themes.dots ? this.hide_dots() : this.show_dots() }, show_icons: function () { this._data.core.themes.icons = !0, this.get_container_ul().removeClass("jstree-no-icons") }, hide_icons: function () { this._data.core.themes.icons = !1, this.get_container_ul().addClass("jstree-no-icons") }, toggle_icons: function () { this._data.core.themes.icons ? this.hide_icons() : this.show_icons() }, set_icon: function (c, d) { var e, f, g, h; if (a.isArray(c)) { for (c = c.slice(), e = 0, f = c.length; f > e; e++) this.set_icon(c[e], d); return !0 } return c = this.get_node(c), c && c.id !== a.jstree.root ? (h = c.icon, c.icon = d === !0 || null === d || d === b || "" === d ? !0 : d, g = this.get_node(c, !0).children(".jstree-anchor").children(".jstree-themeicon"), d === !1 ? this.hide_icon(c) : d === !0 || null === d || d === b || "" === d ? (g.removeClass("jstree-themeicon-custom " + h).css("background", "").removeAttr("rel"), h === !1 && this.show_icon(c)) : -1 === d.indexOf("/") && -1 === d.indexOf(".") ? (g.removeClass(h).css("background", ""), g.addClass(d + " jstree-themeicon-custom").attr("rel", d), h === !1 && this.show_icon(c)) : (g.removeClass(h).css("background", ""), g.addClass("jstree-themeicon-custom").css("background", "url('" + d + "') center center no-repeat").attr("rel", d), h === !1 && this.show_icon(c)), !0) : !1 }, get_icon: function (b) { return b = this.get_node(b), b && b.id !== a.jstree.root ? b.icon : !1 }, hide_icon: function (b) { var c, d; if (a.isArray(b)) { for (b = b.slice(), c = 0, d = b.length; d > c; c++) this.hide_icon(b[c]); return !0 } return b = this.get_node(b), b && b !== a.jstree.root ? (b.icon = !1, this.get_node(b, !0).children(".jstree-anchor").children(".jstree-themeicon").addClass("jstree-themeicon-hidden"), !0) : !1 }, show_icon: function (b) { var c, d, e; if (a.isArray(b)) { for (b = b.slice(), c = 0, d = b.length; d > c; c++) this.show_icon(b[c]); return !0 } return b = this.get_node(b), b && b !== a.jstree.root ? (e = this.get_node(b, !0), b.icon = e.length ? e.children(".jstree-anchor").children(".jstree-themeicon").attr("rel") : !0, b.icon || (b.icon = !0), e.children(".jstree-anchor").children(".jstree-themeicon").removeClass("jstree-themeicon-hidden"), !0) : !1 }
        }, a.vakata = {}, a.vakata.attributes = function (b, c) { b = a(b)[0]; var d = c ? {} : []; return b && b.attributes && a.each(b.attributes, function (b, e) { -1 === a.inArray(e.name.toLowerCase(), ["style", "contenteditable", "hasfocus", "tabindex"]) && null !== e.value && "" !== a.trim(e.value) && (c ? d[e.name] = e.value : d.push(e.name)) }), d }, a.vakata.array_unique = function (a) { var c = [], d, e, f, g = {}; for (d = 0, f = a.length; f > d; d++) g[a[d]] === b && (c.push(a[d]), g[a[d]] = !0); return c }, a.vakata.array_remove = function (a, b, c) { var d = a.slice((c || b) + 1 || a.length); return a.length = 0 > b ? a.length + b : b, a.push.apply(a, d), a }, a.vakata.array_remove_item = function (b, c) { var d = a.inArray(c, b); return -1 !== d ? a.vakata.array_remove(b, d) : b }, a.jstree.plugins.changed = function (a, b) { var c = []; this.trigger = function (a, d) { var e, f; if (d || (d = {}), "changed" === a.replace(".jstree", "")) { d.changed = { selected: [], deselected: [] }; var g = {}; for (e = 0, f = c.length; f > e; e++) g[c[e]] = 1; for (e = 0, f = d.selected.length; f > e; e++) g[d.selected[e]] ? g[d.selected[e]] = 2 : d.changed.selected.push(d.selected[e]); for (e = 0, f = c.length; f > e; e++) 1 === g[c[e]] && d.changed.deselected.push(c[e]); c = d.selected.slice() } b.trigger.call(this, a, d) }, this.refresh = function (a, d) { return c = [], b.refresh.apply(this, arguments) } }; var m = i.createElement("I"); m.className = "jstree-icon jstree-checkbox", m.setAttribute("role", "presentation"), a.jstree.defaults.checkbox = { visible: !0, three_state: !0, whole_node: !0, keep_selected_style: !0, cascade: "", tie_selection: !0 }, a.jstree.plugins.checkbox = function (c, d) { this.bind = function () { d.bind.call(this), this._data.checkbox.uto = !1, this._data.checkbox.selected = [], this.settings.checkbox.three_state && (this.settings.checkbox.cascade = "up+down+undetermined"), this.element.on("init.jstree", a.proxy(function () { this._data.checkbox.visible = this.settings.checkbox.visible, this.settings.checkbox.keep_selected_style || this.element.addClass("jstree-checkbox-no-clicked"), this.settings.checkbox.tie_selection && this.element.addClass("jstree-checkbox-selection") }, this)).on("loading.jstree", a.proxy(function () { this[this._data.checkbox.visible ? "show_checkboxes" : "hide_checkboxes"]() }, this)), -1 !== this.settings.checkbox.cascade.indexOf("undetermined") && this.element.on("changed.jstree uncheck_node.jstree check_node.jstree uncheck_all.jstree check_all.jstree move_node.jstree copy_node.jstree redraw.jstree open_node.jstree", a.proxy(function () { this._data.checkbox.uto && clearTimeout(this._data.checkbox.uto), this._data.checkbox.uto = setTimeout(a.proxy(this._undetermined, this), 50) }, this)), this.settings.checkbox.tie_selection || this.element.on("model.jstree", a.proxy(function (a, b) { var c = this._model.data, d = c[b.parent], e = b.nodes, f, g; for (f = 0, g = e.length; g > f; f++) c[e[f]].state.checked = c[e[f]].state.checked || c[e[f]].original && c[e[f]].original.state && c[e[f]].original.state.checked, c[e[f]].state.checked && this._data.checkbox.selected.push(e[f]) }, this)), (-1 !== this.settings.checkbox.cascade.indexOf("up") || -1 !== this.settings.checkbox.cascade.indexOf("down")) && this.element.on("model.jstree", a.proxy(function (b, c) { var d = this._model.data, e = d[c.parent], f = c.nodes, g = [], h, i, j, k, l, m, n = this.settings.checkbox.cascade, o = this.settings.checkbox.tie_selection; if (-1 !== n.indexOf("down")) if (e.state[o ? "selected" : "checked"]) { for (i = 0, j = f.length; j > i; i++) d[f[i]].state[o ? "selected" : "checked"] = !0; this._data[o ? "core" : "checkbox"].selected = this._data[o ? "core" : "checkbox"].selected.concat(f) } else for (i = 0, j = f.length; j > i; i++) if (d[f[i]].state[o ? "selected" : "checked"]) { for (k = 0, l = d[f[i]].children_d.length; l > k; k++) d[d[f[i]].children_d[k]].state[o ? "selected" : "checked"] = !0; this._data[o ? "core" : "checkbox"].selected = this._data[o ? "core" : "checkbox"].selected.concat(d[f[i]].children_d) } if (-1 !== n.indexOf("up")) { for (i = 0, j = e.children_d.length; j > i; i++) d[e.children_d[i]].children.length || g.push(d[e.children_d[i]].parent); for (g = a.vakata.array_unique(g), k = 0, l = g.length; l > k; k++) { e = d[g[k]]; while (e && e.id !== a.jstree.root) { for (h = 0, i = 0, j = e.children.length; j > i; i++) h += d[e.children[i]].state[o ? "selected" : "checked"]; if (h !== j) break; e.state[o ? "selected" : "checked"] = !0, this._data[o ? "core" : "checkbox"].selected.push(e.id), m = this.get_node(e, !0), m && m.length && m.attr("aria-selected", !0).children(".jstree-anchor").addClass(o ? "jstree-clicked" : "jstree-checked"), e = this.get_node(e.parent) } } } this._data[o ? "core" : "checkbox"].selected = a.vakata.array_unique(this._data[o ? "core" : "checkbox"].selected) }, this)).on(this.settings.checkbox.tie_selection ? "select_node.jstree" : "check_node.jstree", a.proxy(function (b, c) { var d = c.node, e = this._model.data, f = this.get_node(d.parent), g = this.get_node(d, !0), h, i, j, k, l = this.settings.checkbox.cascade, m = this.settings.checkbox.tie_selection; if (-1 !== l.indexOf("down")) for (this._data[m ? "core" : "checkbox"].selected = a.vakata.array_unique(this._data[m ? "core" : "checkbox"].selected.concat(d.children_d)), h = 0, i = d.children_d.length; i > h; h++) k = e[d.children_d[h]], k.state[m ? "selected" : "checked"] = !0, k && k.original && k.original.state && k.original.state.undetermined && (k.original.state.undetermined = !1); if (-1 !== l.indexOf("up")) while (f && f.id !== a.jstree.root) { for (j = 0, h = 0, i = f.children.length; i > h; h++) j += e[f.children[h]].state[m ? "selected" : "checked"]; if (j !== i) break; f.state[m ? "selected" : "checked"] = !0, this._data[m ? "core" : "checkbox"].selected.push(f.id), k = this.get_node(f, !0), k && k.length && k.attr("aria-selected", !0).children(".jstree-anchor").addClass(m ? "jstree-clicked" : "jstree-checked"), f = this.get_node(f.parent) } -1 !== l.indexOf("down") && g.length && g.find(".jstree-anchor").addClass(m ? "jstree-clicked" : "jstree-checked").parent().attr("aria-selected", !0) }, this)).on(this.settings.checkbox.tie_selection ? "deselect_all.jstree" : "uncheck_all.jstree", a.proxy(function (b, c) { var d = this.get_node(a.jstree.root), e = this._model.data, f, g, h; for (f = 0, g = d.children_d.length; g > f; f++) h = e[d.children_d[f]], h && h.original && h.original.state && h.original.state.undetermined && (h.original.state.undetermined = !1) }, this)).on(this.settings.checkbox.tie_selection ? "deselect_node.jstree" : "uncheck_node.jstree", a.proxy(function (b, c) { var d = c.node, e = this.get_node(d, !0), f, g, h, i = this.settings.checkbox.cascade, j = this.settings.checkbox.tie_selection; if (d && d.original && d.original.state && d.original.state.undetermined && (d.original.state.undetermined = !1), -1 !== i.indexOf("down")) for (f = 0, g = d.children_d.length; g > f; f++) h = this._model.data[d.children_d[f]], h.state[j ? "selected" : "checked"] = !1, h && h.original && h.original.state && h.original.state.undetermined && (h.original.state.undetermined = !1); if (-1 !== i.indexOf("up")) for (f = 0, g = d.parents.length; g > f; f++) h = this._model.data[d.parents[f]], h.state[j ? "selected" : "checked"] = !1, h && h.original && h.original.state && h.original.state.undetermined && (h.original.state.undetermined = !1), h = this.get_node(d.parents[f], !0), h && h.length && h.attr("aria-selected", !1).children(".jstree-anchor").removeClass(j ? "jstree-clicked" : "jstree-checked"); for (h = [], f = 0, g = this._data[j ? "core" : "checkbox"].selected.length; g > f; f++) -1 !== i.indexOf("down") && -1 !== a.inArray(this._data[j ? "core" : "checkbox"].selected[f], d.children_d) || -1 !== i.indexOf("up") && -1 !== a.inArray(this._data[j ? "core" : "checkbox"].selected[f], d.parents) || h.push(this._data[j ? "core" : "checkbox"].selected[f]); this._data[j ? "core" : "checkbox"].selected = a.vakata.array_unique(h), -1 !== i.indexOf("down") && e.length && e.find(".jstree-anchor").removeClass(j ? "jstree-clicked" : "jstree-checked").parent().attr("aria-selected", !1) }, this)), -1 !== this.settings.checkbox.cascade.indexOf("up") && this.element.on("delete_node.jstree", a.proxy(function (b, c) { var d = this.get_node(c.parent), e = this._model.data, f, g, h, i, j = this.settings.checkbox.tie_selection; while (d && d.id !== a.jstree.root && !d.state[j ? "selected" : "checked"]) { for (h = 0, f = 0, g = d.children.length; g > f; f++) h += e[d.children[f]].state[j ? "selected" : "checked"]; if (!(g > 0 && h === g)) break; d.state[j ? "selected" : "checked"] = !0, this._data[j ? "core" : "checkbox"].selected.push(d.id), i = this.get_node(d, !0), i && i.length && i.attr("aria-selected", !0).children(".jstree-anchor").addClass(j ? "jstree-clicked" : "jstree-checked"), d = this.get_node(d.parent) } }, this)).on("move_node.jstree", a.proxy(function (b, c) { var d = c.is_multi, e = c.old_parent, f = this.get_node(c.parent), g = this._model.data, h, i, j, k, l, m = this.settings.checkbox.tie_selection; if (!d) { h = this.get_node(e); while (h && h.id !== a.jstree.root && !h.state[m ? "selected" : "checked"]) { for (i = 0, j = 0, k = h.children.length; k > j; j++) i += g[h.children[j]].state[m ? "selected" : "checked"]; if (!(k > 0 && i === k)) break; h.state[m ? "selected" : "checked"] = !0, this._data[m ? "core" : "checkbox"].selected.push(h.id), l = this.get_node(h, !0), l && l.length && l.attr("aria-selected", !0).children(".jstree-anchor").addClass(m ? "jstree-clicked" : "jstree-checked"), h = this.get_node(h.parent) } } h = f; while (h && h.id !== a.jstree.root) { for (i = 0, j = 0, k = h.children.length; k > j; j++) i += g[h.children[j]].state[m ? "selected" : "checked"]; if (i === k) h.state[m ? "selected" : "checked"] || (h.state[m ? "selected" : "checked"] = !0, this._data[m ? "core" : "checkbox"].selected.push(h.id), l = this.get_node(h, !0), l && l.length && l.attr("aria-selected", !0).children(".jstree-anchor").addClass(m ? "jstree-clicked" : "jstree-checked")); else { if (!h.state[m ? "selected" : "checked"]) break; h.state[m ? "selected" : "checked"] = !1, this._data[m ? "core" : "checkbox"].selected = a.vakata.array_remove_item(this._data[m ? "core" : "checkbox"].selected, h.id), l = this.get_node(h, !0), l && l.length && l.attr("aria-selected", !1).children(".jstree-anchor").removeClass(m ? "jstree-clicked" : "jstree-checked") } h = this.get_node(h.parent) } }, this)) }, this._undetermined = function () { if (null !== this.element) { var c, d, e, f, g = {}, h = this._model.data, i = this.settings.checkbox.tie_selection, j = this._data[i ? "core" : "checkbox"].selected, k = [], l = this; for (c = 0, d = j.length; d > c; c++) if (h[j[c]] && h[j[c]].parents) for (e = 0, f = h[j[c]].parents.length; f > e; e++) g[h[j[c]].parents[e]] === b && h[j[c]].parents[e] !== a.jstree.root && (g[h[j[c]].parents[e]] = !0, k.push(h[j[c]].parents[e])); for (this.element.find(".jstree-closed").not(":has(.jstree-children)").each(function () { var i = l.get_node(this), j; if (i.state.loaded) { for (c = 0, d = i.children_d.length; d > c; c++) if (j = h[i.children_d[c]], !j.state.loaded && j.original && j.original.state && j.original.state.undetermined && j.original.state.undetermined === !0) for (g[j.id] === b && j.id !== a.jstree.root && (g[j.id] = !0, k.push(j.id)), e = 0, f = j.parents.length; f > e; e++) g[j.parents[e]] === b && j.parents[e] !== a.jstree.root && (g[j.parents[e]] = !0, k.push(j.parents[e])) } else if (i.original && i.original.state && i.original.state.undetermined && i.original.state.undetermined === !0) for (g[i.id] === b && i.id !== a.jstree.root && (g[i.id] = !0, k.push(i.id)), e = 0, f = i.parents.length; f > e; e++) g[i.parents[e]] === b && i.parents[e] !== a.jstree.root && (g[i.parents[e]] = !0, k.push(i.parents[e])) }), this.element.find(".jstree-undetermined").removeClass("jstree-undetermined"), c = 0, d = k.length; d > c; c++) h[k[c]].state[i ? "selected" : "checked"] || (j = this.get_node(k[c], !0), j && j.length && j.children(".jstree-anchor").children(".jstree-checkbox").addClass("jstree-undetermined")) } }, this.redraw_node = function (b, c, e, f) { if (b = d.redraw_node.apply(this, arguments)) { var g, h, i = null, j = null; for (g = 0, h = b.childNodes.length; h > g; g++) if (b.childNodes[g] && b.childNodes[g].className && -1 !== b.childNodes[g].className.indexOf("jstree-anchor")) { i = b.childNodes[g]; break } i && (!this.settings.checkbox.tie_selection && this._model.data[b.id].state.checked && (i.className += " jstree-checked"), j = m.cloneNode(!1), this._model.data[b.id].state.checkbox_disabled && (j.className += " jstree-checkbox-disabled"), i.insertBefore(j, i.childNodes[0])) } return e || -1 === this.settings.checkbox.cascade.indexOf("undetermined") || (this._data.checkbox.uto && clearTimeout(this._data.checkbox.uto), this._data.checkbox.uto = setTimeout(a.proxy(this._undetermined, this), 50)), b }, this.show_checkboxes = function () { this._data.core.themes.checkboxes = !0, this.get_container_ul().removeClass("jstree-no-checkboxes") }, this.hide_checkboxes = function () { this._data.core.themes.checkboxes = !1, this.get_container_ul().addClass("jstree-no-checkboxes") }, this.toggle_checkboxes = function () { this._data.core.themes.checkboxes ? this.hide_checkboxes() : this.show_checkboxes() }, this.is_undetermined = function (b) { b = this.get_node(b); var c = this.settings.checkbox.cascade, d, e, f = this.settings.checkbox.tie_selection, g = this._data[f ? "core" : "checkbox"].selected, h = this._model.data; if (!b || b.state[f ? "selected" : "checked"] === !0 || -1 === c.indexOf("undetermined") || -1 === c.indexOf("down") && -1 === c.indexOf("up")) return !1; if (!b.state.loaded && b.original.state.undetermined === !0) return !0; for (d = 0, e = b.children_d.length; e > d; d++) if (-1 !== a.inArray(b.children_d[d], g) || !h[b.children_d[d]].state.loaded && h[b.children_d[d]].original.state.undetermined) return !0; return !1 }, this.disable_checkbox = function (b) { var c, d, e; if (a.isArray(b)) { for (b = b.slice(), c = 0, d = b.length; d > c; c++) this.disable_checkbox(b[c]); return !0 } return b = this.get_node(b), b && b.id !== a.jstree.root ? (e = this.get_node(b, !0), void (b.state.checkbox_disabled || (b.state.checkbox_disabled = !0, e && e.length && e.children(".jstree-anchor").children(".jstree-checkbox").addClass("jstree-checkbox-disabled"), this.trigger("disable_checkbox", { node: b })))) : !1 }, this.enable_checkbox = function (b) { var c, d, e; if (a.isArray(b)) { for (b = b.slice(), c = 0, d = b.length; d > c; c++) this.enable_checkbox(b[c]); return !0 } return b = this.get_node(b), b && b.id !== a.jstree.root ? (e = this.get_node(b, !0), void (b.state.checkbox_disabled && (b.state.checkbox_disabled = !1, e && e.length && e.children(".jstree-anchor").children(".jstree-checkbox").removeClass("jstree-checkbox-disabled"), this.trigger("enable_checkbox", { node: b })))) : !1 }, this.activate_node = function (b, c) { return a(c.target).hasClass("jstree-checkbox-disabled") ? !1 : (this.settings.checkbox.tie_selection && (this.settings.checkbox.whole_node || a(c.target).hasClass("jstree-checkbox")) && (c.ctrlKey = !0), this.settings.checkbox.tie_selection || !this.settings.checkbox.whole_node && !a(c.target).hasClass("jstree-checkbox") ? d.activate_node.call(this, b, c) : this.is_disabled(b) ? !1 : (this.is_checked(b) ? this.uncheck_node(b, c) : this.check_node(b, c), void this.trigger("activate_node", { node: this.get_node(b) }))) }, this.check_node = function (b, c) { if (this.settings.checkbox.tie_selection) return this.select_node(b, !1, !0, c); var d, e, f, g; if (a.isArray(b)) { for (b = b.slice(), e = 0, f = b.length; f > e; e++) this.check_node(b[e], c); return !0 } return b = this.get_node(b), b && b.id !== a.jstree.root ? (d = this.get_node(b, !0), void (b.state.checked || (b.state.checked = !0, this._data.checkbox.selected.push(b.id), d && d.length && d.children(".jstree-anchor").addClass("jstree-checked"), this.trigger("check_node", { node: b, selected: this._data.checkbox.selected, event: c })))) : !1 }, this.uncheck_node = function (b, c) { if (this.settings.checkbox.tie_selection) return this.deselect_node(b, !1, c); var d, e, f; if (a.isArray(b)) { for (b = b.slice(), d = 0, e = b.length; e > d; d++) this.uncheck_node(b[d], c); return !0 } return b = this.get_node(b), b && b.id !== a.jstree.root ? (f = this.get_node(b, !0), void (b.state.checked && (b.state.checked = !1, this._data.checkbox.selected = a.vakata.array_remove_item(this._data.checkbox.selected, b.id), f.length && f.children(".jstree-anchor").removeClass("jstree-checked"), this.trigger("uncheck_node", { node: b, selected: this._data.checkbox.selected, event: c })))) : !1 }, this.check_all = function () { if (this.settings.checkbox.tie_selection) return this.select_all(); var b = this._data.checkbox.selected.concat([]), c, d; for (this._data.checkbox.selected = this._model.data[a.jstree.root].children_d.concat(), c = 0, d = this._data.checkbox.selected.length; d > c; c++) this._model.data[this._data.checkbox.selected[c]] && (this._model.data[this._data.checkbox.selected[c]].state.checked = !0); this.redraw(!0), this.trigger("check_all", { selected: this._data.checkbox.selected }) }, this.uncheck_all = function () { if (this.settings.checkbox.tie_selection) return this.deselect_all(); var a = this._data.checkbox.selected.concat([]), b, c; for (b = 0, c = this._data.checkbox.selected.length; c > b; b++) this._model.data[this._data.checkbox.selected[b]] && (this._model.data[this._data.checkbox.selected[b]].state.checked = !1); this._data.checkbox.selected = [], this.element.find(".jstree-checked").removeClass("jstree-checked"), this.trigger("uncheck_all", { selected: this._data.checkbox.selected, node: a }) }, this.is_checked = function (b) { return this.settings.checkbox.tie_selection ? this.is_selected(b) : (b = this.get_node(b), b && b.id !== a.jstree.root ? b.state.checked : !1) }, this.get_checked = function (b) { return this.settings.checkbox.tie_selection ? this.get_selected(b) : b ? a.map(this._data.checkbox.selected, a.proxy(function (a) { return this.get_node(a) }, this)) : this._data.checkbox.selected }, this.get_top_checked = function (b) { if (this.settings.checkbox.tie_selection) return this.get_top_selected(b); var c = this.get_checked(!0), d = {}, e, f, g, h; for (e = 0, f = c.length; f > e; e++) d[c[e].id] = c[e]; for (e = 0, f = c.length; f > e; e++) for (g = 0, h = c[e].children_d.length; h > g; g++) d[c[e].children_d[g]] && delete d[c[e].children_d[g]]; c = []; for (e in d) d.hasOwnProperty(e) && c.push(e); return b ? a.map(c, a.proxy(function (a) { return this.get_node(a) }, this)) : c }, this.get_bottom_checked = function (b) { if (this.settings.checkbox.tie_selection) return this.get_bottom_selected(b); var c = this.get_checked(!0), d = [], e, f; for (e = 0, f = c.length; f > e; e++) c[e].children.length || d.push(c[e].id); return b ? a.map(d, a.proxy(function (a) { return this.get_node(a) }, this)) : d }, this.load_node = function (b, c) { var e, f, g, h, i, j; if (!a.isArray(b) && !this.settings.checkbox.tie_selection && (j = this.get_node(b), j && j.state.loaded)) for (e = 0, f = j.children_d.length; f > e; e++) this._model.data[j.children_d[e]].state.checked && (i = !0, this._data.checkbox.selected = a.vakata.array_remove_item(this._data.checkbox.selected, j.children_d[e])); return d.load_node.apply(this, arguments) }, this.get_state = function () { var a = d.get_state.apply(this, arguments); return this.settings.checkbox.tie_selection ? a : (a.checkbox = this._data.checkbox.selected.slice(), a) }, this.set_state = function (b, c) { var e = d.set_state.apply(this, arguments); if (e && b.checkbox) { if (!this.settings.checkbox.tie_selection) { this.uncheck_all(); var f = this; a.each(b.checkbox, function (a, b) { f.check_node(b) }) } return delete b.checkbox, this.set_state(b, c), !1 } return e }, this.refresh = function (a, b) { return this.settings.checkbox.tie_selection || (this._data.checkbox.selected = []), d.refresh.apply(this, arguments) } }, a.jstree.defaults.conditionalselect = function () { return !0 }, a.jstree.plugins.conditionalselect = function (a, b) { this.activate_node = function (a, c) { this.settings.conditionalselect.call(this, this.get_node(a), c) && b.activate_node.call(this, a, c) } }, a.jstree.defaults.contextmenu = { select_node: !0, show_at_node: !0, items: function (b, c) { return { create: { separator_before: !1, separator_after: !0, _disabled: !1, label: "Create", action: function (b) { var c = a.jstree.reference(b.reference), d = c.get_node(b.reference); c.create_node(d, {}, "last", function (a) { setTimeout(function () { c.edit(a) }, 0) }) } }, rename: { separator_before: !1, separator_after: !1, _disabled: !1, label: "Rename", action: function (b) { var c = a.jstree.reference(b.reference), d = c.get_node(b.reference); c.edit(d) } }, remove: { separator_before: !1, icon: !1, separator_after: !1, _disabled: !1, label: "Delete", action: function (b) { var c = a.jstree.reference(b.reference), d = c.get_node(b.reference); c.is_selected(d) ? c.delete_node(c.get_selected()) : c.delete_node(d) } }, ccp: { separator_before: !0, icon: !1, separator_after: !1, label: "Edit", action: !1, submenu: { cut: { separator_before: !1, separator_after: !1, label: "Cut", action: function (b) { var c = a.jstree.reference(b.reference), d = c.get_node(b.reference); c.is_selected(d) ? c.cut(c.get_top_selected()) : c.cut(d) } }, copy: { separator_before: !1, icon: !1, separator_after: !1, label: "Copy", action: function (b) { var c = a.jstree.reference(b.reference), d = c.get_node(b.reference); c.is_selected(d) ? c.copy(c.get_top_selected()) : c.copy(d) } }, paste: { separator_before: !1, icon: !1, _disabled: function (b) { return !a.jstree.reference(b.reference).can_paste() }, separator_after: !1, label: "Paste", action: function (b) { var c = a.jstree.reference(b.reference), d = c.get_node(b.reference); c.paste(d) } } } } } } }, a.jstree.plugins.contextmenu = function (c, d) { this.bind = function () { d.bind.call(this); var b = 0, c = null, e, f; this.element.on("contextmenu.jstree", ".jstree-anchor", a.proxy(function (a, d) { a.preventDefault(), b = a.ctrlKey ? +new Date : 0, (d || c) && (b = +new Date + 1e4), c && clearTimeout(c), this.is_loading(a.currentTarget) || this.show_contextmenu(a.currentTarget, a.pageX, a.pageY, a) }, this)).on("click.jstree", ".jstree-anchor", a.proxy(function (c) { this._data.contextmenu.visible && (!b || +new Date - b > 250) && a.vakata.context.hide(), b = 0 }, this)).on("touchstart.jstree", ".jstree-anchor", function (b) { b.originalEvent && b.originalEvent.changedTouches && b.originalEvent.changedTouches[0] && (e = b.pageX, f = b.pageY, c = setTimeout(function () { a(b.currentTarget).trigger("contextmenu", !0) }, 750)) }).on("touchmove.vakata.jstree", function (a) { c && a.originalEvent && a.originalEvent.changedTouches && a.originalEvent.changedTouches[0] && (Math.abs(e - a.pageX) > 50 || Math.abs(f - a.pageY) > 50) && clearTimeout(c) }).on("touchend.vakata.jstree", function (a) { c && clearTimeout(c) }), a(i).on("context_hide.vakata.jstree", a.proxy(function () { this._data.contextmenu.visible = !1 }, this)) }, this.teardown = function () { this._data.contextmenu.visible && a.vakata.context.hide(), d.teardown.call(this) }, this.show_contextmenu = function (c, d, e, f) { if (c = this.get_node(c), !c || c.id === a.jstree.root) return !1; var g = this.settings.contextmenu, h = this.get_node(c, !0), i = h.children(".jstree-anchor"), j = !1, k = !1; (g.show_at_node || d === b || e === b) && (j = i.offset(), d = j.left, e = j.top + this._data.core.li_height), this.settings.contextmenu.select_node && !this.is_selected(c) && this.activate_node(c, f), k = g.items, a.isFunction(k) && (k = k.call(this, c, a.proxy(function (a) { this._show_contextmenu(c, d, e, a) }, this))), a.isPlainObject(k) && this._show_contextmenu(c, d, e, k) }, this._show_contextmenu = function (b, c, d, e) { var f = this.get_node(b, !0), g = f.children(".jstree-anchor"); a(i).one("context_show.vakata.jstree", a.proxy(function (b, c) { var d = "jstree-contextmenu jstree-" + this.get_theme() + "-contextmenu"; a(c.element).addClass(d) }, this)), this._data.contextmenu.visible = !0, a.vakata.context.show(g, { x: c, y: d }, e), this.trigger("show_contextmenu", { node: b, x: c, y: d }) } }, function (a) { var b = !1, c = { element: !1, reference: !1, position_x: 0, position_y: 0, items: [], html: "", is_visible: !1 }; a.vakata.context = { settings: { hide_onmouseleave: 0, icons: !0 }, _trigger: function (b) { a(i).triggerHandler("context_" + b + ".vakata", { reference: c.reference, element: c.element, position: { x: c.position_x, y: c.position_y } }) }, _execute: function (b) { return b = c.items[b], b && (!b._disabled || a.isFunction(b._disabled) && !b._disabled({ item: b, reference: c.reference, element: c.element })) && b.action ? b.action.call(null, { item: b, reference: c.reference, element: c.element, position: { x: c.position_x, y: c.position_y } }) : !1 }, _parse: function (b, d) { if (!b) return !1; d || (c.html = "", c.items = []); var e = "", f = !1, g; return d && (e += "<ul>"), a.each(b, function (b, d) { return d ? (c.items.push(d), !f && d.separator_before && (e += "<li class='vakata-context-separator'><a href='#' " + (a.vakata.context.settings.icons ? "" : 'style="margin-left:0px;"') + ">&#160;</a></li>"), f = !1, e += "<li class='" + (d._class || "") + (d._disabled === !0 || a.isFunction(d._disabled) && d._disabled({ item: d, reference: c.reference, element: c.element }) ? " vakata-contextmenu-disabled " : "") + "' " + (d.shortcut ? " data-shortcut='" + d.shortcut + "' " : "") + ">", e += "<a href='#' rel='" + (c.items.length - 1) + "'>", a.vakata.context.settings.icons && (e += "<i ", d.icon && (e += -1 !== d.icon.indexOf("/") || -1 !== d.icon.indexOf(".") ? " style='background:url(\"" + d.icon + "\") center center no-repeat' " : " class='" + d.icon + "' "), e += "></i><span class='vakata-contextmenu-sep'>&#160;</span>"), e += (a.isFunction(d.label) ? d.label({ item: b, reference: c.reference, element: c.element }) : d.label) + (d.shortcut ? ' <span class="vakata-contextmenu-shortcut vakata-contextmenu-shortcut-' + d.shortcut + '">' + (d.shortcut_label || "") + "</span>" : "") + "</a>", d.submenu && (g = a.vakata.context._parse(d.submenu, !0), g && (e += g)), e += "</li>", void (d.separator_after && (e += "<li class='vakata-context-separator'><a href='#' " + (a.vakata.context.settings.icons ? "" : 'style="margin-left:0px;"') + ">&#160;</a></li>", f = !0))) : !0 }), e = e.replace(/<li class\='vakata-context-separator'\><\/li\>$/, ""), d && (e += "</ul>"), d || (c.html = e, a.vakata.context._trigger("parse")), e.length > 10 ? e : !1 }, _show_submenu: function (c) { if (c = a(c), c.length && c.children("ul").length) { var d = c.children("ul"), e = c.offset().left + c.outerWidth(), f = c.offset().top, g = d.width(), h = d.height(), i = a(window).width() + a(window).scrollLeft(), j = a(window).height() + a(window).scrollTop(); b ? c[e - (g + 10 + c.outerWidth()) < 0 ? "addClass" : "removeClass"]("vakata-context-left") : c[e + g + 10 > i ? "addClass" : "removeClass"]("vakata-context-right"), f + h + 10 > j && d.css("bottom", "-1px"), d.show() } }, show: function (d, e, f) { var g, h, i, j, k, l, m, n, o = !0; switch (c.element && c.element.length && c.element.width(""), o) { case !e && !d: return !1; case !!e && !!d: c.reference = d, c.position_x = e.x, c.position_y = e.y; break; case !e && !!d: c.reference = d, g = d.offset(), c.position_x = g.left + d.outerHeight(), c.position_y = g.top; break; case !!e && !d: c.position_x = e.x, c.position_y = e.y } d && !f && a(d).data("vakata_contextmenu") && (f = a(d).data("vakata_contextmenu")), a.vakata.context._parse(f) && c.element.html(c.html), c.items.length && (c.element.appendTo("body"), h = c.element, i = c.position_x, j = c.position_y, k = h.width(), l = h.height(), m = a(window).width() + a(window).scrollLeft(), n = a(window).height() + a(window).scrollTop(), b && (i -= h.outerWidth() - a(d).outerWidth(), i < a(window).scrollLeft() + 20 && (i = a(window).scrollLeft() + 20)), i + k + 20 > m && (i = m - (k + 20)), j + l + 20 > n && (j = n - (l + 20)), c.element.css({ left: i, top: j }).show().find("a").first().focus().parent().addClass("vakata-context-hover"), c.is_visible = !0, a.vakata.context._trigger("show")) }, hide: function () { c.is_visible && (c.element.hide().find("ul").hide().end().find(":focus").blur().end().detach(), c.is_visible = !1, a.vakata.context._trigger("hide")) } }, a(function () { b = "rtl" === a("body").css("direction"); var d = !1; c.element = a("<ul class='vakata-context'></ul>"), c.element.on("mouseenter", "li", function (b) { b.stopImmediatePropagation(), a.contains(this, b.relatedTarget) || (d && clearTimeout(d), c.element.find(".vakata-context-hover").removeClass("vakata-context-hover").end(), a(this).siblings().find("ul").hide().end().end().parentsUntil(".vakata-context", "li").addBack().addClass("vakata-context-hover"), a.vakata.context._show_submenu(this)) }).on("mouseleave", "li", function (b) { a.contains(this, b.relatedTarget) || a(this).find(".vakata-context-hover").addBack().removeClass("vakata-context-hover") }).on("mouseleave", function (b) { a(this).find(".vakata-context-hover").removeClass("vakata-context-hover"), a.vakata.context.settings.hide_onmouseleave && (d = setTimeout(function (b) { return function () { a.vakata.context.hide() } }(this), a.vakata.context.settings.hide_onmouseleave)) }).on("click", "a", function (b) { b.preventDefault(), a(this).blur().parent().hasClass("vakata-context-disabled") || a.vakata.context._execute(a(this).attr("rel")) === !1 || a.vakata.context.hide() }).on("keydown", "a", function (b) { var d = null; switch (b.which) { case 13: case 32: b.type = "mouseup", b.preventDefault(), a(b.currentTarget).trigger(b); break; case 37: c.is_visible && (c.element.find(".vakata-context-hover").last().closest("li").first().find("ul").hide().find(".vakata-context-hover").removeClass("vakata-context-hover").end().end().children("a").focus(), b.stopImmediatePropagation(), b.preventDefault()); break; case 38: c.is_visible && (d = c.element.find("ul:visible").addBack().last().children(".vakata-context-hover").removeClass("vakata-context-hover").prevAll("li:not(.vakata-context-separator)").first(), d.length || (d = c.element.find("ul:visible").addBack().last().children("li:not(.vakata-context-separator)").last()), d.addClass("vakata-context-hover").children("a").focus(), b.stopImmediatePropagation(), b.preventDefault()); break; case 39: c.is_visible && (c.element.find(".vakata-context-hover").last().children("ul").show().children("li:not(.vakata-context-separator)").removeClass("vakata-context-hover").first().addClass("vakata-context-hover").children("a").focus(), b.stopImmediatePropagation(), b.preventDefault()); break; case 40: c.is_visible && (d = c.element.find("ul:visible").addBack().last().children(".vakata-context-hover").removeClass("vakata-context-hover").nextAll("li:not(.vakata-context-separator)").first(), d.length || (d = c.element.find("ul:visible").addBack().last().children("li:not(.vakata-context-separator)").first()), d.addClass("vakata-context-hover").children("a").focus(), b.stopImmediatePropagation(), b.preventDefault()); break; case 27: a.vakata.context.hide(), b.preventDefault() } }).on("keydown", function (a) { a.preventDefault(); var b = c.element.find(".vakata-contextmenu-shortcut-" + a.which).parent(); b.parent().not(".vakata-context-disabled") && b.click() }), a(i).on("mousedown.vakata.jstree", function (b) { c.is_visible && !a.contains(c.element[0], b.target) && a.vakata.context.hide() }).on("context_show.vakata.jstree", function (a, d) { c.element.find("li:has(ul)").children("a").addClass("vakata-context-parent"), b && c.element.addClass("vakata-context-rtl").css("direction", "rtl"), c.element.find("ul").hide().end() }) }) }(a), a.jstree.defaults.dnd = { copy: !0, open_timeout: 500, is_draggable: !0, check_while_dragging: !0, always_copy: !1, inside_pos: 0, drag_selection: !0, touch: !0, large_drop_target: !1, large_drag_target: !1 }, a.jstree.plugins.dnd = function (b, c) {
            this.bind = function () {
                c.bind.call(this), this.element.on("mousedown.jstree touchstart.jstree", this.settings.dnd.large_drag_target ? ".jstree-node" : ".jstree-anchor", a.proxy(function (b) {
                    if (this.settings.dnd.large_drag_target && a(b.target).closest(".jstree-node")[0] !== b.currentTarget) return !0; if ("touchstart" === b.type && (!this.settings.dnd.touch || "selected" === this.settings.dnd.touch && !a(b.currentTarget).closest(".jstree-node").children(".jstree-anchor").hasClass("jstree-clicked"))) return !0; var c = this.get_node(b.target), d = this.is_selected(c) && this.settings.dnd.drag_selection ? this.get_top_selected().length : 1, e = d > 1 ? d + " " + this.get_string("nodes") : this.get_text(b.currentTarget); return this.settings.core.force_text && (e = a.vakata.html.escape(e)), c && c.id && c.id !== a.jstree.root && (1 === b.which || "touchstart" === b.type) && (this.settings.dnd.is_draggable === !0 || a.isFunction(this.settings.dnd.is_draggable) && this.settings.dnd.is_draggable.call(this, d > 1 ? this.get_top_selected(!0) : [c], b)) ? (this.element.trigger("mousedown.jstree"), a.vakata.dnd.start(b, { jstree: !0, origin: this, obj: this.get_node(c, !0), nodes: d > 1 ? this.get_top_selected() : [c.id] }, '<div id="jstree-dnd" class="jstree-' + this.get_theme() + " jstree-" + this.get_theme() + "-" + this.get_theme_variant() + " " + (this.settings.core.themes.responsive ? " jstree-dnd-responsive" : "") + '"><i class="jstree-icon jstree-er"></i>' + e + '<ins class="jstree-copy" style="display:none;">+</ins></div>')) : void 0
                }, this))
            }
        }, a(function () { var b = !1, c = !1, d = !1, e = !1, f = a('<div id="jstree-marker">&#160;</div>').hide(); a(i).on("dnd_start.vakata.jstree", function (a, c) { b = !1, d = !1, c && c.data && c.data.jstree && f.appendTo("body") }).on("dnd_move.vakata.jstree", function (g, h) { if (e && clearTimeout(e), h && h.data && h.data.jstree && (!h.event.target.id || "jstree-marker" !== h.event.target.id)) { d = h.event; var i = a.jstree.reference(h.event.target), j = !1, k = !1, l = !1, m, n, o, p, q, r, s, t, u, v, w, x, y, z, A; if (i && i._data && i._data.dnd) if (f.attr("class", "jstree-" + i.get_theme() + (i.settings.core.themes.responsive ? " jstree-dnd-responsive" : "")), h.helper.children().attr("class", "jstree-" + i.get_theme() + " jstree-" + i.get_theme() + "-" + i.get_theme_variant() + " " + (i.settings.core.themes.responsive ? " jstree-dnd-responsive" : "")).find(".jstree-copy").first()[h.data.origin && (h.data.origin.settings.dnd.always_copy || h.data.origin.settings.dnd.copy && (h.event.metaKey || h.event.ctrlKey)) ? "show" : "hide"](), h.event.target !== i.element[0] && h.event.target !== i.get_container_ul()[0] || 0 !== i.get_container_ul().children().length) { if (j = i.settings.dnd.large_drop_target ? a(h.event.target).closest(".jstree-node").children(".jstree-anchor") : a(h.event.target).closest(".jstree-anchor"), j && j.length && j.parent().is(".jstree-closed, .jstree-open, .jstree-leaf") && (k = j.offset(), l = h.event.pageY - k.top, p = j.outerHeight(), s = p / 3 > l ? ["b", "i", "a"] : l > p - p / 3 ? ["a", "i", "b"] : l > p / 2 ? ["i", "a", "b"] : ["i", "b", "a"], a.each(s, function (d, g) { switch (g) { case "b": n = k.left - 6, o = k.top, q = i.get_parent(j), r = j.parent().index(); break; case "i": z = i.settings.dnd.inside_pos, A = i.get_node(j.parent()), n = k.left - 2, o = k.top + p / 2 + 1, q = A.id, r = "first" === z ? 0 : "last" === z ? A.children.length : Math.min(z, A.children.length); break; case "a": n = k.left - 6, o = k.top + p, q = i.get_parent(j), r = j.parent().index() + 1 } for (t = !0, u = 0, v = h.data.nodes.length; v > u; u++) if (w = h.data.origin && (h.data.origin.settings.dnd.always_copy || h.data.origin.settings.dnd.copy && (h.event.metaKey || h.event.ctrlKey)) ? "copy_node" : "move_node", x = r, "move_node" === w && "a" === g && h.data.origin && h.data.origin === i && q === i.get_parent(h.data.nodes[u]) && (y = i.get_node(q), x > a.inArray(h.data.nodes[u], y.children) && (x -= 1)), t = t && (i && i.settings && i.settings.dnd && i.settings.dnd.check_while_dragging === !1 || i.check(w, h.data.origin && h.data.origin !== i ? h.data.origin.get_node(h.data.nodes[u]) : h.data.nodes[u], q, x, { dnd: !0, ref: i.get_node(j.parent()), pos: g, origin: h.data.origin, is_multi: h.data.origin && h.data.origin !== i, is_foreign: !h.data.origin })), !t) { i && i.last_error && (c = i.last_error()); break } return "i" === g && j.parent().is(".jstree-closed") && i.settings.dnd.open_timeout && (e = setTimeout(function (a, b) { return function () { a.open_node(b) } }(i, j), i.settings.dnd.open_timeout)), t ? (b = { ins: i, par: q, pos: "i" !== g || "last" !== z || 0 !== r || i.is_loaded(A) ? r : "last" }, f.css({ left: n + "px", top: o + "px" }).show(), h.helper.find(".jstree-icon").first().removeClass("jstree-er").addClass("jstree-ok"), c = {}, s = !0, !1) : void 0 }), s === !0)) return } else { for (t = !0, u = 0, v = h.data.nodes.length; v > u; u++) if (t = t && i.check(h.data.origin && (h.data.origin.settings.dnd.always_copy || h.data.origin.settings.dnd.copy && (h.event.metaKey || h.event.ctrlKey)) ? "copy_node" : "move_node", h.data.origin && h.data.origin !== i ? h.data.origin.get_node(h.data.nodes[u]) : h.data.nodes[u], a.jstree.root, "last", { dnd: !0, ref: i.get_node(a.jstree.root), pos: "i", origin: h.data.origin, is_multi: h.data.origin && h.data.origin !== i, is_foreign: !h.data.origin }), !t) break; if (t) return b = { ins: i, par: a.jstree.root, pos: "last" }, f.hide(), void h.helper.find(".jstree-icon").first().removeClass("jstree-er").addClass("jstree-ok") } b = !1, h.helper.find(".jstree-icon").removeClass("jstree-ok").addClass("jstree-er"), f.hide() } }).on("dnd_scroll.vakata.jstree", function (a, c) { c && c.data && c.data.jstree && (f.hide(), b = !1, d = !1, c.helper.find(".jstree-icon").first().removeClass("jstree-ok").addClass("jstree-er")) }).on("dnd_stop.vakata.jstree", function (g, h) { if (e && clearTimeout(e), h && h.data && h.data.jstree) { f.hide().detach(); var i, j, k = []; if (b) { for (i = 0, j = h.data.nodes.length; j > i; i++) k[i] = h.data.origin ? h.data.origin.get_node(h.data.nodes[i]) : h.data.nodes[i]; b.ins[h.data.origin && (h.data.origin.settings.dnd.always_copy || h.data.origin.settings.dnd.copy && (h.event.metaKey || h.event.ctrlKey)) ? "copy_node" : "move_node"](k, b.par, b.pos, !1, !1, !1, h.data.origin) } else i = a(h.event.target).closest(".jstree"), i.length && c && c.error && "check" === c.error && (i = i.jstree(!0), i && i.settings.core.error.call(this, c)); d = !1, b = !1 } }).on("keyup.jstree keydown.jstree", function (b, c) { c = a.vakata.dnd._get(), c && c.data && c.data.jstree && (c.helper.find(".jstree-copy").first()[c.data.origin && (c.data.origin.settings.dnd.always_copy || c.data.origin.settings.dnd.copy && (b.metaKey || b.ctrlKey)) ? "show" : "hide"](), d && (d.metaKey = b.metaKey, d.ctrlKey = b.ctrlKey, a.vakata.dnd._trigger("move", d))) }) }), function (a) { a.vakata.html = { div: a("<div />"), escape: function (b) { return a.vakata.html.div.text(b).html() }, strip: function (b) { return a.vakata.html.div.empty().append(a.parseHTML(b)).text() } }; var b = { element: !1, target: !1, is_down: !1, is_drag: !1, helper: !1, helper_w: 0, data: !1, init_x: 0, init_y: 0, scroll_l: 0, scroll_t: 0, scroll_e: !1, scroll_i: !1, is_touch: !1 }; a.vakata.dnd = { settings: { scroll_speed: 10, scroll_proximity: 20, helper_left: 5, helper_top: 10, threshold: 5, threshold_touch: 50 }, _trigger: function (b, c) { var d = a.vakata.dnd._get(); d.event = c, a(i).triggerHandler("dnd_" + b + ".vakata", d) }, _get: function () { return { data: b.data, element: b.element, helper: b.helper } }, _clean: function () { b.helper && b.helper.remove(), b.scroll_i && (clearInterval(b.scroll_i), b.scroll_i = !1), b = { element: !1, target: !1, is_down: !1, is_drag: !1, helper: !1, helper_w: 0, data: !1, init_x: 0, init_y: 0, scroll_l: 0, scroll_t: 0, scroll_e: !1, scroll_i: !1, is_touch: !1 }, a(i).off("mousemove.vakata.jstree touchmove.vakata.jstree", a.vakata.dnd.drag), a(i).off("mouseup.vakata.jstree touchend.vakata.jstree", a.vakata.dnd.stop) }, _scroll: function (c) { if (!b.scroll_e || !b.scroll_l && !b.scroll_t) return b.scroll_i && (clearInterval(b.scroll_i), b.scroll_i = !1), !1; if (!b.scroll_i) return b.scroll_i = setInterval(a.vakata.dnd._scroll, 100), !1; if (c === !0) return !1; var d = b.scroll_e.scrollTop(), e = b.scroll_e.scrollLeft(); b.scroll_e.scrollTop(d + b.scroll_t * a.vakata.dnd.settings.scroll_speed), b.scroll_e.scrollLeft(e + b.scroll_l * a.vakata.dnd.settings.scroll_speed), (d !== b.scroll_e.scrollTop() || e !== b.scroll_e.scrollLeft()) && a.vakata.dnd._trigger("scroll", b.scroll_e) }, start: function (c, d, e) { "touchstart" === c.type && c.originalEvent && c.originalEvent.changedTouches && c.originalEvent.changedTouches[0] && (c.pageX = c.originalEvent.changedTouches[0].pageX, c.pageY = c.originalEvent.changedTouches[0].pageY, c.target = i.elementFromPoint(c.originalEvent.changedTouches[0].pageX - window.pageXOffset, c.originalEvent.changedTouches[0].pageY - window.pageYOffset)), b.is_drag && a.vakata.dnd.stop({}); try { c.currentTarget.unselectable = "on", c.currentTarget.onselectstart = function () { return !1 }, c.currentTarget.style && (c.currentTarget.style.MozUserSelect = "none") } catch (f) { } return b.init_x = c.pageX, b.init_y = c.pageY, b.data = d, b.is_down = !0, b.element = c.currentTarget, b.target = c.target, b.is_touch = "touchstart" === c.type, e !== !1 && (b.helper = a("<div id='vakata-dnd'></div>").html(e).css({ display: "block", margin: "0", padding: "0", position: "absolute", top: "-2000px", lineHeight: "16px", zIndex: "10000" })), a(i).on("mousemove.vakata.jstree touchmove.vakata.jstree", a.vakata.dnd.drag), a(i).on("mouseup.vakata.jstree touchend.vakata.jstree", a.vakata.dnd.stop), !1 }, drag: function (c) { if ("touchmove" === c.type && c.originalEvent && c.originalEvent.changedTouches && c.originalEvent.changedTouches[0] && (c.pageX = c.originalEvent.changedTouches[0].pageX, c.pageY = c.originalEvent.changedTouches[0].pageY, c.target = i.elementFromPoint(c.originalEvent.changedTouches[0].pageX - window.pageXOffset, c.originalEvent.changedTouches[0].pageY - window.pageYOffset)), b.is_down) { if (!b.is_drag) { if (!(Math.abs(c.pageX - b.init_x) > (b.is_touch ? a.vakata.dnd.settings.threshold_touch : a.vakata.dnd.settings.threshold) || Math.abs(c.pageY - b.init_y) > (b.is_touch ? a.vakata.dnd.settings.threshold_touch : a.vakata.dnd.settings.threshold))) return; b.helper && (b.helper.appendTo("body"), b.helper_w = b.helper.outerWidth()), b.is_drag = !0, a.vakata.dnd._trigger("start", c) } var d = !1, e = !1, f = !1, g = !1, h = !1, j = !1, k = !1, l = !1, m = !1, n = !1; return b.scroll_t = 0, b.scroll_l = 0, b.scroll_e = !1, a(a(c.target).parentsUntil("body").addBack().get().reverse()).filter(function () { return /^auto|scroll$/.test(a(this).css("overflow")) && (this.scrollHeight > this.offsetHeight || this.scrollWidth > this.offsetWidth) }).each(function () { var d = a(this), e = d.offset(); return this.scrollHeight > this.offsetHeight && (e.top + d.height() - c.pageY < a.vakata.dnd.settings.scroll_proximity && (b.scroll_t = 1), c.pageY - e.top < a.vakata.dnd.settings.scroll_proximity && (b.scroll_t = -1)), this.scrollWidth > this.offsetWidth && (e.left + d.width() - c.pageX < a.vakata.dnd.settings.scroll_proximity && (b.scroll_l = 1), c.pageX - e.left < a.vakata.dnd.settings.scroll_proximity && (b.scroll_l = -1)), b.scroll_t || b.scroll_l ? (b.scroll_e = a(this), !1) : void 0 }), b.scroll_e || (d = a(i), e = a(window), f = d.height(), g = e.height(), h = d.width(), j = e.width(), k = d.scrollTop(), l = d.scrollLeft(), f > g && c.pageY - k < a.vakata.dnd.settings.scroll_proximity && (b.scroll_t = -1), f > g && g - (c.pageY - k) < a.vakata.dnd.settings.scroll_proximity && (b.scroll_t = 1), h > j && c.pageX - l < a.vakata.dnd.settings.scroll_proximity && (b.scroll_l = -1), h > j && j - (c.pageX - l) < a.vakata.dnd.settings.scroll_proximity && (b.scroll_l = 1), (b.scroll_t || b.scroll_l) && (b.scroll_e = d)), b.scroll_e && a.vakata.dnd._scroll(!0), b.helper && (m = parseInt(c.pageY + a.vakata.dnd.settings.helper_top, 10), n = parseInt(c.pageX + a.vakata.dnd.settings.helper_left, 10), f && m + 25 > f && (m = f - 50), h && n + b.helper_w > h && (n = h - (b.helper_w + 2)), b.helper.css({ left: n + "px", top: m + "px" })), a.vakata.dnd._trigger("move", c), !1 } }, stop: function (c) { if ("touchend" === c.type && c.originalEvent && c.originalEvent.changedTouches && c.originalEvent.changedTouches[0] && (c.pageX = c.originalEvent.changedTouches[0].pageX, c.pageY = c.originalEvent.changedTouches[0].pageY, c.target = i.elementFromPoint(c.originalEvent.changedTouches[0].pageX - window.pageXOffset, c.originalEvent.changedTouches[0].pageY - window.pageYOffset)), b.is_drag) a.vakata.dnd._trigger("stop", c); else if ("touchend" === c.type && c.target === b.target) { var d = setTimeout(function () { a(c.target).click() }, 100); a(c.target).one("click", function () { d && clearTimeout(d) }) } return a.vakata.dnd._clean(), !1 } } }(a), a.jstree.defaults.massload = null, a.jstree.plugins.massload = function (b, c) { this.init = function (a, b) { c.init.call(this, a, b), this._data.massload = {} }, this._load_nodes = function (b, d, e) { var f = this.settings.massload; return e && !a.isEmptyObject(this._data.massload) ? c._load_nodes.call(this, b, d, e) : a.isFunction(f) ? f.call(this, b, a.proxy(function (a) { if (a) for (var f in a) a.hasOwnProperty(f) && (this._data.massload[f] = a[f]); c._load_nodes.call(this, b, d, e) }, this)) : "object" == typeof f && f && f.url ? (f = a.extend(!0, {}, f), a.isFunction(f.url) && (f.url = f.url.call(this, b)), a.isFunction(f.data) && (f.data = f.data.call(this, b)), a.ajax(f).done(a.proxy(function (a, f, g) { if (a) for (var h in a) a.hasOwnProperty(h) && (this._data.massload[h] = a[h]); c._load_nodes.call(this, b, d, e) }, this)).fail(a.proxy(function (a) { c._load_nodes.call(this, b, d, e) }, this))) : c._load_nodes.call(this, b, d, e) }, this._load_node = function (b, d) { var e = this._data.massload[b.id]; return e ? this["string" == typeof e ? "_append_html_data" : "_append_json_data"](b, "string" == typeof e ? a(a.parseHTML(e)).filter(function () { return 3 !== this.nodeType }) : e, function (a) { d.call(this, a), delete this._data.massload[b.id] }) : c._load_node.call(this, b, d) } }, a.jstree.defaults.search = { ajax: !1, fuzzy: !1, case_sensitive: !1, show_only_matches: !1, show_only_matches_children: !1, close_opened_onclear: !0, search_leaves_only: !1, search_callback: !1 }, a.jstree.plugins.search = function (c, d) { this.bind = function () { d.bind.call(this), this._data.search.str = "", this._data.search.dom = a(), this._data.search.res = [], this._data.search.opn = [], this._data.search.som = !1, this._data.search.smc = !1, this._data.search.hdn = [], this.element.on("search.jstree", a.proxy(function (b, c) { if (this._data.search.som && c.res.length) { var d = this._model.data, e, f, g = []; for (e = 0, f = c.res.length; f > e; e++) d[c.res[e]] && !d[c.res[e]].state.hidden && (g.push(c.res[e]), g = g.concat(d[c.res[e]].parents), this._data.search.smc && (g = g.concat(d[c.res[e]].children_d))); g = a.vakata.array_remove_item(a.vakata.array_unique(g), a.jstree.root), this._data.search.hdn = this.hide_all(!0), this.show_node(g) } }, this)).on("clear_search.jstree", a.proxy(function (a, b) { this._data.search.som && b.res.length && this.show_node(this._data.search.hdn) }, this)) }, this.search = function (c, d, e, f, g, h) { if (c === !1 || "" === a.trim(c.toString())) return this.clear_search(); f = this.get_node(f), f = f && f.id ? f.id : null, c = c.toString(); var i = this.settings.search, j = i.ajax ? i.ajax : !1, k = this._model.data, l = null, m = [], n = [], o, p; if (this._data.search.res.length && !g && this.clear_search(), e === b && (e = i.show_only_matches), h === b && (h = i.show_only_matches_children), !d && j !== !1) return a.isFunction(j) ? j.call(this, c, a.proxy(function (b) { b && b.d && (b = b.d), this._load_nodes(a.isArray(b) ? a.vakata.array_unique(b) : [], function () { this.search(c, !0, e, f, g) }, !0) }, this), f) : (j = a.extend({}, j), j.data || (j.data = {}), j.data.str = c, f && (j.data.inside = f), a.ajax(j).fail(a.proxy(function () { this._data.core.last_error = { error: "ajax", plugin: "search", id: "search_01", reason: "Could not load search parents", data: JSON.stringify(j) }, this.settings.core.error.call(this, this._data.core.last_error) }, this)).done(a.proxy(function (b) { b && b.d && (b = b.d), this._load_nodes(a.isArray(b) ? a.vakata.array_unique(b) : [], function () { this.search(c, !0, e, f, g) }, !0) }, this))); if (g || (this._data.search.str = c, this._data.search.dom = a(), this._data.search.res = [], this._data.search.opn = [], this._data.search.som = e, this._data.search.smc = h), l = new a.vakata.search(c, !0, { caseSensitive: i.case_sensitive, fuzzy: i.fuzzy }), a.each(k[f ? f : a.jstree.root].children_d, function (a, b) { var d = k[b]; d.text && (!i.search_leaves_only || d.state.loaded && 0 === d.children.length) && (i.search_callback && i.search_callback.call(this, c, d) || !i.search_callback && l.search(d.text).isMatch) && (m.push(b), n = n.concat(d.parents)) }), m.length) { for (n = a.vakata.array_unique(n), o = 0, p = n.length; p > o; o++) n[o] !== a.jstree.root && k[n[o]] && this.open_node(n[o], null, 0) === !0 && this._data.search.opn.push(n[o]); g ? (this._data.search.dom = this._data.search.dom.add(a(this.element[0].querySelectorAll("#" + a.map(m, function (b) { return -1 !== "0123456789".indexOf(b[0]) ? "\\3" + b[0] + " " + b.substr(1).replace(a.jstree.idregex, "\\$&") : b.replace(a.jstree.idregex, "\\$&") }).join(", #")))), this._data.search.res = a.vakata.array_unique(this._data.search.res.concat(m))) : (this._data.search.dom = a(this.element[0].querySelectorAll("#" + a.map(m, function (b) { return -1 !== "0123456789".indexOf(b[0]) ? "\\3" + b[0] + " " + b.substr(1).replace(a.jstree.idregex, "\\$&") : b.replace(a.jstree.idregex, "\\$&") }).join(", #"))), this._data.search.res = m), this._data.search.dom.children(".jstree-anchor").addClass("jstree-search") } this.trigger("search", { nodes: this._data.search.dom, str: c, res: this._data.search.res, show_only_matches: e }) }, this.clear_search = function () { this.settings.search.close_opened_onclear && this.close_node(this._data.search.opn, 0), this.trigger("clear_search", { nodes: this._data.search.dom, str: this._data.search.str, res: this._data.search.res }), this._data.search.res.length && (this._data.search.dom = a(this.element[0].querySelectorAll("#" + a.map(this._data.search.res, function (b) { return -1 !== "0123456789".indexOf(b[0]) ? "\\3" + b[0] + " " + b.substr(1).replace(a.jstree.idregex, "\\$&") : b.replace(a.jstree.idregex, "\\$&") }).join(", #"))), this._data.search.dom.children(".jstree-anchor").removeClass("jstree-search")), this._data.search.str = "", this._data.search.res = [], this._data.search.opn = [], this._data.search.dom = a() }, this.redraw_node = function (b, c, e, f) { if (b = d.redraw_node.apply(this, arguments), b && -1 !== a.inArray(b.id, this._data.search.res)) { var g, h, i = null; for (g = 0, h = b.childNodes.length; h > g; g++) if (b.childNodes[g] && b.childNodes[g].className && -1 !== b.childNodes[g].className.indexOf("jstree-anchor")) { i = b.childNodes[g]; break } i && (i.className += " jstree-search") } return b } }, function (a) { a.vakata.search = function (b, c, d) { d = d || {}, d = a.extend({}, a.vakata.search.defaults, d), d.fuzzy !== !1 && (d.fuzzy = !0), b = d.caseSensitive ? b : b.toLowerCase(); var e = d.location, f = d.distance, g = d.threshold, h = b.length, i, j, k, l; return h > 32 && (d.fuzzy = !1), d.fuzzy && (i = 1 << h - 1, j = function () { var a = {}, c = 0; for (c = 0; h > c; c++) a[b.charAt(c)] = 0; for (c = 0; h > c; c++) a[b.charAt(c)] |= 1 << h - c - 1; return a }(), k = function (a, b) { var c = a / h, d = Math.abs(e - b); return f ? c + d / f : d ? 1 : c }), l = function (a) { if (a = d.caseSensitive ? a : a.toLowerCase(), b === a || -1 !== a.indexOf(b)) return { isMatch: !0, score: 0 }; if (!d.fuzzy) return { isMatch: !1, score: 1 }; var c, f, l = a.length, m = g, n = a.indexOf(b, e), o, p, q = h + l, r, s, t, u, v, w = 1, x = []; for (-1 !== n && (m = Math.min(k(0, n), m), n = a.lastIndexOf(b, e + h), -1 !== n && (m = Math.min(k(0, n), m))), n = -1, c = 0; h > c; c++) { o = 0, p = q; while (p > o) k(c, e + p) <= m ? o = p : q = p, p = Math.floor((q - o) / 2 + o); for (q = p, s = Math.max(1, e - p + 1), t = Math.min(e + p, l) + h, u = new Array(t + 2), u[t + 1] = (1 << c) - 1, f = t; f >= s; f--) if (v = j[a.charAt(f - 1)], 0 === c ? u[f] = (u[f + 1] << 1 | 1) & v : u[f] = (u[f + 1] << 1 | 1) & v | ((r[f + 1] | r[f]) << 1 | 1) | r[f + 1], u[f] & i && (w = k(c, f - 1), m >= w)) { if (m = w, n = f - 1, x.push(n), !(n > e)) break; s = Math.max(1, 2 * e - n) } if (k(c + 1, e) > m) break; r = u } return { isMatch: n >= 0, score: w } }, c === !0 ? { search: l } : l(c) }, a.vakata.search.defaults = { location: 0, distance: 100, threshold: .6, fuzzy: !1, caseSensitive: !1 } }(a), a.jstree.defaults.sort = function (a, b) { return this.get_text(a) > this.get_text(b) ? 1 : -1 }, a.jstree.plugins.sort = function (b, c) { this.bind = function () { c.bind.call(this), this.element.on("model.jstree", a.proxy(function (a, b) { this.sort(b.parent, !0) }, this)).on("rename_node.jstree create_node.jstree", a.proxy(function (a, b) { this.sort(b.parent || b.node.parent, !1), this.redraw_node(b.parent || b.node.parent, !0) }, this)).on("move_node.jstree copy_node.jstree", a.proxy(function (a, b) { this.sort(b.parent, !1), this.redraw_node(b.parent, !0) }, this)) }, this.sort = function (b, c) { var d, e; if (b = this.get_node(b), b && b.children && b.children.length && (b.children.sort(a.proxy(this.settings.sort, this)), c)) for (d = 0, e = b.children_d.length; e > d; d++) this.sort(b.children_d[d], !1) } }; var n = !1; a.jstree.defaults.state = { key: "jstree", events: "changed.jstree open_node.jstree close_node.jstree check_node.jstree uncheck_node.jstree", ttl: !1, filter: !1 }, a.jstree.plugins.state = function (b, c) { this.bind = function () { c.bind.call(this); var b = a.proxy(function () { this.element.on(this.settings.state.events, a.proxy(function () { n && clearTimeout(n), n = setTimeout(a.proxy(function () { this.save_state() }, this), 100) }, this)), this.trigger("state_ready") }, this); this.element.on("ready.jstree", a.proxy(function (a, c) { this.element.one("restore_state.jstree", b), this.restore_state() || b() }, this)) }, this.save_state = function () { var b = { state: this.get_state(), ttl: this.settings.state.ttl, sec: +new Date }; a.vakata.storage.set(this.settings.state.key, JSON.stringify(b)) }, this.restore_state = function () { var b = a.vakata.storage.get(this.settings.state.key); if (b) try { b = JSON.parse(b) } catch (c) { return !1 } return b && b.ttl && b.sec && +new Date - b.sec > b.ttl ? !1 : (b && b.state && (b = b.state), b && a.isFunction(this.settings.state.filter) && (b = this.settings.state.filter.call(this, b)), b ? (this.element.one("set_state.jstree", function (c, d) { d.instance.trigger("restore_state", { state: a.extend(!0, {}, b) }) }), this.set_state(b), !0) : !1) }, this.clear_state = function () { return a.vakata.storage.del(this.settings.state.key) } }, function (a, b) { a.vakata.storage = { set: function (a, b) { return window.localStorage.setItem(a, b) }, get: function (a) { return window.localStorage.getItem(a) }, del: function (a) { return window.localStorage.removeItem(a) } } }(a), a.jstree.defaults.types = { "default": {} }, a.jstree.defaults.types[a.jstree.root] = {}, a.jstree.plugins.types = function (c, d) { this.init = function (c, e) { var f, g; if (e && e.types && e.types["default"]) for (f in e.types) if ("default" !== f && f !== a.jstree.root && e.types.hasOwnProperty(f)) for (g in e.types["default"]) e.types["default"].hasOwnProperty(g) && e.types[f][g] === b && (e.types[f][g] = e.types["default"][g]); d.init.call(this, c, e), this._model.data[a.jstree.root].type = a.jstree.root }, this.refresh = function (b, c) { d.refresh.call(this, b, c), this._model.data[a.jstree.root].type = a.jstree.root }, this.bind = function () { this.element.on("model.jstree", a.proxy(function (c, d) { var e = this._model.data, f = d.nodes, g = this.settings.types, h, i, j = "default"; for (h = 0, i = f.length; i > h; h++) j = "default", e[f[h]].original && e[f[h]].original.type && g[e[f[h]].original.type] && (j = e[f[h]].original.type), e[f[h]].data && e[f[h]].data.jstree && e[f[h]].data.jstree.type && g[e[f[h]].data.jstree.type] && (j = e[f[h]].data.jstree.type), e[f[h]].type = j, e[f[h]].icon === !0 && g[j].icon !== b && (e[f[h]].icon = g[j].icon); e[a.jstree.root].type = a.jstree.root }, this)), d.bind.call(this) }, this.get_json = function (b, c, e) { var f, g, h = this._model.data, i = c ? a.extend(!0, {}, c, { no_id: !1 }) : {}, j = d.get_json.call(this, b, i, e); if (j === !1) return !1; if (a.isArray(j)) for (f = 0, g = j.length; g > f; f++) j[f].type = j[f].id && h[j[f].id] && h[j[f].id].type ? h[j[f].id].type : "default", c && c.no_id && (delete j[f].id, j[f].li_attr && j[f].li_attr.id && delete j[f].li_attr.id, j[f].a_attr && j[f].a_attr.id && delete j[f].a_attr.id); else j.type = j.id && h[j.id] && h[j.id].type ? h[j.id].type : "default", c && c.no_id && (j = this._delete_ids(j)); return j }, this._delete_ids = function (b) { if (a.isArray(b)) { for (var c = 0, d = b.length; d > c; c++) b[c] = this._delete_ids(b[c]); return b } return delete b.id, b.li_attr && b.li_attr.id && delete b.li_attr.id, b.a_attr && b.a_attr.id && delete b.a_attr.id, b.children && a.isArray(b.children) && (b.children = this._delete_ids(b.children)), b }, this.check = function (c, e, f, g, h) { if (d.check.call(this, c, e, f, g, h) === !1) return !1; e = e && e.id ? e : this.get_node(e), f = f && f.id ? f : this.get_node(f); var i = e && e.id ? h && h.origin ? h.origin : a.jstree.reference(e.id) : null, j, k, l, m; switch (i = i && i._model && i._model.data ? i._model.data : null, c) { case "create_node": case "move_node": case "copy_node": if ("move_node" !== c || -1 === a.inArray(e.id, f.children)) { if (j = this.get_rules(f), j.max_children !== b && -1 !== j.max_children && j.max_children === f.children.length) return this._data.core.last_error = { error: "check", plugin: "types", id: "types_01", reason: "max_children prevents function: " + c, data: JSON.stringify({ chk: c, pos: g, obj: e && e.id ? e.id : !1, par: f && f.id ? f.id : !1 }) }, !1; if (j.valid_children !== b && -1 !== j.valid_children && -1 === a.inArray(e.type || "default", j.valid_children)) return this._data.core.last_error = { error: "check", plugin: "types", id: "types_02", reason: "valid_children prevents function: " + c, data: JSON.stringify({ chk: c, pos: g, obj: e && e.id ? e.id : !1, par: f && f.id ? f.id : !1 }) }, !1; if (i && e.children_d && e.parents) { for (k = 0, l = 0, m = e.children_d.length; m > l; l++) k = Math.max(k, i[e.children_d[l]].parents.length); k = k - e.parents.length + 1 } (0 >= k || k === b) && (k = 1); do { if (j.max_depth !== b && -1 !== j.max_depth && j.max_depth < k) return this._data.core.last_error = { error: "check", plugin: "types", id: "types_03", reason: "max_depth prevents function: " + c, data: JSON.stringify({ chk: c, pos: g, obj: e && e.id ? e.id : !1, par: f && f.id ? f.id : !1 }) }, !1; f = this.get_node(f.parent), j = this.get_rules(f), k++ } while (f) } } return !0 }, this.get_rules = function (a) { if (a = this.get_node(a), !a) return !1; var c = this.get_type(a, !0); return c.max_depth === b && (c.max_depth = -1), c.max_children === b && (c.max_children = -1), c.valid_children === b && (c.valid_children = -1), c }, this.get_type = function (b, c) { return b = this.get_node(b), b ? c ? a.extend({ type: b.type }, this.settings.types[b.type]) : b.type : !1 }, this.set_type = function (c, d) { var e, f, g, h, i; if (a.isArray(c)) { for (c = c.slice(), f = 0, g = c.length; g > f; f++) this.set_type(c[f], d); return !0 } return e = this.settings.types, c = this.get_node(c), e[d] && c ? (h = c.type, i = this.get_icon(c), c.type = d, (i === !0 || e[h] && e[h].icon !== b && i === e[h].icon) && this.set_icon(c, e[d].icon !== b ? e[d].icon : !0), !0) : !1 } }, a.jstree.defaults.unique = { case_sensitive: !1, duplicate: function (a, b) { return a + " (" + b + ")" } }, a.jstree.plugins.unique = function (c, d) { this.check = function (b, c, e, f, g) { if (d.check.call(this, b, c, e, f, g) === !1) return !1; if (c = c && c.id ? c : this.get_node(c), e = e && e.id ? e : this.get_node(e), !e || !e.children) return !0; var h = "rename_node" === b ? f : c.text, i = [], j = this.settings.unique.case_sensitive, k = this._model.data, l, m; for (l = 0, m = e.children.length; m > l; l++) i.push(j ? k[e.children[l]].text : k[e.children[l]].text.toLowerCase()); switch (j || (h = h.toLowerCase()), b) { case "delete_node": return !0; case "rename_node": return l = -1 === a.inArray(h, i) || c.text && c.text[j ? "toString" : "toLowerCase"]() === h, l || (this._data.core.last_error = { error: "check", plugin: "unique", id: "unique_01", reason: "Child with name " + h + " already exists. Preventing: " + b, data: JSON.stringify({ chk: b, pos: f, obj: c && c.id ? c.id : !1, par: e && e.id ? e.id : !1 }) }), l; case "create_node": return l = -1 === a.inArray(h, i), l || (this._data.core.last_error = { error: "check", plugin: "unique", id: "unique_04", reason: "Child with name " + h + " already exists. Preventing: " + b, data: JSON.stringify({ chk: b, pos: f, obj: c && c.id ? c.id : !1, par: e && e.id ? e.id : !1 }) }), l; case "copy_node": return l = -1 === a.inArray(h, i), l || (this._data.core.last_error = { error: "check", plugin: "unique", id: "unique_02", reason: "Child with name " + h + " already exists. Preventing: " + b, data: JSON.stringify({ chk: b, pos: f, obj: c && c.id ? c.id : !1, par: e && e.id ? e.id : !1 }) }), l; case "move_node": return l = c.parent === e.id && (!g || !g.is_multi) || -1 === a.inArray(h, i), l || (this._data.core.last_error = { error: "check", plugin: "unique", id: "unique_03", reason: "Child with name " + h + " already exists. Preventing: " + b, data: JSON.stringify({ chk: b, pos: f, obj: c && c.id ? c.id : !1, par: e && e.id ? e.id : !1 }) }), l } return !0 }, this.create_node = function (c, e, f, g, h) { if (!e || e.text === b) { if (null === c && (c = a.jstree.root), c = this.get_node(c), !c) return d.create_node.call(this, c, e, f, g, h); if (f = f === b ? "last" : f, !f.toString().match(/^(before|after)$/) && !h && !this.is_loaded(c)) return d.create_node.call(this, c, e, f, g, h); e || (e = {}); var i, j, k, l, m, n = this._model.data, o = this.settings.unique.case_sensitive, p = this.settings.unique.duplicate; for (j = i = this.get_string("New node"), k = [], l = 0, m = c.children.length; m > l; l++) k.push(o ? n[c.children[l]].text : n[c.children[l]].text.toLowerCase()); l = 1; while (-1 !== a.inArray(o ? j : j.toLowerCase(), k)) j = p.call(this, i, ++l).toString(); e.text = j } return d.create_node.call(this, c, e, f, g, h) } }; var o = i.createElement("DIV"); if (o.setAttribute("unselectable", "on"), o.setAttribute("role", "presentation"), o.className = "jstree-wholerow", o.innerHTML = "&#160;", a.jstree.plugins.wholerow = function (b, c) { this.bind = function () { c.bind.call(this), this.element.on("ready.jstree set_state.jstree", a.proxy(function () { this.hide_dots() }, this)).on("init.jstree loading.jstree ready.jstree", a.proxy(function () { this.get_container_ul().addClass("jstree-wholerow-ul") }, this)).on("deselect_all.jstree", a.proxy(function (a, b) { this.element.find(".jstree-wholerow-clicked").removeClass("jstree-wholerow-clicked") }, this)).on("changed.jstree", a.proxy(function (a, b) { this.element.find(".jstree-wholerow-clicked").removeClass("jstree-wholerow-clicked"); var c = !1, d, e; for (d = 0, e = b.selected.length; e > d; d++) c = this.get_node(b.selected[d], !0), c && c.length && c.children(".jstree-wholerow").addClass("jstree-wholerow-clicked") }, this)).on("open_node.jstree", a.proxy(function (a, b) { this.get_node(b.node, !0).find(".jstree-clicked").parent().children(".jstree-wholerow").addClass("jstree-wholerow-clicked") }, this)).on("hover_node.jstree dehover_node.jstree", a.proxy(function (a, b) { "hover_node" === a.type && this.is_disabled(b.node) || this.get_node(b.node, !0).children(".jstree-wholerow")["hover_node" === a.type ? "addClass" : "removeClass"]("jstree-wholerow-hovered") }, this)).on("contextmenu.jstree", ".jstree-wholerow", a.proxy(function (b) { b.preventDefault(); var c = a.Event("contextmenu", { metaKey: b.metaKey, ctrlKey: b.ctrlKey, altKey: b.altKey, shiftKey: b.shiftKey, pageX: b.pageX, pageY: b.pageY }); a(b.currentTarget).closest(".jstree-node").children(".jstree-anchor").first().trigger(c) }, this)).on("click.jstree", ".jstree-wholerow", function (b) { b.stopImmediatePropagation(); var c = a.Event("click", { metaKey: b.metaKey, ctrlKey: b.ctrlKey, altKey: b.altKey, shiftKey: b.shiftKey }); a(b.currentTarget).closest(".jstree-node").children(".jstree-anchor").first().trigger(c).focus() }).on("click.jstree", ".jstree-leaf > .jstree-ocl", a.proxy(function (b) { b.stopImmediatePropagation(); var c = a.Event("click", { metaKey: b.metaKey, ctrlKey: b.ctrlKey, altKey: b.altKey, shiftKey: b.shiftKey }); a(b.currentTarget).closest(".jstree-node").children(".jstree-anchor").first().trigger(c).focus() }, this)).on("mouseover.jstree", ".jstree-wholerow, .jstree-icon", a.proxy(function (a) { return a.stopImmediatePropagation(), this.is_disabled(a.currentTarget) || this.hover_node(a.currentTarget), !1 }, this)).on("mouseleave.jstree", ".jstree-node", a.proxy(function (a) { this.dehover_node(a.currentTarget) }, this)) }, this.teardown = function () { this.settings.wholerow && this.element.find(".jstree-wholerow").remove(), c.teardown.call(this) }, this.redraw_node = function (b, d, e, f) { if (b = c.redraw_node.apply(this, arguments)) { var g = o.cloneNode(!0); -1 !== a.inArray(b.id, this._data.core.selected) && (g.className += " jstree-wholerow-clicked"), this._data.core.focused && this._data.core.focused === b.id && (g.className += " jstree-wholerow-hovered"), b.insertBefore(g, b.childNodes[0]) } return b } }, i.registerElement && Object && Object.create) { var p = Object.create(HTMLElement.prototype); p.createdCallback = function () { var b = { core: {}, plugins: [] }, c; for (c in a.jstree.plugins) a.jstree.plugins.hasOwnProperty(c) && this.attributes[c] && (b.plugins.push(c), this.getAttribute(c) && JSON.parse(this.getAttribute(c)) && (b[c] = JSON.parse(this.getAttribute(c)))); for (c in a.jstree.defaults.core) a.jstree.defaults.core.hasOwnProperty(c) && this.attributes[c] && (b.core[c] = JSON.parse(this.getAttribute(c)) || this.getAttribute(c)); a(this).jstree(b) }; try { i.registerElement("vakata-jstree", { prototype: p }) } catch (q) { } }
    }
});

angular.module("MyApp").run(["$templateCache", function($templateCache) {$templateCache.put("/app/partials/footer.html","<div class=page-footer-inner>2017 &copy; Siten.</div><div class=scroll-to-top><i class=icon-arrow-up></i></div>");
$templateCache.put("/app/partials/header.html","<!-- BEGIN HEADER INNER --><div class=page-header-inner><!-- BEGIN LOGO --><div class=page-logo><a ui-sref=dashboard.list><h5 class=\"txtlogo logo-default\">アプリ名/管理画面</h5></a><div class=\"menu-toggler sidebar-toggler fa fa-bars\" style=\"color: #1997c6;\n    font-size: 25px;\n    padding-top: 5px\"><!-- DOC: Remove the above \"hide\" to enable the sidebar toggler button on header --></div></div><!-- END LOGO --><!-- BEGIN RESPONSIVE MENU TOGGLER --><!-- <a href=\"javascript:;\" class=\"menu-toggler responsive-toggler\" data-toggle=\"collapse\" data-target=\".navbar-collapse\"> </a> --><!-- END RESPONSIVE MENU TOGGLER --><!-- BEGIN PAGE ACTIONS --><!-- DOC: Remove \"hide\" class to enable the page header actions --><!-- END PAGE ACTIONS --><!-- BEGIN PAGE TOP --><div class=page-top><!-- BEGIN HEADER SEARCH BOX --><!-- DOC: Apply \"search-form-expanded\" right after the \"search-form\" class to have half expanded search box --><!-- END HEADER SEARCH BOX --><!-- BEGIN TOP NAVIGATION MENU --><ul class=\"nav navbar-nav pull-right\"><li><a style=\"pointer-events: none; cursor: default;\n    max-width: 300px;\n    overflow: hidden;\n    height: 40px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis\">{{user.user_name}}&nbsp;様</a></li><li><a href=# ng-click=logout()><span class=border-logout><i class=icon-logout></i>ログアウト</span></a></li></ul><!-- END TOP NAVIGATION MENU --></div><!-- END PAGE TOP --></div><!-- END HEADER INNER -->");
$templateCache.put("/app/partials/quick-sidebar.html","<div class=page-quick-sidebar><div class=nav-justified><ul class=\"nav nav-tabs nav-justified\"><li class=active><a href=# data-target=#quick_sidebar_tab_1 data-toggle=tab dropdown-menu-hover data-close-others=true>Cấu hình thông báo<!--<span class=\"badge badge-danger\">2</span>--></a></li></ul><div class=tab-content><div class=\"tab-pane active page-quick-sidebar-chat\" id=quick_sidebar_tab_1><div class=page-quick-sidebar-settings-list><h3 class=list-heading>General Settings</h3><ul class=\"list-items borderless\"><li ng-repeat=\"x in allNoti\"><span ng-bind=x.text>.</span> <input type=checkbox bootstrap-switch class=make-switch change-func=changeStateNoti(name,state) data-on-color=info name={{x.name}} ng-model=x.state data-on-text=BẬT data-off-color=default data-off-text=TẮT></li></ul></div></div></div></div></div>");
$templateCache.put("/app/partials/sidebar-admin.html","<div class=\"page-sidebar navbar-collapse collapse\"><div class=\"page-logo-menu page-logo\" style=margin-top:25px;margin-bottom:10px><a href=javascript:; class=\"nav-link nav-toggle\" ui-sref=dashboard.list ui-sref-opts=\"{reload: true, notify: true}\" style=\"display: block;\n    width: 75%;\n    margin: 0 auto\"><img src=../../assets/layouts/layout2/img/SampleLogo.png style=width:100%></a></div><ul class=\"page-sidebar-menu page-sidebar-menu-compact page-sidebar-menu-hover-submenu\" data-keep-expanded=false data-auto-scroll=true data-slide-speed=200 ng-class=\"{\'page-sidebar-menu-closed\': settings.layout.pageSidebarClosed}\"><li class=\"nav-item text-menu\"><p style=\"padding-left:10px; margin-bottom:0px\"><b style=\"pointer-events: none\"><span class=title style=font-size:15px>メニュー</span></b> <span class=arrow></span></p></li><li class=nav-item><a href=javascript:; class=\"nav-link nav-toggle\" ui-sref=member.list ui-sref-opts=\"{reload: true, notify: true}\"><i class=\"fa fa-female\"></i> <span class=title>{{\"Member manager\"|translate}}</span> <span class=arrow></span></a></li><li class=nav-item><a href=javascript:; class=\"nav-link nav-toggle\" ui-sref=upload.list ui-sref-opts=\"{reload: true, notify: true}\"><i class=\"fa fa-upload\"></i> <span class=title>{{\"D001-list-info-up-product\"|translate}}</span> <span class=arrow></span></a></li><li class=nav-item><a href=javascript:; class=\"nav-link nav-toggle\" ui-sref=purchase.list ui-sref-opts=\"{reload: true, notify: true}\"><i class=\"fa fa-shopping-cart\"></i> <span class=title>{{\"purchase\"|translate}}</span> <span class=arrow></span></a></li><li class=nav-item><a href=javascript:; class=\"nav-link nav-toggle\" ui-sref=transfer-request.list ui-sref-opts=\"{reload: true, notify: true}\"><i class=\"fa fa-money\"></i> <span class=title>{{\"Transfer request\"|translate}}</span> <span class=arrow></span></a></li><li class=nav-item><a href=javascript:; class=\"nav-link nav-toggle\" ui-sref=staff.list ui-sref-opts=\"{reload: true, notify: true}\"><i class=\"fa fa-user\"></i> <span class=title>スタッフ管理</span> <span class=arrow></span></a></li><li class=nav-item><a href=javascript:; class=\"nav-link nav-toggle\" ui-sref=contact.list ui-sref-opts=\"{reload: true, notify: true}\"><i class=\"fa fa-question-circle\"></i> <span class=title>質問管理</span> <span class=arrow></span></a></li><li class=nav-item><a href=javascript:; class=\"nav-link nav-toggle\" ui-sref=report_violation.list ui-sref-opts=\"{reload: true, notify: true}\"><i class=\"fa fa-window-close-o\"></i> <span class=title>違反報告管理</span> <span class=arrow></span></a></li><li class=nav-item><a href=javascript:; class=\"nav-link nav-toggle\" ui-sref=ngword.detail ui-sref-opts=\"{reload: true, notify: true}\"><i class=\"fa fa-gear\"></i> <span class=title>基本設定</span> <span class=arrow></span></a></li><!-- <li class=\"nav-item\">\n      <a href=\"javascript:;\" class=\"nav-link nav-toggle\" ui-sref=\"contact.list\" ui-sref-opts=\"{reload: true, notify: true}\">\n        <i class=\"fa fa-address-book\"></i>\n        <span class=\"title\">お問い合わせ</span>\n        <span class=\"arrow \"></span>\n      </a>\n    </li> --><li class=nav-item style=\"border-bottom:1px solid #dee2e6\"></li></ul></div>");
$templateCache.put("/app/partials/theme-panel.html","<div class=\"toggler tooltips\" data-container=body data-placement=left data-html=true data-original-title=\"Click to open advance theme customizer panel\"><i class=icon-settings></i></div><div class=toggler-close><i class=icon-close></i></div><div class=theme-options><div class=\"theme-option theme-colors clearfix\"><span>THEME COLOR</span><ul><li class=\"color-default current tooltips\" data-style=default data-container=body data-original-title=Default></li><li class=\"color-grey tooltips\" data-style=grey data-container=body data-original-title=Grey></li><li class=\"color-blue tooltips\" data-style=blue data-container=body data-original-title=Blue></li><li class=\"color-dark tooltips\" data-style=dark data-container=body data-original-title=Dark></li><li class=\"color-light tooltips\" data-style=light data-container=body data-original-title=Light></li></ul></div><div class=theme-option><span>Theme Style</span><select class=\"layout-style-option form-control input-small\"><option value=square>Square corners</option><option value=rounded selected>Rounded corners</option></select></div><div class=theme-option><span>Layout</span><select class=\"layout-option form-control input-small\"><option value=fluid selected>Fluid</option><option value=boxed>Boxed</option></select></div><div class=theme-option><span>Header</span><select class=\"page-header-option form-control input-small\"><option value=fixed selected>Fixed</option><option value=default>Default</option></select></div><div class=theme-option><span>Top Dropdown</span><select class=\"page-header-top-dropdown-style-option form-control input-small\"><option value=light selected>Light</option><option value=dark>Dark</option></select></div><div class=theme-option><span>Sidebar Mode</span><select class=\"sidebar-option form-control input-small\"><option value=fixed>Fixed</option><option value=default selected>Default</option></select></div><div class=theme-option><span>Sidebar Style</span><select class=\"sidebar-style-option form-control input-small\"><option value=default>Default</option><option value=compact selected>Compact</option></select></div><div class=theme-option><span>Sidebar Menu</span><select class=\"sidebar-menu-option form-control input-small\"><option value=accordion>Accordion</option><option value=hover selected>Hover</option></select></div><div class=theme-option><span>Sidebar Position</span><select class=\"sidebar-pos-option form-control input-small\"><option value=left selected>Left</option><option value=right>Right</option></select></div><div class=theme-option><span>Footer</span><select class=\"page-footer-option form-control input-small\"><option value=fixed>Fixed</option><option value=default selected>Default</option></select></div></div>");
$templateCache.put("/app/components/upload-image/editImageTemplate.html","<div class=popupEditImage><div class=\"modal fade\" role=dialog data-backdrop=false><div class=\"modal-dialog modal-full\" style=max-width:1024px><div class=modal-content><div class=modal-header><div class=caption><span class=\"caption-subject font-dark sbold uppercase\" ng-if=\"disabled==undifined\">Cập nhật thông tin ảnh</span> <span class=\"caption-subject font-dark sbold uppercase\" ng-if=\"disabled==\'\'\">Thông tin ảnh</span></div></div><div class=modal-body><form class=form-horizontal><div class=\"form-group text-center\" ng-if=\"disabled==undifined\"><button class=\"btn btn-success\" ng-click=update()>Lưu</button> <button class=\"btn btn-success\" ng-if=\"dataImage.id != featureImage\" ng-click=setFeatureImage(dataImage.id)>Ảnh đại diện</button> <button type=button class=\"btn btn-inverse closeModal\" data-dismiss=modal>Hủy</button></div><div class=row><div class=col-md-12></div><!-- column left --><div class=col-md-6><div class=form-group><label class=col-md-4>Tiêu đề</label><div class=col-md-8><input ng-if=\"disabled==undifined\" ng-model=dataImage.metaTitle class=form-control> <span ng-if=\"disabled==\'\'\" class=\"form-control no-scrollBar\">{{dataImage.metaTitle}}</span></div></div></div><!-- column right --><div class=col-md-6><div class=form-group><label class=col-md-4>Mô tả chi tiết</label><div class=col-md-8><textarea ng-model=dataImage.metaDescription class=form-control ng-if=\"disabled==undifined\"></textarea><textarea ng-model=dataImage.metaDescription class=form-control ng-if=\"disabled==\'\'\" disabled></textarea></div></div></div></div></form></div><div class=modal-footer><button type=button class=\"btn dark btn-outline\" data-dismiss=modal>Đóng</button></div></div></div></div></div><style>.featureImage {\n        border: 4px solid #1BBC9B;\n    }</style>");
$templateCache.put("/app/modules/bank/bank.detail.html","<div class=body-margin><div class=\"caption caption-list\"><span class=\"caption-subject font-dark uppercase\"><b>Bank detail</b></span></div><div class=\"acts-add-form portlet-body form\"><div data-tmdt-table=dtConfig reload=count ng-model=list class=table-container><div class=row><div class=\"filter-region form-inline\"><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>新規登録</div><div class=\"tools reloadTableFilter\"><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=width:100%><div class=row><div class=col-md-6><span class=col-md-4>銀行名</span><label style=margin-right:15px><input type=text ng-model=dataType.name class=\"ngwordInput withinput form-control input-sm\"></label><!-- <span class=\"\"><button ng-click=\"\" class=\"btn btn-large btnseachtxt btn-sm-fr btn-seach-table pull-right  \">登録</button></span> --> <span class=col-md-4></span><!-- <label style=\"margin-right:15px;\" class=\"\"><input type=\"text\" ng-model=\"errMes\" style=\"color:red\" class=\"ngwordInput withinput form-control input-sm\" /> </label> --></div><div class=col-md-6><span class=col-md-4>銀行コード</span><label style=margin-right:15px><input type=text ng-model=dataType.code class=\"ngwordInput withinput form-control input-sm\"></label><span><button ng-click=\"\" class=\"btn btn-large btnseachtxt btn-sm-fr btn-seach-table pull-right\">登録</button></span> <span class=col-md-4></span></div></div></div><div class=clearfix></div></div></div></div></div></div></div></div>");
$templateCache.put("/app/modules/bank/bank.list.html","<div class=body-margin><div class=\"caption caption-list\"><span class=\"caption-subject font-dark uppercase\"><b>銀行一覧</b></span></div><div class=\"acts-add-form portlet-body form\"><div data-tmdt-table=dtConfig reload=count ng-model=list class=table-container><div class=row><div class=\"filter-region form-inline\"><div class=\"portlet box green-meadow\"><div class=portlet-title style=\"background-color: white !important\"><div class=caption style=\"color: #000 !important\">銀行</div><div class=\"tools reloadTableFilter\"><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><form class=\"form-group fade-in-up\" style=width:100% name=bankForm><div class=row><div class=col-md-4 style=\"padding-left: 0px\"><span class=col-md-4>銀行コード</span><label><input type=text ng-change=validateBankCode(dataType.code) ng-model=dataType.code required class=\"ngwordInput withinput form-control input-sm\"></label></div><div class=col-md-4><span class=col-md-4 style=\"max-width: 54px; padding-left: 0px\">銀行名</span><label style=margin-right:15px><input type=text required ng-model=dataType.name class=\"ngwordInput withinput form-control input-sm\"></label></div><div class=col-md-4><span class=col-md-4>銀行名（カナ）</span><label style=margin-right:15px><input type=text required ng-model=dataType.name_kana class=\"ngwordInput withinput form-control input-sm\"></label></div></div><div class=row style=text-align:center;padding:15px><span><button type=submit ng-click=AddBank(dataType) class=\"btn btn-large btnseachtxt btn-sm-fr btn-seach-table pull-right\">登録</button></span> <button type=button ng-click=deleteBank() ng-disabled=\"list.length ==0\" class=\"btn btn-large btnseachtxt btn-sm-fr btn-seach-table pull-right\">削除</button></div></form><div class=clearfix></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"portlet-title titel-table\"><div><span class=\"caption-subject font-dark\">銀行一覧</span></div></div><table class=\"table table-bordered table-hover table-checkable\"></table></div></div></div></div></div>");
$templateCache.put("/app/modules/category/category.list.html","<div ng-init=myApp><div class=margin-bottom-10><div class=\"caption caption-list\"><span class=\"caption-subject font-dark sbold uppercase\">カテゴリ管理</span></div></div><div class=form><form id=form-danh-muc-san-pham role=form><div class=row><div class=col-md-12><div class=\"col-md-12 clearfix text-right\" style=\"margin-bottom: 15px\"><span ng-disabled=disabled.btnAdd ng-click=AddTree() class=\"btn btn-primary btn-sm\">追加 </span><span ng-disabled=disabled.btnDelete ng-click=DeleteTree() class=\"btn btn-primary btn-sm\">削除 </span><span ng-disabled=disabled.btnUp ng-click=go.up() class=\"btn btn-primary btn-sm\">上へ移動 </span><span ng-disabled=disabled.btnDown ng-click=go.down() class=\"btn btn-primary btn-sm\">下へ移動</span></div><div class=col-md-12 style=\"overflow:hidden; height:66vh\"><div style=overflow-y:auto;height:100% id=tree class=\"tree-demo portlet light bordered\"></div></div></div></div></form></div></div>");
$templateCache.put("/app/modules/contact/contact.details.html","<br><div class=\"portlet-body form\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=form-body style=padding:0px><div class=\"caption caption-list\"><span class=\"caption-subject font-dark uppercase\"><b>お問い合わせ詳細</b></span></div><div class=\"portlet box green-meadow\"><div class=portlet-body>お問い合わせ詳細<div class=clearfix></div></div></div></div></form></div><div class=col-md-12><div class=row><div class=col-md-2>お問い合わせID</div><div class=col-md-8>{{contact.id}}</div></div><br><div class=row><div class=col-md-2>お問い合わせ日</div><div class=col-md-9>{{contact.created_at}}</div></div><br><div class=row><div class=col-md-2>ユーザーID</div><div class=col-md-9>{{contact.created_by}}</div></div><br><div class=row><div class=col-md-2>ユーザー名</div><div class=col-md-9>{{member.user_name}}</div></div><br><div class=row><div class=col-md-2>問い合わせカテゴリー</div><div class=col-md-9>{{contact.data_type.name}}</div></div><br><div class=row><label for=\"\" class=col-md-2>問い合わせ 内容</label><div class=col-md-3><textarea name=\"\" cols=30 style=\"width: 100%\" ; rows=10>{{contact.content}}</textarea></div><label for=\"\" class=col-md-1>回答</label><div class=col-md-3><textarea cols=30 style=\"width: 100%\" ; rows=10 ng-model=contact.reply_content></textarea></div><a href=\"\" ng-click=answerContact() class=\"btn btn-primary\">返事</a></div><br><div class=row><div class=\"col-md-offset-5 col-md-4\"><a ui-sref=contact.list({id:contact.id}) style=\"float: right\" class=\"btn btn-primary\">このユーザーに関する問い合わせ リストへ</a></div></div></div>");
$templateCache.put("/app/modules/contact/contact.list.html","<div><div class=\"caption caption-list\"><span class=\"caption-subject font-dark sbold uppercase\">{{\"Member info list\"|translate}}</span></div></div><form class=\"acts-add-form portlet-body form-inline\" name=searchForm novalidate><div class=row><div data-tmdt-table=dtConfig class=table-container><!-- Directive datatable --><div class=acticles-add><div class=col-md-12><div class=\"portlet-title titel-table\"><div><span class=\"caption-subject font-dark\">{{\"Search result list\"|translate}}</span></div></div><table class=\"table table-bordered table-hover table-checkable\"></table></div></div></div></div></form>");
$templateCache.put("/app/modules/contact/contact.list1.html","<div class=body-margin><div class=\"caption caption-list\"><span class=\"caption-subject font-dark uppercase\"><b>{{\"List staff info\"|translate}}</b></span></div><div class=\"acts-add-form portlet-body form\"><div data-tmdt-table=dtConfig class=table-container><div class=\"portlet box row green-meadow\"><div class=portlet-title><div class=caption>スタッフ検索</div><div class=\"tools reloadTableFilter\"><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=\"portlet-body filter-region\"><div class=\"form-group fade-in-up\" style=width:100%><div class=row><div class=col-md-5><span class=\"col-md-6 text-right\">お問い合わせID</span><label class=col-md-6><input type=text filter=id class=\"form-control input-sm withinput\"></label><span class=\"col-md-6 text-right\">問い合わせユーザーID</span><label class=col-md-6><input type=text filter=createdBy class=\"form-control input-sm withinput\"></label><span class=\"col-md-6 text-right\">問い合わせユーザー名</span><label class=col-md-6><input type=text filter=userName class=\"form-control input-sm withinput\"></label><span class=\"col-md-6 text-right\">問い合わせカテゴリー</span><label class=col-md-6><select data-ng-options=\"o.name for o in options\" value={{$scope.options.id}} class=\"form-control input-sm withinput\" data-ng-model=selectedOption></select></label></div><div class=col-md-7><span style=margin-right:15px class=col-md-3>お問い合わせ日 </span><input type=text jqdatepicker=\"\" ng-model=date_start class=\"form-control input-sm ng-untouched ng-valid ng-empty ng-dirty ng-valid-parse\" placeholder=yyyy/mm/dd filter=request_date_start> <span style=\"margin:0 20px\">~</span> <input type=text jqdatepicker=\"\" ng-model=date_end class=\"form-control input-sm ng-valid ng-empty ng-dirty ng-valid-parse ng-touched\" placeholder=yyyy/mm/dd filter=request_date_end><br><span class=\"ng-binding col-md-3\">回答状況</span><div class=\"form-check col-md-9\" filter=status_request_list><label class=\"form-check-label ng-binding\"><input type=checkbox class=\"form-check-input inputnone\" value=0>&nbsp;□未回答&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label><label class=\"form-check-label ng-binding\"><input type=checkbox class=\"form-check-input inputnone\" value=1>&nbsp;回答済</label></div></div></div></div><div class=row><div class=\"col-md-2 col-md-offset-5\"><button class=\"btn btn-sm-fr btn-large btnseachtxt btn-seach-table search-button pull-right col-md-2\">検索</button></div></div><div class=clearfix></div></div></div><div class=row><div class=col-md-12><div class=\"portlet-title titel-table\"><div><span class=\"caption-subject font-dark\">{{\"Search result list\"|translate}}</span></div></div><table class=\"table table-bordered table-hover table-checkable\"></table></div></div></div></div></div>");
$templateCache.put("/app/modules/dashboard/dashboard.list.html","<div ng-init=myApp><div class=margin-bottom-10><div class=\"caption caption-list\"><span class=\"caption-subject font-dark sbold uppercase\">ダッシュボード</span></div></div><form style=padding-left:20px class=\"acts-add-form portlet-body form-inline\" name=searchForm novalidate><div class=\"portlet-title portlet-title-new\"><div class=caption><span style=font-size:16px class=\"caption-subject font-dark sbold uppercase\">{{\"B001-dashboard\" | translate}}</span></div></div><!-- head --><div class=row style=margin-bottom:25px><div class=\"col-lg-3 col-md-3\"><div class=div-broadash><div class=heading-broadash>{{\"B001-count-menber\"|translate}}</div><div class=footer-broadash>{{AllDashboard.membership | number:0}}</div></div></div><div class=\"col-lg-3 col-md-3\"><div class=div-broadash><div class=heading-broadash>{{\"B001-count-product\"|translate}}</div><div class=footer-broadash>{{AllDashboard.number_product}}</div></div></div></div><!-- end head --><div class=\"portlet-title portlet-title-new\"><div class=caption><span style=font-size:16px class=\"caption-subject font-dark sbold uppercase\">{{\"B001-purchase-status\" |translate}}</span></div></div><!--content  --><div class=row><div class=\"col-lg-3 col-md-3\"><a class=ahome ng-click=gotoLpurchase(0)><div class=\"div-broadash div-none-border\"><div class=heading-broadash>{{\"B001-Waiting-for-deposit\" | translate}}</div><div class=footer-broadash>{{AllDashboard.waiting_deposit}}</div></div></a></div><div class=\"col-lg-3 col-md-3\"><a class=ahome ng-click=gotoLpurchase(1)><div class=\"div-broadash div-none-border\"><div class=heading-broadash>{{\"B001-Waiting-for-delivery\" | translate}}</div><div class=footer-broadash>{{AllDashboard.waiting_delivery}}</div></div></a></div><div class=\"col-lg-3 col-md-3\"><a class=ahome ng-click=gotoLpurchase(2)><div class=\"div-broadash div-none-border\"><div class=heading-broadash>{{\"B001-Pending-receipt\" | translate}}</div><div class=footer-broadash>{{AllDashboard.pending_receipt}}</div></div></a></div></div><div class=\"row margin-top-20 margin-bottom-25\"><div class=\"col-lg-3 col-md-3\"><a class=ahome ng-click=gotoLpurchase_list(0)><div class=\"div-broadash div-none-border div-background\"><div class=heading-broadash>{{\"B001-Waiting-for-deposit\" | translate}}</div><div class=footer-broadash>{{AllDashboard.alert_waiting_deposit}}</div></div></a></div><div class=\"col-lg-3 col-md-3\"><a class=ahome ng-click=gotoLpurchase_list(1)><div class=\"div-broadash div-none-border div-background\"><div class=heading-broadash>{{\"B001-Waiting-for-delivery\" | translate}}</div><div class=footer-broadash>{{AllDashboard.alert_waiting_delivery}}</div></div></a></div><div class=\"col-lg-3 col-md-3\"><a class=ahome ng-click=gotoLpurchase_list(2)><div class=\"div-broadash div-none-border div-background\"><div class=heading-broadash>{{\"B001-Pending-receipt\" | translate}}</div><div class=footer-broadash>{{AllDashboard.alert_pending_receipt}}</div></div></a></div></div><div class=\"portlet-title portlet-title-new\"><div class=caption><span style=font-size:16px class=\"caption-subject font-dark sbold uppercase\">{{\"B001-treatment\" |translate}}</span></div></div><div class=row><div class=\"col-lg-3 col-md-3\"><div class=div-broadash><div class=heading-broadash>{{\"B001-transfer\" |translate}}</div><div class=footer-broadash>{{AllDashboard.transfer_request}}</div></div></div><div class=\"col-lg-3 col-md-3\"><div class=div-broadash><div class=heading-broadash>{{\"B001-Q&A \"|translate}}</div><div class=footer-broadash>{{AllDashboard.new_inquiries}}</div></div></div><div class=\"col-lg-3 col-md-3\"><div class=div-broadash><div class=heading-broadash>{{\"B001-report\" |translate}}</div><div class=footer-broadash>{{AllDashboard.new_violation_reported}}</div></div></div></div></form><!-- end content --></div>");
$templateCache.put("/app/modules/member/member.details.html","<div class=\"caption caption-list title-font\" style=padding-left:20px><span class=\"caption-subject font-dark sbold uppercase routePageTile\">{{\"Member info detail\"|translate}}</span></div><div class=\"portlet light borderblack member-page body-page-detail\" ng-init=getById()><div class=caption style=padding-left:0px><span class=\"nomaTitle caption-subject font-dark sbold uppercase\">{{\"Member info detail\"|translate}}</span></div><div class=line-titel></div><div class=\"portlet-body form\"><form class=form-horizontal><div class=form-body><div class=\"form-group page-body\"><div class=col-md-6><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>会員基本情報</div><div class=tools><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\"><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"Avatar\"|translate}}</label><div class=col-md-8><img class=img-circle ng-src={{domainHttp+member.image_url}} alt=\"\" width=120px height=120px></div></div><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"Profile\"|translate}}</label><div class=col-md-8><span style=text-align:justify;display:block>{{member.description}}</span></div></div><div class=\"form-group col-md-12\"><label class=col-md-4>ユーザーID</label><div class=col-md-8><span>{{member.id}}</span></div></div><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"User name\"|translate}}</label><div class=col-md-8><span>{{member.user_name}}</span></div></div><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"Sex\"|translate}}</label><div class=col-md-8><span>{{member.surname}}</span></div></div><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"MemberName\"|translate}}</label><div class=col-md-8><span>{{member.name}}</span></div></div><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"Last name katakana\"|translate}}</label><div class=col-md-8><span>{{member.surname_kana}}</span></div></div><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"Name katakana\"|translate}}</label><div class=col-md-8><span>{{member.name_kana}}</span></div></div><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"Email\"|translate}}</label><div class=col-md-8><span>{{member.email}}</span></div></div></div><div class=clearfix></div></div></div><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>{{\"Address\"|translate}}</div><div class=tools><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\"><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"Postal code\"|translate}}</label><div class=col-md-8><span>{{member.postcode}}</span></div></div><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"City\"|translate}}</label><div class=col-md-8><span>{{member.prefecture_name}}</span></div></div><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"Municipality\"|translate}}</label><div class=col-md-8><span>{{member.district}}</span></div></div><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"House number\"|translate}}</label><div class=col-md-8><span>{{member.home_address}}</span></div></div><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"Building\"|translate}}</label><div class=col-md-8><span>{{member.building}}</span></div></div><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"Tel\"|translate}}</label><div class=col-md-8><span>{{member.phone_no}}</span></div></div></div><div class=clearfix></div></div></div></div><div class=col-md-6><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>{{\"Revenue information\"|translate}}</div><div class=tools><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\"><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"Total revenue\"|translate}}</label><div class=\"col-md-8 text-right\"><span>￥{{member.total_revenue==null?0:member.total_revenue | number:0}}</span></div></div><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"Total applied\"|translate}}</label><div class=\"col-md-8 text-right\"><span>￥{{member.total_request_payment==null?0:member.total_request_payment| number:0}}</span></div></div><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"Not apply\"|translate}}</label><div class=\"col-md-8 text-right\"><span>￥{{member.total_need_to_request| number:0}}</span></div></div><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"Total already paid\"|translate}}</label><div class=\"col-md-8 text-right\"><span>￥{{member.total_paid_payment==null?0:member.total_paid_payment| number:0}}</span></div></div><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"Total expiration\"|translate}}</label><div class=\"col-md-8 text-right\"><span>￥{{member.total_expired==null?0:member.total_expired| number:0}}</span></div></div><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"status\"|translate}}</label><div class=col-md-8><span><span ng-if=\"member.status==\'active\'\">有効</span> <span ng-if=\"member.status==\'delete\'\">削除済（退会半年以上)</span> <span ng-if=\"member.status==\'confirm\'\">仮会員（未認証）</span> <span ng-if=\"member.status==\'leave\'\">退会済</span></span></div></div><div class=form-group><div class=text-center><div class=\"btn btn-lg btn-xl-fr btn-default\" style=\"margin-left: -9px; width: 400px!important\" ng-disabled=\"member.is_deleted==1||member.status==\'leave\'\" ng-click=memberLeave()><span>{{\"Depart\"|translate}}</span></div></div></div><div class=\"form-group col-md-12\"><label class=col-md-4>{{\"Ratings\"|translate}}</label><div class=\"icon-member col-md-8\" style=padding-top:2px><!-- <img src=\"../..\"/>    --> <span class=\"glyphicon glyphicon-user\"></span> 1 &nbsp;&nbsp; <span class=\"glyphicon glyphicon-user\"></span> 22 &nbsp;&nbsp; <span class=\"glyphicon glyphicon-user\"></span> 33 &nbsp;&nbsp;</div></div><div style=\"margin:0 auto\"><div class=form-group><div class=text-center><div class=\"btn-lg-fr btn btn-lg btn-default\" ng-click=gotoCommentOfUser(member.id)><span>{{\"List comments\"|translate}}</span></div><div class=\"btn-lg-fr btn btn-lg btn-default\" ng-click=\"\" style=visibility:hidden></div></div></div><div class=\"form-group text-center\"><div class=group-button><div class=\"btn btn-lg-fr btn-lg btn-default\" ng-click=gotoListBuy(member.id)><span>{{\"List buy product\"|translate}}</span></div><div class=\"btn btn-lg btn-lg-fr btn-default\" ng-click=gotoListUpload(member.id)><span>{{\"List upload\"|translate}}</span></div></div></div></div></div><div class=clearfix></div></div></div></div></div></div></form></div></div>");
$templateCache.put("/app/modules/member/member.list.html","<div><div class=\"caption caption-list\"><span class=\"caption-subject font-dark sbold uppercase\">{{\"Member info list\"|translate}}</span></div></div><form class=\"acts-add-form portlet-body form-inline\" name=searchForm novalidate><div class=row><div data-tmdt-table=dtConfig class=table-container><!-- Directive datatable --><div class=acticles-add><div class=filter-region><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>{{\"Search condition\"|translate}}</div><div class=\"tools reloadTableFilter\"><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=width:100%><div class=row><label class=\"col-md-6 col-sm-6\"><div class=row><span class=\"input-group col-sm-3 col-md-3\">{{\"Member id\"|translate}}</span><label style=margin-bottom:0px class=\"col-sm-9 col-md-9\"><input class=\"form-control input-member-page-300\" type=text filter=id></label></div></label><div class=\"col-md-6 col-sm-6\"><span class=\"input-group col-md-2\">{{\"Revenue\"|translate}}</span><label style=\"float:left; padding-left:15px\"><input type=text class=\"form-control input-sm\" filter=revenueFrom></label><span style=\"float:left; margin:0 15px\">~</span><div style=float:left><input type=text class=\"form-control input-sm\" filter=revenueTo></div></div></div><!--</div>--><div class=row><div class=\"col-md-6 col-sm-6\"><div class=row><span class=\"input-group col-sm-3 col-md-3\">{{\"User name\"|translate}}</span><label style=margin-bottom:0px class=\"col-sm-8 col-md-9\"><input type=text filter=user_name class=\"form-control input-member-page-300\"></label></div></div><div class=col-md-6><span class=\"input-group col-md-2\">{{\"Number of Exhibit Items\"|translate}}</span><label style=\"float:left; padding-left:15px\"><input type=text class=\"form-control input-sm\" filter=productFrom></label><span style=\"float:left; margin:0 15px\">~</span><div style=float:left><input type=text class=\"form-control input-sm\" filter=productTo></div></div></div><!--<div class=\"input-group col-md-10 col-md-offset-2\">\n                                    <span class=\"input-group error\" ng-show=\"searchForm.input.$error.email\"> {{\"Not valid email!\"|translate}}</span>\n                                </div>--><div class=row><div class=\"col-md-6 col-sm-6\"><div class=row><span class=\"input-group col-md-3\">{{\"Email\"|translate}}</span><label class=col-md-9><input type=text name=input ng-model=input class=form-control filter=email></label></div></div></div><div class=row><div class=\"col-md-2 col-md-offset-5\"><button ng-disabled=searchForm.input.$error.email class=\"btn btn-sm-fr btn-large btnseachtxt btn-seach-table search-button pull-right col-md-2\">検索</button></div></div><div class=clearfix></div></div></div></div></div><div class=col-md-12><div class=\"portlet-title titel-table\"><div><span class=\"caption-subject font-dark\">{{\"Search result list\"|translate}}</span></div></div><table class=\"table table-bordered table-hover table-checkable\"></table></div></div></div></div></form>");
$templateCache.put("/app/modules/login/login.list.html","<div ng-init=myApp><div class=margin-bottom-10><div class=caption><span class=\"caption-subject font-dark sbold uppercase\">ダッシュボード</span></div></div><form class=\"acts-add-form portlet-body form-inline\" name=searchForm novalidate><div class=\"portlet-title portlet-title-new\"><div class=caption><span class=\"caption-subject font-dark sbold uppercase\">{{\"B001-dashboard\" | translate}}</span></div></div><!-- head --><div class=row><div class=\"col-lg-3 col-md-3\"><div class=div-broadash><div class=heading-broadash>{{\"B001-count-menber\"|translate}}</div><div class=footer-broadash>{{AllDashboard.membership | number:0}}</div></div></div><div class=\"col-lg-3 col-md-3\"><div class=div-broadash><div class=heading-broadash>{{\"B001-count-product\"|translate}}</div><div class=footer-broadash>{{AllDashboard.number_product}}</div></div></div></div><!-- end head --><div class=\"portlet-title portlet-title-new\"><div class=caption><span class=\"caption-subject font-dark sbold uppercase\">{{\"B001-purchase-status\" |translate}}</span></div></div><!--content  --><div class=row><div class=\"col-lg-3 col-md-3\"><a class=ahome ng-click=gotoLpurchase(0)><div class=\"div-broadash div-none-border\"><div class=heading-broadash>{{\"B001-Waiting-for-deposit\" | translate}}</div><div class=footer-broadash>{{AllDashboard.waiting_deposit}}</div></div></a></div><div class=\"col-lg-3 col-md-3\"><a class=ahome ng-click=gotoLpurchase(1)><div class=\"div-broadash div-none-border\"><div class=heading-broadash>{{\"B001-Waiting-for-delivery\" | translate}}</div><div class=footer-broadash>{{AllDashboard.waiting_delivery}}</div></div></a></div><div class=\"col-lg-3 col-md-3\"><a class=ahome ng-click=gotoLpurchase(2)><div class=\"div-broadash div-none-border\"><div class=heading-broadash>{{\"B001-Pending-receipt\" | translate}}</div><div class=footer-broadash>{{AllDashboard.pending_receipt}}</div></div></a></div></div><div class=\"row margin-top-20\"><div class=\"col-lg-3 col-md-3\"><a class=ahome ng-click=gotoLpurchase_list(0)><div class=\"div-broadash div-none-border div-background\"><div class=heading-broadash>{{\"B001-Waiting-for-deposit\" | translate}}</div><div class=footer-broadash>{{AllDashboard.alert_waiting_deposit}}</div></div></a></div><div class=\"col-lg-3 col-md-3\"><a class=ahome ng-click=gotoLpurchase_list(1)><div class=\"div-broadash div-none-border div-background\"><div class=heading-broadash>{{\"B001-Waiting-for-delivery\" | translate}}</div><div class=footer-broadash>{{AllDashboard.alert_waiting_delivery}}</div></div></a></div><div class=\"col-lg-3 col-md-3\"><a class=ahome ng-click=gotoLpurchase_list(2)><div class=\"div-broadash div-none-border div-background\"><div class=heading-broadash>{{\"B001-Pending-receipt\" | translate}}</div><div class=footer-broadash>{{AllDashboard.alert_pending_receipt}}</div></div></a></div></div><div class=\"portlet-title portlet-title-new\"><div class=caption><span class=\"caption-subject font-dark sbold uppercase\">{{\"B001-treatment\" |translate}}</span></div></div><div class=row><div class=\"col-lg-3 col-md-3\"><div class=div-broadash><div class=heading-broadash>{{\"B001-transfer\" |translate}}</div><div class=footer-broadash>{{AllDashboard.transfer_request}}</div></div></div><div class=\"col-lg-3 col-md-3\"><div class=div-broadash><div class=heading-broadash>{{\"B001-Q&A \"|translate}}</div><div class=footer-broadash>{{AllDashboard.new_inquiries}}</div></div></div><div class=\"col-lg-3 col-md-3\"><div class=div-broadash><div class=heading-broadash>{{\"B001-report\" |translate}}</div><div class=footer-broadash>{{AllDashboard.new_violation_reported}}</div></div></div></div></form><!-- end content --></div>");
$templateCache.put("/app/modules/ngword/ngword.detail.html","<div class=\"caption caption-list title-font\" ng-init=getCount() style=padding-left:20px><span class=\"caption-subject font-dark sbold uppercase\">基本設定</span></div><div class=\"portlet light order-page body-page-detail\" ng-init=getById()><div class=caption><span class=\"caption-subject nomaTitle font-dark sbold uppercase\">メニュー</span></div><div class=\"margin-bottom-20 margin-top-10 line-titel\"></div><div class=\"portlet-body form\"><form class=form-horizontal><div class=form-body><div class=form-group><div class=col-md-12><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>禁止ワード設定</div><div class=tools><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=padding-left:15px><div class=row><div class=col-md-6><div class=form-group><label class=col-md-4>禁止ワード<!--ID--></label><div class=col-md-8><span>{{countAll}}&nbsp; 件</span></div></div></div><div class=col-md-6><div class=form-group><label class=col-md-6><button ng-click=goList() class=\"btn btn-xl-fr btn-lg\" style=width:100%>禁止ワード一覧へ</button></label></div></div></div></div><div class=clearfix></div></div></div></div><div class=col-md-12><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>取り扱い銀行管理</div><div class=tools><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=padding-left:15px><div class=row><div class=col-md-6><div class=form-group></div></div><div class=col-md-6><div class=form-group><label class=col-md-6><button ng-click=goListbank() class=\"btn btn-xl-fr btn-lg\" style=width:100%>取扱銀行一覧へ</button></label></div></div></div></div><div class=clearfix></div></div></div></div><div class=col-md-12><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>カテゴリ管理</div><div class=tools><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=padding-left:15px><div class=row><div class=col-md-6><div class=form-group></div></div><div class=col-md-6><div class=form-group><label class=col-md-6><button ng-click=goListCategory() class=\"btn btn-xl-fr btn-lg\" style=width:100%><!-- {{\"CategorySetting\" | translate}} --> item</button></label></div></div><!-- <div class=\"col-md-6\">\n                                                    <div class=\"form-group\"></div>\n                                            </div>\n                                            <div class=\"col-md-6\">\n                                                <div class=\"form-group\">\n                                                        <label class=\"col-md-6\">\n                                                            <button ng-click=\"gotoContact()\" class=\"btn btn-xl-fr btn-lg\" style=\"width:100%\">\n                                                                question\n                                                            </button>\n                                                        </label>\n                                                </div>\n                                            </div> --><div class=col-md-6><div class=form-group></div></div><div class=col-md-6><div class=form-group><label class=col-md-6><button ng-click=goTransferMethod() class=\"btn btn-xl-fr btn-lg\" style=width:100%>Shipping method</button></label></div></div></div></div></div><div class=clearfix></div></div></div><div class=col-md-12><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>振込手数料設定</div><div class=tools><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=padding-left:15px><div class=row><div class=col-md-6><div class=form-group><label class=col-md-4>販売手数料</label><div class=col-md-8><span>{{config.bankFeeValue}}%</span></div></div></div><div class=col-md-6><div class=form-group><label class=col-md-6><button ng-click=goTransferFeeComission() class=\"btn btn-xl-fr btn-lg\" style=width:100%>販売手数料設定へ</button></label></div></div><div class=col-md-6><div class=form-group><label class=col-md-4>振込手数料</label><div class=col-md-8><span>{{config.systemFeeValue }} 円</span> <span style=\"padding: 0 15 0 15\">以下は</span> <span>{{config.systemFeeFixedValue}} 円</span></div></div></div><div class=col-md-6><div class=form-group><label class=col-md-6><button ng-click=goTransferFeeEdit() class=\"btn btn-xl-fr btn-lg\" style=width:100%>振込手数料設定へ</button></label></div></div></div></div><div class=clearfix></div></div></div></div><div class=col-md-12><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>申請期限設定</div><div class=tools><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=padding-left:15px></div><div class=clearfix></div></div></div></div><!-- <div class=\"col-md-12\">\n                        <div class=\"portlet box green-meadow\">\n                            <div class=\"portlet-title\">\n                                <div class=\"caption\">\n                                    {{\"titleCategory\" | translate}}\n                                </div>\n                                <div class=\"tools\">\n                                    <a href=\"javascript:;\" class=\"collapse\" data-original-title=\"\" title=\"\"> </a>\n                                </div>\n                            </div>\n                            <div class=\"portlet-body\">\n                                <div class=\"form-group fade-in-up\" style=\"padding-left:15px;\">\n                                    <button ng-click=\"goListCategory()\" class=\"btn btn-xl-fr btn-lg\" style=\"width:100%\">\n                                        {{\"CategorySetting\" | translate}}\n                                    </button>\n                                </div>\n                                <div class=\"clearfix\"></div>\n                            </div>\n\n                        </div>\n                    </div> --></div></div></form></div></div>");
$templateCache.put("/app/modules/ngword/ngword.list.html","<div class=body-margin><div class=\"caption caption-list\"><span class=\"caption-subject font-dark uppercase\"><b>禁止ワード一覧</b></span></div><div class=\"acts-add-form portlet-body form\"><div data-tmdt-table=dtConfig reload=count ng-model=list class=table-container><div class=row><div class=\"filter-region form-inline\"><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>新規登録</div><div class=\"tools reloadTableFilter\"><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=width:100%><div class=row><div class=col-md-6><span class=col-md-4>禁止ワード入力</span><label style=margin-right:15px><input type=text ng-model=ngWord class=\"ngwordInput withinput form-control input-sm\"></label><span><button ng-click=add() class=\"btn btn-large btnseachtxt btn-sm-fr btn-seach-table pull-right\">登録</button></span> <span class=col-md-4></span><!--<label style=\"margin-right:15px;\" class=\"\"><input type=\"text\" ng-model=\"errMes\" style=\"color:red\" class=\"ngwordInput withinput form-control input-sm\" /> </label>--></div><span class=\"col-md-4 col-md-offset-2 txt-center\"><button ng-click=deleteMutil() ng-disabled=\"list.length ==0\" class=\"btn btn-sm-fr btn-large btnseachtxt btn-seach-table pull-right col-md-1\">削除</button></span></div></div><div class=clearfix></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"portlet-title titel-table\"><div><span class=\"caption-subject font-dark\">検索結果一覧</span></div></div><table class=\"table table-bordered table-hover table-checkable\"></table></div></div></div></div></div>");
$templateCache.put("/app/modules/purchase/purchase.details.html","<div class=\"routePageTile caption caption-list\" style=padding-left:20px><span class=\"caption-subject font-dark sbold uppercase\">{{\"purchase details\"|translate}}</span></div><div class=\"portlet light order-page body-page-detail\" ng-init=getById()><div class=caption><span class=\"caption-subject font-dark sbold uppercase nomaTitle\">{{\"purchase details\"|translate}}</span></div><div class=\"margin-bottom-10 margin-top-10 margin-bottom-20 line-titel\"></div><div class=\"portlet-body form\"><form class=form-horizontal><div class=row style=padding-right:15px><div class=\"form-group page-body\" style=margin-left:0px><div class=col-md-6><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>{{\"chi tiet mua ban\"|translate}}</div><div class=tools><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=\"padding-left: 20px\"><div class=form-group><label class=col-md-4>{{\"Purchas id\"|translate}}</label><div class=col-md-8><span>{{order.id}}</span></div></div><div class=form-group style=padding-left:15px><div class=\"thumbnail col-md-4\" style=padding:0px><img src={{order.product_image_url}} onerror=\"this.onerror=null;this.src=\'/../../assets/layouts/layout2/img/no-image.png\'\"></div><div class=col-md-8><div ng-repeat=\"item in order.product.str_tags track by $index\" class=\"label label-default tags\">{{item}}</div><div class=col-md-12><h5>{{order.product.name}}</h5></div><div class=col-md-12><h5><b>￥{{order.product.price==null?0:order.product.price | number:0}}</b> ( <span>{{order.product.ship_fee_type}} </span>)</h5></div></div></div><div class=form-group><label class=col-md-4>{{\"Payment Method\"|translate}}</label><div class=col-md-8><span ng-if=\"order.payment_method == 1\">銀行振込 </span><span ng-if=\"order.payment_method == 2\">コンビニ/ATM (手数料 ¥100) </span><span ng-if=\"order.payment_method == 3\">クレジットカード</span></div></div><div class=form-group><label class=col-md-4>{{\"Shipping address\"|translate}}</label><div class=col-md-8><p style=padding-right:15px>{{order.surname}}{{order.name}}</p><p>〒{{order.postcode}}</p><p><span>{{order.product.prefecture+order.district}} </span><span>{{order.home_address}}</span><br><br><span>{{order.building}}</span></p></div></div><!--<div class=\"form-group\">\n                                        <label class=\"col-md-4\">{{\"Buyer id\"|translate}}</label>\n                                        <div class=\"col-md-8\">\n                                            <span>\n                                                {{order.user_buy_id }}\n                                            </span>\n                                        </div>  \n                                    </div>--><div class=form-group><label class=col-md-4>{{\"Product id\"|translate}}</label><div class=col-md-8><span>{{order.product_id }}</span></div></div><div class=form-group><label class=col-md-4>{{\"Salespeople id\"|translate}}</label><div class=col-md-8><span>{{order.user_sell_id }}</span></div></div></div><div class=clearfix></div></div></div></div><div class=col-md-6><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>{{\"Status\"|translate}}</div><div class=\"tools reloadTableFilter\"><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=\"padding-left: 20px;padding-right:20px\"><div class=form-group><div class=col-md-4>{{\"Purchas status\"|translate}}</div><!-- <h2 class=\"label label-info\"  ng-style=\"order.status==2?{\'background-color\':\'rgb(182, 182, 182)\'}:{\'background-color\':\'#C3C3C3\'}\'} \" style=\"font-size:14px\">{{orderStatus[order.status].text |translate }}</h2>  --> <span class=col-md-8>{{order.statusText }}</span><!-- <span class=\"col-md-8\" ng-if=\"order.status==4\">受取済み</span> --></div><div class=form-group><div class=\"text-center col-md-12\" style=\"padding:0 30px\"><div class=\"btn btn-lg btn-xl-fr btn-default col-md-12 btn-confirmPayment\" ng-if=\"order.status==1\" ng-click=confirmPayment()><span>{{\"confirm_payment_buyer\"|translate}}</span></div></div></div><div class=form-group><div class=\"text-center col-md-12\" style=\"padding:0 30px\"><div class=\"btn btn-lg btn-default btn-xl-fr col-md-12\" ng-if=\"order.status==2\" ng-click=unConfirmPayment()><span>{{\"un_confirm_payment_buyer\"|translate}}</span></div></div></div><div class=form-group><label class=col-md-4>{{\"Purchase date\"|translate}}</label><div class=col-md-8><strong>{{order.created_at }}</strong></div></div><div class=form-group><label class=col-md-4>{{\"Settlement date\"|translate}}</label><div class=col-md-8><strong>{{order.payment_buy_at}}</strong></div></div><div class=form-group><label class=col-md-4>{{\"Delivery date\"|translate}}</label><div class=col-md-8><strong>{{order.deliver_at}}</strong></div></div><div class=form-group><label class=col-md-4>{{\"Date confirmed\"|translate}}</label><div class=col-md-8><strong>{{order.received_at}}</strong></div></div></div><div class=clearfix></div></div></div></div></div></div></form></div></div>");
$templateCache.put("/app/modules/purchase/purchase.list.html","<div><div class=\"caption caption-list\"><span class=\"caption-subject font-dark sbold uppercase\">{{\"List purchase\"|translate}}</span></div></div><div class=\"acts-add-form portlet-body form-inline order-list-page\"><div class=row><div data-tmdt-table=dtConfig class=table-container><div class=\"col-md-12 filter-region\" style=\"padding-left:0px; padding-right:0px\"><div></div><div class=search-input><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>{{\"Search condition\"|translate}}</div><div class=\"tools reloadTableFilter\"><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=width:100%><div class=row><div class=col-md-6><span class=col-md-4>{{\"Buyer id\"|translate}}</span><label class=col-md-8><input type=text value={{memberSearchUserId}} filter=user_buy_id class=\"form-control input-sm custom-input\"></label></div><!--<div class=\"col-md-6\">\n                                       \n                                            <span class=\"col-md-4\">商品ID</span>\n                                            <label class=\"col-md-8\"><input type=\"text\"  value=\"\" class=\"form-control input-sm custom-input\" filter=\"product_id\" /></label>\n                                   \n\n                                    </div>--></div><div class=row><div class=col-md-6><span class=col-md-4>商品ID</span><label class=col-md-8><input type=text class=\"form-control input-sm custom-input\" filter=product_id></label></div><div class=col-md-6><span class=col-md-4>商品名</span><label class=col-md-8><input type=text class=\"form-control input-sm custom-input\" filter=product_name></label></div></div><div class=row><div class=col-md-6><span class=col-md-4>{{\"Salespeople id\"|translate}}</span><label class=col-md-8><input type=text filter=user_sell_id class=\"form-control input-sm custom-input\"></label></div><div class=col-md-6><span class=col-md-4>{{\"Salespeople name\"|translate}}</span><label class=col-md-8><input type=text class=\"form-control input-sm custom-input\" filter=user_sell_name></label></div></div><div class=row style=margin-bottom:7px><div class=col-md-6><div class=\"col-md-4 label-check\">購入状況</div><div class=col-md-8 filter=status_buy_list><label class=\"checkbox-item col-md-4\">&nbsp; <input type=checkbox value=1 ng-checked=\"purchaseStatus==0\"> <span>{{\"wait buyer pay\"|translate}}</span></label><label class=\"checkbox-item col-md-4\"><input type=checkbox value=2 ng-checked=\"purchaseStatus==1\"> <span>{{\"wait seller deliver\"|translate}}</span></label><label class=\"checkbox-item col-md-4\"><input type=checkbox value=3 ng-checked=\"purchaseStatus==2\"> <span>{{\"wait buyer receive\"|translate}}</span></label></div></div><div class=col-md-6><div class=\"col-md-4 label-check\">アラート状況</div><div class=col-md-8 filter=status_alert_list><label class=\"checkbox-item col-md-4\">&nbsp; <input type=checkbox value=1 ng-checked=\"purchaseStatus_list==0\"> <span>{{\"wait buyer pay\"|translate}}</span></label><label class=\"checkbox-item col-md-4\"><input type=checkbox value=2 ng-checked=\"purchaseStatus_list==1\"> <span>{{\"wait seller deliver\"|translate}}</span></label><label class=\"checkbox-item col-md-4\"><input type=checkbox value=3 ng-checked=\"purchaseStatus_list==2\"> <span>{{\"wait buyer receive\"|translate}}</span></label></div></div></div><div class=row><div class=\"col-md-2 col-md-offset-5\"><button class=\"btn btn-sm-fr btn-large btnseachtxt btn-seach-table search-button pull-right\">検索</button></div></div></div><div class=clearfix></div></div></div></div></div><div class=col-md-12><div class=\"portlet-title titel-table\"><div><span class=\"caption-subject font-dark\">{{\"Search result list\"|translate}}</span></div></div><table class=\"table table-bordered table-hover table-checkable\"></table></div></div></div></div>");
$templateCache.put("/app/modules/report_violation/report_violation.detail.html","<div class=\"caption caption-list routePageTile title-font\" style=padding-left:20px><span class=\"caption-subject font-dark sbold uppercase\">違反報告詳細</span></div><div class=\"portlet light order-page body-page-detail\" ng-init=getById()><div class=caption><span class=\"caption-subject font-dark sbold nomaTitle uppercase\">違反報告詳細</span></div><div class=\"margin-bottom-20 line-titel\"></div><div class=\"portlet-body form\"><form class=form-horizontal><div class=form-body style=padding:0px><div class=form-group><div class=col-md-12><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>違反報告情報</div><div class=tools><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=padding-left:15px><!--<div class=\"form-group\" style=\" \">\n                                        <span class=\"caption-subject font-dark\">違反報告情報</span>\n                                    </div>--><div class=col-md-6><div class=form-group style=margin-top:0px><label class=col-md-4>違反報告ID</label><div class=col-md-8><span>{{dataReport.id}}</span></div></div><div class=form-group><label class=col-md-4>違反報告申請日</label><div class=col-md-8><span>{{dataReport.created_at}}</span></div></div><div class=form-group><label class=col-md-4>報告者ID</label><div class=col-md-8><span>{{dataReport.created_by}}</span></div></div><div class=form-group><label class=col-md-4>報告者名</label><div class=col-md-8><span>{{dataReport.user_name}}</span></div></div></div><div class=col-md-6 style=padding-right:30px><div class=form-group><label class=col-md-4>違反の種類</label><div class=col-md-8><span style=\"display:block; text-align:justify; word-wrap: break-word\">{{dataType.name}}</span></div></div><div class=form-group><label class=col-md-4>報告詳細</label><div class=col-md-8><span style=\"display:block; text-align:justify; word-wrap: break-word\">{{dataReport.content}}</span></div></div><div class=form-group><label class=col-md-4>違反報告<br>ステータス</label><div class=col-md-8><span>{{dataReport.statusName}}</span></div></div><div class=form-group ng-if=\"dataReport.status==0||dataReport.status==1\"><div class=text-center><div style=padding-left:15px><button class=\"btn btn-lg-fr btn-lg\" ng-click=changeStatusReport(1) ng-if=\"dataReport.status==0\" style=\"margin-right:15px; width: 100%\">対応中</button> <button ng-click=changeStatusReport(2) ng-if=\"dataReport.status==0 ||dataReport.status==1\" class=\"btn btn-lg-fr btn-lg\" style=\"width: 100%\">対応済</button></div></div></div></div></div><div class=clearfix></div></div></div><div style=\"height: 15px\"></div></div><div class=col-md-12><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>出品情報</div><div class=tools><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=padding-left:15px><div class=row><div class=col-md-6><div class=form-group><label class=col-md-4>商品ID</label><div class=col-md-8><span>{{dataProduct.id}}</span></div></div><div class=form-group><label class=col-md-4>商品名</label><div class=col-md-8><span style=text-align:justify;display:block>{{dataProduct.name}}</span></div></div><div class=form-group><label class=col-md-4>出品者ID</label><div class=col-md-8><span>{{dataProduct.created_by}}</span></div></div><div class=form-group><label class=col-md-4>商品カテゴリ</label><div class=col-md-8><span>{{dataProduct.category_name}}</span></div></div><div class=form-group><label class=col-md-4>出品ステータス</label><div class=col-md-8><span>{{dataProduct.status}}</span></div></div><div class=form-group><label class=col-md-4>商品説明</label><div class=col-md-8><span style=\"display:block; text-align:justify\">{{dataProduct.description}}</span></div></div></div><div class=col-md-6 style=padding-right:30px><div class=form-group><label class=col-md-4>商品画像</label><div class=col-md-8><img src={{dataProduct.product_image_url}} width=100 height=100 alt=\"\" onerror=\"this.onerror=null;this.src=\'/../../assets/layouts/layout2/img/no-image.png\'\"></div></div><div class=form-group><div class=col-md-12 style=text-align:center><button ng-click=goDetailProduct() class=\"btn btn-xl-fr btn-lg\" style=margin-left:-15px;display:initial>この商品の詳細へ</button></div></div></div></div></div><div class=clearfix></div></div></div></div></div></div></form></div></div>");
$templateCache.put("/app/modules/report_violation/report_violation.list.html","<div class=body-margin><div class=\"caption caption-list\"><span class=\"caption-subject font-dark uppercase\"><b>違反報告一覧</b></span></div><div class=\"acts-add-form form\"><div data-tmdt-table=dtConfig class=table-container><div class=row><div class=portlet-title></div><div class=\"filter-region form-inline\"><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>{{\"Search condition\"|translate}}</div><div class=\"tools reloadTableFilter\"><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=width:100%><div class=row><div class=col-md-5><span class=col-md-4>出品者ID</span><label class=col-md-8><input type=text filter=created_by class=\"form-control input-sm withinput\"></label></div><div class=col-md-7><span style=margin-right:15px class=col-md-3>違反報告日 </span><input type=text jqdatepicker ng-model=date_start class=\"form-control input-sm\" placeholder=yyyy/mm/dd filter=date_start> <span style=\"margin:0 20px\">~</span> <input type=text jqdatepicker ng-model=date_end class=\"form-control input-sm\" placeholder=yyyy/mm/dd filter=date_end></div></div><div class=row><div class=col-md-5><div class=\"col-md-4 label-check\"><span>出品ステータス</span></div><div class=col-md-8><div class=form-check filter=upload_status><label class=form-check-label ng-repeat=\"i in statusproduct\"><input type=checkbox class=\"form-check-input inputnone\" value={{i.value}}>&nbsp;{{i.text}}&nbsp;&nbsp;&nbsp;&nbsp;</label></div></div></div><div class=col-md-7><div class=\"col-md-3 label-check\"><span>違反報告ステータス</span></div><div class=col-md-8 filter=status><label class=list-cate ng-repeat=\"cate in statusBCVP\"><input type=checkbox class=\"form-check-input inputnone\" value={{cate.value}}>&nbsp;{{cate.text}}&nbsp;&nbsp;&nbsp;&nbsp;</label></div></div></div><div class=row><div class=\"col-md-2 col-md-offset-5\" style=padding-top:10px><button class=\"btn btn-sm-fr btn-large btnseachtxt btn-seach-table search-button pull-right col-md-2\">検索</button></div></div></div><div class=clearfix></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"portlet-title titel-table\"><div><span class=\"caption-subject font-dark\">違反報告一覧</span></div></div><table class=\"table table-bordered table-hover table-checkable\"></table></div></div></div></div></div>");
$templateCache.put("/app/modules/transfer-fee/transfer-fee.list.html","<div class=body-margin><div class=\"caption caption-list\"><span class=\"caption-subject font-dark uppercase\"><b>Transfer Method</b></span></div><div class=\"acts-add-form portlet-body form\"><div data-tmdt-table=dtConfig reload=count ng-model=list class=table-container><div class=row><div class=\"filter-region form-inline\"><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>新規登録</div><div class=\"tools reloadTableFilter\"><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=width:100%><div class=row><div class=col-md-6><span class=col-md-4>禁止ワード入力</span><label style=margin-right:15px><input type=text ng-model=ngWord class=\"ngwordInput withinput form-control input-sm\"></label><span><button ng-click=\"\" class=\"btn btn-sm-fr btn-large btnseachtxt btn-seach-table pull-right col-md-1\">登録</button></span> <span class=col-md-4></span><!--<label style=\"margin-right:15px;\" class=\"\"><input type=\"text\" ng-model=\"errMes\" style=\"color:red\" class=\"ngwordInput withinput form-control input-sm\" /> </label>--></div><div class=col-md-6><span class=col-md-4>禁止ワード入力</span><label style=margin-right:15px><input type=text ng-model=ng class=\"ngwordInput withinput form-control input-sm\"></label><span><button ng-click=\"\" class=\"btn btn-large btnseachtxt btn-sm-fr btn-seach-table pull-right\">登録</button></span> <span class=col-md-4></span><!--<label style=\"margin-right:15px;\" class=\"\"><input type=\"text\" ng-model=\"errMes\" style=\"color:red\" class=\"ngwordInput withinput form-control input-sm\" /> </label>--></div></div></div><div class=clearfix></div></div></div></div></div></div></div></div>");
$templateCache.put("/app/modules/staff/staff.add.html","<div ng-include=\"\'/app/modules/staff/staff.form.html\'\" ng-init=\"mode=\'create\'; staff.email=\'\';staff.password=\'\'; staff.role=\'Admin\';staff.is_deleted=\'false\'\"></div>");
$templateCache.put("/app/modules/staff/staff.details.html","");
$templateCache.put("/app/modules/staff/staff.edit.html","<div ng-include=\"\'/app/modules/staff/staff.form.html\'\" ng-init=\"mode=\'edit\'\"></div>");
$templateCache.put("/app/modules/staff/staff.form.html","<div class=body-margin><div class=portlet-title><div class=\"caption caption-list margin-bottom-10\"><span ng-if=\"mode==\'create\' && updateCreate==false\" class=\"caption-subject routePageTile font-dark uppercase\"><b>スタッフ情報新規作成</b></span> <span ng-if=\"mode==\'create\'&& updateCreate==true\" class=\"caption-subject routePageTile font-dark uppercase\"><b>スタッフ情報詳細</b></span> <span ng-if=\"mode==\'edit\' && updateConfirm==false\" class=\"caption-subject routePageTile font-dark uppercase\"><b>スタッフ情報編集</b></span> <span ng-if=\"mode==\'edit\' && updateConfirm==true\" class=\"caption-subject routePageTile font-dark uppercase\"><b>スタッフ情報詳細</b></span></div></div><div class=\"border-div body-page-detail\"><div class=\"portlet-body form\"><div class=caption style=padding-top:5px;padding-bottom:0px><span ng-if=\"mode == \'create\' && updateCreate==false\" class=nomaTitle><b>スタッフ情報新規作成</b></span> <span ng-if=\"mode == \'create\' && updateCreate==true\" class=nomaTitle><b>スタッフ情報新規作成確認</b></span> <span ng-if=\"mode == \'edit\' && updateConfirm==false\" class=nomaTitle><b>スタッフ情報編集</b></span> <span ng-if=\"mode == \'edit\' && updateConfirm==true\" class=nomaTitle><b>スタッフ情報編集確認</b></span></div><hr style=margin-top:5px><form tmdt-form create-func=create() update-staff-func=update() registration-staff-func=goToAdd() update-func=update() cancel-func=goToList() class=form-horizontal role=form id=them-nhan-vien><div class=form-body style=\"padding:0 20px\" ng-init=\"getById();staff.user_name=\' \';staff.password=\'\'\"><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption><div><span>スタッフ情報</span></div></div><div class=tools><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=padding-left:15px><div ng-if=\"(updateCreate==false || updateConfirm==false) && user.role == \'Admin\'\"><div class=form-group><div class=col-md-8><div class=form-group ng-if=\"mode==\'edit\'\"><label class=col-md-5>{{\"Status staff ID\"|translate}}</label><div class=col-md-7>{{staff.id}}</div></div><div class=form-group><label class=col-md-5>{{\"Staff name\"|translate}}<span class=required aria-required=true> * </span></label><div class=col-md-7><input type=text class=form-control ng-model=staff.user_name frima-maxlength=256 name=userName autocomplete=off frima-required frima-required-ms=ユーザー名を入力してください。></div></div><div class=form-group><label class=col-md-5>{{\"Login ID\"|translate}}<span class=required aria-required=true> * </span></label><div class=col-md-7><input type=text autocomplete=off class=form-control ng-model=staff.email frima-maxlength=256 name=email frima-required></div></div><div class=form-group><label class=col-md-5>{{\"Login Password\"|translate}}<span class=required aria-required=true> * </span></label><div class=col-md-7><input type=password ng-keyup=keypress() autocomplete=off class=form-control frima-minlength=8 frima-maxlength=256 ng-model=staff.password name=password frima-required frima-required-ms=パスワードを入力してください。></div></div><div class=form-group ng-if=\"mode==\'create\'\"><label class=col-md-5>{{\"Role\"|translate}}<span class=required aria-required=true> *</span></label><div class=col-md-7><div class=mt-radio-inline ng-init=\"staff.role=\'Admin\'\" required><label class=mt-radio><input type=radio name=role ng-model=staff.role value=Admin> {{\"Admin\"|translate}} <span></span></label><label class=mt-radio><input type=radio name=role ng-model=staff.role value=User> {{\"User\"|translate}} <span></span></label></div></div></div><div class=form-group ng-if=\"mode==\'create\'\"><label class=col-md-5>{{\"Enable/Disable\"|translate}}<span class=required aria-required=true> * </span></label><div class=col-md-7><div class=mt-radio-inline><label class=mt-radio><input type=radio name=is_deleted ng-model=staff.is_deleted value=false> {{\"Enable\"|translate}} <span></span></label><label class=mt-radio><input type=radio name=is_deleted ng-model=staff.is_deleted value=true> {{\"Disable\"|translate}} <span></span></label></div></div></div><div class=form-group ng-if=\"mode==\'edit\'\"><label class=col-md-5>{{\"Role\"|translate}}<span class=required aria-required=true> *</span></label><div class=col-md-7><div class=mt-radio-inline><label class=mt-radio><input type=radio name=role ng-model=staff.role value=Admin> {{\"Admin\"|translate}} <span></span></label><label class=mt-radio><input type=radio name=role ng-model=staff.role value=User> {{\"User\"|translate}} <span></span></label></div></div></div><div class=form-group ng-if=\"mode==\'edit\'\"><label class=col-md-5>{{\"Enable/Disable\"|translate}}<span class=required aria-required=true> * </span></label><div class=col-md-7><div class=mt-radio-inline><label class=mt-radio><input type=radio name=isDeleted ng-model=staff.is_deleted value=false> {{\"Enable\"|translate}} <span></span></label><label class=mt-radio><input type=radio name=isDeleted ng-model=staff.is_deleted value=true> {{\"Disable\"|translate}} <span></span></label></div></div></div></div></div><div class=form-group><div class=\"col-md-12 text-center group-btn-staff\"><button-confirm-add class=\"btn btn-lg btn-lg-fr btn-default\" ng-show=\"mode==\'create\' && updateCreate==false\" ng-class=\"{\'disableUser\': user.role === \'User\'}\" button-text=確認></button-confirm-add><button-confirm-update class=\"btn btn-lg btn-lg-fr btn-default\" ng-if=\"mode==\'edit\' && updateConfirm==false\" ng-class=\"{\'disableUser\': user.role === \'User\'}\" button-text=確認></button-confirm-update><button type=button ng-if=\"mode==\'edit\' && updateConfirm\" class=\"btn btn-lg-fr btn-lg btn-default\" ng-click=goBack()>編集</button> <button type=button ng-if=\"mode==\'edit\' && updateConfirm\" class=\"btn btn-lg-fr btn-lg btn-default\" ng-click=updateStaff()>登録</button> <button type=button ng-if=\"mode==\'create\' && updateCreate\" class=\"btn btn-lg-fr btn-lg btn-default\" ng-click=goBackCreate()>編集</button> <button type=button ng-if=\"mode==\'create\' && updateCreate\" class=\"btn btn-lg-fr btn-lg btn-default\" ng-click=createStaff()>登録</button></div></div></div><div ng-if=\"updateCreate==true || updateConfirm==true || user.role == \'User\'\"><div class=form-group><div class=col-md-8><div class=form-group ng-if=\"mode==\'edit\'\"><label class=col-md-5>{{\"Status staff ID\"|translate}}</label><div class=col-md-7>{{staff.id}}</div></div><div class=form-group><label class=col-md-5>{{\"Staff name\"|translate}}<span class=required aria-required=true> * </span></label><div class=col-md-7><input type=text class=form-control disabled ng-model=staff.user_name checkscript frima-maxlength=256 autocomplete=off name=userName frima-required frima-required-ms=ユーザー名を入力してください。></div></div><div class=form-group><label class=col-md-5>{{\"Login ID\"|translate}}<span class=required aria-required=true> * </span></label><div class=col-md-7><input type=text disabled autocomplete=off class=form-control ng-model=staff.email frima-maxlength=256 name=email frima-required></div></div><div class=form-group><label class=col-md-5>{{\"Login Password\"|translate}}<span class=required aria-required=true> * </span></label><div class=col-md-7><input type=password disabled autocomplete=off class=form-control frima-minlength=8 frima-maxlength=256 ng-model=staff.password name=password frima-required frima-required-ms=パスワードを入力してください。></div></div><div class=form-group ng-if=\"mode==\'create\'\"><label class=col-md-5>{{\"Role\"|translate}}<span class=required aria-required=true> *</span></label><div class=col-md-7><div class=mt-radio-inline required><label class=mt-radio style=cursor:no-drop><input type=radio disabled name=role ng-model=staff.role value=Admin> {{\"Admin\"|translate}} <span></span></label><label class=mt-radio style=cursor:no-drop><input type=radio disabled name=role ng-model=staff.role value=User> {{\"User\"|translate}} <span></span></label></div></div></div><div class=form-group ng-if=\"mode==\'create\'\"><label class=col-md-5>{{\"Enable/Disable\"|translate}}<span class=required aria-required=true> * </span></label><div class=col-md-7><div class=mt-radio-inline><label class=mt-radio style=cursor:no-drop><input type=radio disabled name=is_deleted ng-model=staff.is_deleted value=false> {{\"Enable\"|translate}} <span></span></label><label class=mt-radio style=cursor:no-drop><input type=radio disabled name=is_deleted ng-model=staff.is_deleted value=true> {{\"Disable\"|translate}} <span></span></label></div></div></div><div class=form-group ng-if=\"mode==\'edit\'\"><label class=col-md-5>{{\"Role\"|translate}}<span class=required aria-required=true> *</span></label><div class=col-md-7><div class=mt-radio-inline><label class=mt-radio style=cursor:no-drop><input type=radio disabled name=role ng-model=staff.role value=Admin> {{\"Admin\"|translate}} <span></span></label><label class=mt-radio style=cursor:no-drop><input type=radio disabled name=role ng-model=staff.role value=User> {{\"User\"|translate}} <span></span></label></div></div></div><div class=form-group ng-if=\"mode==\'edit\'\"><label class=col-md-5>{{\"Enable/Disable\"|translate}}<span class=required aria-required=true> * </span></label><div class=col-md-7><div class=mt-radio-inline><label class=mt-radio style=cursor:no-drop><input type=radio disabled name=isDeleted ng-model=staff.is_deleted value=false> {{\"Enable\"|translate}} <span></span></label><label class=mt-radio style=cursor:no-drop><input type=radio disabled name=isDeleted ng-model=staff.is_deleted value=true> {{\"Disable\"|translate}} <span></span></label></div></div></div></div></div><div class=form-group><div class=\"form-group text-center\"><button-confirm-add class=\"btn btn-lg btn-lg-fr btn-default\" ng-show=\"mode==\'create\' && updateCreate==false\" ng-class=\"{\'disableUser\': user.role === \'User\'}\" button-text=確認></button-confirm-add><button-confirm-update class=\"btn btn-lg btn-lg-fr btn-default\" ng-if=\"mode==\'edit\' && updateConfirm==false\" ng-class=\"{\'disableUser\': user.role === \'User\'}\" button-text=確認></button-confirm-update><button type=button class=\"btn btn-lg btn-lg-fr btn-default\" ng-if=\"mode==\'edit\' && updateConfirm\" ng-click=goBack()>編集</button> <button type=button class=\"btn btn-lg btn-lg-fr btn-default\" ng-if=\"mode==\'edit\' && updateConfirm\" ng-click=updateStaff()>登録</button> <button type=button class=\"btn btn-lg btn-lg-fr btn-default\" ng-if=\"mode==\'create\' && updateCreate\" ng-click=goBackCreate()>編集</button> <button type=button class=\"btn btn-lg btn-lg-fr btn-default\" ng-if=\"mode==\'create\' && updateCreate\" ng-click=createStaff()>登録</button></div></div></div></div><div class=clearfix></div></div></div></div></form></div></div></div><!--modal update address--><div class=\"modal fade bs-modal-lg\" role=dialog><div class=\"modal-dialog modal-lg\"><div class=modal-content><form tmdt-form validator=validation class=form-horizontal create-func=createStaff() update-func=updateStaff()><div class=modal-header><button type=button class=close data-dismiss=modal aria-hidden=true></button><h4 class=modal-title ng-if=\"mode == \'create\'\">{{\"Confirm add staff\"|translate}}</h4><h4 class=modal-title ng-if=\"mode == \'edit\'\">{{\"Confirm edit staff\"|translate}}</h4></div><div class=modal-body><div class=form-group><div class=col-md-6><div class=form-group ng-if=\"mode==\'edit\'\"><label class=col-md-5>{{\"Status staff ID\"|translate}}</label><div class=col-md-7>{{staff.id}}</div></div><div class=form-group><label class=col-md-5>{{\"Staff name\"|translate}}<span class=required aria-required=true> * </span></label><div class=col-md-7><input type=text disabled class=form-control ng-model=staff.user_name frima-maxlength=256 name=userName frima-required></div></div><div class=form-group><label class=col-md-5>{{\"Login ID\"|translate}}<span class=required aria-required=true> * </span></label><div class=col-md-7><input type=text disabled class=form-control frima-email ng-model=staff.email frima-maxlength=256 name=email frima-required></div></div><div class=form-group><label class=col-md-5>{{\"Login Password\"|translate}}<span class=required aria-required=true> * </span></label><div class=col-md-7><input type=password disabled class=form-control frima-minlength=8 frima-maxlength=256 ng-model=staff.password name=password frima-required></div></div></div><div class=col-md-6><div class=form-group ng-if=\"mode==\'create\'\"><label class=col-md-4>{{\"Role\"|translate}}<span class=required aria-required=true> *</span></label><div class=col-md-8><div class=mt-radio-inline><label class=mt-radio><input type=radio disabled name=role ng-model=staff.role value=Admin> {{\"Admin\"|translate}} <span></span></label><label class=mt-radio><input type=radio disabled name=role ng-model=staff.role value=User> {{\"User\"|translate}} <span></span></label></div></div></div><div class=form-group ng-if=\"mode==\'create\'\"><label class=col-md-4>{{\"Enable/Disable\"|translate}}<span class=required aria-required=true> * </span></label><div class=col-md-8><div class=mt-radio-inline><label class=mt-radio><input type=radio disabled name=is_deleted ng-model=staff.is_deleted value=false> {{\"Enable\"|translate}} <span></span></label><label class=mt-radio><input type=radio disabled name=is_deleted ng-model=staff.is_deleted value=true> {{\"Disable\"|translate}} <span></span></label>{{staff.is_deleted}}</div></div></div><div class=form-group ng-if=\"mode==\'edit\'\"><label class=col-md-4>{{\"Role\"|translate}}<span class=required aria-required=true> *</span></label><div class=col-md-8><div class=mt-radio-inline><label class=mt-radio><input type=radio disabled name=role ng-model=staff.role value=Admin> {{\"Admin\"|translate}} <span></span></label><label class=mt-radio><input type=radio disabled name=role ng-model=staff.role value=User> {{\"User\"|translate}} <span></span></label></div></div></div><div class=form-group ng-if=\"mode==\'edit\'\"><label class=col-md-4>{{\"Enable/Disable\"|translate}}<span class=required aria-required=true> * </span></label><div class=col-md-8><div class=mt-radio-inline><label class=mt-radio><input type=radio disabled name=isDeleted ng-model=staff.is_deleted value=false> {{\"Enable\"|translate}} <span></span></label><label class=mt-radio><input type=radio disabled name=isDeleted ng-model=staff.is_deleted value=true> {{\"Disable\"|translate}} <span></span></label></div></div></div></div></div></div><div class=form-group></div><div class=modal-footer><div class=\"col-md-12 text-center\"><button type=button class=\"btn btn-staff\" data-dismiss=modal>編集</button> <button ng-click=createStaff() ng-if=\"mode==\'create\'\" type=button class=\"btn btn-staff\">登録</button> <button ng-click=updateStaff() ng-if=\"mode==\'edit\' && confirmUpdate==false \" type=button class=\"btn btn-staff\">登録</button></div></div></form></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div>");
$templateCache.put("/app/modules/staff/staff.list.html","<div class=body-margin><div class=\"caption caption-list\"><span class=\"caption-subject font-dark uppercase\"><b>{{\"List staff info\"|translate}}</b></span> <button style=\"float:right; width:192.5px\" ng-click=goToAdd() ng-class=\"{\'disableUser\': user.role === \'User\'}\" class=\"btn btn-default btn-add-staff btn-add\">{{\"Registration staff info\"|translate}}</button></div><div class=\"acts-add-form portlet-body form\"><div data-tmdt-table=dtConfig class=table-container><div class=\"portlet box row green-meadow\"><div class=portlet-title><div class=caption>スタッフ検索</div><div class=\"tools reloadTableFilter\"><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=\"portlet-body filter-region\"><div class=\"form-group fade-in-up\" style=width:100%><div class=row><div class=col-md-6><span class=\"col-md-3 text-right\">スタッフID</span><label class=col-md-9><input type=text filter=id class=\"form-control input-sm withinput\"></label></div><div class=col-md-6><span class=\"col-md-3 text-right\">スタッフ名</span><label class=col-md-9><input type=text filter=user_name class=\"form-control input-sm withinput\"></label></div></div></div><div class=row><div class=\"col-md-2 col-md-offset-5\"><button class=\"btn btn-sm-fr btn-large btnseachtxt btn-seach-table search-button pull-right col-md-2\">検索</button></div></div><div class=clearfix></div></div></div><div class=row><div class=col-md-12><div class=\"portlet-title titel-table\"><div><span class=\"caption-subject font-dark\">{{\"Search result list\"|translate}}</span></div></div><table class=\"table table-bordered table-hover table-checkable\"></table></div></div></div></div></div>");
$templateCache.put("/app/modules/transfer-fee1/transfer-fee1.edit.html","<div class=body-margin><div class=\"caption caption-list\"><span class=\"caption-subject font-dark uppercase\"><b>振込手数料設定へ</b></span></div><div class=\"acts-add-form portlet-body form\"><div class=table-container><div class=row><div class=\"filter-region form-inline\"><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>振込手数料</div><div class=\"tools reloadTableFilter\"><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><form class=\"form-group fade-in-up\" style=width:100% name=system_fee_form><div class=\"row col-md-6\"><div class=col-md-4 style=text-align:center><label><input type=number pattern=[0-9]* step=1 min=0 style=text-align:right required ng-model=systemFee.systemFeeValue class=\"ngwordInput withinput form-control input-sm\"></label><span style=\"padding-left: 5px\">円</span></div><div class=col-md-1><span style=\"float:right; margin-top: 2px; font-weight: 600; font-size: 14px\">以下</span></div><div class=col-md-6 style=text-align:center><span style=\"padding-right: 5px\">手数料</span><label><input type=number pattern=[0-9]* style=text-align:right required ng-model=systemFee.systemFeeFixedValue step=1 min=0 class=\"ngwordInput withinput form-control input-sm\"></label><span style=\"padding-left: 5px;padding-right: 10px\">円</span> <span><button ng-click=addSystemFee() type=submit class=\"btn btn-large btnseachtxt btn-sm-fr btn-seach-table pull-right\">登録</button></span> <span class=col-md-4></span></div></div><div class=\"row col-md-12\" ng-if=BankFeeForm.bankFeeValue.$dirty><span style=color:red ng-if=!systemFeeForm.$valid>Data can not empty</span></div></form><div class=clearfix></div></div></div></div></div></div></div></div>");
$templateCache.put("/app/modules/transfer-fee1/transfer-fee1.sales-comission-edit.html","<div class=body-margin><div class=\"caption caption-list\"><span class=\"caption-subject font-dark uppercase\"><b>販売手数料設定へ</b></span></div><div class=\"acts-add-form portlet-body form\"><div class=table-container><div class=row><div class=\"filter-region form-inline\"><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>販売手数料</div><div class=\"tools reloadTableFilter\"><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><form class=\"form-group fade-in-up\" style=width:100% name=bank_fee_form><div class=\"row col-md-6\"><div class=col-md-4 style=text-align:center><span style=\"padding-right: 5px\">手数料</span><label><input type=number step=1 min=0 max=100.00000000000000 required ng-model=BankFee.bankFeeValue class=\"withinput form-control input-sm\" style=text-align:right></label><span style=\"padding-left: 5px;padding-right: 10px\">%</span></div><div class=col-md-1 style=text-align:center><span style=\"font-weight: 600; font-size: 14px\">+</span></div><div class=col-md-3 style=text-align:center><label><input type=number pattern=[0-9]* step=1 min=0 style=text-align:right required ng-model=BankFee.bankFeeThresholdValue class=\"withinput form-control input-sm\"></label><span style=\"padding-left: 5px;padding-right: 10px\">円</span></div><div class=col-md-2><span><button ng-click=addBankFee() type=submit class=\"btn btn-large btnseachtxt btn-sm-fr btn-seach-table pull-right\">登録</button></span></div></div></form><div class=clearfix></div></div></div></div></div></div></div></div>");
$templateCache.put("/app/modules/transfer-request/transfer-request.add.html","<div ng-include=\"\'/app/modules/transfer-request/transfer-request.form.html\'\" ng-init=\"mode=\'create\'\"></div>");
$templateCache.put("/app/modules/transfer-request/transfer-request.detail.html","<div class=body-margin><div class=\"caption caption-list margin-bottom-10\" style=\"font-size: 14px\"><b><span class=\"caption-subject font-dark uppercase routePageTile\">{{\"Transfer request details\"|translate}}</span></b></div><div class=\"border-div body-page-detail\"><div class=portlet-title style=\"padding:0px 0px\"><div class=caption><b><span class=\"caption-subject font-dark\" style=font-size:16px>{{\"Transfer request information details\"|translate}}</span></b></div><hr style=margin-top:10px></div><div class=\"portlet-body form\" ng-init=getById()><form class=form-horizontal><div class=form-body style=padding:0px><div class=\"form-group row\" style=\"padding:0px 0px\"><div class=col-md-6><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>{{\"Transfer request information\"|translate}}</div><div class=tools><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=padding-left:15px><div class=form-group><label class=col-md-4>{{\"Transfer request ID\"|translate}}</label><div class=\"col-md-8 text-right\"><span style=padding-right:15px>{{payment.id}}</span></div></div><div class=form-group><label class=col-md-4>{{\"Money transfer request\"|translate}}</label><div class=\"col-md-8 text-right\"><span class=text-right style=padding-right:15px>￥{{payment.total| number:0}}</span></div></div><div class=form-group><label class=col-md-4>{{\"Fee transfer service\"|translate}}</label><div class=\"col-md-8 text-right\"><span class=text-right style=padding-right:15px>￥{{payment.fee| number:0}}</span></div></div><div class=form-group><label class=col-md-4>{{\"Money transfer\"|translate}}</label><div class=\"col-md-8 text-right\"><span class=text-right style=padding-right:15px>￥{{payment.total - payment.fee | number:0}}</span></div></div></div><div class=clearfix></div></div></div><div style=\"height: 35px\"></div><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>{{\"Information of deliver place\"|translate}}</div><div class=tools><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=padding-left:15px><div class=form-group><label class=col-md-4>{{\"Bank name\"|translate}}</label><div class=col-md-8><span>{{payment.bank}}</span></div></div><div class=form-group><label class=col-md-4>{{\"Type account\"|translate}}</label><div class=col-md-8><span>{{payment.account_type_name}}</span></div></div><div class=form-group><label class=col-md-4>{{\"Branch code\"|translate}}</label><div class=col-md-8><span>{{payment.center_code}}</span></div></div><div class=form-group><label class=col-md-4>{{\"Account number\"|translate}}</label><div class=col-md-8><span>{{payment.account_num}}</span></div></div><div class=form-group><label class=col-md-4>{{\"Account name (First name)\"|translate}}</label><div class=col-md-8><span>{{payment.account_surname}}</span></div></div><div class=form-group><label class=col-md-4>{{\"Account name (Last name)\"|translate}}</label><div class=col-md-8><span>{{payment.account_lastname}}</span></div></div></div><div class=clearfix></div></div></div></div><div class=col-md-6><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>{{\"Status\"|translate}}</div><div class=tools><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=padding-left:15px><div class=form-group><label class=col-md-4>{{\"Status transfer request\"|translate}}</label><div class=col-md-8><span>{{payment.status}}</span></div></div><div class=form-group style=\"margin-top:0px;text-align:center;padding:0 15px\" id=buttonTransfer><div style=\"padding-right: 30px\" class=col-md-12><button ng-click=update() class=\"btn btn-lg btn-xl-fr btn-default\">{{\"Complete transfer\"|translate}}</button></div></div><div class=form-group style=margin-top:0px><label class=col-md-4>{{\"Date request\"|translate}}</label><div class=col-md-8><span>{{payment.created_at}}</span></div></div><div class=form-group><label class=col-md-4>{{\"Date transfer\"|translate}}</label><div class=col-md-8><span id=dateTransfer>{{payment.updated_at}}</span></div></div></div><div class=clearfix></div></div></div></div></div><div style=clear:both></div></div></form></div></div></div>");
$templateCache.put("/app/modules/transfer-request/transfer-request.edit.html","<div ng-include=\"\'/app/modules/transfer-request/transfer-request.form.html\'\" ng-init=\"mode=\'edit\'\"></div>");
$templateCache.put("/app/modules/transfer-request/transfer-request.form.html","<!--\n<div class=\" portlet light bordered\">\n    <div class=\"portlet-title\">\n        <div class=\"caption\">\n                <div class=\"caption\" style=\"font-size: 20px;\">\n                        <span class=\"caption-subject font-dark sbold uppercase\">Danh sách kết quả tìm kiếm</span>\n                </div>\n        </div>\n    </div>\n    <div class=\"portlet-body form\">\n\n        <form tmdt-form create-func=\"create()\" detail-func=\"detail()\" update-func=\"update()\" delete-func=\"del()\" cancel-func=\"gotoList()\" class=\"form-horizontal\" role=\"form\" id=\"them-nhan-vien\">\n            <div class=\"form-body\">\n                <div class=\"form-group\">\n                    <div class=\"col-md-12 text-center\">\n                        <button-detail ng-if=\"mode==\'detail\'\"></button-detail>\n                        <button-add ng-if=\"mode==\'create\'\"></button-add>\n                        <button-save ng-if=\"mode==\'edit\'\"></button-save>\n                        <button-delete ng-if=\"mode==\'edit\'\"></button-delete>\n                        <button-cancel></button-cancel>\n                    </div>\n                </div>\n                <div class=\"form-group\" >\n\n                    <div class=\"col-md-6\">\n                        <div class=\"form-group\">\n                            <label class=\"col-md-4\">Tên khách hàng<span class=\"required\" aria-required=\"true\"> * </span></label>\n                            <div class=\"col-md-8\">\n                                <input type=\"text\" class=\"form-control\" ng-model=\"customer.name\" siten-maxlength=\"200\" name=\"name\" required />\n                            </div>\n                        </div>\n                        <div class=\"form-group\" ng-if=\"mode==\'create\'\">\n                            <label class=\"col-md-4\">Số điện thoại<span class=\"required\" aria-required=\"true\"> * </span></label>\n                            <div class=\"col-md-8\">\n                                <input type=\"text\" class=\"form-control\" siten-phone ng-model=\"customer.phone\" name=\"userPhone\" required />\n                            </div>\n                        </div>\n                        <div class=\"form-group\" ng-if=\"mode==\'edit\'\">\n                            <label class=\"col-md-4\">Giới tính</label>\n                            <div class=\"col-md-8\">\n                                <div class=\"mt-radio-inline\">\n                                    <label class=\"mt-radio\">\n                                        <input type=\"radio\" name=\"optionsRadios\" id=\"optionsRadios25\" ng-model=\"customer.gender\" value=\"true\" ng-checked=\"customer.gender== undefined || customer.gender == \'true\'\"> Nam\n                                        <span></span>\n                                    </label>\n                                    <label class=\"mt-radio\">\n                                        <input type=\"radio\" name=\"optionsRadios\" id=\"optionsRadios26\" ng-model=\"customer.gender\" value=\"false\"> Nữ\n                                        <span></span>\n                                    </label>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group\" ng-if=\"mode==\'detail\'\">\n                            <label class=\"col-md-4\">Hoạt động</label>\n                            <div class=\"col-md-8\">\n                                <div class=\"mt-checkbox-inline\">\n                                    <label class=\"mt-checkbox\">\n                                        <input type=\"checkbox\" value=\"true\" ng-model=\"customer.isActive\">\n                                        <span></span>\n                                    </label>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-md-6\">\n                        <div class=\"form-group\">\n                            <label class=\"col-md-4\">Email</label>\n                            <div class=\"col-md-8\">\n                                <input type=\"text\" siten-email class=\"form-control\" ng-model=\"customer.emailAddress\" name=\"emailAddress\" ng-if=\"mode==\'create\'\"  siten-maxlength=\"256\" />\n                                <input type=\"text\" siten-email class=\"form-control\" ng-model=\"customer.email\" name=\"email\" ng-if=\"mode==\'edit\'\"  siten-maxlength=\"256\" />\n                            </div>\n                        </div>\n\n                        <div class=\"form-group\" ng-if=\"mode==\'edit\'\">\n                            <label class=\"col-md-4\">Mật khẩu<span class=\"required\" aria-required=\"true\"> * </span></label>\n                            <div class=\"col-md-8\">\n                                <input type=\"text\" class=\"form-control\" ng-model=\"customer.password\" siten-maxlength=\"32\" name=\"password\" required />\n                            </div>\n                        </div>\n                        <div class=\"form-group\" ng-if=\"mode==\'edit\'\">\n                            <label class=\"col-md-4\">Ngày sinh</label>\n                            <div class=\"col-md-8\">\n                                <div class=\"input-group date bs-datetime\" name=\"expiryTime\" datepicker ng-model=\"customer.birthday\"></div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>\n\n\n<div class=\"modal fade bs-modal-lg\" id=\"modalAddress\" role=\"dialog\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <form tmdt-form validator=\"validation\" class=\"form-horizontal\" create-func=\"createAddress()\" update-func=\"updateAddress()\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"></button>\n                    <h4 class=\"modal-title\" ng-if=\"typeAction == \'add\'\">Thêm mới địa chỉ</h4>\n                    <h4 class=\"modal-title\" ng-if=\"typeAction == \'edit\'\">Cập nhật địa chỉ</h4>\n                </div>\n                <div class=\"modal-body\">\n                    <div class=\"form-group\">\n                        <label class=\"col-md-3\">Họ tên:<span class=\"required\" aria-required=\"true\"> * </span></label>\n                        <div class=\"col-md-9\">\n                            <input type=\"text\" name=\"addressUserName\" ng-model=\"customerAddressAction.name\" required siten-maxlength=\"200\" class=\"form-control\" />\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"col-md-3\">Số điện thoại<span class=\"required\" aria-required=\"true\"> * </span></label>\n                        <div class=\"col-md-9\">\n                            <input type=\"text\" siten-phone name=\"addressUserPhone\" ng-model=\"customerAddressAction.phone\" required maxlength=\"20\" class=\"form-control\" />\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"col-md-3\">Tỉnh/TP<span class=\"required\" aria-required=\"true\"> * </span></label>\n                        <div class=\"col-md-9\">\n                            <select select2-promise ng-model=\"customerAddressAction.provinceId\" requiredSelect2 get-data=\"getProvince()\" class=\"form-control\" style=\"width: 100%\"></select>\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"col-md-3\">Quận/Huyện<span class=\"required\" aria-required=\"true\"> * </span> </label>\n                        <div class=\"col-md-9\">\n                            <select select2-promise ng-model=\"customerAddressAction.districtId\" requiredSelect2 get-data=\"getDistrict()\" class=\"form-control\" style=\"width: 100%\"></select>\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"col-md-3\">Địa chỉ<span class=\"required\" aria-required=\"true\"> * </span></label>\n                        <div class=\"col-md-9\">\n                            <textarea ng-model=\"customerAddressAction.address\" required maxlength=\"255\" class=\"form-control\"></textarea>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn dark btn-outline closeModalAddress\" data-dismiss=\"modal\">Đóng</button>\n                    <button-add ng-if=\"typeAction == \'add\'\"></button-add>\n                    <button-save ng-if=\"typeAction == \'edit\'\"></button-save>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n-->");
$templateCache.put("/app/modules/transfer-request/transfer-request.list.html","<div class=body-margin><div class=\"caption caption-list\"><span class=\"caption-subject font-dark uppercase\"><b>{{\"List transfer request information\"|translate}}</b></span></div><div class=\"acts-add-form portlet-body form\"><div data-tmdt-table=dtConfig class=table-container><div class=row><div class=\"margin-bottom-10 filter-region form-inline\"><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>{{\"Search condition\"|translate}}</div><div class=\"tools reloadTableFilter\"><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=width:100%><div class=row><div class=col-md-6><div class=\"col-md-5 label-check\"><span>{{\"Status transfer request\" |translate}}</span></div><div class=col-md-7><div class=form-check filter=status_request_list><label class=form-check-label><input type=checkbox class=\"form-check-input inputnone\" value=0>&nbsp;{{\"Requesting\"|translate}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label><label class=form-check-label><input type=checkbox class=\"form-check-input inputnone\" value=1>&nbsp;{{\"Processed\"|translate}}</label></div></div></div><div class=col-md-6><span class=col-md-2>{{\"Date request\"|translate}}</span> <input type=text jqdatepicker ng-model=request_date_start class=\"form-control input-sm\" placeholder=yyyy/mm/dd filter=request_date_start> <span style=\"margin:0 15px\">~</span> <input type=text jqdatepicker ng-model=request_date_end class=\"form-control input-sm\" placeholder=yyyy/mm/dd filter=request_date_end></div></div><div class=\"row search-input\"></div><div class=row><div class=\"col-md-2 col-md-offset-5\" style=padding-top:10px><button type=submit class=\"btn btn-sm-fr btn-sm pull-right btn-seach-table search-button btnseachtxt\" style=\"padding-top:8px; padding-bottom:8px\">検索</button></div></div></div><div class=clearfix></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"portlet-title titel-table\"><div><span class=\"caption-subject font-dark\">{{\"Search result list\"|translate}}</span></div></div><table class=\"table table-bordered table-hover table-checkable\"></table></div></div></div></div></div>");
$templateCache.put("/app/modules/upload/upload.detail.html","<div class=\"caption caption-list\"><span class=\"D002-product-detail routePageTile\" style=color:white>{{\"D002-details-up-product\" | translate}}</span></div><div class=\"portlet light borderblack\" style=\"padding: 5px 15px;\n    margin: 0px -15px 0px -15px\" ng-init=getById()><div class=portlet-title><div class=caption><span style=\"padding-left: 0px\" class=\"nomaTitle caption-subject font-dark sbold uppercase\">{{\"D002-details-up-product\" | translate}}</span></div></div><div class=\"portlet-body form\"><div class=row><div class=col-md-6><div class=\"portlet box green-meadow\"><div class=portlet-title><div class=caption>{{\"D002-detail-upload\" | translate}}</div><div class=tools><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\"><div class=\"col-md-12 D002-dettail-content\"><div class=col-md-4>{{\"D001_Idproduct\" |translate}}</div><div class=col-md-8>{{exbit.id}}</div></div><div class=\"col-md-12 D002-dettail-content\"><div class=col-md-4>{{\"D001_nameproduct\" |translate}}</div><div class=col-md-8>{{exbit.name}}</div></div><div class=\"col-md-12 D002-dettail-content\"><div class=col-md-4>{{\"D001-Iduser\" |translate}}</div><div class=col-md-8>{{exbit.created_by}}</div></div><div class=\"col-md-12 D002-dettail-content\"><div class=col-md-4>{{\"D002-category-product\" |translate}}</div><div class=col-md-8>{{exbit.category_name}}</div></div><div class=\"col-md-12 D002-dettail-content\"><div class=col-md-4>{{\"D002-price\" |translate}}</div><div class=col-md-8>¥{{exbit.price | number}}</div></div><div class=\"col-md-12 D002-dettail-content\"><div class=col-md-4>{{\"D002-dateresgister\" |translate}}</div><div class=col-md-8>{{exbit.created_at }}</div></div><div class=\"col-md-12 D002-dettail-content\"><div class=col-md-4>{{\"D002-tag\" |translate}}</div><div class=col-md-8><div class=\"tags label label-default\" ng-repeat=\"i in tag track by $index\">{{i}}</div></div></div><div class=\"col-md-12 D002-dettail-content\"><div class=col-md-4>{{\"D002-status-up\" |translate}}</div><div class=col-md-8>{{exbit.status |translate}}</div></div><div class=\"col-md-12 D002-dettail-content\"><div class=col-md-4>商品説明</div><div class=col-md-8 style=text-align:justify>{{exbit.description }}</div></div><div class=\"col-md-12 D002-dettail-content\"><div class=col-md-4>管理メモ</div><div class=col-md-8 style=text-align:justify>{{exbit.description_manage }}</div></div><div class=\"col-md-12 D002-dettail-content\"><div class=col-md-4>{{\"D002-dungtich\" |translate}}</div><div class=col-md-8>{{exbit.volumn}}</div></div><div class=\"col-md-12 D002-dettail-content\"><div class=col-md-4>{{\"D002-preservation\" |translate}}</div><div class=col-md-8>{{exbit.store_type}}</div></div><div class=\"col-md-12 D002-dettail-content\"><div class=col-md-4>{{\"D002-status-product\" |translate}}</div><div class=col-md-8>{{exbit.product_status}}</div></div><div class=\"col-md-12 D002-dettail-content\"><div class=col-md-4>{{\"D002-ship\" |translate}}</div><div class=col-md-8>{{exbit.ship_fee_type}}</div></div><div class=\"col-md-12 D002-dettail-content\"><div class=col-md-4>{{\"D002-trasnfer\" |translate}}</div><div class=col-md-8>{{exbit.ship_method}}</div></div><div class=\"col-md-12 D002-dettail-content\"><div class=col-md-4>{{\"D002-transfer-where\" |translate}}</div><div class=col-md-8>{{exbit.prefecture}}</div></div><div class=\"col-md-12 D002-dettail-content\"><div class=col-md-4>{{\"D002-dimit\" |translate}}</div><div class=col-md-8>{{exbit.deliver_day}}</div></div><div class=\"col-md-12 D002-dettail-content\" ng-if=exbit.violation_title><div class=col-md-4>見出し</div><div class=col-md-8>{{exbit.violation_title}}</div></div><div class=\"col-md-12 D002-dettail-content\" ng-if=exbit.violation_detail><div class=col-md-4>違反理由</div><div class=col-md-8>{{exbit.violation_detail}}</div></div></div><div class=clearfix></div></div></div></div><div class=col-md-6><div class=\"col-md-12 margin-bottom-10 margin-top-10\"><div class=caption><b class=nomaTitle>商品画像</b></div></div><div class=col-md-4 ng-repeat=\"img in exbitdata\"><div class=thumbnail style=padding:0px ng-if=img.image_url><img ng-src={{img.image_url}} onerror=\"this.onerror=null;this.src=\'/../../assets/layouts/layout2/img/no-image.png\'\"></div></div><div class=cleafix></div><div><div class=\"btncenter col-md-12\" ng-if=\"exbit.status==\'published\'\"><button class=\"btn btn-lg btn-xl-fr\" data-toggle=modal data-target=#myModal>{{\"D002-upload-product \"| translate}}</button></div></div></div><!-- table coment --><div class=\"col-md-12 margin-top-20\"><div class=caption style=padding-bottom:10px><span style=font-size:14px class=\"caption-subject font-dark sbold uppercase\">{{\"D002-history-coment\" | translate}}</span></div><div><table class=\"table table-bordered table-text-center\" style=\"border:#dee2e6 1px solid!important\"><thead><tr bgcolor=#dee2e6><th class=table-text-center width=170>記入日</th><th class=table-text-center width=120>記入者ID</th><th>記入者名</th><th>内容</th></tr></thead><tbody><tr ng-repeat=\"chat in exbitchat\" style=\"border-bottom:#dee2e6 1px solid!important\"><td title={{chat.created_at}}>{{chat.created_at}}</td><td title={{chat.created_by}}>{{chat.created_by}}</td><td title={{chat.user_name}} class=text-left>{{chat.user_name}}</td><td title={{chat.content}} class=text-left>{{chat.content}}</td></tr></tbody></table></div></div><div class=\"col-md-12 margin-top-20\"><div class=caption style=padding-bottom:10px><span style=font-size:14px class=\"caption-subject font-dark sbold uppercase\">{{\"D002-history-report\" | translate}}</span></div><div><table class=\"table table-bordered table-text-center\" style=\"border:#dee2e6 1px solid!important\"><thead><tr bgcolor=#dee2e6><th class=table-text-center width=170>記入日</th><th class=table-text-center width=120>記入者ID</th><th width=\"\">記入者名</th><th>内容</th></tr></thead><tbody><tr ng-repeat=\"report in exbitreport\"><td title={{report.created_at}}>{{report.created_at}}</td><td title={{report.created_by}}>{{report.created_by}}</td><td title={{report.user_name}} class=text-left>{{report.user_name}}</td><td title={{report.content}} class=text-left>{{report.content}}</td></tr></tbody></table></div></div></div></div></div><!-- Modal --><div id=myModal class=\"modal fade\" role=dialog><div class=modal-dialog><!-- Modal content--><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal>&times;</button><h5 class=modal-title><b>違反理由</b></h5></div><div class=modal-body style=padding-bottom:0px><div class=\"portlet-body form\"><form class=form-horizontal role=form id=huy-san-pham><div class=form-body style=\"padding:0 20px\" ng-init=\"getById();staff.user_name=\' \';staff.password=\'\'\"><div class=portlet-body><div class=\"form-group fade-in-up\" style=padding-left:15px><div><div class=form-group><div class=col-md-12><div class=form-group><label class=col-md-4>見出し <span class=required aria-required=true>*</span></label><div class=col-md-8><input type=text class=form-control ng-model=dataVio.violation_title name=violation_title></div></div><div class=form-group><label class=col-md-4>違反理由 <span class=required aria-required=true>*</span></label><div class=col-md-8><input type=text class=form-control ng-model=dataVio.violation_detail name=violation_detail1></div></div><div style=text-align:right><button type=submit class=\"btn btn-lg btn-sm-fr btn-staff\">送信</button><div ng-click=dimisData() class=\"btn btn-lg btn-sm-fr btn-staff\" style=margin-right:0px!important data-dismiss=modal>キャンセル</div></div></div></div></div></div><div class=clearfix></div></div></div></form></div></div></div></div></div><script>$(document).ready(function () {\n\n        var scope = angular.element(\"#up-load-page\").scope();\n        validator = myApp.validateForm(\"#huy-san-pham\", {\n            rules: {\n                violation_title: {\n                    required: true,\n                    maxlength: 125\n                },\n                violation_detail1: {\n                    required: true,\n                    maxlength: 125\n                }\n            },\n            messages: {\n                violation_title: {\n                    required: \"入力してください。\",\n                    maxlength: \"125 文字以内で入力してください。\"\n                },\n                violation_detail1: {\n                    required: \"入力してください。\",\n                    maxlength: \"125 文字以内で入力してください。\"\n                }\n            },\n            submitHandler: function (form) {\n                debugger;\n                scope.stopuploadproduct();\n            }\n        });\n    });</script>");
$templateCache.put("/app/modules/upload/upload.list.html","<div><div><div class=\"caption caption-list\"><span class=\"caption-subject font-dark sbold uppercase\">{{\"D001-list-info-up-product-header\"|translate}}</span></div></div><div class=\"acts-add-form portlet-body form\"><div data-tmdt-table=dtConfig><div class=row><div class=table-container><div class=\"filter-region form-inline\"><div class=\"portlet box green-meadow upload-list\"><div class=portlet-title><div class=caption>{{\"Search condition\"|translate}}</div><div class=\"tools reloadTableFilter\"><a href=javascript:; class=collapse data-original-title=\"\"></a></div></div><div class=portlet-body><div class=\"form-group fade-in-up\" style=width:100%><div class=row><div class=col-md-6><span class=col-md-4>{{\"D001_Idproduct\"| translate}}</span><label class=col-md-8><input type=text filter=id class=\"form-control input-sm withinput\"></label></div><div class=col-md-6><span class=col-md-2>{{\"D001_nameproduct\"| translate}}</span><label class=col-md-10><input type=text filter=name class=\"form-control input-sm withinput\"></label></div></div><div class=row><div class=col-md-6><span class=col-md-4>{{\"D001-Iduser\"|translate}}</span><label class=col-md-8><input type=text filter=created_by value={{memberSearchUserId}} class=\"form-control input-sm withinput\"></label></div><div class=col-md-6><span class=col-md-2>{{\"D001-dateRegister\" |translate}}</span><label style=padding-left:15px><input type=text jqdatepicker ng-model=created_at_from class=\"form-control input-sm\" placeholder=yyyy/mm/dd filter=created_at_from></label><span style=\"margin:0 10px\">~</span> <input type=text jqdatepicker ng-model=created_at_to class=\"form-control input-sm\" placeholder=yyyy/mm/dd filter=created_at_to></div></div></div><div class=row></div><div class=\"col-md-2 label-check\"><span>{{\"D001-status\" |translate}}</span></div><div class=col-md-10><div class=form-check filter=status_list><label class=\"form-check-label fm-5-item\" ng-repeat=\"i in statusproduct\"><input type=checkbox class=\"form-check-input inputnone\" value={{i.value}}>&nbsp;{{i.text}}</label></div></div><div class=\"col-md-2 label-check\"><span>商品カテゴリ</span></div><div class=col-md-10 filter=category_list><label class=\"list-cate fm-5-item\" ng-repeat=\"cate in category\"><input type=checkbox class=\"form-check-input inputnone\" value={{cate.id}}>&nbsp;{{cate.name}}</label></div><div class=row><div class=\"col-md-2 col-md-offset-5\" style=padding-top:10px><button class=\"btn btn-large btn-sm-fr btnseachtxt btn-seach-table search-button pull-right col-md-2\">検索</button></div></div></div><div class=clearfix></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"portlet-title titel-table\"><div><span class=\"caption-subject font-dark\">{{\"D001-list-seach\"|translate}}</span></div></div><table class=\"table table-bordered table-hover table-checkable\"></table></div></div></div></div></div>");}]);